const echarts = require("echarts");
//全国json
var chinaJson = {
	"type": "FeatureCollection",
	"features": [{
		"id": "710000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@°Ü¯Û"],
				["@@ƛĴÕƊÉɼģºðʀ\\ƎsÆNŌÔĚänÜƤɊĂǀĆĴĤǊŨxĚĮǂƺòƌâÔ®ĮXŦţƸZûÐƕƑGđ¨ĭMó·ęcëƝɉlÝƯֹÅŃ^Ó·śŃǋƏďíåɛGɉ¿@ăƑ¥ĘWǬÏĶŁâ"],
				["@@\\p|WoYG¿¥Ij@¢"],
				["@@¡@V^RqBbAnTXeRz¤L«³I"],
				["@@ÆEEkWqë @"],
				["@@fced"]
			],
			"encodeOffsets": [
				[
					[122886, 24033]
				],
				[
					[123335, 22980]
				],
				[
					[122375, 24193]
				],
				[
					[122518, 24117]
				],
				[
					[124427, 22618]
				],
				[
					[124862, 26043]
				]
			]
		},
		"properties": {
			"cp": [121.509062, 24.044332],
			"name": "台湾",
			"childNum": 6
		}
	}, {
		"id": "130000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@o~Z]ªrºc_ħ²G¼s`jÎŸnüsÂłNX_M`Ç½ÓnUKĜēs¤­©yrý§uģcJe"],
				["@@U`Ts¿mÂ"],
				["@@oºƋÄdeVDJj£J|ÅdzÂFt~KŨ¸IÆv|¢r}èonb}`RÎÄn°ÒdÞ²^®lnÐèĄlðÓ×]ªÆ}LiĂ±Ö`^°Ç¶p®đDcŋ`ZÔ¶êqvFÆN®ĆTH®¦O¾IbÐã´BĐɢŴÆíȦpĐÞXR·nndO¤OÀĈƒ­QgµFo|gȒęSWb©osx|hYhgŃfmÖĩnºTÌSp¢dYĤ¶UĈjlǐpäìë|³kÛfw²Xjz~ÂqbTÑěŨ@|oMzv¢ZrÃVw¬ŧĖ¸f°ÐTªqs{S¯r æÝlNd®²Ğ ǆiGĘJ¼lr}~K¨ŸƐÌWöÆzR¤lêmĞLÎ@¡|q]SvKÑcwpÏÏĿćènĪWlĄkT}J¤~ÈTdpddʾĬBVtEÀ¢ôPĎƗè@~kü\\rÊĔÖæW_§¼F´©òDòjYÈrbĞāøŀG{ƀ|¦ðrb|ÀH`pʞkvGpuARhÞÆǶgĘTǼƹS£¨¡ù³ŘÍ]¿ÂyôEP xX¶¹ÜO¡gÚ¡IwÃé¦ÅBÏ|Ç°N«úmH¯âDùyŜŲIÄuĐ¨D¸dɂFOhđ©OiÃ`ww^ÌkÑH«ƇǤŗĺtFu{Z}Ö@U´ʚLg®¯Oı°Ãw ^VbÉsmAê]]w§RRl£ȭµu¯b{ÍDěïÿȧuT£ġěŗƃĝQ¨fVƋƅn­a@³@ďyÃ½IĹÊKŭfċŰóxV@tƯJ]eR¾fe|rHA|h~Ėƍl§ÏlTíb ØoÅbbx³^zÃĶ¶Sj®AyÂhðk`«PËµEFÛ¬Y¨Ļrõqi¼Wi°§Ð±´°^[À|ĠO@ÆxO\\ta\\tĕtû{ġȧXýĪÓjùÎRb^ÎfK[ÝděYfíÙTyuUSyŌŏů@Oi½éŅ­aVcř§ax¹XŻácWU£ôãºQ¨÷Ñws¥qEHÙ|šYQoŕÇyáĂ£MÃ°oťÊP¡mWO¡v{ôvîēÜISpÌhp¨ jdeŔQÖjX³àĈ[n`Yp@UcM`RKhEbpŞlNut®EtqnsÁgAiúoHqCXhfgu~ÏWP½¢G^}¯ÅīGCÑ^ãziMáļMTÃƘrMc|O_¯Ŏ´|morDkO\\mĆJfl@cĢ¬¢aĦtRıÒ¾ùƀ^juųœK­UFyƝīÛ÷ąV×qƥV¿aȉd³BqPBmaËđŻģmÅ®V¹d^KKonYg¯XhqaLdu¥Ípǅ¡KąÅkĝęěhq}HyÃ]¹ǧ£Í÷¿qáµ§g¤o^á¾ZE¤i`ĳ{nOl»WÝĔįhgF[¿¡ßkOüš_ūiǱàUtėGyl}ÓM}jpEC~¡FtoQiHkk{Ãmï"]
			],
			"encodeOffsets": [
				[
					[119712, 40641]
				],
				[
					[121616, 39981]
				],
				[
					[116462, 37237]
				]
			]
		},
		"properties": {
			"cp": [114.502461, 38.045474],
			"name": "河北",
			"childNum": 3
		}
	}, {
		"id": "140000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ÞĩÒSra}ÁyWix±Üe´lèßÓǏokćiµVZģ¡coTSË¹ĪmnÕńehZg{gtwªpXaĚThȑp{¶Eh®RćƑP¿£Pmc¸mQÝWďȥoÅîɡųAďä³aÏJ½¥PG­ąSM­EÅruµéYÓŌ_dĒCo­Èµ]¯_²ÕjāK~©ÅØ^ÔkïçămÏk]­±cÝ¯ÑÃmQÍ~_apm~ç¡qu{JÅŧ·Ls}EyÁÆcI{¤IiCfUcƌÃp§]ě«vD@¡SÀµMÅwuYY¡DbÑc¡h×]nkoQdaMç~eDÛtT©±@¥ù@É¡ZcW|WqOJmĩl«ħşvOÓ«IqăV¥D[mI~Ó¢cehiÍ]Ɠ~ĥqX·eƷn±}v[ěďŕ]_œ`¹§ÕōIo©b­s^}Ét±ū«³p£ÿ·Wµ|¡¥ăFÏs×¥ŅxÊdÒ{ºvĴÎêÌɊ²¶ü¨|ÞƸµȲLLúÉƎ¤ϊęĔV`_bªS^|dzY|dz¥pZbÆ£¶ÒK}tĦÔņƠPYznÍvX¶Ěn ĠÔzý¦ª÷ÑĸÙUȌ¸dòÜJð´ìúNM¬XZ´¤ŊǸ_tldI{¦ƀðĠȤ¥NehXnYGR° ƬDj¬¸|CĞKqºfƐiĺ©ª~ĆOQª ¤@ìǦɌ²æBÊTŸʂōĖĴŞȀÆÿȄlŤĒötÎ½î¼ĨXh|ªM¤Ðz"],
			"encodeOffsets": [
				[116874, 41716]
			]
		},
		"properties": {
			"cp": [111.849248, 36.857014],
			"name": "山西",
			"childNum": 1
		}
	}, {
		"id": "150000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@Č^â£ĂhĖMÈÄw\\fŦ°W ¢¾luŸDw\\̀ʉÌÛMĀ[bÓEn}¶Vcês¯PqFB|S³C|kñHdiÄ¥sŉÅPóÑÑE^ÅPpy_YtShQ·aHwsOnŉÃs©iqjUSiº]ïW«gW¡ARëśĳĘů`çõh]y»ǃǛҤxÒm~zf}pf|ÜroÈzrKÈĵSƧż؜Ġu¦ö"],
				["@@sKCGS|úþXgp{ÁX¿ć{ƱȏñZáĔyoÁhA}ŅĆfdŉ_¹Y°ėǩÑ¡H¯¶oMQqð¡Ë|Ñ`ƭŁX½·óÛxğįÅcQs«tȋǅFù^it«Č¯[hAi©á¥ÇĚ×l|¹y¯YȵƓñǙµïċĻ|Düȭ¶¡oŽäÕG\\ÄT¿Òõr¯LguÏYęRƩɷŌO\\İÐ¢æ^Ŋ ĲȶȆbÜGĝ¬¿ĚVĎgª^íu½jÿĕęjık@Ľ]ėl¥ËĭûÁėéV©±ćn©­ȇÍq¯½YÃÔŉÉNÑÅÝy¹NqáʅDǡËñ­ƁYÅy̱os§ȋµʽǘǏƬɱàưN¢ƔÊuľýľώȪƺɂļxZĈ}ÌŉŪĺœĭFЛĽ̅ȣͽÒŵìƩÇϋÿȮǡŏçƑůĕ~Ç¼ȳÐUfdIxÿ\\G zâɏÙOº·pqy£@qþ@Ǟ˽IBäƣzsÂZÁàĻdñ°ŕzéØűzșCìDȐĴĺf®Àľưø@ɜÖÞKĊŇƄ§͑těï͡VAġÑÑ»d³öǍÝXĉĕÖ{þĉu¸ËʅğU̎éhɹƆ̗̮ȘǊ֥ड़ࡰţાíϲäʮW¬®ҌeרūȠkɬɻ̼ãüfƠSצɩςåȈHϚÎKǳͲOðÏȆƘ¼CϚǚ࢚˼ФÔ¤ƌĞ̪Qʤ´¼mȠJˀƲÀɠmǐnǔĎȆÞǠN~ʢĜ¶ƌĆĘźʆȬ˪ĚĒ¸ĞGȖƴƀj`ĢçĶāàŃºēĢĖćYÀŎüôQÐÂŎŞǆŞêƖoˆDĤÕºÑǘÛˤ³̀gńƘĔÀ^ªƂ`ªt¾äƚêĦĀ¼ÐĔǎ¨Ȕ»͠^ˮÊȦƤøxRrŜH¤¸ÂxDÄ|ø˂˜ƮÐ¬ɚwɲFjĔ²Äw°ǆdÀÉ_ĸdîàŎjÊêTĞªŌŜWÈ|tqĢUB~´°ÎFCU¼pĀēƄN¦¾O¶łKĊOjĚj´ĜYp{¦SĚÍ\\T×ªV÷Ší¨ÅDK°ßtŇĔK¨ǵÂcḷ̌ĚǣȄĽFlġUĵŇȣFʉɁMğįʏƶɷØŭOǽ«ƽū¹Ʊő̝Ȩ§ȞʘĖiɜɶʦ}¨֪ࠜ̀ƇǬ¹ǨE˦ĥªÔêFxúQEr´Wrh¤Ɛ \\talĈDJÜ|[Pll̚¸ƎGú´P¬W¦^¦H]prRn|or¾wLVnÇIujkmon£cX^Bh`¥V¦U¤¸}xRj[^xN[~ªxQ[`ªHÆÂExx^wN¶Ê|¨ìMrdYpoRzNyÀDs~bcfÌ`L¾n|¾T°c¨È¢ar¤`[|òDŞĔöxElÖdHÀI`Ď\\Àì~ÆR¼tf¦^¢ķ¶eÐÚMptgjɡČÅyġLûŇV®ÄÈƀĎ°P|ªVVªj¬ĚÒêp¬E|ŬÂc|ÀtƐK f{ĘFĒƌXƲąo½Ę\\¥o}Ûu£ç­kX{uĩ«āíÓUŅßŢqŤ¥lyň[oi{¦LńðFȪȖĒL¿Ìf£K£ʺoqNwğc`uetOj×°KJ±qÆġmĚŗos¬qehqsuH{¸kH¡ÊRǪÇƌbȆ¢´äÜ¢NìÉʖ¦â©Ż؛Ç@Vu»Aylßí¹ĵêÝlISò³C¹Ìâ²i¶Ìoú^H²CǜңǄ z¼g^èöŰ_Ĳĕê}gÁnUI«m]jvV¼euhwqAaW_µj»çjioQR¹ēÃßt@r³[ÛlćË^ÍÉáGOUÛOB±XkÅ¹£k|e]olkVÍ¼ÕqtaÏõjgÁ£§U^RLËnX°ÇBz^~wfvypV ¯ƫĉ˭ȫƗŷɿÿĿƑ˃ĝÿÃǃßËőó©ǐȍŒĖM×ÍEyxþp]ÉvïèvƀnÂĴÖ@V~Ĉ³MEĸÅĖtējyÄDXÄxGQuv_i¦aBçw˛wD©{tāmQ{EJ§KPśƘƿ¥@sCTÉ}ɃwƇy±gÑ}T[÷kÐç¦«SÒ¥¸ëBX½HáÅµÀğtSÝÂa[ƣ°¯¦Pï¡]£ġÒk®G²èQ°óMq}EóƐÇ\\@áügQÍu¥FTÕ¿Jû]|mvāÎYua^WoÀa·­ząÒot×¶CLƗi¯¤mƎHǊ¤îìɾŊìTdåwsRÖgĒųúÍġäÕ}Q¶¿A[¡{d×uQAMxVvMOmăl«ct[wº_ÇÊjbÂ£ĦS_éQZ_lwgOiýe`YYLq§IÁǳ£ÙË[ÕªuƏ³ÍTs·bÁĽäė[b[ŗfãcn¥îC¿÷µ[ŏÀQ­ōĉm¿Á^£mJVmL[{Ï_£F¥Ö{ŹA}×Wu©ÅaųĳƳhB{·TQqÙIķËZđ©Yc|M¡LeVUóK_QWk_ĥ¿ãZ»X\\ĴuUèlG®ěłTĠğDŃOrÍdÆÍz]±ŭ©Å]ÅÐ}UË¥©TċïxgckfWgi\\ÏĒ¥HkµEë{»ÏetcG±ahUiñiWsɁ·cCÕk]wȑ|ća}wVaĚá G°ùnM¬¯{ÈÐÆA¥ÄêJxÙ¢hP¢ÛºµwWOóFÁz^ÀŗÎú´§¢T¤ǻƺSėǵhÝÅQgvBHouʝl_o¿Ga{ïq{¥|ſĿHĂ÷aĝÇqZñiñC³ª»E`¨åXēÕqÉû[l}ç@čƘóO¿¡FUsAʽīccocÇS}£IS~ălkĩXçmĈŀÐoÐdxÒuL^T{r@¢ÍĝKén£kQyÅõËXŷƏL§~}kq»IHėǅjĝ»ÑÞoå°qTt|r©ÏS¯·eŨĕx«È[eM¿yupN~¹ÏyN£{©għWí»Í¾səšǅ_ÃĀɗ±ąĳĉʍŌŷSÉA±åǥɋ@ë£R©ąP©}ĹªƏj¹erLDĝ·{i«ƫC£µ"]
			],
			"encodeOffsets": [
				[
					[127444, 52594]
				],
				[
					[113793, 40312]
				]
			]
		},
		"properties": {
			"cp": [111.670801, 41.818311],
			"name": "内蒙古",
			"childNum": 2
		}
	}, {
		"id": "210000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@L@@sa"],
				["@@MnNm"],
				["@@dc"],
				["@@eÀC@b"],
				["@@fXwkbrÄ`qg"],
				["@@^jtWQ"],
				["@@~ Y]c"],
				["@@G`ĔN^_¿ZÃM"],
				["@@iX¶BY"],
				["@@YZ"],
				["@@L_{Epf"],
				["@@^WqCT\\"],
				["@@\\[§t|¤_"],
				["@@m`n_"],
				["@@Ïxǌ{q_×^Giip"],
				["@@@é^BntaÊU]x ¯ÄPĲ­°hʙK³VÕ@Y~|EvĹsÇ¦­L^pÃ²ŸÒG Ël]xxÄ_fT¤Ď¤cPC¨¸TVjbgH²sdÎdHt`B²¬GJję¶[ÐhjeXdlwhðSČ¦ªVÊÏÆZÆŶ®²^ÎyÅÎcPqńĚDMħĜŁH­kçvV[ĳ¼WYÀäĦ`XlR`ôLUVfK¢{NZdĒªYĸÌÚJRr¸SA|ƴgŴĴÆbvªØX~źB|¦ÕE¤Ð`\\|KUnnI]¤ÀÂĊnŎR®Ő¿¶\\ÀøíDm¦ÎbŨabaĘ\\ľãÂ¸atÎSƐ´©v\\ÖÚÌǴ¤Â¨JKrZ_ZfjþhPkx`YRIjJcVf~sCN¤ EhæmsHy¨SðÑÌ\\\\ĐRZk°IS§fqŒßýáĞÙÉÖ[^¯ǤŲê´\\¦¬ĆPM¯£»uïpùzExanµyoluqe¦W^£ÊL}ñrkqWňûPUP¡ôJoo·U}£[·¨@XĸDXm­ÛÝºGUCÁª½{íĂ^cjk¶Ã[q¤LÉö³cux«zZf²BWÇ®Yß½ve±ÃCý£W{Ú^q^sÑ·¨ÍOt¹·C¥GDrí@wÕKţÃ«V·i}xËÍ÷i©ĝɝǡ]{c±OW³Ya±_ç©HĕoƫŇqr³Lys[ñ³¯OSďOMisZ±ÅFC¥Pq{Ã[Pg}\\¿ghćOk^ģÁFıĉĥM­oEqqZûěŉ³F¦oĵhÕP{¯~TÍlªNßYÐ{Ps{ÃVUeĎwk±ŉVÓ½ŽJãÇÇ»Jm°dhcÀffdF~ĀeĖd`sx² ®EżĀdQÂd^~ăÔH¦\\LKpĄVez¤NP ǹÓRÆąJSh­a[¦´ÂghwmBÐ¨źhI|VV|p] Â¼èNä¶ÜBÖ¼L`¼bØæKVpoúNZÞÒKxpw|ÊEMnzEQIZZNBčÚFÜçmĩWĪñtÞĵÇñZ«uD±|Əlĳ¥ãn·±PmÍada CLǑkùó¡³Ï«QaċÏOÃ¥ÕđQȥċƭy³ÃA"]
			],
			"encodeOffsets": [
				[
					[123686, 41445]
				],
				[
					[126019, 40435]
				],
				[
					[124393, 40128]
				],
				[
					[126117, 39963]
				],
				[
					[125322, 40140]
				],
				[
					[126686, 40700]
				],
				[
					[126041, 40374]
				],
				[
					[125584, 40168]
				],
				[
					[125453, 40165]
				],
				[
					[125362, 40214]
				],
				[
					[125280, 40291]
				],
				[
					[125774, 39997]
				],
				[
					[125976, 40496]
				],
				[
					[125822, 39993]
				],
				[
					[125509, 40217]
				],
				[
					[122731, 40949]
				]
			]
		},
		"properties": {
			"cp": [123.429096, 41.796767],
			"name": "辽宁",
			"childNum": 16
		}
	}, {
		"id": "220000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@pä³PClFbbÍzwBGĭZÅi»lY­ċ²SgkÇ£^Sqd¯R©é£¯S\\cZ¹iűƏCuƍÓXoR}M^o£R}oªU­FuuXHlEÅÏ©¤ÛmTþ¤D²ÄufàÀ­XXÈ±AeyYw¬dvõ´KÊ£\\rµÄlidā]|î©¾DÂVH¹Þ®ÜWnCķ W§@\\¸~¤Vp¸póIO¢VOŇürXql~òÉK]¤¥Xrfkvzpm¶bwyFoúvð¼¤ N°ąO¥«³[éǡű_°Õ\\ÚÊĝþâőàerR¨­JYlďQ[ ÏYëÐ§TGztnß¡gFkMāGÁ¤ia ÉÈ¹`\\xs¬dĆkNnuNUuP@vRY¾\\¢GªóĄ~RãÖÎĢùđŴÕhQxtcæëSɽŉíëǉ£ƍG£nj°KƘµDsØÑpyĆ¸®¿bXp]vbÍZuĂ{n^IüÀSÖ¦EvRÎûh@â[ƏÈô~FNr¯ôçR±­HÑlĢ^¤¢OðævxsŒ]ÞÁTĠs¶¿âÆGW¾ìA¦·TÑ¬è¥ÏÐJ¨¼ÒÖ¼ƦɄxÊ~StD@Ă¼Ŵ¡jlºWvÐzƦZÐ²CH AxiukdGgetqmcÛ£Ozy¥cE}|¾cZk¿uŐã[oxGikfeäT@SUwpiÚFM©£è^Ú`@v¶eňf heP¶täOlÃUgÞzŸU`l}ÔÆUvØ_Ō¬Öi^ĉi§²ÃB~¡ĈÚEgc|DC_Ȧm²rBx¼MÔ¦ŮdĨÃâYxƘDVÇĺĿg¿cwÅ\\¹¥Yĭl¤OvLjM_a W`zļMž·\\swqÝSAqŚĳ¯°kRē°wx^ĐkǂÒ\\]nrĂ}²ĊŲÒøãh·M{yMzysěnĒġV·°G³¼XÀ¤¹i´o¤ŃÈ`ÌǲÄUĞd\\iÖmÈBĤÜɲDEh LG¾ƀÄ¾{WaYÍÈĢĘÔRîĐj}ÇccjoUb½{h§Ǿ{KƖµÎ÷GĀÖŠåưÎs­lyiē«`å§H¥Ae^§GK}iã\\c]v©ģZmÃ|[M}ģTɟĵÂÂ`ÀçmFK¥ÚíÁbX³ÌQÒHof{]ept·GŋĜYünĎųVY^ydõkÅZW«WUa~U·SbwGçǑiW^qFuNĝ·EwUtW·Ýďæ©PuqEzwAVXRãQ`­©GMehccďÏd©ÑW_ÏYƅ»é\\ɹ~ǙG³mØ©BšuT§Ĥ½¢Ã_Ã½L¡ýqT^rme\\PpZZbyuybQefµ]UhĿDCmûvaÙNSkCwncćfv~YÇG"],
			"encodeOffsets": [
				[130196, 42528]
			]
		},
		"properties": {
			"cp": [125.3245, 43.886841],
			"name": "吉林",
			"childNum": 1
		}
	}, {
		"id": "230000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@ƨĶTLÇyqpÇÛqe{~oyen}s`qiXGù]Ëp½©lÉÁp]Þñ´FĂ^fäîºkàz¼BUvÈ@"],
				["@@UµNÿ¥īèçHÍøƕ¶Lǽ|g¨|a¾pVidd~ÈiíďÓQġėÇZÎXb½|ſÃH½KFgɱCģÛÇAnjÕc[VĝǱÃËÇ_ £ń³pj£º¿»WH´¯U¸đĢmtĜyzzNN|g¸÷äűÑ±ĉā~mq^[ǁÑďlw]¯xQĔ¯l°řĴrBÞTxr[tŽ¸ĻN_yX`biNKuP£kZĮ¦[ºxÆÀdhĹŀUÈƗCwáZħÄŭcÓ¥»NAw±qȥnD`{ChdÙFć}¢A±Äj¨]ĊÕjŋ«×`VuÓÅ~_kŷVÝyhVkÄãPsOµfgeŇµf@u_Ù ÙcªNªÙEojVxT@ãSefjlwH\\pŏäÀvlY½d{F~¦dyz¤PÜndsrhfHcvlwjF£G±DÏƥYyÏu¹XikĿ¦ÏqƗǀOŜ¨LI|FRĂn sª|C˜zxAè¥bfudTrFWÁ¹Am|ĔĕsķÆF´N}ćUÕ@Áĳſmuçuð^ÊýowFzØÎĕNőǏȎôªÌŒǄàĀÄ˄ĞŀƒʀĀƘŸˮȬƬĊ°Uzouxe]}AyÈW¯ÌmKQ]Īºif¸ÄX|sZt|½ÚUÎ lk^p{f¤lºlÆW A²PVÜPHÊâ]ÎĈÌÜk´\\@qàsĔÄQºpRij¼èi`¶bXrBgxfv»uUi^v~J¬mVp´£´VWrnP½ì¢BX¬hðX¹^TjVriªjtŊÄmtPGx¸bgRsT`ZozÆO]ÒFôÒOÆŊvÅpcGêsx´DR{AEOr°x|íb³Wm~DVjºéNNËÜ˛ɶ­GxŷCSt}]ûōSmtuÇÃĕNāg»íT«u}ç½BĵÞʣ¥ëÊ¡MÛ³ãȅ¡ƋaǩÈÉQG¢·lG|tvgrrf«ptęŘnÅĢrI²¯LiØsPf_vĠdxM prʹL¤¤eËÀđKïÙVY§]Ióáĥ]ķK¥j|pŇ\\kzţ¦šnņäÔVĂîĪ¬|vW®l¤èØrxm¶ă~lÄƯĄ̈́öȄEÔ¤ØQĄĄ»ƢjȦOǺ¨ìSŖÆƬyQv`cwZSÌ®ü±Ǆ]ŀç¬B¬©ńzƺŷɄeeOĨSfm ĊƀP̎ēz©ĊÄÕÊmgÇsJ¥ƔŊśæÎÑqv¿íUOµªÂnĦÁ_½ä@êí£P}Ġ[@gġ}gɊ×ûÏWXá¢užƻÌsNÍ½ƎÁ§čŐAēeL³àydl¦ĘVçŁpśǆĽĺſÊQíÜçÛġÔsĕ¬Ǹ¯YßċġHµ ¡eå`ļrĉŘóƢFìĎWøxÊkƈdƬv|I|·©NqńRŀ¤éeŊŀàŀU²ŕƀBQ£Ď}L¹Îk@©ĈuǰųǨÚ§ƈnTËÇéƟÊcfčŤ^XmHĊĕË«W·ċëx³ǔķÐċJāwİ_ĸȀ^ôWr­°oú¬ĦŨK~ȰCĐ´Ƕ£fNÎèâw¢XnŮeÂÆĶ¾¾xäLĴĘlļO¤ÒĨA¢Êɚ¨®ØCÔ ŬGƠƦYĜĘÜƬDJg_ͥœ@čŅĻA¶¯@wÎqC½Ĉ»NăëKďÍQÙƫ[«ÃígßÔÇOÝáWñuZ¯ĥŕā¡ÑķJu¤E å¯°WKÉ±_d_}}vyõu¬ï¹ÓU±½@gÏ¿rÃ½DgCdµ°MFYxw¿CG£Rƛ½Õ{]L§{qqą¿BÇƻğëܭǊË|c²}Fµ}ÙRsÓpg±QNqǫŋRwŕnéÑÉK«SeYRŋ@{¤SJ}D Ûǖ֍]gr¡µŷjqWÛham³~S«Þ]"]
			],
			"encodeOffsets": [
				[
					[127123, 51780]
				],
				[
					[134456, 44547]
				]
			]
		},
		"properties": {
			"cp": [128.642464, 46.756967],
			"name": "黑龙江",
			"childNum": 2
		}
	}, {
		"id": "320000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@cþÅPi`ZRu¥É\\]~°Y`µÓ^phÁbnÀşúòaĬºTÖŒbe¦¦{¸ZâćNp©Hr|^mjhSEb\\afv`sz^lkljÄtg¤D­¾X¿À|ĐiZȀåB·î}GL¢õcßjayBFµÏC^ĭcÙt¿sğH]j{s©HM¢QnDÀ©DaÜÞ·jgàiDbPufjDk`dPOîhw¡ĥ¥GP²ĐobºrYî¶aHŢ´ ]´rılw³r_{£DB_Ûdåuk|Ũ¯F Cºyr{XFye³Þċ¿ÂkĭB¿MvÛpm`rÚã@Ę¹hågËÖƿxnlč¶Åì½Ot¾dJlVJĂǀŞqvnO^JZż·Q}êÍÅmµÒ]ƍ¦Dq}¬R^èĂ´ŀĻĊIÔtĲyQŐĠMNtR®òLhĚs©»}OÓGZz¶A\\jĨFäOĤHYJvÞHNiÜaĎÉnFQlNM¤B´ĄNöɂtpŬdfåqm¿QûùŞÚb¤uŃJŴu»¹ĄlȖħŴw̌ŵ²ǹǠ͛hĭłƕrçü±Yxcitğ®jű¢KOķCoy`å®VTa­_Ā]ŐÝɞï²ʯÊ^]afYǸÃĆēĪȣJđ͍ôƋÄÄÍīçÛɈǥ£­ÛmY`ó£Z«§°Ó³QafusNıǅ_k}¢m[ÝóDµ¡RLčiXyÅNïă¡¸iĔÏNÌŕoēdōîåŤûHcs}~Ûwbù¹£¦ÓCtOPrE^ÒogĉIµÛÅʹK¤½phMü`oæŀ"],
			"encodeOffsets": [
				[121740, 32276]
			]
		},
		"properties": {
			"cp": [119.767413, 33.041544],
			"name": "江苏",
			"childNum": 1
		}
	}, {
		"id": "330000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@E^dQ]K"],
				["@@jX^j"],
				["@@sfbU"],
				["@@qP\\xz[ck"],
				["@@R¢FX}°[s_"],
				["@@Cb\\}"],
				["@@e|v\\la{u"],
				["@@v~u}"],
				["@@QxÂF¯}"],
				["@@¹nvÞs¯o"],
				["@@rSkUEj"],
				["@@bi­ZP"],
				["@@p[}INf"],
				["@@À¿"],
				["@@¹dnb"],
				["@@rSBnR"],
				["@@g~h}"],
				["@@FlEk"],
				["@@OdPc"],
				["@@v[u\\"],
				["@@FjâL~wyoo~sµL\\"],
				["@@¬e¹aN"],
				["@@\\nÔ¡q]L³ë\\ÿ®QÖ"],
				["@@ÊA­©[¬"],
				["@@Kxv­"],
				["@@@hlIk]"],
				["@@pW{o||j"],
				["@@Md|_mC"],
				["@@¢X£ÏylD¼XtH"],
				["@@hlÜ[LykAvyfw^E¤"],
				["@@fp¤MusR"],
				["@@®_ma~LÁ¬Z"],
				["@@iMxZ"],
				["@@ZcYd"],
				["@@Z~dOSo|A¿qZv"],
				["@@@`EN¡v"],
				["@@|TY{"],
				["@@@n@m"],
				["@@XWkCT\\"],
				["@@ºwZRkĕWO¢"],
				["@@X®±GrÆª\\ÔáXq{"],
				["@@ůTG°ĄLHm°UC"],
				["@@¤aÜx~}dtüGæţŎíĔcŖpMËÐjē¢·ðĄÆMzjWKĎ¢Q¶À_ê_Bıi«pZgf¤Nrq]§ĂN®«H±yƳí¾×ŸīàLłčŴǝĂíÀBŖÕªÁŖHŗŉåqûõi¨hÜ·ñt»¹ýv_[«¸mYL¯QªmĉÅdMgÇjcº«ę¬­K­´B«Âącoċ\\xKd¡gěŧ«®á[~ıxu·ÅKsËÉc¢Ù\\ĭƛëbf¹­ģSĜkáƉÔ­ĈZB{aMµfzŉfåÂŧįƋǝÊĕġć£g³ne­ą»@­¦S®\\ßðChiqªĭiAuA­µ_W¥ƣO\\lċĢttC¨£t`PZäuXßBsĻyekOđġĵHuXBµ]×­­\\°®¬F¢¾pµ¼kŘó¬Wät¸|@L¨¸µrºù³Ù~§WIZW®±Ð¨ÒÉx`²pĜrOògtÁZ}þÙ]¡FKwsPlU[}¦Rvn`hq¬\\nQ´ĘRWb_ rtČFIÖkĦPJ¶ÖÀÖJĈĄTĚòC ²@PúØz©Pî¢£CÈÚĒ±hŖl¬â~nm¨f©iļ«mntuÖZÜÄjL®EÌFª²iÊxØ¨IÈhhst"],
				["@@o\\VzRZ}y"],
				["@@@°¡mÛGĕ¨§Ianá[ýƤjfæØLäGr"]
			],
			"encodeOffsets": [
				[
					[125592, 31553]
				],
				[
					[125785, 31436]
				],
				[
					[125729, 31431]
				],
				[
					[125513, 31380]
				],
				[
					[125223, 30438]
				],
				[
					[125115, 30114]
				],
				[
					[124815, 29155]
				],
				[
					[124419, 28746]
				],
				[
					[124095, 28635]
				],
				[
					[124005, 28609]
				],
				[
					[125000, 30713]
				],
				[
					[125111, 30698]
				],
				[
					[125078, 30682]
				],
				[
					[125150, 30684]
				],
				[
					[124014, 28103]
				],
				[
					[125008, 31331]
				],
				[
					[125411, 31468]
				],
				[
					[125329, 31479]
				],
				[
					[125626, 30916]
				],
				[
					[125417, 30956]
				],
				[
					[125254, 30976]
				],
				[
					[125199, 30997]
				],
				[
					[125095, 31058]
				],
				[
					[125083, 30915]
				],
				[
					[124885, 31015]
				],
				[
					[125218, 30798]
				],
				[
					[124867, 30838]
				],
				[
					[124755, 30788]
				],
				[
					[124802, 30809]
				],
				[
					[125267, 30657]
				],
				[
					[125218, 30578]
				],
				[
					[125200, 30562]
				],
				[
					[124968, 30474]
				],
				[
					[125167, 30396]
				],
				[
					[124955, 29879]
				],
				[
					[124714, 29781]
				],
				[
					[124762, 29462]
				],
				[
					[124325, 28754]
				],
				[
					[123990, 28459]
				],
				[
					[125366, 31477]
				],
				[
					[125115, 30363]
				],
				[
					[125369, 31139]
				],
				[
					[122495, 31878]
				],
				[
					[125329, 30690]
				],
				[
					[125192, 30787]
				]
			]
		},
		"properties": {
			"cp": [120.153576, 29.287459],
			"name": "浙江",
			"childNum": 45
		}
	}, {
		"id": "340000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@^iuLX^"],
				["@@e©Ehl"],
				["@@°ZÆëĎµmkǀwÌÕæhºgBĝâqÙĊzÖgņtÀÁĂÆáhEz|WzqD¹°Eŧl{ævÜcA`¤C`|´qxĲkq^³³GšµbíZ¹qpa±ď OH¦Ħx¢gPícOl_iCveaOjChß¸iÝbÛªCC¿mRV§¢A|t^iĠGÀtÚsd]ĮÐDE¶zAb àiödK¡~H¸íæAǿYj{ď¿À½W®£ChÃsikkly]_teu[bFaTign{]GqªoĈMYá|·¥f¥őaSÕėNµñĞ«Im_m¿Âa]uĜp Z_§{Cäg¤°r[_YjÆOdý[I[á·¥Q_nùgL¾mvˊBÜÆ¶ĊJhpc¹O]iŠ]¥ jtsggJÇ§w×jÉ©±EFË­KiÛÃÕYvsm¬njĻª§emná}k«ŕgđ²ÙDÇ¤í¡ªOy×Où±@DñSęćăÕIÕ¿IµĥOjNÕËT¡¿tNæŇàåyķrĕq§ÄĩsWÆßF¶X®¿mwRIÞfßoG³¾©uyHį{Ɓħ¯AFnuPÍÔzVdàôº^Ðæd´oG¤{S¬ćxã}ŧ×Kǥĩ«ÕOEÐ·ÖdÖsƘÑ¨[Û^Xr¢¼§xvÄÆµ`K§ tÒ´Cvlo¸fzŨð¾NY´ı~ÉĔēßúLÃÃ_ÈÏ|]ÂÏFlg`ben¾¢pUh~ƴĖ¶_r sĄ~cƈ]|r c~`¼{À{ȒiJjz`îÀT¥Û³]u}fïQl{skloNdjäËzDvčoQďHI¦rbtHĔ~BmlRV_ħTLnñH±DL¼Lªl§Ťa¸ĚlK²\\RòvDcÎJbt[¤D@®hh~kt°ǾzÖ@¾ªdbYhüóZ ň¶vHrľ\\ÊJuxAT|dmÀO[ÃÔG·ĚąĐlŪÚpSJ¨ĸLvÞcPæķŨ®mÐálwKhïgA¢ųÆ©Þ¤OÈm°K´"]
			],
			"encodeOffsets": [
				[
					[121722, 32278]
				],
				[
					[119475, 30423]
				],
				[
					[119168, 35472]
				]
			]
		},
		"properties": {
			"cp": [117.283042, 31.26119],
			"name": "安徽",
			"childNum": 3
		}
	}, {
		"id": "350000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@zht´]"],
				["@@aj^~ĆG©O"],
				["@@ed¨C}}i"],
				["@@@vPGsQ"],
				["@@sBzddW]Q"],
				["@@S¨Q{"],
				["@@NVucW"],
				["@@qptBAq"],
				["@@¸[mu"],
				["@@Q\\pD]_"],
				["@@jSwUadpF"],
				["@@eXª~"],
				["@@AjvFso"],
				["@@fT_Çí\\v|ba¦jZÆy°"],
				["@@IjJi"],
				["@@wJIx«¼AoNe{M­"],
				["@@K±¡ÓČäeZ"],
				["@@k¡¹Eh~c®wBkUplÀ¡I~Māe£bN¨gZý¡a±Öcp©PhI¢QqÇGj|¥U g[Ky¬ŏv@OptÉEF\\@ åA¬V{XģĐBycpě¼³Ăp·¤¥ohqqÚ¡ŅLs^Ã¡§qlÀhH¨MCe»åÇGD¥zPO£čÙkJA¼ßėuĕeûÒiÁŧSW¥Qûŗ½ùěcÝ§SùĩąSWó«íęACµeRåǃRCÒÇZÍ¢ź±^dlstjD¸ZpuÔâÃH¾oLUêÃÔjjēò´ĄWƛ^Ñ¥Ħ@ÇòmOw¡õyJyD}¢ďÑÈġfZda©º²z£NjD°Ötj¶¬ZSÎ~¾c°¶ÐmxO¸¢Pl´SL|¥AȪĖMņĲg®áIJČĒü` QF¬h|ĂJ@zµ |ê³È ¸UÖŬŬÀEttĸr]ðM¤ĶĲHtÏ AĬkvsq^aÎbvdfÊòSD´Z^xPsĂrvƞŀjJd×ŘÉ ®AÎ¦ĤdxĆqAZRÀMźnĊ»İÐZ YXæJyĊ²·¶q§·K@·{sXãô«lŗ¶»o½E¡­«¢±¨Y®Ø¶^AvWĶGĒĢPlzfļtàAvWYãO_¤sD§ssČġ[kƤPX¦`¶®BBvĪjv©jx[L¥àï[F¼ÍË»ğV`«Ip}ccÅĥZEãoP´B@D¸m±z«Ƴ¿å³BRØ¶Wlâþäą`]Z£Tc ĹGµ¶Hm@_©k¾xĨôȉðX«½đCIbćqK³ÁÄš¬OAwã»aLŉËĥW[ÂGIÂNxĳ¤D¢îĎÎB§°_JGs¥E@¤ućPåcuMuw¢BI¿]zG¹guĮck\\_"]
			],
			"encodeOffsets": [
				[
					[123250, 27563]
				],
				[
					[122541, 27268]
				],
				[
					[123020, 27189]
				],
				[
					[122916, 27125]
				],
				[
					[122887, 26845]
				],
				[
					[122808, 26762]
				],
				[
					[122568, 25912]
				],
				[
					[122778, 26197]
				],
				[
					[122515, 26757]
				],
				[
					[122816, 26587]
				],
				[
					[123388, 27005]
				],
				[
					[122450, 26243]
				],
				[
					[122578, 25962]
				],
				[
					[121255, 25103]
				],
				[
					[120987, 24903]
				],
				[
					[122339, 25802]
				],
				[
					[121042, 25093]
				],
				[
					[122439, 26024]
				]
			]
		},
		"properties": {
			"cp": [118.306239, 26.075302],
			"name": "福建",
			"childNum": 18
		}
	}, {
		"id": "360000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ĢĨƐgļ¼ÂMD~ņªe^\\^§ý©j×cZØ¨zdÒa¶lÒJìõ`oz÷@¤uŞ¸´ôęöY¼HČƶajlÞƩ¥éZ[|h}^U  ¥pĄžƦO lt¸Æ Q\\aÆ|CnÂOjt­ĚĤdÈF`¶@Ðë ¦ōÒ¨SêvHĢûXD®QgÄWiØPÞìºr¤ǆNĠ¢lĄtZoCƞÔºCxrpĠV®Ê{f_Y`_eq®Aot`@oDXfkp¨|s¬\\DÄSfè©Hn¬^DhÆyøJhØxĢĀLÊƠPżċĄwȠĚ¦G®ǒĤäTŠÆ~Ħw«|TF¡nc³Ïå¹]ĉđxe{ÎÓvOEm°BƂĨİ|Gvz½ª´HàpeJÝQxnÀW­EµàXÅĪt¨ÃĖrÄwÀFÎ|ňÓMå¼ibµ¯»åDT±m[r«_gmQu~¥V\\OkxtL E¢Ú^~ýêPóqoě±_Êw§ÑªåƗā¼mĉŹ¿NQYBąrwģcÍ¥B­ŗÊcØiIƝĿuqtāwO]³YCñTeÉcaubÍ]trluīBÐGsĵıN£ï^ķqss¿FūūVÕ·´Ç{éĈýÿOER_đûIċâJh­ŅıNȩĕB¦K{Tk³¡OP·wnµÏd¯}½TÍ«YiµÕsC¯iM¤­¦¯P|ÿUHvhe¥oFTuõ\\OSsMòđƇiaºćXĊĵà·çhƃ÷Ç{ígu^đgm[×zkKN¶Õ»lčÓ{XSÆv©_ÈëJbVkĔVÀ¤P¾ºÈMÖxlò~ªÚàGĂ¢B±ÌKyáV¼Ã~­`gsÙfIƋlę¹e|~udjuTlXµf`¿Jd[\\L²"],
			"encodeOffsets": [
				[116689, 26234]
			]
		},
		"properties": {
			"cp": [115.592151, 27.676493],
			"name": "江西",
			"childNum": 1
		}
	}, {
		"id": "370000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@Xjd]{K"],
				["@@itbFHy"],
				["@@HlGk"],
				["@@TGy"],
				["@@K¬U"],
				["@@WdXc"],
				["@@PtOs"],
				["@@LnXhc"],
				["@@ppVu]Or"],
				["@@cdzAUa"],
				["@@udRhnCI"],
				["@@oIpR"],
				["@@Ľč{fzƤîKÎMĮ]ZF½Y]â£ph¶¨râøÀÎǨ¤^ºÄGz~grĚĜlĞÆLĆǆ¢Îo¦cvKbgr°WhmZp L]LºcUÆ­nżĤÌĒbAnrOA´ȊcÀbƦUØrĆUÜøĬƞEzVL®öØBkŖÝĐĖ¹ŧ̄±ÀbÎÉnb²ĦhņBĖįĦåXćì@L¯´ywƕCéÃµė ƿ¸lµ¾Z|ZWyFY¨Mf~C¿`à_RÇzwƌfQnny´INoƬèôº|sTJULîVjǎ¾ĒØDz²XPn±ŴPè¸ŔLƔÜƺ_TüÃĤBBċÈöA´faM¨{«M`¶d¡ôÖ°mȰBÔjj´PM|c^d¤u¤Û´ä«ƢfPk¶Môl]Lb}su^ke{lCMrDÇ­]NÑFsmoõľHyGă{{çrnÓEƕZGª¹Fj¢ïWuøCǷë¡ąuhÛ¡^KxC`C\\bÅxì²ĝÝ¿_NīCȽĿåB¥¢·IŖÕy\\¹kxÃ£Č×GDyÃ¤ÁçFQ¡KtŵƋ]CgÏAùSedcÚźuYfyMmhUWpSyGwMPqŀÁ¼zK¶G­Y§Ë@´śÇµƕBm@IogZ¯uTMx}CVKï{éƵP_K«pÛÙqċtkkù]gTğwoɁsMõ³ăAN£MRkmEÊčÛbMjÝGuIZGPģãħE[iµBEuDPÔ~ª¼ęt]ûG§¡QMsğNPŏįzs£Ug{đJĿļā³]ç«Qr~¥CƎÑ^n¶ÆéÎR~Ż¸YI] PumŝrƿIā[xeÇ³L¯v¯s¬ÁY~}ťuŁgƋpÝĄ_ņī¶ÏSR´ÁP~¿Cyċßdwk´SsX|t`Ä ÈðAªìÎT°¦Dda^lĎDĶÚY°`ĪŴǒàŠv\\ebZHŖR¬ŢƱùęOÑM­³FÛWp["]
			],
			"encodeOffsets": [
				[
					[123806, 39303]
				],
				[
					[123821, 39266]
				],
				[
					[123742, 39256]
				],
				[
					[123702, 39203]
				],
				[
					[123649, 39066]
				],
				[
					[123847, 38933]
				],
				[
					[123580, 38839]
				],
				[
					[123894, 37288]
				],
				[
					[123043, 36624]
				],
				[
					[123344, 38676]
				],
				[
					[123522, 38857]
				],
				[
					[123628, 38858]
				],
				[
					[118260, 36742]
				]
			]
		},
		"properties": {
			"cp": [118.000923, 36.275807],
			"name": "山东",
			"childNum": 13
		}
	}, {
		"id": "410000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ýLùµP³swIÓxcŢĞð´E®ÚPtĴXØxÂ¶@«ŕŕQGYfa[şußǩđš_X³ĳÕčC]kbc¥CS¯ëÍB©÷³­Si_}mYTt³xlàcČzÀD}ÂOQ³ÐTĨ¯ƗòËŖ[hłŦv~}ÂZ«¤lPÇ£ªÝŴÅR§ØnhctâknÏ­ľŹUÓÝdKuķI§oTũÙďkęĆH¸Ó\\Ä¿PcnS{wBIvÉĽ[GqµuŇôYgûZca©@½Õǽys¯}lgg@­C\\£asIdÍuCQñ[L±ęk·ţb¨©kK»KC²òGKmĨS`UQnk}AGēsqaJ¥ĐGRĎpCuÌy ã iMcplk|tRkðev~^´¦ÜSí¿_iyjI|ȑ|¿_»d}q^{Ƈdă}tqµ`Ƴĕg}V¡om½faÇo³TTj¥tĠRyK{ùÓjuµ{t}uËRivGçJFjµÍyqÎàQÂFewixGw½Yŷpµú³XU½ġyłåkÚwZX·l¢Á¢KzOÎÎjc¼htoDHr|­J½}JZ_¯iPq{tę½ĕ¦Zpĵø«kQĹ¤]MÛfaQpě±ǽ¾]u­Fu÷nčÄ¯ADp}AjmcEÇaª³o³ÆÍSƇĈÙDIzËčľ^KLiÞñ[aA²zzÌ÷D|[íÄ³gfÕÞd®|`Ć~oĠƑô³ŊD×°¯CsøÀ«ìUMhTº¨¸ǡîSÔDruÂÇZÖEvPZW~ØÐtĄE¢¦Ðy¸bô´oŬ¬²Ês~]®tªapŎJ¨Öº_Ŕ`Ŗ^Đ\\Ĝu~m²Ƹ¸fWĦrƔ}Î^gjdfÔ¡J}\\n C¦þWxªJRÔŠu¬ĨĨmFdM{\\d\\YÊ¢ú@@¦ª²SÜsC}fNècbpRmlØ^gd¢aÒ¢CZZxvÆ¶N¿¢T@uC¬^ĊðÄn|lGlRjsp¢ED}Fio~ÔN~zkĘHVsǲßjŬŢ`Pûàl¢\\ÀEhİgÞē X¼Pk|m"],
			"encodeOffsets": [
				[118256, 37017]
			]
		},
		"properties": {
			"cp": [113.665412, 33.757975],
			"name": "河南",
			"childNum": 1
		}
	}, {
		"id": "420000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@AB"],
				["@@lskt"],
				["@@¾«}{ra®pîÃ\\{øCËyyB±b\\òÝjKL ]ĎĽÌJyÚCƈćÎT´Å´pb©ÈdFin~BCo°BĎÃømv®E^vǾ½Ĝ²RobÜeN^ĺ£R¬lĶ÷YoĖ¥Ě¾|sOr°jY`~I¾®I{GqpCgyl{£ÍÍyPLÂ¡¡¸kWxYlÙæŁĢz¾V´W¶ùŸo¾ZHxjwfxGNÁ³Xéæl¶EièIH ujÌQ~v|sv¶Ôi|ú¢FhQsğ¦SiŠBgÐE^ÁÐ{čnOÂÈUÎóĔÊēĲ}Z³½Mŧïeyp·uk³DsÑ¨L¶_ÅuÃ¨w»¡WqÜ]\\Ò§tƗcÕ¸ÕFÏǝĉăxŻČƟOKÉġÿ×wg÷IÅzCg]m«ªGeçÃTC«[t§{loWeC@ps_Bp­rf_``Z|ei¡oċMqow¹DƝÓDYpûsYkıǃ}s¥ç³[§cY§HK«Qy]¢wwö¸ïx¼ņ¾Xv®ÇÀµRĠÐHM±cÏdƒǍũȅȷ±DSyúĝ£ŤĀàtÖÿï[îb\\}pĭÉI±Ñy¿³x¯No|¹HÏÛmjúË~TuęjCöAwě¬Rđl¯ Ñb­ŇTĿ_[IčĄʿnM¦ğ\\É[T·k¹©oĕ@A¾wya¥Y\\¥Âaz¯ãÁ¡k¥ne£ÛwE©Êō¶˓uoj_U¡cF¹­[WvP©whuÕyBF`RqJUw\\i¡{jEPïÿ½fćQÑÀQ{°fLÔ~wXgītêÝ¾ĺHd³fJd]HJ²EoU¥HhwQsƐ»Xmg±çve]DmÍPoCc¾_hhøYrŊU¶eD°Č_N~øĹĚ·`z]Äþp¼äÌQv\\rCé¾TnkžŐÚÜa¼ÝƆĢ¶ÛodĔňÐ¢JqPb ¾|J¾fXƐîĨ_Z¯À}úƲN_ĒÄ^ĈaŐyp»CÇÄKñL³ġM²wrIÒŭxjb[n«øæà ^²­h¯ÚŐªÞ¸Y²ĒVø}Ā^İ´LÚm¥ÀJÞ{JVųÞŃx×sxxƈē ģMřÚðòIfĊŒ\\Ʈ±ŒdÊ§ĘDvČ_Àæ~Dċ´A®µ¨ØLV¦êHÒ¤"]
			],
			"encodeOffsets": [
				[
					[113712, 34000]
				],
				[
					[115612, 30507]
				],
				[
					[113649, 34054]
				]
			]
		},
		"properties": {
			"cp": [113.298572, 30.684355],
			"name": "湖北",
			"childNum": 3
		}
	}, {
		"id": "430000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@nFTs"],
				["@@ßÅÆá½ÔXrCOËRïÿĩ­TooQyÓ[ŅBE¬ÎÓXaį§Ã¸G °ITxpúxÚĳ¥ÏĢ¾edÄ©ĸGàGhM¤Â_U}Ċ}¢pczfþg¤ÇòAVM"],
				["@@©KA·³CQ±Á«³BUƑ¹AtćOwD]JiØSm¯b£ylXHËÑ±H«C^õľAÅ§¤É¥ïyuǙuA¢^{ÌC´­¦ŷJ£^[ª¿ĕ~ƇN skóā¹¿ï]ă~÷O§­@Vm¡Qđ¦¢Ĥ{ºjÔª¥nf´~Õo×ÛąMąıuZmZcÒ ĲĪ²SÊǄŶ¨ƚCÖŎªQØ¼rŭ­«}NÏürÊ¬mjr@ĘrTW ­SsdHzƓ^ÇÂyUi¯DÅYlŹu{hT}mĉ¹¥ěDÿë©ıÓ[Oº£¥ótł¹MÕƪ`PDiÛU¾ÅâìUñBÈ£ýhedy¡oċ`pfmjP~kZaZsÐd°wj§@Ĵ®w~^kÀÅKvNmX\\¨aŃqvíó¿F¤¡@ũÑVw}S@j}¾«pĂrªg àÀ²NJ¶¶DôK|^ª°LX¾ŴäPĪ±£EXd^¶ĲÞÜ~u¸ǔMRhsRe`ÄofIÔ\\Ø  ićymnú¨cj ¢»GČìƊÿÐ¨XeĈĀ¾Oð Fi ¢|[jVxrIQ_EzAN¦zLU`cªxOTu RLÄ¢dVi`p˔vŎµªÉF~Ød¢ºgİàw¸Áb[¦Zb¦z½xBĖ@ªpºlS¸Ö\\Ĕ[N¥ˀmĎăJ\\ŀ`ňSÚĖÁĐiOĜ«BxDõĚivSÌ}iùÜnÐºG{p°M´wÀÒzJ²ò¨ oTçüöoÛÿñőĞ¤ùTz²CȆȸǎŪƑÐc°dPÎğË¶[È½u¯½WM¡­ÉB·rínZÒ `¨GA¾\\pēXhÃRC­üWGġuTé§ŎÑ©ò³I±³}_EÃħg®ęisÁPDmÅ{b[RÅs·kPŽƥóRoOV~]{g\\êYƪ¦kÝbiċƵGZ»Ěõó·³vŝ£ø@pyö_ëIkÑµbcÑ§y×dYØªiþ¨[]f]Ņ©C}ÁN»hĻħƏĩ"]
			],
			"encodeOffsets": [
				[
					[115640, 30489]
				],
				[
					[112543, 27312]
				],
				[
					[116690, 26230]
				]
			]
		},
		"properties": {
			"cp": [111.782279, 28.09409],
			"name": "湖南",
			"childNum": 3
		}
	}, {
		"id": "440000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@QdAua"],
				["@@lxDLo"],
				["@@sbhNLo"],
				["@@Ă ā"],
				["@@WltO[["],
				["@@Kr]S"],
				["@@eI]y"],
				["@@I|Mym"],
				["@@Û³LS¼Y"],
				["@@nvºBëui©`¾"],
				["@@zdÛJw®"],
				["@@°¯"],
				["@@a yAª¸ËJIxØ@ĀHAmÃV¡ofuo"],
				["@@sŗÃÔėAƁZÄ ~°ČPäh"],
				["@@¶ÝÌvmĞh­ıQ"],
				["@@HdSjĒ¢D}waru«ZqadYM"],
				["@@el\\LqqU"],
				["@@~rMo\\"],
				["@@f^C"],
				["@@øPªoj÷ÍÝħXČx°Q¨ıXNv"],
				["@@gÇƳo[~tly"],
				["@@EÆC¿"],
				["@@OP"],
				["@@wđógĝ[³¡VÙæÅöMÌ³¹pÁaËýý©D©ÜJŹƕģGą¤{ÙūÇO²«BƱéAÒĥ¡«BhlmtÃPµyU¯ucd·w_bŝcīímGO|KPȏŹãŝIŕŭŕ@Óoo¿ē±ß}ŭĲWÈCőâUâǙIğŉ©IĳE×Á³AówXJþ±ÌÜÓĨ£L]ĈÙƺZǾĆĖMĸĤfÎĵlŨnÈĐtFFĤêk¶^k°f¶g}®Faf`vXŲxl¦ÔÁ²¬Ð¦pqÊÌ²iXØRDÎ}Ä@ZĠsx®AR~®ETtĄZƈfŠŠHâÒÐAµ\\S¸^wĖkRzalŜ|E¨ÈNĀňZTpBh£\\ĎƀuXĖtKL¶G|»ĺEļĞ~ÜĢÛĊrOÙîvd]n¬VÊĜ°RÖpMƂªFbwEÀ©\\¤]ŸI®¥D³|Ë]CöAŤ¦æ´¥¸Lv¼¢ĽBaôF~®²GÌÒEYzk¤°ahlVÕI^CxĈPsBƒºV¸@¾ªR²ĨN]´_eavSivc}p}Đ¼ƌkJÚe th_¸ ºx±ò_xNË²@ă¡ßH©Ùñ}wkNÕ¹ÇO½¿£ĕ]ly_WìIÇª`uTÅxYĒÖ¼kÖµMjJÚwn\\hĒv]îh|ÈƄøèg¸Ķß ĉĈWb¹ƀdéĘNTtP[öSvrCZaGubo´ŖÒÇĐ~¡zCIözx¢PnÈñ @ĥÒ¦]ƞV}³ăĔñiiÄÓVépKG½ÄÓávYoC·sitiaÀyŧÎ¡ÈYDÑům}ý|m[węõĉZÅxUO}÷N¹³ĉo_qtăqwµŁYÙǝŕ¹tïÛUÃ¯mRCºĭ|µÕÊK½Rē ó]GªęAx»HO£|ām¡diď×YïYWªŉOeÚtĐ«zđ¹TāúEá²\\ķÍ}jYàÙÆſ¿Çdğ·ùTßÇţʄ¡XgWÀǇğ·¿ÃOj YÇ÷Qěi"]
			],
			"encodeOffsets": [
				[
					[117381, 22988]
				],
				[
					[116552, 22934]
				],
				[
					[116790, 22617]
				],
				[
					[116973, 22545]
				],
				[
					[116444, 22536]
				],
				[
					[116931, 22515]
				],
				[
					[116496, 22490]
				],
				[
					[116453, 22449]
				],
				[
					[113301, 21439]
				],
				[
					[118726, 21604]
				],
				[
					[118709, 21486]
				],
				[
					[113210, 20816]
				],
				[
					[115482, 22082]
				],
				[
					[113171, 21585]
				],
				[
					[113199, 21590]
				],
				[
					[115232, 22102]
				],
				[
					[115739, 22373]
				],
				[
					[115134, 22184]
				],
				[
					[113056, 21175]
				],
				[
					[119573, 21271]
				],
				[
					[119957, 24020]
				],
				[
					[115859, 22356]
				],
				[
					[116561, 22649]
				],
				[
					[116285, 22746]
				]
			]
		},
		"properties": {
			"cp": [113.280637, 23.125178],
			"name": "广东",
			"childNum": 24
		}
	}, {
		"id": "450000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@H TQ§A"],
				["@@ĨÊªLƊDÎĹĐCǦė¸zÚGn£¾rªŀÜt¬@ÖÚSx~øOŒŶÐÂæȠ\\ÈÜObĖw^oÞLf¬°bI lTØBÌF£Ć¹gñĤaYt¿¤VSñK¸¤nM¼JE±½¸ñoÜCƆæĪ^ĚQÖ¦^f´QüÜÊz¯lzUĺš@ìp¶n]sxtx¶@~ÒĂJb©gk{°~c°`Ô¬rV\\la¼¤ôá`¯¹LCÆbxEræOv[H­[~|aB£ÖsºdAĐzNÂðsÞÆĤªbab`ho¡³F«èVlo¤ÔRzpp®SĪº¨ÖºNĳd`a¦¤F³ºDÎńĀìCĜº¦Ċ~nS|gźvZkCÆj°zVÈÁƔ]LÊFZgčP­kini«qÇczÍY®¬Ů»qR×ō©DÕ§ƙǃŵTÉĩ±ıdÑnYYĲvNĆĆØÜ Öp}e³¦m©iÓ|¹ħņ|ª¦QF¢Â¬ʖovg¿em^ucà÷gÕuíÙćĝ}FĻ¼Ĺ{µHKsLSđƃrč¤[AgoSŇYMÿ§Ç{FśbkylQxĕ]T·¶[BÑÏGáşşƇeăYSs­FQ}­BwtYğÃ@~CÍQ ×WjË±rÉ¥oÏ ±«ÓÂ¥kwWűmcih³K~µh¯e]lµélEģEďsmÇŧē`ãògK_ÛsUʝćğ¶höO¤Ǜn³c`¡y¦CezYwa[ďĵűMę§]XÎ_íÛ]éÛUćİÕBƣ±dy¹T^dûÅÑŦ·PĻþÙ`K¦¢ÍeĥR¿³£[~äu¼dltW¸oRM¢ď\\z}Æzdvň{ÎXF¶°Â_ÒÂÏL©ÖTmu¼ãlīkiqéfA·Êµ\\őDc¥ÝFyÔćcűH_hLÜêĺĐ¨c}rn`½Ì@¸¶ªVLhŒ\\Ţĺk~Ġið°|gtTĭĸ^xvKVGréAébUuMJVÃO¡qĂXËSģãlýà_juYÛÒBG^éÖ¶§EGÅzěƯ¤EkN[kdåucé¬dnYpAyČ{`]þ¯TbÜÈk¡ĠvàhÂƄ¢Jî¶²"]
			],
			"encodeOffsets": [
				[
					[111707, 21520]
				],
				[
					[107619, 25527]
				]
			]
		},
		"properties": {
			"cp": [108.320004, 22.82402],
			"name": "广西",
			"childNum": 2
		}
	}, {
		"id": "460000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@¦Ŝil¢XƦƞòïè§ŞCêɕrŧůÇąĻõ·ĉ³œ̅kÇm@ċȧŧĥĽʉ­ƅſȓÒË¦ŝE}ºƑ[ÍĜȋ gÎfǐÏĤ¨êƺ\\Ɔ¸ĠĎvʄȀÐ¾jNðĀÒRZǆzÐŘÎ°H¨Ƣb²_Ġ "],
			"encodeOffsets": [
				[112750, 20508]
			]
		},
		"properties": {
			"cp": [109.83119, 19.031971],
			"name": "海南",
			"childNum": 1
		}
	}, {
		"id": "510000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@LqKr"],
				["@@[ĻéV£_ţġñpG réÏ·~ąSfy×Í·ºſƽiÍıƣıĻmHH}siaX@iÇ°ÁÃ×t«­T¤JJJyJÈ`Ohß¦¡uËhIyCjmÿwZGTiSsOB²fNmsPa{M{õE^Hj}gYpaeu¯oáwHjÁ½M¡pMuåmni{fk\\oÎqCwEZ¼KĝAy{m÷LwO×SimRI¯rKõBS«sFe]fµ¢óY_ÆPRcue°Cbo×bd£ŌIHgtrnyPt¦foaXďxlBowz_{ÊéWiêEGhÜ¸ºuFĈIxf®Y½ĀǙ]¤EyF²ċw¸¿@g¢§RGv»áW`ÃĵJwi]t¥wO­½a[×]`Ãi­üL¦LabbTÀåc}ÍhÆh®BHî|îºÉk­¤Sy£ia©taį·Ɖ`ō¥UhOĝLk}©Fos´JmµlŁuønÑJWÎªYÀïAetTŅÓGË«bo{ıwodƟ½OġÜÂµxàNÖ¾P²§HKv¾]|BÆåoZ`¡Ø`ÀmºĠ~ÌÐ§nÇ¿¤]wğ@srğu~Io[é±¹ ¿ſđÓ@qg¹zƱřaí°KtÇ¤V»Ã[ĩǭƑ^ÇÓ@áťsZÏÅĭƋěpwDóÖáŻneQËq·GCœýS]x·ýq³OÕ¶Qzßti{řáÍÇWŝŭñzÇWpç¿JXĩè½cFÂLiVjx}\\NŇĖ¥GeJA¼ÄHfÈu~¸Æ«dE³ÉMA|bÒćhG¬CMõƤąAvüVéŀ_VÌ³ĐwQj´·ZeÈÁ¨X´Æ¡Qu·»ÕZ³ġqDoy`L¬gdp°şp¦ėìÅĮZ°Iähzĵf²å ĚÑKpIN|Ñz]ń·FU×é»R³MÉ»GM«kiér}Ã`¹ăÞmÈnÁîRǀ³ĜoİzŔwǶVÚ£À]ɜ»ĆlƂ²ĠþTº·àUȞÏʦ¶I«dĽĢdĬ¿»Ĕ×h\\c¬ä²GêëĤł¥ÀǿżÃÆMº}BÕĢyFVvwxBèĻĒ©ĈtCĢɽŠȣ¦āæ·HĽîôNÔ~^¤Ɗu^s¼{TA¼ø°¢İªDè¾Ň¶ÝJ®Z´ğ~Sn|ªWÚ©òzPOȸbð¢|øĞŒQìÛÐ@ĞǎRS¤Á§di´ezÝúØã]HqkIþËQÇ¦ÃsÇ¤[E¬ÉŪÍxXƒ·ÖƁİlƞ¹ª¹|XÊwnÆƄmÀêErĒtD®ċæcQE®³^ĭ¥©l}äQtoŖÜqÆkµªÔĻĴ¡@Ċ°B²Èw^^RsºTĀ£ŚæQPJvÄz^Đ¹Æ¯fLà´GC²dt­ĀRt¼¤ĦOðğfÔðDŨŁĞƘïPÈ®âbMüÀXZ ¸£@Å»»QÉ­]dsÖ×_Í_ÌêŮPrĔĐÕGĂeZÜîĘqBhtO ¤tE[h|YÔZśÎs´xº±Uñt|OĩĠºNbgþJy^dÂY Į]Řz¦gC³R`Āz¢Aj¸CL¤RÆ»@­Ŏk\\Ç´£YW}z@Z}Ã¶oû¶]´^NÒ}èNªPÍy¹`S°´ATeVamdUĐwʄvĮÕ\\uÆŗ¨Yp¹àZÂmWh{á}WØǍÉüwga§áCNęÎ[ĀÕĪgÖÉªXøx¬½Ů¦¦[NÎLÜUÖ´òrÙŠxR^JkĳnDX{U~ET{ļº¦PZcjF²Ė@pg¨B{u¨ŦyhoÚD®¯¢ WòàFÎ¤¨GDäz¦kŮPġqË¥À]eâÚ´ªKxīPÖ|æ[xÃ¤JÞĥsNÖ½I¬nĨY´®ÐƐmDŝuäđđEbee_v¡}ìęǊē}qÉåT¯µRs¡M@}ůaa­¯wvƉåZw\\Z{åû^"]
			],
			"encodeOffsets": [
				[
					[108815, 30935]
				],
				[
					[110617, 31811]
				]
			]
		},
		"properties": {
			"cp": [104.065735, 30.659462],
			"name": "四川",
			"childNum": 2
		}
	}, {
		"id": "520000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@G\\lY£in"],
				["@@q|mc¯tÏVSÎ"],
				["@@hÑ£IsNgßHHªķÃh_¹¡ĝÄ§ń¦uÙùgS¯JH|sÝÅtÁïyMDč»eÕtA¤{b\\}G®u\\åPFqwÅaDK°ºâ_£ùbµmÁÛĹM[q|hlaªāI}Ñµ@swtwm^oµDéĽŠyVky°ÉûÛR³e¥]RÕěħ[ƅåÛDpJiVÂF²I»mN·£LbÒYbWsÀbpkiTZĄă¶Hq`ĥ_J¯ae«KpÝx]aĕÛPÇȟ[ÁåŵÏő÷Pw}TÙ@Õs«ĿÛq©½m¤ÙH·yǥĘĉBµĨÕnđ]K©œáGçş§ÕßgǗĦTèƤƺ{¶ÉHÎd¾ŚÊ·OÐjXWrãLyzÉAL¾ę¢bĶėy_qMĔąro¼hĊw¶øV¤w²Ĉ]ÊKx|`ź¦ÂÈdrcÈbe¸`I¼čTF´¼Óýȃr¹ÍJ©k_șl³´_pĐ`oÒh¶pa^ÓĔ}D»^Xy`d[KvJPhèhCrĂĚÂ^Êƌ wZL­Ġ£ÁbrzOIlMMĪŐžËr×ÎeŦtw|¢mKjSǘňĂStÎŦEtqFT¾Eì¬¬ôxÌO¢ K³ŀºäYPVgŎ¦ŊmŞ¼VZwVlz¤£Tl®ctĽÚó{G­AÇge~Îd¿æaSba¥KKûj®_Ä^\\Ø¾bP®¦x^sxjĶI_Ä Xâ¼Hu¨Qh¡À@Ëô}±GNìĎlT¸`V~R°tbÕĊ`¸úÛtÏFDu[MfqGH·¥yAztMFe|R_GkChZeÚ°tov`xbDnÐ{E}ZèxNEÞREn[Pv@{~rĆAB§EO¿|UZ~ìUf¨J²ĂÝÆsªB`s¶fvö¦Õ~dÔq¨¸º»uù[[§´sb¤¢zþF¢ÆÀhÂW\\ıËIÝo±ĭŠ£þÊs}¡R]ěDg´VG¢j±®èºÃmpU[Áëº°rÜbNu¸}º¼`niºÔXĄ¤¼ÔdaµÁ_ÃftQQgR·Ǔv}Ý×ĵ]µWc¤F²OĩųãW½¯K©]{LóµCIµ±Mß¿h©āq¬o½~@i~TUxŪÒ¢@£ÀEîôruńb[§nWuMÆLl¿]x}ĳ­½"]
			],
			"encodeOffsets": [
				[
					[112158, 27383]
				],
				[
					[112105, 27474]
				],
				[
					[112095, 27476]
				]
			]
		},
		"properties": {
			"cp": [106.713478, 26.578343],
			"name": "贵州",
			"childNum": 3
		}
	}, {
		"id": "530000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@[ùx½}ÑRHYīĺûsÍniEoã½Ya²ė{c¬ĝgĂsAØÅwďõzFjw}«Dx¿}Uũlê@HÅ­F¨ÇoJ´Ónũuą¡Ã¢pÒÅØ TF²xa²ËXcÊlHîAßËŁkŻƑŷÉ©hW­æßUËs¡¦}teèÆ¶StÇÇ}Fd£jĈZĆÆ¤Tč\\D}O÷£U§~ŃGåŃDĝ¸Tsd¶¶Bª¤u¢ŌĎo~t¾ÍŶÒtD¦ÚiôözØX²ghįh½Û±¯ÿm·zR¦Ɵ`ªŊÃh¢rOÔ´£Ym¼èêf¯ŪĽncÚbw\\zlvWªâ ¦gmĿBĹ£¢ƹřbĥkǫßeeZkÙIKueT»sVesbaĕ  ¶®dNĄÄpªy¼³BE®lGŭCǶwêżĔÂepÍÀQƞpC¼ŲÈ­AÎô¶RäQ^Øu¬°_Èôc´¹ò¨PÎ¢hlĎ¦´ĦÆ´sâÇŲPnÊD^¯°Upv}®BPÌªjǬxSöwlfòªvqĸ|`H­viļndĜ­Ćhňem·FyÞqóSį¯³X_ĞçêtryvL¤§z¦c¦¥jnŞklD¤øz½ĜàĂŧMÅ|áƆàÊcðÂFÜáŢ¥\\\\ºİøÒÐJĴîD¦zK²ǏÎEh~CD­hMn^ÌöÄ©ČZÀaüfɭyœpį´ěFűk]Ôě¢qlÅĆÙa¶~ÄqêljN¬¼HÊNQ´ê¼VØ¸E^ŃÒyM{JLoÒęæe±Ķygã¯JYÆĭĘëo¥Šo¯hcK«z_prC´ĢÖY¼ v¸¢RÅW³Â§fÇ¸Yi³xR´ďUË`êĿUûuĆBƣöNDH«ĈgÑaB{ÊNF´¬c·Åv}eÇÃGB»If¦HňĕM~[iwjUÁKE¾dĪçWIèÀoÈXòyŞŮÈXâÎŚj|àsRyµÖPr´þ ¸^wþTDŔHr¸RÌmfżÕâCôoxĜƌÆĮÐYtâŦÔ@]ÈǮƒ\\Ī¼Ä£UsÈ¯LbîƲŚºyhr@ĒÔƀÀ²º\\êpJ}ĠvqtĠ@^xÀ£È¨mËÏğ}n¹_¿¢×Y_æpÅA^{½Lu¨GO±Õ½ßM¶wÁĢÛPƢ¼pcĲx|apÌ¬HÐŊSfsðBZ¿©XÏÒKk÷Eû¿SrEFsÕūkóVǥŉiTL¡n{uxţÏhôŝ¬ğōNNJkyPaqÂğ¤K®YxÉƋÁ]āęDqçgOgILu\\_gz]W¼~CÔē]bµogpÑ_oď`´³Țkl`IªºÎȄqÔþ»E³ĎSJ»_f·adÇqÇc¥Á_Źw{L^É±ćxU£µ÷xgĉp»ĆqNē`rĘzaĵĚ¡K½ÊBzyäKXqiWPÏÉ¸½řÍcÊG|µƕƣGË÷k°_^ý|_zċBZocmø¯hhcæ\\lMFlư£ĜÆyHF¨µêÕ]HAàÓ^it `þßäkĤÎT~Wlÿ¨ÔPzUCNVv [jâôDôď[}z¿msSh¯{jïğl}šĹ[őgK©U·µË@¾m_~q¡f¹ÅË^»f³ø}Q¡ÖË³gÍ±^Ç\\ëÃA_¿bWÏ[¶ƛé£F{īZgm@|kHǭƁć¦UĔť×ë}ǝeďºȡȘÏíBÉ£āĘPªĳ¶ŉÿy©nď£G¹¡I±LÉĺÑdĉÜW¥}gÁ{aqÃ¥aıęÏZï`"],
			"encodeOffsets": [
				[104636, 22969]
			]
		},
		"properties": {
			"cp": [101.512251, 24.740609],
			"name": "云南",
			"childNum": 1
		}
	}, {
		"id": "540000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ÂhľxŖxÒVºÅâAĪÝȆµę¯Ňa±r_w~uSÕňqOj]ɄQ£ZUDûoY»©M[L¼qãË{VÍçWVi]ë©Ä÷àyƛhÚU°adcQ~Mx¥cc¡ÙaSyFÖk­uRýq¿ÔµQĽ³aG{¿FµëªéĜÿª@¬·K·àariĕĀ«V»ŶĴūgèLǴŇƶaftèBŚ£^âǐÝ®M¦ÁǞÿ¬LhJ¾óƾÆºcxwf]Y´¦|QLn°adĊ\\¨oǀÍŎ´ĩĀd`tÊQŞŕ|¨C^©Ĉ¦¦ÎJĊ{ëĎjª²rÐl`¼Ą[t|¦Stè¾PÜK¸dƄı]s¤î_v¹ÎVòŦj£Əsc¬_Ğ´|Ł¦Av¦w`ăaÝaa­¢e¤ı²©ªSªÈMĄwÉØŔì@T¤Ę\\õª@þo´­xA sÂtŎKzó´ÇĊµ¢r^nĊ­Æ¬×üG¢³ {âĊ]G~bÀgVjzlhǶfOfdªB]pjTOtĊn¤}®¦Č¥d¢¼»ddY¼t¢eȤJ¤}Ǿ¡°§¤AÐlc@ĝsªćļđAçwxUuzEÖġ~AN¹ÄÅȀŻ¦¿ģŁéì±Hãd«g[Ø¼ēÀcīľġ¬cJµÐʥVȝ¸ßS¹ý±ğkƁ¼ą^ɛ¤Ûÿb[}¬ōõÃ]ËNm®g@Bg}ÍF±ǐyL¥íCIĳÏ÷Ñį[¹¦[âšEÛïÁÉdƅß{âNÆāŨß¾ě÷yC£k­´ÓH@Â¹TZ¥¢į·ÌAÐ§®Zcv½Z­¹|ÅWZqgW|ieZÅYVÓqdqbc²R@c¥Rã»GeeƃīQ}J[ÒK¬Ə|oėjġĠÑN¡ð¯EBčnwôɍėª²CλŹġǝʅįĭạ̃ūȹ]ΓͧgšsgȽóϧµǛęgſ¶ҍć`ĘąŌJÞä¤rÅň¥ÖÁUětęuůÞiĊÄÀ\\Æs¦ÓRb|Â^řÌkÄŷ¶½÷f±iMÝ@ĥ°G¬ÃM¥n£Øąğ¯ß§aëbéüÑOčk£{\\eµª×MÉfm«Ƒ{Å×Gŏǩãy³©WÑăû··Qòı}¯ãIéÕÂZ¨īès¶ZÈsæĔTŘvgÌsN@îá¾ó@ÙwU±ÉTå»£TđWxq¹Zobs[×¯cĩvėŧ³BM|¹kªħ¥TzNYnÝßpęrñĠĉRS~½ěVVµõ«M££µBĉ¥áºae~³AuĐh`Ü³ç@BÛïĿa©|z²Ý¼D£àč²ŸIûI āóK¥}rÝ_Á´éMaň¨~ªSĈ½½KÙóĿeƃÆB·¬ën×W|Uº}LJrƳlŒµ`bÔ`QÐÓ@s¬ñIÍ@ûws¡åQÑßÁ`ŋĴ{ĪTÚÅTSÄ³Yo|Ç[Ç¾µMW¢ĭiÕØ¿@MhpÕ]jéò¿OƇĆƇpêĉâlØwěsǩĵ¸cbU¹ř¨WavquSMzeo_^gsÏ·¥Ó@~¯¿RiīB\\qTGªÇĜçPoÿfñòą¦óQīÈáPābß{ZŗĸIæÅhnszÁCËìñÏ·ąĚÝUm®ó­L·ăUÈíoù´Êj°ŁŤ_uµ^°ìÇ@tĶĒ¡ÆM³Ģ«İĨÅ®ğRāðggheÆ¢zÊ©Ô\\°ÝĎz~ź¤PnMĪÖB£kné§żćĆKĒ°¼L¶èâz¨u¦¥LDĘz¬ýÎmĘd¾ßFzhg²Fy¦ĝ¤ċņbÎ@yĄæm°NĮZRÖíJ²öLĸÒ¨Y®ƌÐVàtt_ÚÂyĠz]ŢhzĎ{ÂĢXc|ÐqfO¢¤ögÌHNPKŖUú´xx[xvĐCûĀìÖT¬¸^}Ìsòd´_KgžLĴÀBon|H@Êx¦BpŰŌ¿fµƌA¾zǈRx¶FkĄźRzŀ~¶[´HnªVƞuĒ­È¨ƎcƽÌm¸ÁÈM¦x͊ëÀxǆBú^´W£dkɾĬpw˂ØɦļĬIŚÊnŔa¸~J°îlɌxĤÊÈðhÌ®gT´øàCÀ^ªerrƘd¢İP|Ė ŸWªĦ^¶´ÂLaT±üWƜǀRÂŶUńĖ[QhlLüAÜ\\qRĄ©"],
			"encodeOffsets": [
				[90849, 37210]
			]
		},
		"properties": {
			"cp": [89.132212, 30.860361],
			"name": "西藏",
			"childNum": 1
		}
	}, {
		"id": "610000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@p¢ȮµûGĦ}Ħðǚ¶òƄjɂz°{ºØkÈęâ¦jªBg\\ċ°s¬]jú EȌǆ¬stRÆdĠİwÜ¸ôW¾ƮłÒ_{Ìû¼jº¹¢GǪÒ¯ĘZ`ºŊecņą~BÂgzpâēòYǠȰÌTÎ¨ÂW|fcă§uF@N¢XLRMº[ğȣſï|¥Jkc`sŉǷY¹W@µ÷Kãï³ÛIcñ·VȋÚÒķø©þ¥yÓğęmWµÎumZyOŅƟĥÓ~sÑL¤µaÅY¦ocyZ{y c]{Ta©`U_Ěē£ωÊƍKùK¶ȱÝƷ§{û»ÅÁȹÍéuĳ|¹cÑdìUYOuFÕÈYvÁCqÓTǢí§·S¹NgV¬ë÷Át°DØ¯C´ŉƒópģ}ċcEËFéGU¥×K§­¶³BČ}C¿åċ`wġB·¤őcƭ²ő[Å^axwQOÿEËßŚĤNĔwƇÄńwĪ­o[_KÓª³ÙnKÇěÿ]ďă_d©·©Ýŏ°Ù®g]±ßå¬÷m\\iaǑkěX{¢|ZKlçhLtŇîŵœè[É@ƉĄEtƇÏ³­ħZ«mJ×¾MtÝĦ£IwÄå\\Õ{OwĬ©LÙ³ÙgBƕŀrÌĢŭO¥lãyC§HÍ£ßEñX¡­°ÙCgpťzb`wIvA|§hoĕ@E±iYd¥OĻ¹S|}F@¾oAO²{tfÜ¢FǂÒW²°BĤh^Wx{@¬­F¸¡ķn£P|ªĴ@^ĠĈæbÔc¶lYi^MicĎ°Â[ävï¶gv@ÀĬ·lJ¸sn|¼u~a]ÆÈtŌºJpþ£KKf~¦UbyäIĺãnÔ¿^­ŵMThĠÜ¤ko¼Ŏìąǜh`[tRd²Ĳ_XPrɲlXiL§à¹H°Ȧqº®QCbAŌJ¸ĕÚ³ĺ§ `d¨YjiZvRĺ±öVKkjGȊÄePĞZmļKÀ[`ösìhïÎoĬdtKÞ{¬èÒÒBÔpĲÇĬJŊ¦±J«Y§@·pHµàåVKepWftsAÅqC·¬ko«pHÆuK@oHĆÛķhxenS³àǍrqƶRbzy¸ËÐl¼EºpĤ¼x¼½~Ğà@ÚüdK^mÌSj"],
			"encodeOffsets": [
				[110234, 38774]
			]
		},
		"properties": {
			"cp": [108.948024, 34.263161],
			"name": "陕西",
			"childNum": 1
		}
	}, {
		"id": "620000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@VuUv"],
				["@@ũEĠtt~nkh`Q¦ÅÄÜdwAb×ĠąJ¤DüègĺqBqj°lI¡ĨÒ¤úSHbjÎB°aZ¢KJO[|A£Dx}NĂ¬HUnrk kp¼Y kMJn[aGáÚÏ[½rc}aQxOgsPMnUsncZsKúvAtÞġ£®ĀYKdnFw¢JE°Latf`¼h¬we|Æbj}GA·~W`¢MC¤tL©Ĳ°qdfObÞĬ¹ttu`^ZúE`[@Æsîz®¡CƳƜG²R¢RmfwĸgÜą G@pzJM½mhVy¸uÈÔO±¨{LfæU¶ßGĂq\\ª¬²I¥IŉÈīoıÓÑAçÑ|«LÝcspīðÍgtë_õ\\ĉñLYnĝgRǡÁiHLlõUĹ²uQjYi§Z_c¨´ĹĖÙ·ŋIaBD­R¹ȥr¯GºßK¨jWkɱOqWĳ\\a­Q\\sg_ĆǛōëp»£lğÛgSŶN®À]ÓämĹãJaz¥V}Le¤Lýo¹IsŋÅÇ^bz³tmEÁ´a¹cčecÇNĊãÁ\\č¯dNj]jZµkÓdaćå]ğĳ@ ©O{¤ĸm¢E·®«|@Xwg]Aģ±¯XǁÑǳªcwQÚŝñsÕ³ÛV_ý¥\\ů¥©¾÷w©WÕÊĩhÿÖÁRo¸V¬âDb¨hûxÊ×ǌ~Zâg|XÁnßYoº§ZÅŘv[ĭÖʃuďxcVbnUSfB¯³_TzºÎO©çMÑ~M³]µ^püµÄY~y@X~¤Z³[Èōl@®Å¼£QK·Di¡ByÿQ_´D¥hŗy^ĭÁZ]cIzýah¹MĪğPs{ò²Vw¹t³ŜË[Ñ}X\\gsF£sPAgěp×ëfYHāďÖqēŭOÏëdLü\\it^c®RÊº¶¢H°mrY£B¹čIoľu¶uI]vģSQ{UŻÅ}QÂ|Ì°ƅ¤ĩŪU ęĄÌZÒ\\v²PĔ»ƢNHĂyAmƂwVm`]ÈbH`Ì¢²ILvĜH®¤Dlt_¢JJÄämèÔDëþgºƫaʎÌrêYi~ Îİ¤NpÀA¾Ĕ¼bð÷®üszMzÖĖQdȨýv§Tè|ªHÃ¾a¸|Ð ƒwKĢx¦ivr^ÿ ¸l öæfƟĴ·PJv}n\\h¹¶v·À|\\ƁĚN´ĜçèÁz]ġ¤²¨QÒŨTIlªťØ}¼˗ƦvÄùØEÂ«FïËIqōTvāÜŏíÛßÛVj³âwGăÂíNOPìyV³ŉĖýZso§HÑiYw[ß\\X¦¥c]ÔƩÜ·«jÐqvÁ¦m^ċ±R¦΋ƈťĚgÀ»IïĨʗƮ°ƝĻþÍAƉſ±tÍEÕÞāNUÍ¡\\ſčåÒʻĘm ƭÌŹöʥëQ¤µ­ÇcƕªoIýIÉ_mkl³ăƓ¦j¡YzŇi}Msßõīʋ }ÁVm_[n}eı­Uĥ¼ªI{Î§DÓƻėojqYhĹT©oūĶ£]ďxĩǑMĝq`B´ƃ˺Чç~²ņj@¥@đ´ί}ĥtPńÇ¾V¬ufÓÉCtÓ̻¹£G³]ƖƾŎĪŪĘ̖¨ʈĢƂlɘ۪üºňUðǜȢƢż̌ȦǼĤŊɲĖÂ­Kq´ï¦ºĒǲņɾªǀÞĈĂD½ĄĎÌŗĞrôñnN¼â¾ʄľԆ|Ǆ֦ज़ȗǉ̘̭ɺƅêgV̍ʆĠ·ÌĊv|ýĖÕWĊǎÞ´õ¼cÒÒBĢ͢UĜð͒s¨ňƃLĉÕÝ@ɛƯ÷¿Ľ­ĹeȏĳëCȚDŲyê×Ŗyò¯ļcÂßYtÁƤyAã˾J@ǝrý@¤rz¸oP¹ɐÚyáHĀ[JwcVeȴÏ»ÈĖ}ƒŰŐèȭǢόĀƪÈŶë;Ñ̆ȤМľĮEŔĹŊũ~ËUă{ĻƹɁύȩþĽvĽƓÉ@ēĽɲßǐƫʾǗĒpäWÐxnsÀ^ƆwW©¦cÅ¡Ji§vúF¶¨c~c¼īeXǚ\\đ¾JwÀďksãAfÕ¦L}waoZD½Ml«]eÒÅaÉ²áo½FõÛ]ĻÒ¡wYR£¢rvÓ®y®LFLzĈôe]gx}|KK}xklL]c¦£fRtív¦PĤoH{tK"]
			],
			"encodeOffsets": [
				[
					[108619, 36299]
				],
				[
					[108589, 36341]
				]
			]
		},
		"properties": {
			"cp": [103.823557, 36.058039],
			"name": "甘肃",
			"childNum": 2
		}
	}, {
		"id": "630000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@InJm"],
				["@@CÆ½OŃĦsΰ~Ē³¦@@Ņi±è}ШƄ˹A³r_ĞǒNĪĐw¤^ŬĵªpĺSZgrpiƼĘÔ¨C|ÍJ©Ħ»®VĲ~f\\m `UnÂ~ʌĬàöNt~ňjy¢ZiƔ¥Ąk´nl`JÊJþ©pdƖ®È£¶ìRʦźõƮËnʼėæÑƀĎ[¢VÎĂMÖÝÎF²sƊƀÎBļýƞ¯ʘƭðħ¼Jh¿ŦęΌƇ¥²Q]Č¥nuÂÏri¸¬ƪÛ^Ó¦d¥[Wàx\\ZjÒ¨GtpþYŊĕ´zUOëPîMĄÁxH´áiÜUàîÜŐĂÛSuŎrJðÌ¬EFÁú×uÃÎkrĒ{V}İ«O_ÌËĬ©ÓŧSRÑ±§Ģ£^ÂyèçěM³Ƃę{[¸¿uºµ[gt£¸OƤĿéYõ·kĀq]juw¥DĩƍõÇPéÄ½G©ã¤GuȧþRcÕĕNyyût­øï»a½ē¿BMoį£Íj}éZËqbʍƬh¹ìÿÓAçãnIÃ¡I`ks£CG­ěUy×Cy@¶ʡÊBnāzGơMē¼±O÷õJËĚăVĪũƆ£¯{ËL½ÌzżVR|ĠTbuvJvµhĻĖHAëáa­OÇðñęNwœľ·LmI±íĠĩPÉ×®ÿscB³±JKßĊ«`ađ»·QAmOVţéÿ¤¹SQt]]Çx±¯A@ĉĳ¢Óļ©l¶ÅÛrŕspãRk~¦ª]Į­´FRåd­ČsCqđéFn¿ÅƃmÉx{W©ºƝºįkÕƂƑ¸wWūÐ©ÈF£\\tÈ¥ÄRÈýÌJ lGr^×äùyÞ³fjc¨£ÂZ|ǓMĝÏ@ëÜőRĝ÷¡{aïȷPu°ËXÙ{©TmĠ}Y³­ÞIňµç½©C¡į÷¯B»|St»]vųs»}MÓ ÿʪƟǭA¡fs»PY¼c¡»¦cċ­¥£~msĉPSi^o©AecPeǵkgyUi¿h}aHĉ^|á´¡HØûÅ«ĉ®]m¡qĉ¶³ÈyôōLÁstB®wn±ă¥HSòė£Së@×œÊăxÇN©©T±ª£Ĳ¡fb®Þbb_Ą¥xu¥B{łĝ³«`dƐt¤ťiñÍUuºí`£^tƃĲc·ÛLO½sç¥Ts{ă\\_»kÏ±q©čiìĉ|ÍI¥ć¥]ª§D{ŝŖÉR_sÿc³ĪōƿÎ§p[ĉc¯bKmR¥{³Ze^wx¹dƽÅ½ôIg §Mĕ ƹĴ¿ǣÜÍ]Ý]snåA{eƭ`ǻŊĿ\\ĳŬűYÂÿ¬jĖqßb¸L«¸©@ěĀ©ê¶ìÀEH|´bRľÓ¶rÀQþvl®ÕETzÜdb hw¤{LRdcb¯ÙVgƜßzÃôì®^jUèXÎ|UäÌ»rK\\ªN¼pZCüVY¤ɃRi^rPŇTÖ}|br°qňbĚ°ªiƶGQ¾²x¦PmlŜ[Ĥ¡ΞsĦÔÏâ\\ªÚŒU\\f¢N²§x|¤§xĔsZPòʛ²SÐqF`ªVÞŜĶƨVZÌL`¢dŐIqr\\oäõFÎ·¤»Ŷ×h¹]ClÙ\\¦ďÌį¬řtTӺƙgQÇÓHţĒ´ÃbEÄlbʔC|CŮkƮ[ʼ¬ň´KŮÈΰÌĪ¶ƶlðļATUvdTGº̼ÔsÊDÔveOg"]
			],
			"encodeOffsets": [
				[
					[105308, 37219]
				],
				[
					[95370, 40081]
				]
			]
		},
		"properties": {
			"cp": [96.778916, 35.623178],
			"name": "青海",
			"childNum": 2
		}
	}, {
		"id": "640000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@KëÀęĞ«Oęȿȕı]ŉ¡åįÕÔ«ǴõƪĚQÐZhv K°öqÀÑS[ÃÖHƖčËnL]ûcÙß@ĝ¾}w»»oģF¹»kÌÏ·{zP§B­¢íyÅt@@á]Yv_ssģ¼ißĻL¾ġsKD£¡N_X¸}B~HaiÅf{«x»ge_bsKF¯¡IxmELcÿZ¤­ĢÝsuBLùtYdmVtNmtOPhRw~bd¾qÐ\\âÙH\\bImlNZ»loqlVmGā§~QCw¤{A\\PKNY¯bFkC¥sks_Ã\\ă«¢ħkJi¯rrAhĹûç£CUĕĊ_ÔBixÅÙĄnªÑaM~ħpOu¥sîeQ¥¤^dkKwlL~{L~hw^ófćKyE­K­zuÔ¡qQ¤xZÑ¢^ļöÜ¾Ep±âbÊÑÆ^fk¬NC¾YpxbK~¥eÖäBlt¿Đx½I[ĒǙWf»Ĭ}d§dµùEuj¨IÆ¢¥dXªƅx¿]mtÏwßRĶX¢͎vÆzƂZò®ǢÌʆCrâºMÞzÆMÒÊÓŊZÄ¾r°Î®Ȉmª²ĈUªĚîøºĮ¦ÌĘk^FłĬhĚiĀĖ¾iİbjÕ"],
				["@@mfwěwMrŢªv@G"]
			],
			"encodeOffsets": [
				[
					[109366, 40242]
				],
				[
					[108600, 36303]
				]
			]
		},
		"properties": {
			"cp": [106.278179, 37.26637],
			"name": "宁夏",
			"childNum": 2
		}
	}, {
		"id": "650000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@QØĔ²X¨~ǘBºjʐßØvKƔX¨vĊOÃ·¢i@~cĝe_«E}QxgɪëÏÃ@sÅyXoŖ{ô«ŸuXêÎf`C¹ÂÿÐGĮÕĞXŪōŸMźÈƺQèĽôe|¿ƸJR¤ĘEjcUóº¯Ĩ_ŘÁMª÷Ð¥OéÈ¿ÖğǤǷÂFÒzÉx[]­Ĥĝœ¦EP}ûƥé¿İƷTėƫœŕƅƱB»Đ±ēO¦E}`cȺrĦáŖuÒª«ĲπdƺÏØZƴwʄ¤ĖGĐǂZĶèH¶}ÚZצʥĪï|ÇĦMŔ»İĝǈì¥Βba­¯¥ǕǚkĆŵĦɑĺƯxūД̵nơʃĽá½M»òmqóŘĝčË¾ăCćāƿÝɽ©ǱŅ¹đ¥³ðLrÁ®ɱĕģŉǻ̋ȥơŻǛȡVï¹Ň۩ûkɗġƁ§ʇė̕ĩũƽō^ƕUv£ƁQïƵkŏ½ΉÃŭÇ³LŇʻ«ƭ\\lŭD{ʓDkaFÃÄa³ŤđÔGRÈƚhSӹŚsİ«ĐË[¥ÚDkº^Øg¼ŵ¸£EÍöůŉT¡c_ËKYƧUśĵÝU_©rETÏʜ±OñtYwē¨{£¨uM³x½şL©Ùá[ÓÐĥ Νtģ¢\\śnkOw¥±T»ƷFɯàĩÞáB¹ÆÑUwŕĽw[mG½Èå~Æ÷QyěCFmĭZīŵVÁƿQƛûXS²b½KÏ½ĉS©ŷXĕ{ĕK·¥Ɨcqq©f¿]ßDõU³h­gËÇïģÉɋwk¯í}I·œbmÉřīJɥĻˁ×xoɹīlc¤³Xù]ǅA¿w͉ì¥wÇN·ÂËnƾƍdÇ§đ®ƝvUm©³G\\}µĿQyŹlăµEwǇQ½yƋBe¶ŋÀůo¥AÉw@{Gpm¿AĳŽKLh³`ñcËtW±»ÕSëüÿďDu\\wwwù³VLŕOMËGh£õP¡erÏd{ġWÁč|yšg^ğyÁzÙs`s|ÉåªÇ}m¢Ń¨`x¥ù^}Ì¥H«YªƅAÐ¹n~ź¯f¤áÀzgÇDIÔ´AňĀÒ¶ûEYospõD[{ù°]uJqU|Soċxţ[õÔĥkŋÞŭZËºóYËüċrw ÞkrťË¿XGÉbřaDü·Ē÷AÃª[ÄäIÂ®BÕĐÞ_¢āĠpÛÄȉĖġDKwbmÄNôfƫVÉviǳHQµâFù­Âœ³¦{YGd¢ĚÜO {Ö¦ÞÍÀP^bƾl[vt×ĈÍEË¨¡Đ~´î¸ùÎhuè`¸HÕŔVºwĠââWò@{ÙNÝ´ə²ȕn{¿¥{l÷eé^eďXj©î\\ªÑòÜìc\\üqÕ[Č¡xoÂċªbØ­ø|¶ȴZdÆÂońéG\\¼C°ÌÆn´nxÊOĨŪƴĸ¢¸òTxÊǪMīĞÖŲÃɎOvʦƢ~FRěò¿ġ~åŊúN¸qĘ[Ĕ¶ÂćnÒPĒÜvúĀÊbÖ{Äî¸~Ŕünp¤ÂH¾ĄYÒ©ÊfºmÔĘcDoĬMŬS¤s²ʘÚžȂVŦ èW°ªB|ĲXŔþÈJĦÆæFĚêYĂªĂ]øªŖNÞüAfɨJ¯ÎrDDĤ`mz\\§~D¬{vJÂ«lµĂb¤pŌŰNĄ¨ĊXW|ų ¿¾ɄĦƐMTòP÷fØĶK¢ȝ˔Sô¹òEð­`Ɩ½ǒÂň×äı§ĤƝ§C~¡hlåǺŦŞkâ~}FøàĲaĞfƠ¥Ŕd®U¸źXv¢aƆúŪtŠųƠjdƺƺÅìnrh\\ĺ¯äɝĦ]èpĄ¦´LƞĬ´ƤǬ˼Ēɸ¤rºǼ²¨zÌPðŀbþ¹ļD¢¹\\ĜÑŚ¶ZƄ³àjĨoâȴLÊȮĐ­ĚăÀêZǚŐ¤qȂ\\L¢ŌİfÆs|zºeªÙæ§΢{Ā´ƐÚ¬¨Ĵà²łhʺKÞºÖTiƢ¾ªì°`öøu®Ê¾ãØ"],
			"encodeOffsets": [
				[88824, 50096]
			]
		},
		"properties": {
			"cp": [85.617733, 40.792818],
			"name": "新疆",
			"childNum": 1
		}
	}, {
		"id": "110000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ĽOÁûtŷmiÍt_H»Ĩ±d`¹­{bwYr³S]§§o¹qGtm_SŧoaFLgQN_dV@Zom_ć\\ßcÂ±x¯oœRcfe£o§ËgToÛJíĔóu|wP¤XnO¢ÉŦ¯rNÄā¤zâŖÈRpŢZÚ{GrFt¦Òx§ø¹RóäV¤XdżâºWbwŚ¨Ud®bêņ¾jnŎGŃŶnzÚSeîĜZczî¾i]ÍQaúÍÔiþĩȨWĢü|Ėu[qb[swP@ÅğP¿{\\¥A¨ÏÑ¨j¯X\\¯MKpA³[Hīu}}"],
			"encodeOffsets": [
				[120023, 41045]
			]
		},
		"properties": {
			"cp": [116.405285, 39.904989],
			"name": "北京",
			"childNum": 1
		}
	}, {
		"id": "120000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@ŬgX§Ü«E¶FÌ¬O_ïlÁgz±AXeµÄĵ{¶]gitgIj·¥îakS¨ÐƎk}ĕ{gBqGf{¿aU^fIư³õ{YıëNĿk©ïËZŏR§òoY×Ógcĥs¡bġ«@dekąI[nlPqCnp{ō³°`{PNdƗqSÄĻNNâyj]äÒD ĬH°Æ]~¡HO¾X}ÐxgpgWrDGpù^LrzWxZ^¨´T\\|~@IzbĤjeĊªz£®ĔvěLmV¾Ô_ÈNW~zbĬvG²ZmDM~~"],
			"encodeOffsets": [
				[120237, 41215]
			]
		},
		"properties": {
			"cp": [117.190182, 39.125596],
			"name": "天津",
			"childNum": 1
		}
	}, {
		"id": "310000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@ɧư¬EpƸÁxc"],
				["@@©ª"],
				["@@MA"],
				["@@QpİE§ÉC¾"],
				["@@bŝÕÕEȣÚƥêImɇǦèÜĠÚÃƌÃ͎ó"],
				["@@ǜûȬɋŭ×^sYɍDŋŽąñCG²«ªč@h_p¯A{oloY¬j@Ĳ`gQÚhr|ǀ^MĲvtbe´R¯Ô¬¨Yô¤r]ìƬį"]
			],
			"encodeOffsets": [
				[
					[124702, 32062]
				],
				[
					[124547, 32200]
				],
				[
					[124808, 31991]
				],
				[
					[124726, 32110]
				],
				[
					[124903, 32376]
				],
				[
					[124438, 32149]
				]
			]
		},
		"properties": {
			"cp": [121.472644, 31.231706],
			"name": "上海",
			"childNum": 6
		}
	}, {
		"id": "500000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@vjG~nGŘŬĶȂƀƾ¹¸ØÎezĆT¸}êÐqHðqĖä¥^CÆIj²p\\_ æüY|[YxƊæu°xb®Űb@~¢NQt°¶Sæ Ê~rǉĔëĚ¢~uf`faĔJåĊnÖ]jƎćÊ@£¾a®£Ű{ŶĕFègLk{Y|¡ĜWƔtƬJÑxq±ĢN´òKLÈÃ¼D|s`ŋć]Ã`đMûƱ½~Y°ħ`ƏíW½eI½{aOIrÏ¡ĕŇapµÜƅġ^ÖÛbÙŽŏml½SêqDu[RãË»ÿw`»y¸_ĺę}÷`M¯ċfCVµqŉ÷Zgg`d½pDOÎCn^uf²ènh¼WtƏxRGg¦pVFI±G^Ic´ecGĹÞ½sëĬhxW}KÓe­XsbkF¦LØgTkïƵNï¶}Gyw\\oñ¡nmĈzj@Óc£»Wă¹Ój_m»¹·~MvÛaq»­ê\\ÂoVnÓØÍ²«bq¿efE Ĝ^Q~ Évýş¤²ĮpEİ}zcĺL½¿gÅ¡ýE¡ya£³t\\¨\\vú»¼§·Ñr_oÒý¥u_n»_At©ÞÅ±ā§IVeëY}{VPÀFA¨ąB}q@|Ou\\FmQFÝMwå}]|FmÏCawu_p¯sfÙgYDHl`{QEfNysB¦zG¸rHeN\\CvEsÐùÜ_·ÖĉsaQ¯}_UxÃđqNH¬Äd^ÝŰR¬ã°wećJE·vÝ·HgéFXjÉê`|ypxkAwWĐpb¥eOsmzwqChóUQl¥F^lafanòsrEvfQdÁUVfÎvÜ^eftET¬ôA\\¢sJnQTjPØxøK|nBzĞ»LYFDxÓvr[ehľvN¢o¾NiÂxGpâ¬zbfZo~hGi]öF||NbtOMn eA±tPTLjpYQ|SHYĀxinzDJÌg¢và¥Pg_ÇzIIII£®S¬ØsÎ¼£N"],
				["@@ifjN@s"]
			],
			"encodeOffsets": [
				[
					[109628, 30765]
				],
				[
					[111725, 31320]
				]
			]
		},
		"properties": {
			"cp": [107.304962, 29.533155],
			"name": "重庆",
			"childNum": 2
		}
	}, {
		"id": "810000",
		"type": "Feature",
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				["@@AlBk"],
				["@@mn"],
				["@@EpFo"],
				["@@ea¢pl¸Eõ¹hj[]ÔCÎ@lj¡uBX´AI¹[yDU]W`çwZkmcMpÅv}IoJlcafŃK°ä¬XJmÐ đhI®æÔtSHnEÒrÈc"],
				["@@rMUwAS®e"]
			],
			"encodeOffsets": [
				[
					[117111, 23002]
				],
				[
					[117072, 22876]
				],
				[
					[117045, 22887]
				],
				[
					[116975, 23082]
				],
				[
					[116882, 22747]
				]
			]
		},
		"properties": {
			"cp": [114.173355, 22.320048],
			"name": "香港",
			"childNum": 5
		}
	}, {
		"id": "820000",
		"type": "Feature",
		"geometry": {
			"type": "Polygon",
			"coordinates": ["@@kÊd°å§s"],
			"encodeOffsets": [
				[116279, 22639]
			]
		},
		"properties": {
			"cp": [113.54909, 22.198951],
			"name": "澳门",
			"childNum": 1
		}
	}],
	"UTF8Encoding": true
};

//云南省json
var yunnanJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 530602,
			"name": "昭阳区",
			"center": [103.717267, 27.336636],
			"centroid": [103.610545, 27.42409],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 0,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.627812, 27.11692],
						[103.620378, 27.12627],
						[103.620207, 27.134934],
						[103.626663, 27.14722],
						[103.635294, 27.152323],
						[103.637446, 27.159205],
						[103.647618, 27.161263],
						[103.668134, 27.167373],
						[103.668061, 27.174554],
						[103.653169, 27.188722],
						[103.645613, 27.197702],
						[103.641285, 27.200531],
						[103.623557, 27.203209],
						[103.615512, 27.207474],
						[103.612994, 27.219645],
						[103.619767, 27.231001],
						[103.621552, 27.237193],
						[103.619889, 27.245462],
						[103.614118, 27.251288],
						[103.611673, 27.256686],
						[103.60759, 27.260092],
						[103.602772, 27.255551],
						[103.598542, 27.255487],
						[103.590033, 27.248525],
						[103.579029, 27.249939],
						[103.574579, 27.253045],
						[103.564675, 27.256836],
						[103.559198, 27.263562],
						[103.550077, 27.266646],
						[103.544306, 27.261741],
						[103.537386, 27.259085],
						[103.532007, 27.254544],
						[103.529659, 27.257907],
						[103.515306, 27.253109],
						[103.51022, 27.256236],
						[103.507579, 27.251738],
						[103.502933, 27.251053],
						[103.496942, 27.254951],
						[103.483982, 27.256686],
						[103.478138, 27.250581],
						[103.467305, 27.247968],
						[103.461241, 27.251288],
						[103.460361, 27.256815],
						[103.464958, 27.264097],
						[103.469433, 27.276327],
						[103.470729, 27.286049],
						[103.483909, 27.305127],
						[103.487503, 27.314141],
						[103.49347, 27.321184],
						[103.494057, 27.328805],
						[103.498849, 27.335954],
						[103.498018, 27.342525],
						[103.492223, 27.35053],
						[103.490266, 27.358898],
						[103.497504, 27.379333],
						[103.499558, 27.382499],
						[103.49034, 27.39617],
						[103.484447, 27.40231],
						[103.475546, 27.416791],
						[103.479532, 27.430159],
						[103.477453, 27.43435],
						[103.480901, 27.44098],
						[103.480559, 27.451821],
						[103.478725, 27.454793],
						[103.47222, 27.457957],
						[103.469775, 27.462576],
						[103.474274, 27.468198],
						[103.478065, 27.477177],
						[103.468406, 27.481624],
						[103.461119, 27.477113],
						[103.462293, 27.472025],
						[103.453001, 27.479251],
						[103.447254, 27.485578],
						[103.452903, 27.486711],
						[103.449455, 27.494919],
						[103.453221, 27.502506],
						[103.450042, 27.506759],
						[103.452023, 27.512871],
						[103.448868, 27.517423],
						[103.436373, 27.526526],
						[103.433341, 27.519432],
						[103.429526, 27.515457],
						[103.428206, 27.502442],
						[103.424416, 27.498061],
						[103.416933, 27.501993],
						[103.40972, 27.507977],
						[103.395684, 27.512594],
						[103.388788, 27.512722],
						[103.377173, 27.508234],
						[103.372234, 27.507828],
						[103.364752, 27.503618],
						[103.3626, 27.490601],
						[103.365681, 27.487267],
						[103.364849, 27.48126],
						[103.36908, 27.471149],
						[103.372968, 27.467172],
						[103.37979, 27.465483],
						[103.38314, 27.460074],
						[103.377222, 27.446283],
						[103.363945, 27.439162],
						[103.368199, 27.431763],
						[103.364752, 27.429603],
						[103.364654, 27.424213],
						[103.373188, 27.418524],
						[103.387028, 27.406546],
						[103.385658, 27.404642],
						[103.375902, 27.40539],
						[103.373897, 27.402075],
						[103.383238, 27.395743],
						[103.400746, 27.37852],
						[103.383433, 27.373449],
						[103.379276, 27.368955],
						[103.38248, 27.363905],
						[103.389351, 27.360717],
						[103.395611, 27.36046],
						[103.400452, 27.357635],
						[103.399254, 27.354083],
						[103.393043, 27.34794],
						[103.393581, 27.344152],
						[103.398667, 27.334285],
						[103.390427, 27.330068],
						[103.382528, 27.341648],
						[103.375731, 27.339251],
						[103.372576, 27.329854],
						[103.366414, 27.330475],
						[103.362135, 27.336447],
						[103.356804, 27.336211],
						[103.354677, 27.330774],
						[103.355973, 27.321013],
						[103.349029, 27.316689],
						[103.353577, 27.311229],
						[103.351816, 27.308253],
						[103.342818, 27.309624],
						[103.341106, 27.313798],
						[103.321373, 27.321099],
						[103.313303, 27.326707],
						[103.310271, 27.333536],
						[103.300979, 27.345543],
						[103.296847, 27.352328],
						[103.296309, 27.357721],
						[103.293375, 27.360888],
						[103.28154, 27.361936],
						[103.27819, 27.365703],
						[103.27638, 27.372015],
						[103.269802, 27.374326],
						[103.270047, 27.377386],
						[103.27594, 27.381644],
						[103.262809, 27.390651],
						[103.263616, 27.396256],
						[103.250876, 27.400877],
						[103.246695, 27.405433],
						[103.236351, 27.412342],
						[103.233001, 27.405262],
						[103.227695, 27.40646],
						[103.226839, 27.399615],
						[103.221166, 27.397818],
						[103.223025, 27.403037],
						[103.219528, 27.412428],
						[103.211605, 27.409155],
						[103.204807, 27.410032],
						[103.200651, 27.406439],
						[103.197105, 27.400042],
						[103.18752, 27.400021],
						[103.184561, 27.396727],
						[103.177372, 27.397518],
						[103.172188, 27.394716],
						[103.156025, 27.396085],
						[103.147589, 27.408021],
						[103.14551, 27.417476],
						[103.142894, 27.421925],
						[103.144923, 27.427763],
						[103.144532, 27.450538],
						[103.150767, 27.464265],
						[103.154973, 27.467578],
						[103.159986, 27.47784],
						[103.16649, 27.485044],
						[103.169938, 27.492033],
						[103.178961, 27.496778],
						[103.180257, 27.506717],
						[103.184903, 27.516953],
						[103.190356, 27.523492],
						[103.204465, 27.529154],
						[103.208842, 27.533107],
						[103.209502, 27.536868],
						[103.215004, 27.545371],
						[103.217621, 27.554386],
						[103.218159, 27.562162],
						[103.2219, 27.566305],
						[103.23618, 27.570449],
						[103.262589, 27.567993],
						[103.264643, 27.560239],
						[103.271636, 27.552805],
						[103.279143, 27.55084],
						[103.293203, 27.537658],
						[103.302887, 27.529624],
						[103.318023, 27.522423],
						[103.3313, 27.514966],
						[103.333208, 27.510435],
						[103.338441, 27.505605],
						[103.342304, 27.504665],
						[103.34316, 27.508597],
						[103.346828, 27.509794],
						[103.356976, 27.506182],
						[103.366341, 27.507272],
						[103.37287, 27.512102],
						[103.38693, 27.517017],
						[103.386025, 27.528941],
						[103.380548, 27.538833],
						[103.38133, 27.548319],
						[103.40121, 27.556907],
						[103.414732, 27.560517],
						[103.428035, 27.561393],
						[103.441117, 27.560367],
						[103.451729, 27.562674],
						[103.452023, 27.569018],
						[103.455397, 27.578629],
						[103.45794, 27.581363],
						[103.466939, 27.579185],
						[103.474837, 27.573397],
						[103.498116, 27.565878],
						[103.505843, 27.559449],
						[103.508581, 27.560025],
						[103.514621, 27.569061],
						[103.516186, 27.575234],
						[103.515844, 27.582837],
						[103.522739, 27.58414],
						[103.528021, 27.582709],
						[103.535112, 27.575703],
						[103.536237, 27.572115],
						[103.543475, 27.572265],
						[103.537729, 27.564661],
						[103.541739, 27.56323],
						[103.539538, 27.557633],
						[103.54257, 27.554642],
						[103.537582, 27.544132],
						[103.539098, 27.540713],
						[103.547461, 27.538726],
						[103.552449, 27.53315],
						[103.560812, 27.529582],
						[103.57316, 27.531334],
						[103.574579, 27.533342],
						[103.584702, 27.536098],
						[103.591206, 27.543277],
						[103.592087, 27.5474],
						[103.589886, 27.553681],
						[103.594556, 27.556309],
						[103.602919, 27.556138],
						[103.604973, 27.560004],
						[103.591989, 27.568185],
						[103.588981, 27.576173],
						[103.590986, 27.580851],
						[103.586194, 27.584246],
						[103.588321, 27.589799],
						[103.593529, 27.589628],
						[103.600278, 27.585143],
						[103.611258, 27.580936],
						[103.614534, 27.582709],
						[103.613189, 27.592532],
						[103.615048, 27.599045],
						[103.626076, 27.602633],
						[103.632874, 27.600989],
						[103.646225, 27.590568],
						[103.653707, 27.591785],
						[103.661679, 27.596205],
						[103.660211, 27.605921],
						[103.657033, 27.61096],
						[103.659282, 27.612732],
						[103.66943, 27.612369],
						[103.68058, 27.607693],
						[103.693149, 27.607757],
						[103.699433, 27.608932],
						[103.706036, 27.607821],
						[103.703101, 27.61634],
						[103.707429, 27.618497],
						[103.711978, 27.624795],
						[103.722223, 27.623428],
						[103.740073, 27.623663],
						[103.743766, 27.620034],
						[103.752495, 27.622276],
						[103.753498, 27.629747],
						[103.759318, 27.630772],
						[103.759831, 27.637795],
						[103.764257, 27.644434],
						[103.771935, 27.647102],
						[103.777584, 27.638756],
						[103.770028, 27.632736],
						[103.774723, 27.627997],
						[103.779222, 27.629726],
						[103.784822, 27.636194],
						[103.801694, 27.636152],
						[103.801718, 27.64025],
						[103.805435, 27.643366],
						[103.810986, 27.641573],
						[103.816463, 27.642747],
						[103.821354, 27.648574],
						[103.828665, 27.647593],
						[103.844168, 27.631348],
						[103.849083, 27.629214],
						[103.845146, 27.627186],
						[103.84495, 27.616917],
						[103.854096, 27.611344],
						[103.872997, 27.623791],
						[103.878255, 27.62424],
						[103.8807, 27.619564],
						[103.8863, 27.619991],
						[103.89075, 27.623514],
						[103.890603, 27.629961],
						[103.900629, 27.636578],
						[103.915251, 27.639524],
						[103.921487, 27.631455],
						[103.935351, 27.630217],
						[103.937674, 27.623962],
						[103.930632, 27.610298],
						[103.930583, 27.600668],
						[103.924201, 27.582687],
						[103.912537, 27.561777],
						[103.912537, 27.555475],
						[103.921511, 27.550562],
						[103.924274, 27.54426],
						[103.91755, 27.540436],
						[103.913051, 27.532872],
						[103.900482, 27.524966],
						[103.896839, 27.520265],
						[103.891337, 27.508704],
						[103.88383, 27.50631],
						[103.876323, 27.499856],
						[103.871164, 27.493615],
						[103.858301, 27.493038],
						[103.856272, 27.490238],
						[103.857226, 27.475937],
						[103.855612, 27.468861],
						[103.856565, 27.461442],
						[103.853289, 27.455776],
						[103.856761, 27.448549],
						[103.864928, 27.451201],
						[103.875076, 27.447544],
						[103.877546, 27.442519],
						[103.88515, 27.437515],
						[103.886006, 27.43234],
						[103.882754, 27.427549],
						[103.881923, 27.421946],
						[103.876421, 27.415722],
						[103.877497, 27.408813],
						[103.8874, 27.402909],
						[103.893978, 27.397475],
						[103.897939, 27.397711],
						[103.906669, 27.387463],
						[103.904884, 27.384553],
						[103.905226, 27.374947],
						[103.903319, 27.347983],
						[103.905006, 27.345072],
						[103.90014, 27.342204],
						[103.893709, 27.341755],
						[103.887987, 27.336254],
						[103.885762, 27.33071],
						[103.877008, 27.332958],
						[103.874049, 27.330368],
						[103.875051, 27.314184],
						[103.872215, 27.311893],
						[103.87246, 27.305127],
						[103.865588, 27.303115],
						[103.865466, 27.281723],
						[103.85835, 27.286349],
						[103.845488, 27.287527],
						[103.84116, 27.282965],
						[103.841405, 27.27275],
						[103.834827, 27.266903],
						[103.821134, 27.263947],
						[103.815876, 27.26701],
						[103.806315, 27.268188],
						[103.800691, 27.26549],
						[103.801352, 27.250731],
						[103.798002, 27.24754],
						[103.791399, 27.253216],
						[103.789199, 27.253045],
						[103.791277, 27.244048],
						[103.784797, 27.236528],
						[103.781545, 27.229951],
						[103.774821, 27.228387],
						[103.778415, 27.222538],
						[103.77372, 27.222345],
						[103.766042, 27.21626],
						[103.764575, 27.212038],
						[103.749586, 27.211288],
						[103.745844, 27.198602],
						[103.740147, 27.195387],
						[103.737213, 27.185057],
						[103.72819, 27.179162],
						[103.72682, 27.174768],
						[103.719484, 27.161241],
						[103.716526, 27.159441],
						[103.708261, 27.160877],
						[103.706647, 27.157275],
						[103.711586, 27.142524],
						[103.709459, 27.135877],
						[103.70139, 27.13459],
						[103.696206, 27.126678],
						[103.688038, 27.130816],
						[103.674687, 27.131095],
						[103.661459, 27.12301],
						[103.65493, 27.125777],
						[103.65021, 27.125584],
						[103.64444, 27.121552],
						[103.633509, 27.120373],
						[103.627812, 27.11692]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530621,
			"name": "鲁甸县",
			"center": [103.549333, 27.191637],
			"centroid": [103.42046, 27.207205],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 1,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.627812, 27.11692],
						[103.624535, 27.112201],
						[103.620427, 27.096758],
						[103.627396, 27.095707],
						[103.63258, 27.091696],
						[103.641163, 27.089979],
						[103.647887, 27.092554],
						[103.65334, 27.092575],
						[103.660456, 27.071229],
						[103.659845, 27.065779],
						[103.655321, 27.067045],
						[103.64779, 27.065565],
						[103.637275, 27.070135],
						[103.628374, 27.072645],
						[103.617909, 27.079811],
						[103.612774, 27.077622],
						[103.608641, 27.06565],
						[103.601428, 27.062196],
						[103.605193, 27.055522],
						[103.607149, 27.047304],
						[103.612725, 27.039728],
						[103.618226, 27.035006],
						[103.62297, 27.035521],
						[103.62813, 27.016118],
						[103.623997, 27.015667],
						[103.613703, 27.009334],
						[103.614387, 26.994414],
						[103.611184, 26.99027],
						[103.596195, 26.987629],
						[103.57986, 26.989711],
						[103.569957, 26.99349],
						[103.56783, 27.000146],
						[103.555114, 27.004826],
						[103.548292, 27.0021],
						[103.531616, 27.000146],
						[103.524622, 26.993598],
						[103.517922, 26.992631],
						[103.502517, 26.999244],
						[103.496526, 27.006458],
						[103.481732, 27.005019],
						[103.476402, 26.996797],
						[103.4564, 26.98662],
						[103.448135, 26.988187],
						[103.439723, 26.994585],
						[103.437865, 26.997849],
						[103.42757, 27.00182],
						[103.425272, 27.004483],
						[103.426127, 27.014851],
						[103.42378, 27.022192],
						[103.419721, 27.026271],
						[103.410624, 27.030456],
						[103.391894, 27.031057],
						[103.389742, 27.033461],
						[103.3916, 27.040307],
						[103.388911, 27.047454],
						[103.381355, 27.049535],
						[103.372796, 27.049986],
						[103.369544, 27.046209],
						[103.364214, 27.031551],
						[103.356315, 27.018822],
						[103.3492, 27.016397],
						[103.338563, 27.004783],
						[103.338734, 27.000382],
						[103.334968, 26.997033],
						[103.323842, 27.003259],
						[103.321739, 27.013821],
						[103.313866, 27.020175],
						[103.303938, 27.020948],
						[103.28286, 27.030263],
						[103.282542, 27.034513],
						[103.27594, 27.042303],
						[103.277211, 27.047089],
						[103.282787, 27.050608],
						[103.284938, 27.056273],
						[103.283716, 27.060951],
						[103.292127, 27.075713],
						[103.291687, 27.079789],
						[103.299072, 27.092168],
						[103.298363, 27.096393],
						[103.300759, 27.102528],
						[103.299683, 27.114754],
						[103.295844, 27.123096],
						[103.281295, 27.126635],
						[103.262736, 27.125734],
						[103.256011, 27.127106],
						[103.253346, 27.132082],
						[103.247599, 27.136263],
						[103.2431, 27.147349],
						[103.230165, 27.154402],
						[103.229578, 27.162013],
						[103.226057, 27.166215],
						[103.226521, 27.170845],
						[103.219479, 27.175668],
						[103.21943, 27.18212],
						[103.216251, 27.188915],
						[103.216936, 27.192001],
						[103.21339, 27.197209],
						[103.206886, 27.201088],
						[103.20493, 27.208353],
						[103.195931, 27.218767],
						[103.196274, 27.226137],
						[103.201311, 27.232222],
						[103.217083, 27.241263],
						[103.219137, 27.247775],
						[103.22569, 27.256087],
						[103.226937, 27.263755],
						[103.224981, 27.266175],
						[103.228404, 27.2735],
						[103.227133, 27.281959],
						[103.228722, 27.289111],
						[103.226717, 27.29804],
						[103.222071, 27.306391],
						[103.220555, 27.321099],
						[103.224296, 27.32705],
						[103.224834, 27.340727],
						[103.21498, 27.357656],
						[103.214222, 27.368912],
						[103.21048, 27.373941],
						[103.195907, 27.382713],
						[103.180257, 27.380253],
						[103.167297, 27.385987],
						[103.156025, 27.396085],
						[103.172188, 27.394716],
						[103.177372, 27.397518],
						[103.184561, 27.396727],
						[103.18752, 27.400021],
						[103.197105, 27.400042],
						[103.200651, 27.406439],
						[103.204807, 27.410032],
						[103.211605, 27.409155],
						[103.219528, 27.412428],
						[103.223025, 27.403037],
						[103.221166, 27.397818],
						[103.226839, 27.399615],
						[103.227695, 27.40646],
						[103.233001, 27.405262],
						[103.236351, 27.412342],
						[103.246695, 27.405433],
						[103.250876, 27.400877],
						[103.263616, 27.396256],
						[103.262809, 27.390651],
						[103.27594, 27.381644],
						[103.270047, 27.377386],
						[103.269802, 27.374326],
						[103.27638, 27.372015],
						[103.27819, 27.365703],
						[103.28154, 27.361936],
						[103.293375, 27.360888],
						[103.296309, 27.357721],
						[103.296847, 27.352328],
						[103.300979, 27.345543],
						[103.310271, 27.333536],
						[103.313303, 27.326707],
						[103.321373, 27.321099],
						[103.341106, 27.313798],
						[103.342818, 27.309624],
						[103.351816, 27.308253],
						[103.353577, 27.311229],
						[103.349029, 27.316689],
						[103.355973, 27.321013],
						[103.354677, 27.330774],
						[103.356804, 27.336211],
						[103.362135, 27.336447],
						[103.366414, 27.330475],
						[103.372576, 27.329854],
						[103.375731, 27.339251],
						[103.382528, 27.341648],
						[103.390427, 27.330068],
						[103.398667, 27.334285],
						[103.393581, 27.344152],
						[103.393043, 27.34794],
						[103.399254, 27.354083],
						[103.400452, 27.357635],
						[103.395611, 27.36046],
						[103.389351, 27.360717],
						[103.38248, 27.363905],
						[103.379276, 27.368955],
						[103.383433, 27.373449],
						[103.400746, 27.37852],
						[103.383238, 27.395743],
						[103.373897, 27.402075],
						[103.375902, 27.40539],
						[103.385658, 27.404642],
						[103.387028, 27.406546],
						[103.373188, 27.418524],
						[103.364654, 27.424213],
						[103.364752, 27.429603],
						[103.368199, 27.431763],
						[103.363945, 27.439162],
						[103.377222, 27.446283],
						[103.38314, 27.460074],
						[103.37979, 27.465483],
						[103.372968, 27.467172],
						[103.36908, 27.471149],
						[103.364849, 27.48126],
						[103.365681, 27.487267],
						[103.3626, 27.490601],
						[103.364752, 27.503618],
						[103.372234, 27.507828],
						[103.377173, 27.508234],
						[103.388788, 27.512722],
						[103.395684, 27.512594],
						[103.40972, 27.507977],
						[103.416933, 27.501993],
						[103.424416, 27.498061],
						[103.428206, 27.502442],
						[103.429526, 27.515457],
						[103.433341, 27.519432],
						[103.436373, 27.526526],
						[103.448868, 27.517423],
						[103.452023, 27.512871],
						[103.450042, 27.506759],
						[103.453221, 27.502506],
						[103.449455, 27.494919],
						[103.452903, 27.486711],
						[103.447254, 27.485578],
						[103.453001, 27.479251],
						[103.462293, 27.472025],
						[103.461119, 27.477113],
						[103.468406, 27.481624],
						[103.478065, 27.477177],
						[103.474274, 27.468198],
						[103.469775, 27.462576],
						[103.47222, 27.457957],
						[103.478725, 27.454793],
						[103.480559, 27.451821],
						[103.480901, 27.44098],
						[103.477453, 27.43435],
						[103.479532, 27.430159],
						[103.475546, 27.416791],
						[103.484447, 27.40231],
						[103.49034, 27.39617],
						[103.499558, 27.382499],
						[103.497504, 27.379333],
						[103.490266, 27.358898],
						[103.492223, 27.35053],
						[103.498018, 27.342525],
						[103.498849, 27.335954],
						[103.494057, 27.328805],
						[103.49347, 27.321184],
						[103.487503, 27.314141],
						[103.483909, 27.305127],
						[103.470729, 27.286049],
						[103.469433, 27.276327],
						[103.464958, 27.264097],
						[103.460361, 27.256815],
						[103.461241, 27.251288],
						[103.467305, 27.247968],
						[103.478138, 27.250581],
						[103.483982, 27.256686],
						[103.496942, 27.254951],
						[103.502933, 27.251053],
						[103.507579, 27.251738],
						[103.51022, 27.256236],
						[103.515306, 27.253109],
						[103.529659, 27.257907],
						[103.532007, 27.254544],
						[103.537386, 27.259085],
						[103.544306, 27.261741],
						[103.550077, 27.266646],
						[103.559198, 27.263562],
						[103.564675, 27.256836],
						[103.574579, 27.253045],
						[103.579029, 27.249939],
						[103.590033, 27.248525],
						[103.598542, 27.255487],
						[103.602772, 27.255551],
						[103.60759, 27.260092],
						[103.611673, 27.256686],
						[103.614118, 27.251288],
						[103.619889, 27.245462],
						[103.621552, 27.237193],
						[103.619767, 27.231001],
						[103.612994, 27.219645],
						[103.615512, 27.207474],
						[103.623557, 27.203209],
						[103.641285, 27.200531],
						[103.645613, 27.197702],
						[103.653169, 27.188722],
						[103.668061, 27.174554],
						[103.668134, 27.167373],
						[103.647618, 27.161263],
						[103.637446, 27.159205],
						[103.635294, 27.152323],
						[103.626663, 27.14722],
						[103.620207, 27.134934],
						[103.620378, 27.12627],
						[103.627812, 27.11692]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530622,
			"name": "巧家县",
			"center": [102.929284, 26.9117],
			"centroid": [103.123126, 27.002171],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 2,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[102.895899, 26.932133],
						[102.895899, 26.9331],
						[102.890103, 26.941499],
						[102.888881, 26.951637],
						[102.892695, 26.963342],
						[102.89563, 26.977794],
						[102.894114, 26.989776],
						[102.894872, 27.001563],
						[102.88712, 27.011631],
						[102.872595, 27.022729],
						[102.871299, 27.027966],
						[102.878586, 27.037152],
						[102.8813, 27.042904],
						[102.885311, 27.059557],
						[102.890274, 27.066251],
						[102.8947, 27.069319],
						[102.898931, 27.076314],
						[102.898833, 27.088671],
						[102.900007, 27.093026],
						[102.908076, 27.109456],
						[102.913602, 27.133797],
						[102.913529, 27.14008],
						[102.905264, 27.167394],
						[102.908369, 27.179398],
						[102.904408, 27.186064],
						[102.902207, 27.195923],
						[102.904726, 27.202481],
						[102.90409, 27.227551],
						[102.90162, 27.235757],
						[102.88756, 27.246383],
						[102.883232, 27.258271],
						[102.882596, 27.270587],
						[102.884895, 27.281702],
						[102.882156, 27.29333],
						[102.884186, 27.299282],
						[102.891668, 27.304935],
						[102.900031, 27.317609],
						[102.902794, 27.326985],
						[102.907685, 27.337966],
						[102.911426, 27.349117],
						[102.921158, 27.364141],
						[102.922894, 27.371908],
						[102.934607, 27.388169],
						[102.941405, 27.405562],
						[102.94495, 27.410439],
						[102.950697, 27.413027],
						[102.955269, 27.411401],
						[102.958228, 27.405476],
						[102.962532, 27.389945],
						[102.970943, 27.377621],
						[102.979697, 27.369833],
						[102.985321, 27.367372],
						[102.99009, 27.368185],
						[102.997181, 27.372678],
						[103.016865, 27.37867],
						[103.025864, 27.382542],
						[103.033297, 27.387998],
						[103.055623, 27.409476],
						[103.064108, 27.410353],
						[103.072226, 27.407337],
						[103.079537, 27.397304],
						[103.089318, 27.398802],
						[103.100346, 27.397326],
						[103.11157, 27.401027],
						[103.12541, 27.412364],
						[103.142894, 27.421925],
						[103.14551, 27.417476],
						[103.147589, 27.408021],
						[103.156025, 27.396085],
						[103.167297, 27.385987],
						[103.180257, 27.380253],
						[103.195907, 27.382713],
						[103.21048, 27.373941],
						[103.214222, 27.368912],
						[103.21498, 27.357656],
						[103.224834, 27.340727],
						[103.224296, 27.32705],
						[103.220555, 27.321099],
						[103.222071, 27.306391],
						[103.226717, 27.29804],
						[103.228722, 27.289111],
						[103.227133, 27.281959],
						[103.228404, 27.2735],
						[103.224981, 27.266175],
						[103.226937, 27.263755],
						[103.22569, 27.256087],
						[103.219137, 27.247775],
						[103.217083, 27.241263],
						[103.201311, 27.232222],
						[103.196274, 27.226137],
						[103.195931, 27.218767],
						[103.20493, 27.208353],
						[103.206886, 27.201088],
						[103.21339, 27.197209],
						[103.216936, 27.192001],
						[103.216251, 27.188915],
						[103.21943, 27.18212],
						[103.219479, 27.175668],
						[103.226521, 27.170845],
						[103.226057, 27.166215],
						[103.229578, 27.162013],
						[103.230165, 27.154402],
						[103.2431, 27.147349],
						[103.247599, 27.136263],
						[103.253346, 27.132082],
						[103.256011, 27.127106],
						[103.262736, 27.125734],
						[103.281295, 27.126635],
						[103.295844, 27.123096],
						[103.299683, 27.114754],
						[103.300759, 27.102528],
						[103.298363, 27.096393],
						[103.299072, 27.092168],
						[103.291687, 27.079789],
						[103.292127, 27.075713],
						[103.283716, 27.060951],
						[103.284938, 27.056273],
						[103.282787, 27.050608],
						[103.277211, 27.047089],
						[103.27594, 27.042303],
						[103.282542, 27.034513],
						[103.28286, 27.030263],
						[103.303938, 27.020948],
						[103.313866, 27.020175],
						[103.321739, 27.013821],
						[103.323842, 27.003259],
						[103.334968, 26.997033],
						[103.338734, 27.000382],
						[103.338563, 27.004783],
						[103.3492, 27.016397],
						[103.356315, 27.018822],
						[103.364214, 27.031551],
						[103.369544, 27.046209],
						[103.372796, 27.049986],
						[103.381355, 27.049535],
						[103.388911, 27.047454],
						[103.3916, 27.040307],
						[103.389742, 27.033461],
						[103.391894, 27.031057],
						[103.410624, 27.030456],
						[103.419721, 27.026271],
						[103.42378, 27.022192],
						[103.426127, 27.014851],
						[103.425272, 27.004483],
						[103.419452, 26.99933],
						[103.419819, 26.994693],
						[103.426714, 26.992352],
						[103.434808, 26.985825],
						[103.441679, 26.976119],
						[103.441728, 26.971524],
						[103.436177, 26.963557],
						[103.439919, 26.956298],
						[103.439405, 26.949317],
						[103.434784, 26.938706],
						[103.432632, 26.930285],
						[103.424318, 26.922917],
						[103.419305, 26.908779],
						[103.419134, 26.903408],
						[103.415148, 26.899132],
						[103.405245, 26.900163],
						[103.397518, 26.902376],
						[103.39566, 26.897756],
						[103.398251, 26.89492],
						[103.407592, 26.892427],
						[103.409231, 26.89045],
						[103.409866, 26.875793],
						[103.404878, 26.870699],
						[103.403973, 26.863713],
						[103.397298, 26.853868],
						[103.388593, 26.845871],
						[103.391796, 26.837744],
						[103.387957, 26.825295],
						[103.386245, 26.815447],
						[103.37891, 26.809167],
						[103.377565, 26.801361],
						[103.373359, 26.79037],
						[103.367343, 26.784326],
						[103.366268, 26.780153],
						[103.368664, 26.77471],
						[103.380157, 26.762125],
						[103.389497, 26.757822],
						[103.390793, 26.74743],
						[103.385683, 26.740609],
						[103.385194, 26.733077],
						[103.388446, 26.73142],
						[103.397102, 26.731528],
						[103.398887, 26.729462],
						[103.394021, 26.724469],
						[103.397836, 26.720358],
						[103.406003, 26.716032],
						[103.404658, 26.709123],
						[103.397151, 26.707746],
						[103.392481, 26.710544],
						[103.377076, 26.713213],
						[103.372699, 26.715494],
						[103.372014, 26.722252],
						[103.37419, 26.731894],
						[103.370669, 26.735229],
						[103.365167, 26.735165],
						[103.352501, 26.727977],
						[103.347928, 26.721413],
						[103.338758, 26.713966],
						[103.327999, 26.714117],
						[103.307337, 26.72632],
						[103.301297, 26.735251],
						[103.299072, 26.734734],
						[103.298461, 26.727998],
						[103.293888, 26.724727],
						[103.28242, 26.728085],
						[103.268629, 26.728149],
						[103.260902, 26.721025],
						[103.245448, 26.725545],
						[103.241413, 26.725136],
						[103.236865, 26.720767],
						[103.237207, 26.716355],
						[103.233417, 26.703161],
						[103.239848, 26.694658],
						[103.233686, 26.690675],
						[103.227328, 26.681892],
						[103.225934, 26.676466],
						[103.219137, 26.673],
						[103.217401, 26.668973],
						[103.224101, 26.661308],
						[103.225225, 26.654654],
						[103.220041, 26.650196],
						[103.217743, 26.645156],
						[103.213782, 26.644683],
						[103.21026, 26.640827],
						[103.214613, 26.634086],
						[103.213953, 26.629391],
						[103.210432, 26.626095],
						[103.197496, 26.618125],
						[103.17275, 26.610628],
						[103.167273, 26.617716],
						[103.134262, 26.632363],
						[103.126975, 26.636498],
						[103.119664, 26.63708],
						[103.109491, 26.633612],
						[103.110543, 26.627538],
						[103.108, 26.621076],
						[103.096532, 26.613989],
						[103.088218, 26.610973],
						[103.084208, 26.614549],
						[103.077263, 26.613989],
						[103.072568, 26.610758],
						[103.075209, 26.604273],
						[103.06357, 26.599533],
						[103.068411, 26.594341],
						[103.068093, 26.582705],
						[103.070563, 26.574603],
						[103.064499, 26.568267],
						[103.063154, 26.546649],
						[103.066015, 26.538825],
						[103.073277, 26.537747],
						[103.082251, 26.539234],
						[103.084525, 26.536195],
						[103.075551, 26.536065],
						[103.066357, 26.533155],
						[103.062298, 26.534664],
						[103.054571, 26.541843],
						[103.056234, 26.547081],
						[103.053544, 26.55428],
						[103.04726, 26.556219],
						[103.036696, 26.555357],
						[103.031512, 26.564625],
						[103.030877, 26.572254],
						[103.027478, 26.579214],
						[103.020215, 26.588049],
						[103.019359, 26.594362],
						[103.028016, 26.598844],
						[103.029678, 26.603282],
						[103.026989, 26.618534],
						[103.028871, 26.626741],
						[103.025644, 26.633418],
						[103.024372, 26.64128],
						[103.027453, 26.645846],
						[103.026426, 26.653146],
						[103.027404, 26.662556],
						[103.013075, 26.674033],
						[103.005935, 26.677413],
						[103.005201, 26.680471],
						[103.007084, 26.69328],
						[103.006473, 26.697112],
						[103.010434, 26.701374],
						[103.009309, 26.708241],
						[103.004468, 26.714719],
						[102.9997, 26.71756],
						[102.997132, 26.722145],
						[102.997719, 26.726384],
						[103.002683, 26.728709],
						[103.000653, 26.736671],
						[102.994247, 26.739533],
						[102.992975, 26.748613],
						[102.98361, 26.765632],
						[102.989136, 26.769978],
						[102.991753, 26.774667],
						[102.984294, 26.781594],
						[102.979991, 26.787939],
						[102.981311, 26.802049],
						[102.977032, 26.810178],
						[102.97197, 26.814199],
						[102.967862, 26.821511],
						[102.970626, 26.830198],
						[102.967936, 26.836067],
						[102.962727, 26.840561],
						[102.956492, 26.840668],
						[102.947396, 26.844323],
						[102.939424, 26.858447],
						[102.924777, 26.874074],
						[102.918762, 26.885314],
						[102.912649, 26.894404],
						[102.91101, 26.901195],
						[102.900373, 26.907039],
						[102.896632, 26.911401],
						[102.898075, 26.919136],
						[102.895238, 26.925989],
						[102.895899, 26.932133]
					]
				],
				[
					[
						[103.405587, 26.737747],
						[103.408864, 26.736994],
						[103.392432, 26.733335],
						[103.393263, 26.735767],
						[103.405587, 26.737747]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530623,
			"name": "盐津县",
			"center": [104.23506, 28.106923],
			"centroid": [104.223786, 28.12464],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 3,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.453378, 27.924202],
						[104.448561, 27.91675],
						[104.441152, 27.909702],
						[104.439294, 27.90538],
						[104.438805, 27.885895],
						[104.445896, 27.88238],
						[104.455408, 27.875352],
						[104.458905, 27.870453],
						[104.456044, 27.867684],
						[104.445896, 27.865064],
						[104.438805, 27.865277],
						[104.435699, 27.858971],
						[104.430735, 27.854668],
						[104.429953, 27.85944],
						[104.424598, 27.863913],
						[104.412274, 27.869154],
						[104.410195, 27.876353],
						[104.406527, 27.880102],
						[104.403006, 27.880059],
						[104.389288, 27.868813],
						[104.384055, 27.853709],
						[104.376646, 27.853837],
						[104.367574, 27.848277],
						[104.359114, 27.840309],
						[104.355153, 27.839669],
						[104.347499, 27.832595],
						[104.346912, 27.825926],
						[104.339796, 27.825691],
						[104.334123, 27.833682],
						[104.331727, 27.83413],
						[104.318229, 27.823816],
						[104.305856, 27.833426],
						[104.30121, 27.833746],
						[104.291894, 27.828206],
						[104.289229, 27.823731],
						[104.280695, 27.822239],
						[104.275462, 27.817167],
						[104.264996, 27.822921],
						[104.263994, 27.829442],
						[104.25722, 27.835621],
						[104.250153, 27.836473],
						[104.246461, 27.835024],
						[104.240201, 27.84148],
						[104.236533, 27.842162],
						[104.23179, 27.84702],
						[104.232327, 27.852602],
						[104.23849, 27.862912],
						[104.237854, 27.871284],
						[104.242793, 27.881848],
						[104.249884, 27.886235],
						[104.249664, 27.896053],
						[104.240226, 27.904251],
						[104.236436, 27.90983],
						[104.241668, 27.919177],
						[104.23311, 27.929694],
						[104.232425, 27.937741],
						[104.226801, 27.940466],
						[104.223573, 27.935889],
						[104.214037, 27.929162],
						[104.206163, 27.925735],
						[104.197923, 27.914557],
						[104.190025, 27.909553],
						[104.182762, 27.899673],
						[104.160999, 27.888259],
						[104.150705, 27.875927],
						[104.13975, 27.865916],
						[104.127157, 27.844698],
						[104.119259, 27.839819],
						[104.11119, 27.841267],
						[104.100259, 27.839819],
						[104.097667, 27.843995],
						[104.102485, 27.858077],
						[104.110407, 27.862082],
						[104.10916, 27.877865],
						[104.112412, 27.880719],
						[104.125739, 27.881912],
						[104.130311, 27.885383],
						[104.123367, 27.891645],
						[104.116863, 27.900717],
						[104.107693, 27.905635],
						[104.100333, 27.920327],
						[104.100015, 27.926629],
						[104.0962, 27.9397],
						[104.088302, 27.939402],
						[104.083314, 27.94219],
						[104.074266, 27.944489],
						[104.072604, 27.946852],
						[104.072139, 27.956196],
						[104.078056, 27.963921],
						[104.078399, 27.969859],
						[104.075318, 27.970944],
						[104.066001, 27.96456],
						[104.053139, 27.962283],
						[104.047931, 27.963858],
						[104.039593, 27.973498],
						[104.032819, 27.989521],
						[104.034409, 27.994712],
						[104.039446, 27.996733],
						[104.047222, 28.004945],
						[104.04864, 28.014625],
						[104.063752, 28.013327],
						[104.072775, 28.016348],
						[104.076345, 28.019772],
						[104.064608, 28.019857],
						[104.053457, 28.030067],
						[104.053237, 28.035724],
						[104.057859, 28.04019],
						[104.058323, 28.047187],
						[104.055585, 28.055778],
						[104.046146, 28.060732],
						[104.037392, 28.059946],
						[104.029054, 28.061158],
						[104.029469, 28.064134],
						[104.037245, 28.069918],
						[104.032599, 28.083332],
						[104.018735, 28.085756],
						[104.013502, 28.089731],
						[104.013086, 28.095853],
						[104.007022, 28.102676],
						[104.007633, 28.112027],
						[104.010323, 28.114493],
						[104.010934, 28.120571],
						[104.008489, 28.126181],
						[104.014235, 28.149681],
						[104.01827, 28.153696],
						[104.026804, 28.1582],
						[104.033406, 28.158816],
						[104.034873, 28.167292],
						[104.032844, 28.175342],
						[104.035436, 28.194605],
						[104.033944, 28.198831],
						[104.020569, 28.200402],
						[104.012964, 28.209703],
						[104.011301, 28.216582],
						[104.002963, 28.222421],
						[104.002474, 28.229087],
						[103.996214, 28.235965],
						[103.992497, 28.24227],
						[103.991299, 28.24382],
						[103.993622, 28.255854],
						[104.004356, 28.260884],
						[104.010201, 28.259844],
						[104.013648, 28.262603],
						[104.02744, 28.266996],
						[104.028442, 28.269861],
						[104.020935, 28.279793],
						[104.019346, 28.286116],
						[104.014578, 28.291675],
						[104.014822, 28.304616],
						[104.01827, 28.313272],
						[104.004063, 28.337642],
						[104.009858, 28.346125],
						[104.013722, 28.349794],
						[104.023894, 28.353526],
						[104.034066, 28.351723],
						[104.04397, 28.354459],
						[104.050327, 28.351978],
						[104.05424, 28.357024],
						[104.05847, 28.357873],
						[104.064925, 28.352996],
						[104.078301, 28.356091],
						[104.076076, 28.377272],
						[104.07967, 28.37971],
						[104.086444, 28.378226],
						[104.091921, 28.376806],
						[104.09867, 28.379074],
						[104.108182, 28.379668],
						[104.117303, 28.387935],
						[104.128086, 28.396245],
						[104.13464, 28.398958],
						[104.146157, 28.397919],
						[104.159043, 28.400802],
						[104.176209, 28.400844],
						[104.176576, 28.398131],
						[104.190171, 28.38872],
						[104.202006, 28.391094],
						[104.2302, 28.381215],
						[104.228635, 28.379117],
						[104.20966, 28.376361],
						[104.203816, 28.37193],
						[104.207044, 28.370212],
						[104.221666, 28.371188],
						[104.22575, 28.372778],
						[104.236631, 28.372757],
						[104.245165, 28.381533],
						[104.249469, 28.388804],
						[104.254873, 28.388995],
						[104.261475, 28.39173],
						[104.273726, 28.391624],
						[104.27463, 28.389016],
						[104.268786, 28.381682],
						[104.268444, 28.376233],
						[104.273041, 28.367202],
						[104.277173, 28.355752],
						[104.278421, 28.346634],
						[104.281575, 28.343559],
						[104.28627, 28.343347],
						[104.285316, 28.338681],
						[104.290182, 28.333061],
						[104.299719, 28.330622],
						[104.30187, 28.328501],
						[104.290035, 28.314735],
						[104.296613, 28.308138],
						[104.30571, 28.30642],
						[104.31395, 28.306611],
						[104.323169, 28.311193],
						[104.327423, 28.315117],
						[104.331287, 28.323856],
						[104.338598, 28.330813],
						[104.346961, 28.334906],
						[104.350971, 28.333634],
						[104.358282, 28.338915],
						[104.370655, 28.337133],
						[104.384813, 28.330113],
						[104.388873, 28.31709],
						[104.389093, 28.305804],
						[104.395524, 28.300755],
						[104.392932, 28.291547],
						[104.401808, 28.284737],
						[104.406723, 28.275527],
						[104.408239, 28.26984],
						[104.417091, 28.269479],
						[104.432325, 28.274297],
						[104.449368, 28.269968],
						[104.444111, 28.259229],
						[104.462352, 28.241633],
						[104.460445, 28.236836],
						[104.45196, 28.234522],
						[104.450053, 28.228811],
						[104.450102, 28.219512],
						[104.442521, 28.21155],
						[104.435846, 28.209257],
						[104.419169, 28.208068],
						[104.4167, 28.204097],
						[104.406283, 28.203588],
						[104.401368, 28.201443],
						[104.401661, 28.195306],
						[104.407823, 28.181841],
						[104.404424, 28.177169],
						[104.406332, 28.173324],
						[104.412469, 28.173898],
						[104.417164, 28.170074],
						[104.426798, 28.169841],
						[104.43499, 28.168226],
						[104.446165, 28.171009],
						[104.451667, 28.174046],
						[104.457902, 28.167844],
						[104.455701, 28.165975],
						[104.445847, 28.163702],
						[104.444698, 28.162045],
						[104.448219, 28.154015],
						[104.445113, 28.145878],
						[104.444796, 28.138165],
						[104.450004, 28.133852],
						[104.452743, 28.12871],
						[104.451031, 28.116363],
						[104.446336, 28.112878],
						[104.433767, 28.113919],
						[104.432887, 28.10529],
						[104.427874, 28.100062],
						[104.421468, 28.097192],
						[104.413399, 28.098042],
						[104.402615, 28.092962],
						[104.39902, 28.087775],
						[104.400243, 28.0794],
						[104.398018, 28.077911],
						[104.39814, 28.068812],
						[104.395377, 28.063879],
						[104.386525, 28.061774],
						[104.382197, 28.059223],
						[104.376475, 28.052291],
						[104.369433, 28.05161],
						[104.351314, 28.054332],
						[104.341435, 28.057862],
						[104.334148, 28.053758],
						[104.321139, 28.054523],
						[104.304022, 28.050738],
						[104.299596, 28.04791],
						[104.298814, 28.043891],
						[104.308522, 28.036299],
						[104.316835, 28.031832],
						[104.324978, 28.029344],
						[104.326616, 28.02543],
						[104.33361, 28.024813],
						[104.347499, 28.021644],
						[104.356155, 28.018475],
						[104.365398, 28.009838],
						[104.367354, 28.004775],
						[104.378774, 27.993712],
						[104.377478, 27.990755],
						[104.372172, 27.990797],
						[104.374519, 27.986733],
						[104.386183, 27.976477],
						[104.383469, 27.968731],
						[104.389851, 27.965815],
						[104.395915, 27.954855],
						[104.401172, 27.952301],
						[104.407065, 27.95345],
						[104.413912, 27.951364],
						[104.421297, 27.941573],
						[104.425992, 27.937805],
						[104.432423, 27.937273],
						[104.437778, 27.930397],
						[104.449662, 27.927608],
						[104.453378, 27.924202]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530624,
			"name": "大关县",
			"center": [103.891608, 27.747114],
			"centroid": [103.905474, 27.898798],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 4,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.771935, 27.647102],
						[103.767925, 27.650602],
						[103.767778, 27.660548],
						[103.765406, 27.663194],
						[103.752862, 27.671133],
						[103.748534, 27.676467],
						[103.744891, 27.684768],
						[103.747018, 27.694454],
						[103.745233, 27.702732],
						[103.741761, 27.706465],
						[103.742494, 27.721482],
						[103.739756, 27.729011],
						[103.744573, 27.73703],
						[103.7478, 27.754623],
						[103.743472, 27.760935],
						[103.741907, 27.766905],
						[103.734816, 27.771425],
						[103.730928, 27.781828],
						[103.72506, 27.784344],
						[103.716575, 27.799862],
						[103.718506, 27.804679],
						[103.723323, 27.808536],
						[103.725451, 27.814226],
						[103.737897, 27.821131],
						[103.742005, 27.822111],
						[103.751419, 27.817615],
						[103.760638, 27.818553],
						[103.764795, 27.817082],
						[103.767387, 27.820897],
						[103.785433, 27.833256],
						[103.788392, 27.833043],
						[103.795434, 27.837667],
						[103.794554, 27.841523],
						[103.784724, 27.854519],
						[103.785726, 27.859376],
						[103.791693, 27.868898],
						[103.78756, 27.872583],
						[103.788098, 27.884723],
						[103.782156, 27.890793],
						[103.784528, 27.896415],
						[103.78399, 27.906232],
						[103.781936, 27.909979],
						[103.773965, 27.914216],
						[103.774649, 27.925522],
						[103.770835, 27.927757],
						[103.766629, 27.936677],
						[103.758608, 27.939253],
						[103.75318, 27.934676],
						[103.739462, 27.941999],
						[103.736186, 27.946107],
						[103.727187, 27.946618],
						[103.728459, 27.953642],
						[103.714447, 27.953173],
						[103.704593, 27.959707],
						[103.700509, 27.969625],
						[103.703028, 27.979733],
						[103.695643, 27.990372],
						[103.69354, 27.997031],
						[103.703468, 28.006371],
						[103.707503, 28.013072],
						[103.706084, 28.016411],
						[103.701145, 28.0179],
						[103.694469, 28.013306],
						[103.690557, 28.013795],
						[103.685569, 28.023409],
						[103.686278, 28.026557],
						[103.692905, 28.032002],
						[103.696988, 28.037553],
						[103.710975, 28.044763],
						[103.718531, 28.039276],
						[103.727652, 28.039191],
						[103.734523, 28.041318],
						[103.737213, 28.04421],
						[103.736454, 28.048484],
						[103.739071, 28.061306],
						[103.738704, 28.06979],
						[103.74983, 28.076955],
						[103.7601, 28.071193],
						[103.767191, 28.069918],
						[103.780567, 28.077146],
						[103.788832, 28.073192],
						[103.798882, 28.071214],
						[103.804335, 28.071533],
						[103.812551, 28.077359],
						[103.814629, 28.082057],
						[103.811817, 28.0865],
						[103.817955, 28.096023],
						[103.826978, 28.09547],
						[103.840304, 28.104079],
						[103.843899, 28.104567],
						[103.849865, 28.111135],
						[103.864464, 28.118339],
						[103.868865, 28.12361],
						[103.888085, 28.121187],
						[103.892339, 28.116915],
						[103.89498, 28.111007],
						[103.902512, 28.105545],
						[103.901705, 28.09953],
						[103.904541, 28.098489],
						[103.91129, 28.106714],
						[103.920949, 28.109031],
						[103.927282, 28.123588],
						[103.921731, 28.129623],
						[103.914787, 28.146813],
						[103.924177, 28.146409],
						[103.927404, 28.150743],
						[103.917623, 28.154907],
						[103.910654, 28.155077],
						[103.906595, 28.158858],
						[103.905544, 28.174938],
						[103.901851, 28.189678],
						[103.902389, 28.195306],
						[103.899553, 28.200063],
						[103.898819, 28.214119],
						[103.896594, 28.224141],
						[103.902683, 28.228705],
						[103.917452, 28.22775],
						[103.921609, 28.230722],
						[103.928798, 28.231868],
						[103.93655, 28.226455],
						[103.952224, 28.222655],
						[103.95797, 28.218748],
						[103.966602, 28.21947],
						[103.970001, 28.222803],
						[103.973815, 28.234543],
						[103.980882, 28.235859],
						[103.987924, 28.24193],
						[103.992497, 28.24227],
						[103.996214, 28.235965],
						[104.002474, 28.229087],
						[104.002963, 28.222421],
						[104.011301, 28.216582],
						[104.012964, 28.209703],
						[104.020569, 28.200402],
						[104.033944, 28.198831],
						[104.035436, 28.194605],
						[104.032844, 28.175342],
						[104.034873, 28.167292],
						[104.033406, 28.158816],
						[104.026804, 28.1582],
						[104.01827, 28.153696],
						[104.014235, 28.149681],
						[104.008489, 28.126181],
						[104.010934, 28.120571],
						[104.010323, 28.114493],
						[104.007633, 28.112027],
						[104.007022, 28.102676],
						[104.013086, 28.095853],
						[104.013502, 28.089731],
						[104.018735, 28.085756],
						[104.032599, 28.083332],
						[104.037245, 28.069918],
						[104.029469, 28.064134],
						[104.029054, 28.061158],
						[104.037392, 28.059946],
						[104.046146, 28.060732],
						[104.055585, 28.055778],
						[104.058323, 28.047187],
						[104.057859, 28.04019],
						[104.053237, 28.035724],
						[104.053457, 28.030067],
						[104.064608, 28.019857],
						[104.076345, 28.019772],
						[104.072775, 28.016348],
						[104.063752, 28.013327],
						[104.04864, 28.014625],
						[104.047222, 28.004945],
						[104.039446, 27.996733],
						[104.034409, 27.994712],
						[104.032819, 27.989521],
						[104.039593, 27.973498],
						[104.047931, 27.963858],
						[104.053139, 27.962283],
						[104.066001, 27.96456],
						[104.075318, 27.970944],
						[104.078399, 27.969859],
						[104.078056, 27.963921],
						[104.072139, 27.956196],
						[104.072604, 27.946852],
						[104.074266, 27.944489],
						[104.083314, 27.94219],
						[104.088302, 27.939402],
						[104.0962, 27.9397],
						[104.100015, 27.926629],
						[104.100333, 27.920327],
						[104.107693, 27.905635],
						[104.116863, 27.900717],
						[104.123367, 27.891645],
						[104.130311, 27.885383],
						[104.125739, 27.881912],
						[104.112412, 27.880719],
						[104.10916, 27.877865],
						[104.110407, 27.862082],
						[104.102485, 27.858077],
						[104.094709, 27.865213],
						[104.087104, 27.864893],
						[104.076051, 27.861592],
						[104.073631, 27.859163],
						[104.06605, 27.845805],
						[104.065072, 27.840628],
						[104.068129, 27.832041],
						[104.060206, 27.825862],
						[104.05199, 27.824541],
						[104.04842, 27.815356],
						[104.044214, 27.811477],
						[104.039373, 27.797112],
						[104.030325, 27.793062],
						[104.027904, 27.789183],
						[104.023601, 27.789481],
						[104.025386, 27.785282],
						[104.024652, 27.779334],
						[104.028736, 27.763344],
						[104.027317, 27.759421],
						[104.031743, 27.755924],
						[104.035313, 27.749868],
						[104.034433, 27.74411],
						[104.025435, 27.739376],
						[104.02118, 27.740144],
						[104.0147, 27.737841],
						[104.007217, 27.726388],
						[104.004943, 27.717216],
						[104.01157, 27.709537],
						[104.010274, 27.705505],
						[104.013404, 27.701217],
						[104.018979, 27.69902],
						[104.023674, 27.688565],
						[104.016509, 27.675528],
						[104.01871, 27.668636],
						[104.015825, 27.65692],
						[104.012793, 27.65263],
						[104.012279, 27.646248],
						[104.006337, 27.636749],
						[104.001765, 27.633974],
						[103.994282, 27.623578],
						[103.983058, 27.61903],
						[103.978437, 27.612006],
						[103.964157, 27.605729],
						[103.948262, 27.592212],
						[103.935205, 27.585079],
						[103.924201, 27.582687],
						[103.930583, 27.600668],
						[103.930632, 27.610298],
						[103.937674, 27.623962],
						[103.935351, 27.630217],
						[103.921487, 27.631455],
						[103.915251, 27.639524],
						[103.900629, 27.636578],
						[103.890603, 27.629961],
						[103.89075, 27.623514],
						[103.8863, 27.619991],
						[103.8807, 27.619564],
						[103.878255, 27.62424],
						[103.872997, 27.623791],
						[103.854096, 27.611344],
						[103.84495, 27.616917],
						[103.845146, 27.627186],
						[103.849083, 27.629214],
						[103.844168, 27.631348],
						[103.828665, 27.647593],
						[103.821354, 27.648574],
						[103.816463, 27.642747],
						[103.810986, 27.641573],
						[103.805435, 27.643366],
						[103.801718, 27.64025],
						[103.801694, 27.636152],
						[103.784822, 27.636194],
						[103.779222, 27.629726],
						[103.774723, 27.627997],
						[103.770028, 27.632736],
						[103.777584, 27.638756],
						[103.771935, 27.647102]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530625,
			"name": "永善县",
			"center": [103.63732, 28.231526],
			"centroid": [103.647612, 27.949987],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 5,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.82556, 28.469621],
						[103.830059, 28.471845],
						[103.832137, 28.477035],
						[103.830939, 28.483028],
						[103.839351, 28.500944],
						[103.838642, 28.504967],
						[103.833482, 28.512018],
						[103.845268, 28.516676],
						[103.860258, 28.505327],
						[103.866615, 28.504946],
						[103.86483, 28.493829],
						[103.86505, 28.487582],
						[103.873071, 28.480847],
						[103.884026, 28.479534],
						[103.892046, 28.48233],
						[103.896545, 28.470384],
						[103.891997, 28.466486],
						[103.901045, 28.460555],
						[103.904566, 28.443692],
						[103.911461, 28.436277],
						[103.914567, 28.42956],
						[103.92134, 28.42386],
						[103.927576, 28.420935],
						[103.929678, 28.416803],
						[103.923174, 28.408389],
						[103.924837, 28.400823],
						[103.92963, 28.400123],
						[103.941611, 28.407075],
						[103.958166, 28.415023],
						[103.961834, 28.411399],
						[103.966064, 28.415044],
						[103.97516, 28.417587],
						[103.979073, 28.421719],
						[103.989489, 28.420109],
						[103.994575, 28.412416],
						[104.011668, 28.393086],
						[104.012304, 28.389758],
						[104.00575, 28.382148],
						[104.00575, 28.364933],
						[104.00866, 28.361965],
						[104.006557, 28.35554],
						[104.009858, 28.346125],
						[104.004063, 28.337642],
						[104.01827, 28.313272],
						[104.014822, 28.304616],
						[104.014578, 28.291675],
						[104.019346, 28.286116],
						[104.020935, 28.279793],
						[104.028442, 28.269861],
						[104.02744, 28.266996],
						[104.013648, 28.262603],
						[104.010201, 28.259844],
						[104.004356, 28.260884],
						[103.993622, 28.255854],
						[103.991299, 28.24382],
						[103.992497, 28.24227],
						[103.987924, 28.24193],
						[103.980882, 28.235859],
						[103.973815, 28.234543],
						[103.970001, 28.222803],
						[103.966602, 28.21947],
						[103.95797, 28.218748],
						[103.952224, 28.222655],
						[103.93655, 28.226455],
						[103.928798, 28.231868],
						[103.921609, 28.230722],
						[103.917452, 28.22775],
						[103.902683, 28.228705],
						[103.896594, 28.224141],
						[103.898819, 28.214119],
						[103.899553, 28.200063],
						[103.902389, 28.195306],
						[103.901851, 28.189678],
						[103.905544, 28.174938],
						[103.906595, 28.158858],
						[103.910654, 28.155077],
						[103.917623, 28.154907],
						[103.927404, 28.150743],
						[103.924177, 28.146409],
						[103.914787, 28.146813],
						[103.921731, 28.129623],
						[103.927282, 28.123588],
						[103.920949, 28.109031],
						[103.91129, 28.106714],
						[103.904541, 28.098489],
						[103.901705, 28.09953],
						[103.902512, 28.105545],
						[103.89498, 28.111007],
						[103.892339, 28.116915],
						[103.888085, 28.121187],
						[103.868865, 28.12361],
						[103.864464, 28.118339],
						[103.849865, 28.111135],
						[103.843899, 28.104567],
						[103.840304, 28.104079],
						[103.826978, 28.09547],
						[103.817955, 28.096023],
						[103.811817, 28.0865],
						[103.814629, 28.082057],
						[103.812551, 28.077359],
						[103.804335, 28.071533],
						[103.798882, 28.071214],
						[103.788832, 28.073192],
						[103.780567, 28.077146],
						[103.767191, 28.069918],
						[103.7601, 28.071193],
						[103.74983, 28.076955],
						[103.738704, 28.06979],
						[103.739071, 28.061306],
						[103.736454, 28.048484],
						[103.737213, 28.04421],
						[103.734523, 28.041318],
						[103.727652, 28.039191],
						[103.718531, 28.039276],
						[103.710975, 28.044763],
						[103.696988, 28.037553],
						[103.692905, 28.032002],
						[103.686278, 28.026557],
						[103.685569, 28.023409],
						[103.690557, 28.013795],
						[103.694469, 28.013306],
						[103.701145, 28.0179],
						[103.706084, 28.016411],
						[103.707503, 28.013072],
						[103.703468, 28.006371],
						[103.69354, 27.997031],
						[103.695643, 27.990372],
						[103.703028, 27.979733],
						[103.700509, 27.969625],
						[103.704593, 27.959707],
						[103.714447, 27.953173],
						[103.728459, 27.953642],
						[103.727187, 27.946618],
						[103.736186, 27.946107],
						[103.739462, 27.941999],
						[103.75318, 27.934676],
						[103.758608, 27.939253],
						[103.766629, 27.936677],
						[103.770835, 27.927757],
						[103.774649, 27.925522],
						[103.773965, 27.914216],
						[103.781936, 27.909979],
						[103.78399, 27.906232],
						[103.784528, 27.896415],
						[103.782156, 27.890793],
						[103.788098, 27.884723],
						[103.78756, 27.872583],
						[103.791693, 27.868898],
						[103.785726, 27.859376],
						[103.784724, 27.854519],
						[103.794554, 27.841523],
						[103.795434, 27.837667],
						[103.788392, 27.833043],
						[103.785433, 27.833256],
						[103.767387, 27.820897],
						[103.764795, 27.817082],
						[103.760638, 27.818553],
						[103.751419, 27.817615],
						[103.742005, 27.822111],
						[103.737897, 27.821131],
						[103.725451, 27.814226],
						[103.723323, 27.808536],
						[103.718506, 27.804679],
						[103.716575, 27.799862],
						[103.72506, 27.784344],
						[103.730928, 27.781828],
						[103.734816, 27.771425],
						[103.741907, 27.766905],
						[103.743472, 27.760935],
						[103.7478, 27.754623],
						[103.744573, 27.73703],
						[103.739756, 27.729011],
						[103.742494, 27.721482],
						[103.741761, 27.706465],
						[103.745233, 27.702732],
						[103.747018, 27.694454],
						[103.744891, 27.684768],
						[103.748534, 27.676467],
						[103.752862, 27.671133],
						[103.765406, 27.663194],
						[103.767778, 27.660548],
						[103.767925, 27.650602],
						[103.771935, 27.647102],
						[103.764257, 27.644434],
						[103.759831, 27.637795],
						[103.759318, 27.630772],
						[103.753498, 27.629747],
						[103.752495, 27.622276],
						[103.743766, 27.620034],
						[103.740073, 27.623663],
						[103.722223, 27.623428],
						[103.711978, 27.624795],
						[103.707429, 27.618497],
						[103.703101, 27.61634],
						[103.706036, 27.607821],
						[103.699433, 27.608932],
						[103.693149, 27.607757],
						[103.68058, 27.607693],
						[103.66943, 27.612369],
						[103.659282, 27.612732],
						[103.657033, 27.61096],
						[103.660211, 27.605921],
						[103.661679, 27.596205],
						[103.653707, 27.591785],
						[103.646225, 27.590568],
						[103.632874, 27.600989],
						[103.626076, 27.602633],
						[103.615048, 27.599045],
						[103.613189, 27.592532],
						[103.614534, 27.582709],
						[103.611258, 27.580936],
						[103.600278, 27.585143],
						[103.593529, 27.589628],
						[103.588321, 27.589799],
						[103.586194, 27.584246],
						[103.590986, 27.580851],
						[103.588981, 27.576173],
						[103.591989, 27.568185],
						[103.604973, 27.560004],
						[103.602919, 27.556138],
						[103.594556, 27.556309],
						[103.589886, 27.553681],
						[103.592087, 27.5474],
						[103.591206, 27.543277],
						[103.584702, 27.536098],
						[103.574579, 27.533342],
						[103.57316, 27.531334],
						[103.560812, 27.529582],
						[103.552449, 27.53315],
						[103.547461, 27.538726],
						[103.539098, 27.540713],
						[103.537582, 27.544132],
						[103.54257, 27.554642],
						[103.539538, 27.557633],
						[103.541739, 27.56323],
						[103.537729, 27.564661],
						[103.543475, 27.572265],
						[103.536237, 27.572115],
						[103.535112, 27.575703],
						[103.528021, 27.582709],
						[103.522739, 27.58414],
						[103.515844, 27.582837],
						[103.516186, 27.575234],
						[103.514621, 27.569061],
						[103.508581, 27.560025],
						[103.505843, 27.559449],
						[103.498116, 27.565878],
						[103.474837, 27.573397],
						[103.466939, 27.579185],
						[103.45794, 27.581363],
						[103.455397, 27.578629],
						[103.452023, 27.569018],
						[103.451729, 27.562674],
						[103.441117, 27.560367],
						[103.428035, 27.561393],
						[103.414732, 27.560517],
						[103.40121, 27.556907],
						[103.38133, 27.548319],
						[103.380548, 27.538833],
						[103.386025, 27.528941],
						[103.38693, 27.517017],
						[103.37287, 27.512102],
						[103.366341, 27.507272],
						[103.356976, 27.506182],
						[103.346828, 27.509794],
						[103.34316, 27.508597],
						[103.342304, 27.504665],
						[103.338441, 27.505605],
						[103.333208, 27.510435],
						[103.3313, 27.514966],
						[103.318023, 27.522423],
						[103.302887, 27.529624],
						[103.293203, 27.537658],
						[103.279143, 27.55084],
						[103.271636, 27.552805],
						[103.264643, 27.560239],
						[103.262589, 27.567993],
						[103.266306, 27.565323],
						[103.278703, 27.561863],
						[103.286063, 27.561905],
						[103.29357, 27.564703],
						[103.295673, 27.568805],
						[103.293692, 27.582751],
						[103.299145, 27.597145],
						[103.298534, 27.601159],
						[103.291687, 27.609722],
						[103.28039, 27.618006],
						[103.278092, 27.624112],
						[103.279657, 27.632757],
						[103.283838, 27.635127],
						[103.292519, 27.633078],
						[103.297336, 27.639225],
						[103.302764, 27.642683],
						[103.316727, 27.657026],
						[103.330004, 27.665456],
						[103.336704, 27.67284],
						[103.349738, 27.678452],
						[103.355142, 27.684448],
						[103.357416, 27.692171],
						[103.365779, 27.701516],
						[103.370058, 27.708662],
						[103.378983, 27.712011],
						[103.384851, 27.712161],
						[103.393019, 27.709409],
						[103.397958, 27.713974],
						[103.403729, 27.724788],
						[103.420895, 27.742938],
						[103.426152, 27.746307],
						[103.435273, 27.747267],
						[103.441948, 27.754239],
						[103.448159, 27.755135],
						[103.456889, 27.765583],
						[103.459774, 27.777565],
						[103.464713, 27.782446],
						[103.479678, 27.789204],
						[103.489533, 27.79741],
						[103.490193, 27.800991],
						[103.498996, 27.812202],
						[103.50863, 27.839158],
						[103.509046, 27.844889],
						[103.504327, 27.85045],
						[103.504058, 27.859951],
						[103.502052, 27.864553],
						[103.49995, 27.877524],
						[103.502419, 27.887747],
						[103.502957, 27.911789],
						[103.510464, 27.92252],
						[103.521786, 27.931717],
						[103.525038, 27.938976],
						[103.542008, 27.95362],
						[103.556728, 27.955238],
						[103.562352, 27.959984],
						[103.563942, 27.964198],
						[103.563257, 27.977669],
						[103.553745, 27.977924],
						[103.545162, 27.970859],
						[103.541715, 27.966411],
						[103.532398, 27.964602],
						[103.527385, 27.965773],
						[103.516724, 27.965283],
						[103.504449, 27.975094],
						[103.498923, 27.984095],
						[103.494179, 28.001052],
						[103.493714, 28.006392],
						[103.496502, 28.016603],
						[103.494374, 28.026153],
						[103.488212, 28.032385],
						[103.479238, 28.03398],
						[103.468699, 28.030237],
						[103.466009, 28.025026],
						[103.459481, 28.021368],
						[103.446912, 28.026217],
						[103.435004, 28.038021],
						[103.430822, 28.044656],
						[103.430235, 28.057777],
						[103.434074, 28.073787],
						[103.446178, 28.080037],
						[103.453636, 28.08769],
						[103.458674, 28.098276],
						[103.458209, 28.103037],
						[103.449504, 28.109605],
						[103.448624, 28.115832],
						[103.450849, 28.121378],
						[103.45503, 28.123716],
						[103.47024, 28.122165],
						[103.480314, 28.133767],
						[103.489484, 28.139079],
						[103.50237, 28.143094],
						[103.505867, 28.149511],
						[103.514034, 28.156564],
						[103.521419, 28.160452],
						[103.533132, 28.168545],
						[103.538389, 28.174322],
						[103.540443, 28.181204],
						[103.552596, 28.191271],
						[103.554552, 28.197132],
						[103.564089, 28.211083],
						[103.564578, 28.221996],
						[103.573209, 28.230913],
						[103.597882, 28.236178],
						[103.608176, 28.239043],
						[103.618104, 28.243629],
						[103.619449, 28.249126],
						[103.632409, 28.259993],
						[103.639745, 28.26167],
						[103.649477, 28.257064],
						[103.657155, 28.250909],
						[103.674712, 28.239362],
						[103.691755, 28.232293],
						[103.694959, 28.224417],
						[103.693174, 28.212633],
						[103.695888, 28.206008],
						[103.702001, 28.198958],
						[103.711586, 28.197111],
						[103.721269, 28.201995],
						[103.726282, 28.212442],
						[103.729706, 28.228302],
						[103.74, 28.236029],
						[103.746015, 28.237027],
						[103.758633, 28.233991],
						[103.770786, 28.233545],
						[103.776923, 28.238131],
						[103.785824, 28.254072],
						[103.803675, 28.262773],
						[103.813015, 28.265108],
						[103.82106, 28.272684],
						[103.82979, 28.285458],
						[103.834069, 28.28463],
						[103.845293, 28.286413],
						[103.853093, 28.29282],
						[103.870234, 28.301073],
						[103.874831, 28.306186],
						[103.877423, 28.314184],
						[103.875638, 28.32218],
						[103.87021, 28.331958],
						[103.856419, 28.348585],
						[103.853387, 28.356749],
						[103.859818, 28.37547],
						[103.859842, 28.383526],
						[103.856541, 28.395185],
						[103.851259, 28.406736],
						[103.847469, 28.410212],
						[103.837199, 28.42333],
						[103.82979, 28.436319],
						[103.828934, 28.439815],
						[103.830254, 28.458395],
						[103.82556, 28.469621]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530626,
			"name": "绥江县",
			"center": [103.961095, 28.599953],
			"centroid": [104.00782, 28.532877],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 6,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.086444, 28.378226],
						[104.07967, 28.37971],
						[104.076076, 28.377272],
						[104.078301, 28.356091],
						[104.064925, 28.352996],
						[104.05847, 28.357873],
						[104.05424, 28.357024],
						[104.050327, 28.351978],
						[104.04397, 28.354459],
						[104.034066, 28.351723],
						[104.023894, 28.353526],
						[104.013722, 28.349794],
						[104.009858, 28.346125],
						[104.006557, 28.35554],
						[104.00866, 28.361965],
						[104.00575, 28.364933],
						[104.00575, 28.382148],
						[104.012304, 28.389758],
						[104.011668, 28.393086],
						[103.994575, 28.412416],
						[103.989489, 28.420109],
						[103.979073, 28.421719],
						[103.97516, 28.417587],
						[103.966064, 28.415044],
						[103.961834, 28.411399],
						[103.958166, 28.415023],
						[103.941611, 28.407075],
						[103.92963, 28.400123],
						[103.924837, 28.400823],
						[103.923174, 28.408389],
						[103.929678, 28.416803],
						[103.927576, 28.420935],
						[103.92134, 28.42386],
						[103.914567, 28.42956],
						[103.911461, 28.436277],
						[103.904566, 28.443692],
						[103.901045, 28.460555],
						[103.891997, 28.466486],
						[103.896545, 28.470384],
						[103.892046, 28.48233],
						[103.884026, 28.479534],
						[103.873071, 28.480847],
						[103.86505, 28.487582],
						[103.86483, 28.493829],
						[103.866615, 28.504946],
						[103.860258, 28.505327],
						[103.845268, 28.516676],
						[103.833482, 28.512018],
						[103.838642, 28.504967],
						[103.839351, 28.500944],
						[103.830939, 28.483028],
						[103.832137, 28.477035],
						[103.830059, 28.471845],
						[103.82556, 28.469621],
						[103.82309, 28.471845],
						[103.810448, 28.495396],
						[103.792329, 28.509012],
						[103.78245, 28.522138],
						[103.783672, 28.526563],
						[103.79069, 28.528066],
						[103.800691, 28.533845],
						[103.803748, 28.548112],
						[103.799126, 28.557022],
						[103.801352, 28.561826],
						[103.818273, 28.569466],
						[103.835463, 28.582564],
						[103.838373, 28.587304],
						[103.838202, 28.591874],
						[103.833213, 28.605328],
						[103.834876, 28.622293],
						[103.843092, 28.632085],
						[103.84319, 28.637626],
						[103.839889, 28.647079],
						[103.844657, 28.659934],
						[103.851112, 28.667081],
						[103.854756, 28.668264],
						[103.864781, 28.666341],
						[103.873682, 28.652767],
						[103.874293, 28.647649],
						[103.87065, 28.633819],
						[103.87466, 28.626481],
						[103.887987, 28.620051],
						[103.896325, 28.619691],
						[103.902561, 28.62297],
						[103.90997, 28.631218],
						[103.914469, 28.631345],
						[103.936721, 28.62261],
						[103.93968, 28.618168],
						[103.940609, 28.606196],
						[103.942492, 28.603065],
						[103.950414, 28.601076],
						[103.956332, 28.601563],
						[103.966675, 28.607613],
						[103.977385, 28.608777],
						[103.984648, 28.611844],
						[103.993475, 28.612013],
						[104.009345, 28.61838],
						[104.059595, 28.627644],
						[104.066441, 28.625867],
						[104.071723, 28.62022],
						[104.080355, 28.61582],
						[104.083803, 28.607],
						[104.089647, 28.603975],
						[104.096127, 28.603446],
						[104.103365, 28.606302],
						[104.11097, 28.613705],
						[104.112779, 28.625761],
						[104.117865, 28.634094],
						[104.125225, 28.637288],
						[104.140802, 28.637943],
						[104.152294, 28.639973],
						[104.161317, 28.639297],
						[104.170365, 28.643061],
						[104.182836, 28.636759],
						[104.192494, 28.63365],
						[104.197336, 28.634031],
						[104.210369, 28.637922],
						[104.23108, 28.635786],
						[104.238172, 28.638704],
						[104.241644, 28.644012],
						[104.242549, 28.651054],
						[104.241424, 28.660801],
						[104.245923, 28.663719],
						[104.252672, 28.660696],
						[104.266219, 28.639529],
						[104.271818, 28.633439],
						[104.277271, 28.632149],
						[104.278152, 28.626163],
						[104.276049, 28.614657],
						[104.264703, 28.608798],
						[104.260595, 28.609792],
						[104.261035, 28.606386],
						[104.255631, 28.603403],
						[104.25387, 28.593143],
						[104.251498, 28.588975],
						[104.241742, 28.587304],
						[104.23937, 28.583939],
						[104.228831, 28.581485],
						[104.215773, 28.574481],
						[104.201982, 28.572809],
						[104.193864, 28.568789],
						[104.188093, 28.561445],
						[104.1833, 28.5577],
						[104.182224, 28.551964],
						[104.174082, 28.544979],
						[104.156451, 28.540915],
						[104.152074, 28.534628],
						[104.143125, 28.532046],
						[104.126937, 28.533062],
						[104.121166, 28.537423],
						[104.116863, 28.535835],
						[104.114662, 28.531919],
						[104.100088, 28.523112],
						[104.092483, 28.509604],
						[104.089525, 28.500161],
						[104.095344, 28.485273],
						[104.092679, 28.472333],
						[104.088889, 28.464601],
						[104.081284, 28.453438],
						[104.083191, 28.443692],
						[104.075367, 28.438904],
						[104.077054, 28.429136],
						[104.070012, 28.419007],
						[104.063678, 28.412098],
						[104.069205, 28.403027],
						[104.072652, 28.402158],
						[104.082262, 28.390712],
						[104.086444, 28.378226]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530627,
			"name": "镇雄县",
			"center": [104.873055, 27.436267],
			"centroid": [104.82737, 27.563192],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 7,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.431665, 27.432319],
						[104.429439, 27.439376],
						[104.431493, 27.446497],
						[104.436604, 27.446112],
						[104.442301, 27.455905],
						[104.44279, 27.465398],
						[104.439318, 27.466851],
						[104.437729, 27.47583],
						[104.440272, 27.484381],
						[104.439123, 27.490024],
						[104.434208, 27.495817],
						[104.424231, 27.500946],
						[104.423131, 27.510713],
						[104.419585, 27.518427],
						[104.411736, 27.521526],
						[104.411442, 27.524966],
						[104.405207, 27.532295],
						[104.404791, 27.54896],
						[104.403006, 27.55398],
						[104.408532, 27.567139],
						[104.402786, 27.57848],
						[104.396844, 27.587087],
						[104.393567, 27.597999],
						[104.398972, 27.598704],
						[104.398409, 27.601416],
						[104.391978, 27.603807],
						[104.39523, 27.615614],
						[104.394105, 27.617707],
						[104.382906, 27.622788],
						[104.377576, 27.626673],
						[104.368968, 27.627783],
						[104.362586, 27.636173],
						[104.358038, 27.635276],
						[104.342975, 27.637902],
						[104.338403, 27.636023],
						[104.336251, 27.630004],
						[104.328548, 27.624133],
						[104.323315, 27.624389],
						[104.320381, 27.62821],
						[104.319525, 27.636835],
						[104.308962, 27.6366],
						[104.305514, 27.640613],
						[104.309451, 27.648681],
						[104.309304, 27.653739],
						[104.305392, 27.667739],
						[104.308302, 27.67572],
						[104.313779, 27.680756],
						[104.320454, 27.683359],
						[104.334123, 27.673949],
						[104.344369, 27.678388],
						[104.351338, 27.683103],
						[104.35618, 27.683295],
						[104.366009, 27.688096],
						[104.383102, 27.691126],
						[104.390169, 27.695201],
						[104.395206, 27.689803],
						[104.405989, 27.687925],
						[104.41467, 27.692406],
						[104.412787, 27.701516],
						[104.418631, 27.707233],
						[104.417384, 27.713441],
						[104.418851, 27.724681],
						[104.437215, 27.727646],
						[104.440125, 27.731528],
						[104.46047, 27.732637],
						[104.467341, 27.730589],
						[104.465776, 27.721909],
						[104.48436, 27.725876],
						[104.495779, 27.730717],
						[104.499423, 27.730334],
						[104.503213, 27.725428],
						[104.497809, 27.71519],
						[104.500107, 27.706252],
						[104.507932, 27.700897],
						[104.507198, 27.693835],
						[104.512431, 27.692598],
						[104.530844, 27.695201],
						[104.534879, 27.697804],
						[104.536713, 27.708129],
						[104.541628, 27.711691],
						[104.544562, 27.718112],
						[104.55559, 27.724426],
						[104.557424, 27.729608],
						[104.574272, 27.733213],
						[104.578429, 27.73895],
						[104.584028, 27.743215],
						[104.587598, 27.750956],
						[104.596303, 27.750892],
						[104.599898, 27.75264],
						[104.612662, 27.748226],
						[104.615181, 27.744473],
						[104.62528, 27.736412],
						[104.628728, 27.736668],
						[104.626747, 27.743919],
						[104.62726, 27.750806],
						[104.636626, 27.755306],
						[104.640734, 27.763557],
						[104.652349, 27.767289],
						[104.655234, 27.770209],
						[104.663132, 27.7678],
						[104.678073, 27.779419],
						[104.69673, 27.806746],
						[104.702183, 27.820641],
						[104.706315, 27.821643],
						[104.711915, 27.820385],
						[104.715387, 27.82697],
						[104.719862, 27.829421],
						[104.720082, 27.823497],
						[104.726758, 27.819661],
						[104.732529, 27.820044],
						[104.740989, 27.815207],
						[104.74297, 27.807385],
						[104.735389, 27.799222],
						[104.736588, 27.795854],
						[104.747004, 27.794149],
						[104.748203, 27.789779],
						[104.745391, 27.785708],
						[104.754658, 27.78477],
						[104.756296, 27.781466],
						[104.762092, 27.778289],
						[104.759818, 27.768525],
						[104.764097, 27.764261],
						[104.770552, 27.767267],
						[104.777179, 27.773407],
						[104.790163, 27.776541],
						[104.796521, 27.776222],
						[104.802732, 27.785879],
						[104.810483, 27.788778],
						[104.815985, 27.787435],
						[104.818504, 27.778439],
						[104.823199, 27.773855],
						[104.819506, 27.768952],
						[104.813173, 27.756436],
						[104.811804, 27.751531],
						[104.813833, 27.745646],
						[104.824543, 27.744004],
						[104.829409, 27.756841],
						[104.843568, 27.774431],
						[104.850292, 27.77765],
						[104.862494, 27.787371],
						[104.886286, 27.791613],
						[104.892375, 27.78396],
						[104.900982, 27.780528],
						[104.915605, 27.781679],
						[104.924236, 27.78688],
						[104.929445, 27.786603],
						[104.937098, 27.782766],
						[104.960377, 27.77782],
						[104.98505, 27.780869],
						[104.994709, 27.778545],
						[104.998425, 27.775539],
						[104.993706, 27.771339],
						[104.991774, 27.765071],
						[104.995173, 27.760231],
						[104.992483, 27.756969],
						[104.981358, 27.752747],
						[104.976589, 27.748823],
						[104.958128, 27.745902],
						[104.959644, 27.738758],
						[104.953971, 27.735026],
						[104.955756, 27.729502],
						[104.97055, 27.728883],
						[104.97835, 27.72562],
						[104.985368, 27.726452],
						[104.993779, 27.724788],
						[104.999501, 27.721333],
						[105.002533, 27.716811],
						[105.018036, 27.713377],
						[105.023391, 27.709985],
						[105.03618, 27.71199],
						[105.048578, 27.717515],
						[105.057307, 27.718069],
						[105.080024, 27.725364],
						[105.094084, 27.728201],
						[105.098363, 27.732402],
						[105.100099, 27.742916],
						[105.106652, 27.746989],
						[105.115895, 27.757161],
						[105.142353, 27.770551],
						[105.153699, 27.781125],
						[105.15634, 27.775092],
						[105.160668, 27.773088],
						[105.16458, 27.765348],
						[105.17441, 27.757779],
						[105.174557, 27.754048],
						[105.181257, 27.752214],
						[105.18583, 27.755092],
						[105.182724, 27.760295],
						[105.184363, 27.76635],
						[105.19319, 27.770273],
						[105.191527, 27.781572],
						[105.195219, 27.785793],
						[105.199107, 27.780187],
						[105.204707, 27.775646],
						[105.206468, 27.76279],
						[105.222851, 27.75215],
						[105.225174, 27.746243],
						[105.236789, 27.732232],
						[105.252047, 27.729928],
						[105.259261, 27.72707],
						[105.263246, 27.728371],
						[105.270949, 27.727454],
						[105.278798, 27.71696],
						[105.286036, 27.712587],
						[105.290511, 27.712438],
						[105.298776, 27.707532],
						[105.304058, 27.708598],
						[105.308141, 27.705014],
						[105.305256, 27.702924],
						[105.301026, 27.694774],
						[105.301319, 27.682783],
						[105.308973, 27.670855],
						[105.309877, 27.654977],
						[105.305134, 27.647977],
						[105.303887, 27.63978],
						[105.294986, 27.633184],
						[105.303251, 27.626353],
						[105.305109, 27.613629],
						[105.300292, 27.608718],
						[105.290609, 27.604341],
						[105.285718, 27.597935],
						[105.274935, 27.58982],
						[105.267892, 27.586425],
						[105.257867, 27.583648],
						[105.251754, 27.573461],
						[105.247059, 27.579569],
						[105.242951, 27.57722],
						[105.244002, 27.572585],
						[105.251069, 27.568484],
						[105.250507, 27.56543],
						[105.240457, 27.558744],
						[105.242755, 27.551374],
						[105.232314, 27.546311],
						[105.234735, 27.540179],
						[105.238574, 27.540265],
						[105.246765, 27.5452],
						[105.251827, 27.541397],
						[105.256987, 27.54035],
						[105.253147, 27.536184],
						[105.257402, 27.529047],
						[105.260116, 27.519624],
						[105.259407, 27.513363],
						[105.255153, 27.507016],
						[105.249773, 27.505028],
						[105.248012, 27.49462],
						[105.235884, 27.490516],
						[105.23361, 27.486048],
						[105.233634, 27.475894],
						[105.238965, 27.469844],
						[105.239087, 27.466638],
						[105.234955, 27.459155],
						[105.235566, 27.455327],
						[105.227546, 27.447673],
						[105.226127, 27.441129],
						[105.232803, 27.436318],
						[105.231067, 27.430159],
						[105.225858, 27.419401],
						[105.219672, 27.413519],
						[105.211896, 27.399529],
						[105.203069, 27.389431],
						[105.194413, 27.382842],
						[105.191063, 27.371737],
						[105.18402, 27.367522],
						[105.180792, 27.369148],
						[105.183115, 27.374904],
						[105.184705, 27.392469],
						[105.182357, 27.394566],
						[105.172332, 27.397326],
						[105.16727, 27.408813],
						[105.161475, 27.409348],
						[105.157807, 27.405241],
						[105.15096, 27.404963],
						[105.148344, 27.408984],
						[105.142011, 27.411123],
						[105.136778, 27.415422],
						[105.126728, 27.416321],
						[105.121446, 27.418524],
						[105.11169, 27.41662],
						[105.102226, 27.412064],
						[105.096578, 27.412235],
						[105.086675, 27.419465],
						[105.077627, 27.420085],
						[105.066501, 27.417454],
						[105.058603, 27.409904],
						[105.046621, 27.407251],
						[105.044665, 27.403166],
						[105.047624, 27.39923],
						[105.045399, 27.39617],
						[105.037598, 27.400791],
						[105.031485, 27.400256],
						[105.020115, 27.390544],
						[105.012119, 27.380232],
						[105.003194, 27.376316],
						[104.999819, 27.372229],
						[104.988987, 27.366366],
						[104.981553, 27.364205],
						[104.970647, 27.357614],
						[104.963996, 27.357935],
						[104.958763, 27.355559],
						[104.954998, 27.351215],
						[104.943798, 27.346656],
						[104.937074, 27.337067],
						[104.930594, 27.333193],
						[104.923356, 27.331802],
						[104.913159, 27.326814],
						[104.905017, 27.307461],
						[104.901618, 27.304614],
						[104.894086, 27.305534],
						[104.891935, 27.299796],
						[104.87895, 27.297312],
						[104.871248, 27.290889],
						[104.860758, 27.298854],
						[104.852053, 27.299646],
						[104.850536, 27.304314],
						[104.852297, 27.312064],
						[104.848898, 27.320349],
						[104.856527, 27.332594],
						[104.843885, 27.34321],
						[104.835889, 27.34351],
						[104.826769, 27.348775],
						[104.826108, 27.352328],
						[104.818944, 27.353034],
						[104.81376, 27.351044],
						[104.808649, 27.354575],
						[104.807011, 27.348133],
						[104.802952, 27.345543],
						[104.795836, 27.336468],
						[104.793856, 27.331738],
						[104.790237, 27.330453],
						[104.789136, 27.321077],
						[104.779649, 27.317716],
						[104.771041, 27.317416],
						[104.766713, 27.325894],
						[104.767593, 27.330239],
						[104.75434, 27.345415],
						[104.744804, 27.34184],
						[104.739082, 27.335312],
						[104.735658, 27.334627],
						[104.72265, 27.342461],
						[104.704628, 27.337752],
						[104.700545, 27.338544],
						[104.694138, 27.333493],
						[104.686167, 27.334841],
						[104.683183, 27.329404],
						[104.684748, 27.326643],
						[104.680665, 27.323967],
						[104.680273, 27.319621],
						[104.676165, 27.320306],
						[104.664355, 27.316689],
						[104.660907, 27.317181],
						[104.656359, 27.321891],
						[104.646284, 27.321548],
						[104.630806, 27.317866],
						[104.612491, 27.307226],
						[104.600094, 27.312814],
						[104.594787, 27.311315],
						[104.591242, 27.31504],
						[104.588356, 27.322982],
						[104.582268, 27.323518],
						[104.577402, 27.328334],
						[104.570213, 27.331695],
						[104.55938, 27.331202],
						[104.551286, 27.32934],
						[104.545393, 27.330068],
						[104.542483, 27.325337],
						[104.539354, 27.329704],
						[104.540185, 27.336275],
						[104.53637, 27.341883],
						[104.531993, 27.344152],
						[104.522286, 27.354361],
						[104.522775, 27.365061],
						[104.519107, 27.368805],
						[104.515561, 27.376915],
						[104.512382, 27.378969],
						[104.507663, 27.387506],
						[104.508323, 27.393518],
						[104.515317, 27.397005],
						[104.517273, 27.400363],
						[104.512431, 27.400984],
						[104.504411, 27.397176],
						[104.490913, 27.401882],
						[104.490986, 27.405497],
						[104.497637, 27.411551],
						[104.497075, 27.414481],
						[104.488541, 27.415358],
						[104.484629, 27.412727],
						[104.477978, 27.415401],
						[104.470226, 27.415936],
						[104.467194, 27.414267],
						[104.461301, 27.420663],
						[104.452987, 27.421133],
						[104.44751, 27.426395],
						[104.434501, 27.426993],
						[104.431665, 27.432319]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530628,
			"name": "彝良县",
			"center": [104.048492, 27.627425],
			"centroid": [104.234945, 27.62528],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 8,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.906669, 27.387463],
						[103.897939, 27.397711],
						[103.893978, 27.397475],
						[103.8874, 27.402909],
						[103.877497, 27.408813],
						[103.876421, 27.415722],
						[103.881923, 27.421946],
						[103.882754, 27.427549],
						[103.886006, 27.43234],
						[103.88515, 27.437515],
						[103.877546, 27.442519],
						[103.875076, 27.447544],
						[103.864928, 27.451201],
						[103.856761, 27.448549],
						[103.853289, 27.455776],
						[103.856565, 27.461442],
						[103.855612, 27.468861],
						[103.857226, 27.475937],
						[103.856272, 27.490238],
						[103.858301, 27.493038],
						[103.871164, 27.493615],
						[103.876323, 27.499856],
						[103.88383, 27.50631],
						[103.891337, 27.508704],
						[103.896839, 27.520265],
						[103.900482, 27.524966],
						[103.913051, 27.532872],
						[103.91755, 27.540436],
						[103.924274, 27.54426],
						[103.921511, 27.550562],
						[103.912537, 27.555475],
						[103.912537, 27.561777],
						[103.924201, 27.582687],
						[103.935205, 27.585079],
						[103.948262, 27.592212],
						[103.964157, 27.605729],
						[103.978437, 27.612006],
						[103.983058, 27.61903],
						[103.994282, 27.623578],
						[104.001765, 27.633974],
						[104.006337, 27.636749],
						[104.012279, 27.646248],
						[104.012793, 27.65263],
						[104.015825, 27.65692],
						[104.01871, 27.668636],
						[104.016509, 27.675528],
						[104.023674, 27.688565],
						[104.018979, 27.69902],
						[104.013404, 27.701217],
						[104.010274, 27.705505],
						[104.01157, 27.709537],
						[104.004943, 27.717216],
						[104.007217, 27.726388],
						[104.0147, 27.737841],
						[104.02118, 27.740144],
						[104.025435, 27.739376],
						[104.034433, 27.74411],
						[104.035313, 27.749868],
						[104.031743, 27.755924],
						[104.027317, 27.759421],
						[104.028736, 27.763344],
						[104.024652, 27.779334],
						[104.025386, 27.785282],
						[104.023601, 27.789481],
						[104.027904, 27.789183],
						[104.030325, 27.793062],
						[104.039373, 27.797112],
						[104.044214, 27.811477],
						[104.04842, 27.815356],
						[104.05199, 27.824541],
						[104.060206, 27.825862],
						[104.068129, 27.832041],
						[104.065072, 27.840628],
						[104.06605, 27.845805],
						[104.073631, 27.859163],
						[104.076051, 27.861592],
						[104.087104, 27.864893],
						[104.094709, 27.865213],
						[104.102485, 27.858077],
						[104.097667, 27.843995],
						[104.100259, 27.839819],
						[104.11119, 27.841267],
						[104.119259, 27.839819],
						[104.127157, 27.844698],
						[104.13975, 27.865916],
						[104.150705, 27.875927],
						[104.160999, 27.888259],
						[104.182762, 27.899673],
						[104.190025, 27.909553],
						[104.197923, 27.914557],
						[104.206163, 27.925735],
						[104.214037, 27.929162],
						[104.223573, 27.935889],
						[104.226801, 27.940466],
						[104.232425, 27.937741],
						[104.23311, 27.929694],
						[104.241668, 27.919177],
						[104.236436, 27.90983],
						[104.240226, 27.904251],
						[104.249664, 27.896053],
						[104.249884, 27.886235],
						[104.242793, 27.881848],
						[104.237854, 27.871284],
						[104.23849, 27.862912],
						[104.232327, 27.852602],
						[104.23179, 27.84702],
						[104.236533, 27.842162],
						[104.240201, 27.84148],
						[104.246461, 27.835024],
						[104.250153, 27.836473],
						[104.25722, 27.835621],
						[104.263994, 27.829442],
						[104.264996, 27.822921],
						[104.275462, 27.817167],
						[104.280695, 27.822239],
						[104.289229, 27.823731],
						[104.291894, 27.828206],
						[104.30121, 27.833746],
						[104.305856, 27.833426],
						[104.318229, 27.823816],
						[104.331727, 27.83413],
						[104.334123, 27.833682],
						[104.339796, 27.825691],
						[104.346912, 27.825926],
						[104.347499, 27.832595],
						[104.355153, 27.839669],
						[104.359114, 27.840309],
						[104.367574, 27.848277],
						[104.376646, 27.853837],
						[104.384055, 27.853709],
						[104.389288, 27.868813],
						[104.403006, 27.880059],
						[104.406527, 27.880102],
						[104.410195, 27.876353],
						[104.412274, 27.869154],
						[104.424598, 27.863913],
						[104.429953, 27.85944],
						[104.430735, 27.854668],
						[104.435699, 27.858971],
						[104.438805, 27.865277],
						[104.445896, 27.865064],
						[104.456044, 27.867684],
						[104.458905, 27.870453],
						[104.455408, 27.875352],
						[104.445896, 27.88238],
						[104.438805, 27.885895],
						[104.439294, 27.90538],
						[104.441152, 27.909702],
						[104.448561, 27.91675],
						[104.453378, 27.924202],
						[104.465605, 27.911725],
						[104.469028, 27.911938],
						[104.468148, 27.907424],
						[104.472892, 27.903868],
						[104.479543, 27.901696],
						[104.489348, 27.900802],
						[104.490889, 27.897693],
						[104.497491, 27.896202],
						[104.502479, 27.883062],
						[104.509546, 27.877695],
						[104.519156, 27.880442],
						[104.522604, 27.887407],
						[104.526663, 27.88943],
						[104.539378, 27.885703],
						[104.54444, 27.88008],
						[104.546812, 27.874521],
						[104.550968, 27.876204],
						[104.558378, 27.867961],
						[104.556079, 27.862082],
						[104.558035, 27.852644],
						[104.567278, 27.851174],
						[104.568452, 27.84261],
						[104.572144, 27.84082],
						[104.580874, 27.842034],
						[104.585642, 27.846871],
						[104.594005, 27.849747],
						[104.607967, 27.858183],
						[104.615719, 27.859248],
						[104.626796, 27.858737],
						[104.633642, 27.850919],
						[104.647042, 27.859355],
						[104.663646, 27.871646],
						[104.679124, 27.882253],
						[104.685017, 27.884425],
						[104.694798, 27.884127],
						[104.711035, 27.891283],
						[104.726342, 27.896521],
						[104.736734, 27.898928],
						[104.743728, 27.902016],
						[104.751186, 27.902165],
						[104.752506, 27.900397],
						[104.749205, 27.890111],
						[104.739742, 27.88828],
						[104.735585, 27.881316],
						[104.736294, 27.873967],
						[104.739082, 27.864851],
						[104.735365, 27.859184],
						[104.716952, 27.852005],
						[104.71216, 27.843057],
						[104.705508, 27.835792],
						[104.701229, 27.828717],
						[104.706315, 27.821643],
						[104.702183, 27.820641],
						[104.69673, 27.806746],
						[104.678073, 27.779419],
						[104.663132, 27.7678],
						[104.655234, 27.770209],
						[104.652349, 27.767289],
						[104.640734, 27.763557],
						[104.636626, 27.755306],
						[104.62726, 27.750806],
						[104.626747, 27.743919],
						[104.628728, 27.736668],
						[104.62528, 27.736412],
						[104.615181, 27.744473],
						[104.612662, 27.748226],
						[104.599898, 27.75264],
						[104.596303, 27.750892],
						[104.587598, 27.750956],
						[104.584028, 27.743215],
						[104.578429, 27.73895],
						[104.574272, 27.733213],
						[104.557424, 27.729608],
						[104.55559, 27.724426],
						[104.544562, 27.718112],
						[104.541628, 27.711691],
						[104.536713, 27.708129],
						[104.534879, 27.697804],
						[104.530844, 27.695201],
						[104.512431, 27.692598],
						[104.507198, 27.693835],
						[104.507932, 27.700897],
						[104.500107, 27.706252],
						[104.497809, 27.71519],
						[104.503213, 27.725428],
						[104.499423, 27.730334],
						[104.495779, 27.730717],
						[104.48436, 27.725876],
						[104.465776, 27.721909],
						[104.467341, 27.730589],
						[104.46047, 27.732637],
						[104.440125, 27.731528],
						[104.437215, 27.727646],
						[104.418851, 27.724681],
						[104.417384, 27.713441],
						[104.418631, 27.707233],
						[104.412787, 27.701516],
						[104.41467, 27.692406],
						[104.405989, 27.687925],
						[104.395206, 27.689803],
						[104.390169, 27.695201],
						[104.383102, 27.691126],
						[104.366009, 27.688096],
						[104.35618, 27.683295],
						[104.351338, 27.683103],
						[104.344369, 27.678388],
						[104.334123, 27.673949],
						[104.320454, 27.683359],
						[104.313779, 27.680756],
						[104.308302, 27.67572],
						[104.305392, 27.667739],
						[104.309304, 27.653739],
						[104.309451, 27.648681],
						[104.305514, 27.640613],
						[104.308962, 27.6366],
						[104.319525, 27.636835],
						[104.320381, 27.62821],
						[104.323315, 27.624389],
						[104.328548, 27.624133],
						[104.336251, 27.630004],
						[104.338403, 27.636023],
						[104.342975, 27.637902],
						[104.358038, 27.635276],
						[104.362586, 27.636173],
						[104.368968, 27.627783],
						[104.377576, 27.626673],
						[104.382906, 27.622788],
						[104.394105, 27.617707],
						[104.39523, 27.615614],
						[104.391978, 27.603807],
						[104.398409, 27.601416],
						[104.398972, 27.598704],
						[104.393567, 27.597999],
						[104.396844, 27.587087],
						[104.402786, 27.57848],
						[104.408532, 27.567139],
						[104.403006, 27.55398],
						[104.404791, 27.54896],
						[104.405207, 27.532295],
						[104.411442, 27.524966],
						[104.411736, 27.521526],
						[104.419585, 27.518427],
						[104.423131, 27.510713],
						[104.424231, 27.500946],
						[104.434208, 27.495817],
						[104.439123, 27.490024],
						[104.440272, 27.484381],
						[104.437729, 27.47583],
						[104.439318, 27.466851],
						[104.44279, 27.465398],
						[104.442301, 27.455905],
						[104.436604, 27.446112],
						[104.431493, 27.446497],
						[104.429439, 27.439376],
						[104.431665, 27.432319],
						[104.428999, 27.43435],
						[104.416602, 27.435526],
						[104.414694, 27.441279],
						[104.409462, 27.445299],
						[104.410171, 27.457893],
						[104.402419, 27.455135],
						[104.39726, 27.459005],
						[104.391636, 27.459475],
						[104.376011, 27.464222],
						[104.370362, 27.462212],
						[104.362244, 27.467856],
						[104.353147, 27.466873],
						[104.345323, 27.462832],
						[104.34811, 27.460951],
						[104.344247, 27.452933],
						[104.332754, 27.444016],
						[104.335493, 27.439675],
						[104.342682, 27.436339],
						[104.34207, 27.427271],
						[104.335908, 27.43249],
						[104.335175, 27.427699],
						[104.327448, 27.416043],
						[104.328035, 27.412064],
						[104.322386, 27.40785],
						[104.308815, 27.407273],
						[104.304389, 27.401882],
						[104.30236, 27.396256],
						[104.303142, 27.391571],
						[104.29852, 27.384853],
						[104.295806, 27.374647],
						[104.284069, 27.367372],
						[104.28111, 27.367265],
						[104.280866, 27.37332],
						[104.278249, 27.372315],
						[104.279399, 27.361787],
						[104.276024, 27.359711],
						[104.270425, 27.360952],
						[104.264189, 27.350851],
						[104.258687, 27.349567],
						[104.254457, 27.343788],
						[104.253944, 27.339293],
						[104.24783, 27.336425],
						[104.2492, 27.329982],
						[104.247684, 27.326258],
						[104.251425, 27.322961],
						[104.249591, 27.319728],
						[104.254237, 27.316303],
						[104.259885, 27.308318],
						[104.255337, 27.302344],
						[104.251083, 27.300224],
						[104.254433, 27.2944],
						[104.250373, 27.291488],
						[104.245923, 27.298618],
						[104.242622, 27.29909],
						[104.233697, 27.294957],
						[104.230445, 27.291231],
						[104.223402, 27.299111],
						[104.215651, 27.300931],
						[104.210834, 27.297227],
						[104.215969, 27.29288],
						[104.219123, 27.286777],
						[104.219172, 27.27986],
						[104.208877, 27.278104],
						[104.201982, 27.280717],
						[104.199561, 27.283929],
						[104.190489, 27.287698],
						[104.189902, 27.277933],
						[104.184058, 27.270673],
						[104.178483, 27.267803],
						[104.174155, 27.263026],
						[104.166697, 27.268295],
						[104.163053, 27.272964],
						[104.149287, 27.283929],
						[104.145301, 27.288469],
						[104.142416, 27.296477],
						[104.138528, 27.29864],
						[104.13151, 27.306605],
						[104.131852, 27.315896],
						[104.134297, 27.319001],
						[104.130043, 27.326921],
						[104.118868, 27.330132],
						[104.113855, 27.338009],
						[104.105223, 27.337089],
						[104.094855, 27.332273],
						[104.083509, 27.331523],
						[104.079524, 27.339679],
						[104.071601, 27.342568],
						[104.062505, 27.347683],
						[104.057834, 27.355623],
						[104.047589, 27.360374],
						[104.039544, 27.362664],
						[104.036047, 27.366195],
						[104.029494, 27.368206],
						[104.019933, 27.377172],
						[104.017512, 27.383676],
						[104.019248, 27.388511],
						[104.01981, 27.410952],
						[104.016803, 27.41215],
						[104.015262, 27.42032],
						[104.016901, 27.422823],
						[104.015262, 27.429239],
						[104.005701, 27.429945],
						[103.99861, 27.42586],
						[103.992619, 27.419722],
						[103.979782, 27.417198],
						[103.97516, 27.422994],
						[103.956478, 27.425389],
						[103.956038, 27.433131],
						[103.948629, 27.432639],
						[103.943959, 27.434307],
						[103.934691, 27.443866],
						[103.932442, 27.443952],
						[103.927282, 27.428084],
						[103.925375, 27.413219],
						[103.921193, 27.409604],
						[103.914493, 27.396684],
						[103.91332, 27.388469],
						[103.906669, 27.387463]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530629,
			"name": "威信县",
			"center": [105.04869, 27.843381],
			"centroid": [105.043781, 27.885575],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 9,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.290511, 27.712438],
						[105.286036, 27.712587],
						[105.278798, 27.71696],
						[105.270949, 27.727454],
						[105.263246, 27.728371],
						[105.259261, 27.72707],
						[105.252047, 27.729928],
						[105.236789, 27.732232],
						[105.225174, 27.746243],
						[105.222851, 27.75215],
						[105.206468, 27.76279],
						[105.204707, 27.775646],
						[105.199107, 27.780187],
						[105.195219, 27.785793],
						[105.191527, 27.781572],
						[105.19319, 27.770273],
						[105.184363, 27.76635],
						[105.182724, 27.760295],
						[105.18583, 27.755092],
						[105.181257, 27.752214],
						[105.174557, 27.754048],
						[105.17441, 27.757779],
						[105.16458, 27.765348],
						[105.160668, 27.773088],
						[105.15634, 27.775092],
						[105.153699, 27.781125],
						[105.142353, 27.770551],
						[105.115895, 27.757161],
						[105.106652, 27.746989],
						[105.100099, 27.742916],
						[105.098363, 27.732402],
						[105.094084, 27.728201],
						[105.080024, 27.725364],
						[105.057307, 27.718069],
						[105.048578, 27.717515],
						[105.03618, 27.71199],
						[105.023391, 27.709985],
						[105.018036, 27.713377],
						[105.002533, 27.716811],
						[104.999501, 27.721333],
						[104.993779, 27.724788],
						[104.985368, 27.726452],
						[104.97835, 27.72562],
						[104.97055, 27.728883],
						[104.955756, 27.729502],
						[104.953971, 27.735026],
						[104.959644, 27.738758],
						[104.958128, 27.745902],
						[104.976589, 27.748823],
						[104.981358, 27.752747],
						[104.992483, 27.756969],
						[104.995173, 27.760231],
						[104.991774, 27.765071],
						[104.993706, 27.771339],
						[104.998425, 27.775539],
						[104.994709, 27.778545],
						[104.98505, 27.780869],
						[104.960377, 27.77782],
						[104.937098, 27.782766],
						[104.929445, 27.786603],
						[104.924236, 27.78688],
						[104.915605, 27.781679],
						[104.900982, 27.780528],
						[104.892375, 27.78396],
						[104.886286, 27.791613],
						[104.862494, 27.787371],
						[104.850292, 27.77765],
						[104.843568, 27.774431],
						[104.829409, 27.756841],
						[104.824543, 27.744004],
						[104.813833, 27.745646],
						[104.811804, 27.751531],
						[104.813173, 27.756436],
						[104.819506, 27.768952],
						[104.823199, 27.773855],
						[104.818504, 27.778439],
						[104.815985, 27.787435],
						[104.810483, 27.788778],
						[104.802732, 27.785879],
						[104.796521, 27.776222],
						[104.790163, 27.776541],
						[104.777179, 27.773407],
						[104.770552, 27.767267],
						[104.764097, 27.764261],
						[104.759818, 27.768525],
						[104.762092, 27.778289],
						[104.756296, 27.781466],
						[104.754658, 27.78477],
						[104.745391, 27.785708],
						[104.748203, 27.789779],
						[104.747004, 27.794149],
						[104.736588, 27.795854],
						[104.735389, 27.799222],
						[104.74297, 27.807385],
						[104.740989, 27.815207],
						[104.732529, 27.820044],
						[104.726758, 27.819661],
						[104.720082, 27.823497],
						[104.719862, 27.829421],
						[104.715387, 27.82697],
						[104.711915, 27.820385],
						[104.706315, 27.821643],
						[104.701229, 27.828717],
						[104.705508, 27.835792],
						[104.71216, 27.843057],
						[104.716952, 27.852005],
						[104.735365, 27.859184],
						[104.739082, 27.864851],
						[104.736294, 27.873967],
						[104.735585, 27.881316],
						[104.739742, 27.88828],
						[104.749205, 27.890111],
						[104.754976, 27.885639],
						[104.766689, 27.884745],
						[104.774171, 27.890921],
						[104.790726, 27.894562],
						[104.795249, 27.900525],
						[104.799846, 27.899418],
						[104.813662, 27.902058],
						[104.816743, 27.899716],
						[104.829507, 27.899865],
						[104.835449, 27.904656],
						[104.840609, 27.90093],
						[104.848262, 27.900823],
						[104.85841, 27.902463],
						[104.862787, 27.904592],
						[104.872959, 27.905934],
						[104.885332, 27.912002],
						[104.887924, 27.914472],
						[104.887924, 27.93012],
						[104.897143, 27.935804],
						[104.907511, 27.93855],
						[104.918979, 27.939253],
						[104.920813, 27.942361],
						[104.915189, 27.94964],
						[104.903574, 27.949853],
						[104.903085, 27.960431],
						[104.905628, 27.964666],
						[104.910739, 27.967475],
						[104.919468, 27.969391],
						[104.92184, 27.975073],
						[104.929225, 27.98501],
						[104.937783, 27.981776],
						[104.947124, 27.980541],
						[104.944679, 27.987712],
						[104.946904, 27.994861],
						[104.95869, 28.003605],
						[104.960793, 28.012348],
						[104.973606, 28.017135],
						[104.974951, 28.020729],
						[104.971846, 28.033427],
						[104.975685, 28.048527],
						[104.97632, 28.060137],
						[104.98082, 28.062816],
						[105.002093, 28.064156],
						[105.011067, 28.066707],
						[105.03195, 28.08042],
						[105.041682, 28.089008],
						[105.043345, 28.096512],
						[105.049213, 28.098807],
						[105.061562, 28.096809],
						[105.062785, 28.091432],
						[105.072834, 28.089518],
						[105.078287, 28.083332],
						[105.088826, 28.086117],
						[105.100637, 28.081844],
						[105.108144, 28.081122],
						[105.119686, 28.072235],
						[105.132499, 28.070428],
						[105.141815, 28.067047],
						[105.150985, 28.066707],
						[105.154359, 28.068854],
						[105.166365, 28.07198],
						[105.170131, 28.067047],
						[105.177051, 28.066856],
						[105.179399, 28.062157],
						[105.185487, 28.056841],
						[105.185756, 28.050696],
						[105.18292, 28.045805],
						[105.183751, 28.040318],
						[105.179448, 28.038255],
						[105.169936, 28.028174],
						[105.167808, 28.021282],
						[105.171231, 28.013561],
						[105.184216, 27.996691],
						[105.215588, 27.990584],
						[105.222924, 27.992648],
						[105.227839, 27.999371],
						[105.233341, 28.003286],
						[105.238916, 28.003265],
						[105.246203, 28.009243],
						[105.25146, 28.001456],
						[105.259676, 28.000946],
						[105.268235, 27.998244],
						[105.270876, 27.995755],
						[105.268993, 27.98701],
						[105.269849, 27.978988],
						[105.278016, 27.971476],
						[105.283371, 27.959942],
						[105.282148, 27.949725],
						[105.284618, 27.94219],
						[105.284618, 27.935655],
						[105.280926, 27.929141],
						[105.272441, 27.923393],
						[105.268333, 27.914067],
						[105.264151, 27.911576],
						[105.256644, 27.914536],
						[105.248942, 27.913003],
						[105.234881, 27.898907],
						[105.233292, 27.890516],
						[105.238452, 27.885405],
						[105.241435, 27.874479],
						[105.24053, 27.867258],
						[105.245347, 27.863722],
						[105.246765, 27.859057],
						[105.245078, 27.853305],
						[105.250189, 27.844825],
						[105.241166, 27.830806],
						[105.244785, 27.82258],
						[105.259138, 27.827972],
						[105.270533, 27.818126],
						[105.282295, 27.817956],
						[105.288628, 27.815995],
						[105.303226, 27.820194],
						[105.314157, 27.819426],
						[105.316382, 27.817082],
						[105.313203, 27.810817],
						[105.306968, 27.811904],
						[105.288261, 27.807449],
						[105.288799, 27.79984],
						[105.28611, 27.796132],
						[105.278774, 27.796984],
						[105.273859, 27.795236],
						[105.275448, 27.785303],
						[105.278994, 27.779313],
						[105.292956, 27.771297],
						[105.289191, 27.765071],
						[105.290169, 27.75795],
						[105.29391, 27.751745],
						[105.287919, 27.742383],
						[105.290633, 27.73462],
						[105.291416, 27.72722],
						[105.290511, 27.712438]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 530630,
			"name": "水富县",
			"center": [104.415376, 28.629688],
			"centroid": [104.221258, 28.505038],
			"childrenNum": 0,
			"level": "district",
			"subFeatureIndex": 10,
			"acroutes": [100000, 530000, 530600],
			"parent": {
				"adcode": 530600
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.086444, 28.378226],
						[104.082262, 28.390712],
						[104.072652, 28.402158],
						[104.069205, 28.403027],
						[104.063678, 28.412098],
						[104.070012, 28.419007],
						[104.077054, 28.429136],
						[104.075367, 28.438904],
						[104.083191, 28.443692],
						[104.081284, 28.453438],
						[104.088889, 28.464601],
						[104.092679, 28.472333],
						[104.095344, 28.485273],
						[104.089525, 28.500161],
						[104.092483, 28.509604],
						[104.100088, 28.523112],
						[104.114662, 28.531919],
						[104.116863, 28.535835],
						[104.121166, 28.537423],
						[104.126937, 28.533062],
						[104.143125, 28.532046],
						[104.152074, 28.534628],
						[104.156451, 28.540915],
						[104.174082, 28.544979],
						[104.182224, 28.551964],
						[104.1833, 28.5577],
						[104.188093, 28.561445],
						[104.193864, 28.568789],
						[104.201982, 28.572809],
						[104.215773, 28.574481],
						[104.228831, 28.581485],
						[104.23937, 28.583939],
						[104.241742, 28.587304],
						[104.251498, 28.588975],
						[104.25387, 28.593143],
						[104.255631, 28.603403],
						[104.261035, 28.606386],
						[104.260595, 28.609792],
						[104.264703, 28.608798],
						[104.276049, 28.614657],
						[104.278152, 28.626163],
						[104.277271, 28.632149],
						[104.289057, 28.634961],
						[104.296393, 28.634433],
						[104.302531, 28.62794],
						[104.301406, 28.619564],
						[104.305489, 28.61563],
						[104.314879, 28.615609],
						[104.324856, 28.621975],
						[104.33295, 28.633248],
						[104.343904, 28.640946],
						[104.357965, 28.645429],
						[104.374103, 28.64932],
						[104.387503, 28.64287],
						[104.404865, 28.640629],
						[104.410611, 28.637689],
						[104.416333, 28.632254],
						[104.425282, 28.626713],
						[104.420588, 28.620643],
						[104.420147, 28.613367],
						[104.416895, 28.602578],
						[104.417286, 28.598051],
						[104.407212, 28.596824],
						[104.394252, 28.599067],
						[104.387723, 28.598876],
						[104.375644, 28.594772],
						[104.368406, 28.585971],
						[104.367452, 28.579877],
						[104.363931, 28.571561],
						[104.359725, 28.565614],
						[104.35953, 28.559287],
						[104.356815, 28.555689],
						[104.343733, 28.556282],
						[104.336764, 28.559879],
						[104.330945, 28.559752],
						[104.326274, 28.551985],
						[104.323462, 28.54119],
						[104.317251, 28.538079],
						[104.299205, 28.540619],
						[104.287077, 28.532575],
						[104.267564, 28.537232],
						[104.260252, 28.536195],
						[104.248271, 28.528362],
						[104.24651, 28.520678],
						[104.247488, 28.511425],
						[104.251645, 28.507424],
						[104.259274, 28.503845],
						[104.265412, 28.502723],
						[104.267246, 28.498128],
						[104.261108, 28.492325],
						[104.261133, 28.482562],
						[104.268517, 28.470744],
						[104.270376, 28.465872],
						[104.258369, 28.453226],
						[104.260692, 28.441425],
						[104.266806, 28.429475],
						[104.267637, 28.420511],
						[104.259592, 28.415213],
						[104.254359, 28.408983],
						[104.25431, 28.403578],
						[104.257196, 28.396351],
						[104.261475, 28.39173],
						[104.254873, 28.388995],
						[104.249469, 28.388804],
						[104.245165, 28.381533],
						[104.236631, 28.372757],
						[104.22575, 28.372778],
						[104.221666, 28.371188],
						[104.207044, 28.370212],
						[104.203816, 28.37193],
						[104.20966, 28.376361],
						[104.228635, 28.379117],
						[104.2302, 28.381215],
						[104.202006, 28.391094],
						[104.190171, 28.38872],
						[104.176576, 28.398131],
						[104.176209, 28.400844],
						[104.159043, 28.400802],
						[104.146157, 28.397919],
						[104.13464, 28.398958],
						[104.128086, 28.396245],
						[104.117303, 28.387935],
						[104.108182, 28.379668],
						[104.09867, 28.379074],
						[104.091921, 28.376806],
						[104.086444, 28.378226]
					]
				]
			]
		}
	}]
};

//萍乡市json
var pingxiangJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"name": "安源区",
			"id": "360302"
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[113.812899199219, 27.6693971992188],
						[113.825345488281, 27.6538503242188],
						[113.851986113281, 27.6695095039062],
						[113.8684778125, 27.6674587226563],
						[113.942899199219, 27.6782888007813],
						[113.977345, 27.7038430000001],
						[113.991610136719, 27.6932302070313],
						[113.981385527344, 27.639145734375],
						[113.951405058594, 27.5993044257813],
						[113.953690214844, 27.5860280585938],
						[113.910321074219, 27.5934963203125],
						[113.891610136719, 27.5795778632813],
						[113.881041289063, 27.5529787421875],
						[113.847345, 27.5438430000001],
						[113.842899199219, 27.5593971992188],
						[113.831790800781, 27.5782888007813],
						[113.822899199219, 27.5993971992188],
						[113.811790800781, 27.6082888007813],
						[113.801890898438, 27.6206520820313],
						[113.782345, 27.6182204414063],
						[113.770584746094, 27.61968284375],
						[113.774212675781, 27.6488674140625],
						[113.767345, 27.7038430000001],
						[113.777345, 27.7038430000001],
						[113.777345, 27.713843],
						[113.805323515625, 27.7245973945313],
						[113.79088015625, 27.6870265937501],
						[113.812899199219, 27.6693971992188]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"name": "莲花县",
			"id": "360321"
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[113.975264921875, 27.4306276679688],
						[113.992379179688, 27.4280983710938],
						[114.027345, 27.4338430000001],
						[114.017415800781, 27.3901345039063],
						[114.042899199219, 27.3793971992188],
						[114.051790800781, 27.3682888007813],
						[114.062899199219, 27.3593971992188],
						[114.071790800781, 27.3382888007813],
						[114.092899199219, 27.3293971992188],
						[114.11373171875, 27.3171486640626],
						[114.132869902344, 27.3195314765626],
						[114.153619414063, 27.2468752265625],
						[114.131790800781, 27.2293971992188],
						[114.127345, 27.223843],
						[114.0953528125, 27.2184084296875],
						[114.0701965625, 27.1569435859375],
						[114.043922148438, 27.160825421875],
						[114.022838164063, 27.1481081367188],
						[113.989586210938, 27.0925099921876],
						[113.993140898438, 27.068452375],
						[113.976551542969, 27.0409499335938],
						[113.96170046875, 27.02948753125],
						[113.95298953125, 27.00819846875],
						[113.933949003906, 26.9935036445313],
						[113.917345, 26.963843],
						[113.888316679688, 26.9685353828125],
						[113.873170195313, 26.9896681953126],
						[113.861519804688, 26.9980178046876],
						[113.853170195313, 27.0196681953126],
						[113.811519804688, 27.0480178046875],
						[113.800797148438, 27.1015016914063],
						[113.771881132813, 27.0957863593751],
						[113.767345, 27.1238430000001],
						[113.79197390625, 27.15921409375],
						[113.809705839844, 27.1744924140626],
						[113.85197390625, 27.26921409375],
						[113.862996855469, 27.2889723945313],
						[113.846185332031, 27.3034572578126],
						[113.86271609375, 27.34847190625],
						[113.867345, 27.383843],
						[113.867345, 27.413843],
						[113.877345, 27.413843],
						[113.899156523438, 27.40526878125],
						[113.91298953125, 27.42819846875],
						[113.929359160156, 27.46819846875],
						[113.95298953125, 27.4594875312501],
						[113.975264921875, 27.4306276679688]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"name": "芦溪县",
			"id": "360323"
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[114.157345, 27.743843],
						[114.145152617188, 27.7404201484375],
						[114.153922148438, 27.7316506171875],
						[114.163905058594, 27.7393141914063],
						[114.2069153125, 27.6742287421876],
						[114.200186796875, 27.6442116523438],
						[114.219598417969, 27.6160964179688],
						[114.255091582031, 27.5915895820313],
						[114.267345, 27.573843],
						[114.222154570313, 27.5490334296875],
						[114.212535429688, 27.5286525703125],
						[114.202154570313, 27.5190334296875],
						[114.192535429688, 27.4886525703125],
						[114.166610136719, 27.4396584296876],
						[114.027345, 27.4338430000001],
						[113.992379179688, 27.4280983710938],
						[113.975264921875, 27.4306276679688],
						[113.95298953125, 27.4594875312501],
						[113.929359160156, 27.46819846875],
						[113.91298953125, 27.42819846875],
						[113.899156523438, 27.40526878125],
						[113.877345, 27.413843],
						[113.873260527344, 27.4197585273438],
						[113.861429472656, 27.4279274726563],
						[113.842274199219, 27.4556716132813],
						[113.829686308594, 27.48931175],
						[113.863260527344, 27.4979274726563],
						[113.877291289063, 27.5182497382813],
						[113.851429472656, 27.5279274726563],
						[113.847345, 27.5438430000001],
						[113.881041289063, 27.5529787421875],
						[113.891610136719, 27.5795778632813],
						[113.910321074219, 27.5934963203125],
						[113.953690214844, 27.5860280585938],
						[113.951405058594, 27.5993044257813],
						[113.981385527344, 27.639145734375],
						[113.991610136719, 27.6932302070313],
						[113.977345, 27.7038430000001],
						[113.98170046875, 27.70948753125],
						[114.05298953125, 27.73819846875],
						[114.057345, 27.743843],
						[114.071429472656, 27.7497585273438],
						[114.103260527344, 27.7579274726563],
						[114.115582304688, 27.7757741523438],
						[114.153260527344, 27.7497585273438],
						[114.157345, 27.743843]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"name": "上栗县",
			"id": "360322"
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[113.907345, 27.993843],
						[113.922061796875, 27.9881862617187],
						[113.941890898438, 27.9906520820313],
						[113.952799101563, 27.9770339179687],
						[113.980504179688, 27.9804787421875],
						[113.997342558594, 27.9518337226563],
						[113.942750273438, 27.9081716132813],
						[113.915303984375, 27.9115846992188],
						[113.891282988281, 27.8786989570312],
						[113.903023710938, 27.8692971015625],
						[113.901722441406, 27.858843],
						[113.902967558594, 27.8488430000001],
						[113.90166140625, 27.8383449531251],
						[113.922899199219, 27.8293971992188],
						[113.931846953125, 27.80815940625],
						[113.963370390625, 27.8120803046875],
						[113.95978640625, 27.7832814765625],
						[113.978472929688, 27.759946515625],
						[113.997345, 27.7576003242188],
						[114.02095828125, 27.7605373359375],
						[114.041790800781, 27.7482888007813],
						[114.057345, 27.743843],
						[114.05298953125, 27.73819846875],
						[113.98170046875, 27.70948753125],
						[113.977345, 27.7038430000001],
						[113.942899199219, 27.6782888007813],
						[113.8684778125, 27.6674587226563],
						[113.851986113281, 27.6695095039062],
						[113.825345488281, 27.6538503242188],
						[113.812899199219, 27.6693971992188],
						[113.79088015625, 27.6870265937501],
						[113.805323515625, 27.7245973945313],
						[113.777345, 27.713843],
						[113.767345, 27.713843],
						[113.767345, 27.7038430000001],
						[113.728424101563, 27.6895510078126],
						[113.744820585938, 27.7341994453125],
						[113.697345, 27.723843],
						[113.701339140625, 27.749848859375],
						[113.713350859375, 27.757837140625],
						[113.72533328125, 27.7758547187501],
						[113.760982695313, 27.7995607734375],
						[113.751085234375, 27.838843],
						[113.753604765625, 27.8488430000001],
						[113.749310332031, 27.8658864570313],
						[113.731339140625, 27.877837140625],
						[113.727345, 27.8838430000001],
						[113.732908964844, 27.91581565625],
						[113.758785429688, 27.948130109375],
						[113.782899199219, 27.9582888007813],
						[113.798472929688, 27.977739484375],
						[113.812345, 27.9794655585938],
						[113.841846953125, 27.975796125],
						[113.852347441406, 28.0007131171875],
						[113.907345, 27.993843]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"name": "湘东区",
			"id": "360313"
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[113.767345, 27.7038430000001],
						[113.767345, 27.713843],
						[113.777345, 27.713843],
						[113.777345, 27.7038430000001],
						[113.767345, 27.7038430000001]
					]
				],
				[
					[
						[113.767345, 27.7038430000001],
						[113.774212675781, 27.6488674140625],
						[113.770584746094, 27.61968284375],
						[113.782345, 27.6182204414063],
						[113.801890898438, 27.6206520820313],
						[113.811790800781, 27.6082888007813],
						[113.822899199219, 27.5993971992188],
						[113.831790800781, 27.5782888007813],
						[113.842899199219, 27.5593971992188],
						[113.847345, 27.5438430000001],
						[113.851429472656, 27.5279274726563],
						[113.877291289063, 27.5182497382813],
						[113.863260527344, 27.4979274726563],
						[113.829686308594, 27.48931175],
						[113.842274199219, 27.4556716132813],
						[113.861429472656, 27.4279274726563],
						[113.873260527344, 27.4197585273438],
						[113.877345, 27.413843],
						[113.867345, 27.413843],
						[113.867345, 27.383843],
						[113.827635527344, 27.368921125],
						[113.7262903125, 27.3575563789063],
						[113.692806425781, 27.3383815742188],
						[113.669420195313, 27.3293044257813],
						[113.652806425781, 27.3493044257813],
						[113.60728640625, 27.359399640625],
						[113.592806425781, 27.3834596992188],
						[113.623363066406, 27.408843],
						[113.617345, 27.413843],
						[113.61298953125, 27.4194875312501],
						[113.60170046875, 27.42819846875],
						[113.587257109375, 27.4634914375001],
						[113.630872832031, 27.5223195625001],
						[113.602345, 27.5181032539063],
						[113.585064726563, 27.5206569648438],
						[113.57298953125, 27.5477346015625],
						[113.603148222656, 27.5884133125001],
						[113.600867949219, 27.603843],
						[113.603084746094, 27.6188430000001],
						[113.600128203125, 27.638843],
						[113.632991972656, 27.6522927070313],
						[113.674769316406, 27.7064186835937],
						[113.697345, 27.723843],
						[113.744820585938, 27.7341994453125],
						[113.728424101563, 27.6895510078126],
						[113.767345, 27.7038430000001]
					]
				]
			]
		}
	}]
};

//张掖市json
var zhangyeJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 620702,
			"name": "甘州区",
			"center": [100.454862, 38.931774],
			"centroid": [100.507318, 39.004448],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 0,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[100.101741, 38.988716],
						[100.105108, 38.98617],
						[100.103857, 38.980333],
						[100.109389, 38.973368],
						[100.113622, 38.959956],
						[100.112515, 38.946091],
						[100.117373, 38.939123],
						[100.121943, 38.937296],
						[100.132189, 38.936056],
						[100.141039, 38.93026],
						[100.141664, 38.926088],
						[100.13772, 38.91217],
						[100.128677, 38.887193],
						[100.12988, 38.879859],
						[100.122232, 38.865481],
						[100.128725, 38.861621],
						[100.140991, 38.849745],
						[100.146523, 38.8392],
						[100.151814, 38.834368],
						[100.15773, 38.821787],
						[100.162011, 38.816683],
						[100.159029, 38.810041],
						[100.151525, 38.806697],
						[100.15773, 38.802292],
						[100.16076, 38.79583],
						[100.163502, 38.783695],
						[100.176297, 38.780576],
						[100.180963, 38.771287],
						[100.185532, 38.766359],
						[100.189092, 38.757475],
						[100.183416, 38.746464],
						[100.181781, 38.728417],
						[100.180001, 38.721587],
						[100.1813, 38.717199],
						[100.185773, 38.712946],
						[100.192699, 38.710683],
						[100.212228, 38.708308],
						[100.22435, 38.705005],
						[100.232287, 38.698828],
						[100.237385, 38.688374],
						[100.245707, 38.677624],
						[100.250565, 38.67475],
						[100.269372, 38.675383],
						[100.275962, 38.671785],
						[100.28818, 38.668955],
						[100.292365, 38.659787],
						[100.299724, 38.657342],
						[100.295443, 38.647629],
						[100.299051, 38.642602],
						[100.297608, 38.635401],
						[100.303861, 38.627723],
						[100.313096, 38.623782],
						[100.31324, 38.617644],
						[100.316175, 38.615061],
						[100.317137, 38.609307],
						[100.324256, 38.60344],
						[100.339936, 38.597707],
						[100.347633, 38.593787],
						[100.362496, 38.592178],
						[100.364612, 38.590637],
						[100.360235, 38.579941],
						[100.366729, 38.568744],
						[100.371154, 38.565752],
						[100.373848, 38.560175],
						[100.383901, 38.557387],
						[100.386354, 38.545642],
						[100.398427, 38.552444],
						[100.407759, 38.556593],
						[100.425123, 38.568495],
						[100.446769, 38.579737],
						[100.452926, 38.581867],
						[100.461391, 38.587941],
						[100.46447, 38.594807],
						[100.471204, 38.601831],
						[100.486452, 38.612638],
						[100.49232, 38.615786],
						[100.512426, 38.632751],
						[100.515361, 38.640541],
						[100.519305, 38.66067],
						[100.516371, 38.663386],
						[100.512234, 38.655961],
						[100.509733, 38.656844],
						[100.513196, 38.668638],
						[100.507376, 38.673641],
						[100.50449, 38.683418],
						[100.505211, 38.689076],
						[100.514783, 38.694982],
						[100.524548, 38.706046],
						[100.527626, 38.732127],
						[100.530368, 38.734072],
						[100.57313, 38.736152],
						[100.582702, 38.739974],
						[100.590542, 38.740607],
						[100.598623, 38.736446],
						[100.608051, 38.73631],
						[100.611947, 38.73812],
						[100.631909, 38.757068],
						[100.63441, 38.763714],
						[100.644031, 38.766404],
						[100.647734, 38.770925],
						[100.691987, 38.797027],
						[100.68939, 38.805274],
						[100.705359, 38.820432],
						[100.71724, 38.836265],
						[100.72763, 38.852229],
						[100.735519, 38.865707],
						[100.733065, 38.873201],
						[100.73345, 38.878775],
						[100.738789, 38.884079],
						[100.745235, 38.893625],
						[100.760291, 38.904929],
						[100.771787, 38.917178],
						[100.783764, 38.932606],
						[100.790161, 38.942956],
						[100.800695, 38.954523],
						[100.811422, 38.962887],
						[100.822581, 38.973977],
						[100.835713, 38.983848],
						[100.843457, 38.991623],
						[100.858609, 39.0094],
						[100.867989, 39.006786],
						[100.835184, 39.026023],
						[100.829604, 39.03555],
						[100.830374, 39.057908],
						[100.829412, 39.074925],
						[100.831528, 39.077491],
						[100.864381, 39.106923],
						[100.866209, 39.112457],
						[100.863419, 39.116933],
						[100.86568, 39.124671],
						[100.863708, 39.13171],
						[100.858561, 39.139041],
						[100.853318, 39.151655],
						[100.852596, 39.163435],
						[100.846536, 39.175819],
						[100.845622, 39.180629],
						[100.847979, 39.18973],
						[100.847642, 39.193392],
						[100.842832, 39.200133],
						[100.842591, 39.212444],
						[100.84211, 39.405741],
						[100.723397, 39.403792],
						[100.707957, 39.404598],
						[100.689919, 39.400745],
						[100.674527, 39.395547],
						[100.650139, 39.390708],
						[100.638884, 39.390103],
						[100.619932, 39.387593],
						[100.601894, 39.388333],
						[100.569522, 39.395077],
						[100.561586, 39.396197],
						[100.5511, 39.395659],
						[100.532581, 39.399222],
						[100.523442, 39.399222],
						[100.499102, 39.400543],
						[100.49713, 39.401507],
						[100.495976, 39.389632],
						[100.497323, 39.373789],
						[100.497948, 39.356127],
						[100.499247, 39.34003],
						[100.497659, 39.324512],
						[100.492272, 39.304055],
						[100.490733, 39.29037],
						[100.490829, 39.278903],
						[100.488905, 39.270015],
						[100.488809, 39.254908],
						[100.486789, 39.249475],
						[100.4827, 39.244334],
						[100.466682, 39.228548],
						[100.461343, 39.221608],
						[100.453262, 39.199863],
						[100.438399, 39.183123],
						[100.437678, 39.174673],
						[100.446817, 39.161794],
						[100.44725, 39.152149],
						[100.439457, 39.142526],
						[100.417475, 39.131935],
						[100.409683, 39.129394],
						[100.401939, 39.128786],
						[100.401361, 39.134589],
						[100.388518, 39.146079],
						[100.382265, 39.146011],
						[100.369663, 39.153206],
						[100.359369, 39.156084],
						[100.35023, 39.156826],
						[100.349028, 39.159366],
						[100.335655, 39.159478],
						[100.325458, 39.161546],
						[100.319253, 39.165076],
						[100.312134, 39.172718],
						[100.305015, 39.177617],
						[100.287939, 39.180494],
						[100.282889, 39.182854],
						[100.27702, 39.190426],
						[100.277117, 39.197414],
						[100.275048, 39.201908],
						[100.262013, 39.212331],
						[100.229545, 39.217026],
						[100.221993, 39.214263],
						[100.219251, 39.200605],
						[100.220021, 39.193392],
						[100.222282, 39.187752],
						[100.222618, 39.17755],
						[100.225312, 39.174179],
						[100.225023, 39.167054],
						[100.215644, 39.158264],
						[100.211122, 39.156466],
						[100.20458, 39.147563],
						[100.194094, 39.143493],
						[100.191497, 39.139671],
						[100.193469, 39.133644],
						[100.189717, 39.126447],
						[100.18813, 39.117406],
						[100.183127, 39.107463],
						[100.19015, 39.105551],
						[100.198472, 39.100939],
						[100.196932, 39.096281],
						[100.197269, 39.088856],
						[100.193421, 39.08503],
						[100.196932, 39.079517],
						[100.201935, 39.06653],
						[100.211026, 39.052077],
						[100.218049, 39.037666],
						[100.222426, 39.03046],
						[100.232575, 39.019874],
						[100.233826, 39.007913],
						[100.229737, 39.001154],
						[100.216317, 38.997166],
						[100.197125, 38.995161],
						[100.176297, 38.995296],
						[100.15191, 38.994349],
						[100.145561, 38.992997],
						[100.129591, 38.992795],
						[100.127523, 38.995003],
						[100.107368, 38.992276],
						[100.101741, 38.988716]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620721,
			"name": "肃南裕固族自治县",
			"center": [99.617086, 38.837269],
			"centroid": [98.867052, 39.053609],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 1,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[99.175365, 39.168312],
						[99.171324, 39.160108],
						[99.159924, 39.15433],
						[99.157231, 39.155409],
						[99.161319, 39.161209],
						[99.162137, 39.165413],
						[99.179165, 39.181595],
						[99.168294, 39.188696],
						[99.150929, 39.201481],
						[99.143618, 39.208176],
						[99.143378, 39.224393],
						[99.141309, 39.24604],
						[99.138519, 39.251923],
						[99.120433, 39.261127],
						[99.099077, 39.260745],
						[99.092727, 39.261576],
						[99.078826, 39.267008],
						[99.068436, 39.257692],
						[99.063915, 39.256278],
						[99.060307, 39.257894],
						[99.049917, 39.274684],
						[99.046406, 39.285545],
						[99.034525, 39.295261],
						[99.02351, 39.300354],
						[99.020528, 39.306074],
						[99.008599, 39.30603],
						[99.001143, 39.309215],
						[98.984548, 39.313903],
						[98.975698, 39.330769],
						[98.95131, 39.33124],
						[98.931445, 39.32967],
						[98.907875, 39.332832],
						[98.906432, 39.332518],
						[98.906673, 39.322516],
						[98.902103, 39.316527],
						[98.897678, 39.323884],
						[98.880939, 39.329984],
						[98.866605, 39.324265],
						[98.838706, 39.3442],
						[98.826921, 39.350366],
						[98.816147, 39.347563],
						[98.817638, 39.352742],
						[98.800322, 39.360431],
						[98.78315, 39.371459],
						[98.779061, 39.372669],
						[98.763621, 39.383896],
						[98.752509, 39.389767],
						[98.731682, 39.397362],
						[98.728459, 39.399244],
						[98.710421, 39.414813],
						[98.703687, 39.417635],
						[98.680695, 39.424533],
						[98.660444, 39.436446],
						[98.645725, 39.440252],
						[98.631199, 39.442021],
						[98.615855, 39.44473],
						[98.612199, 39.444529],
						[98.602964, 39.451782],
						[98.58911, 39.453842],
						[98.581366, 39.457401],
						[98.570255, 39.460602],
						[98.560971, 39.467563],
						[98.569966, 39.46989],
						[98.575786, 39.475373],
						[98.575979, 39.479088],
						[98.579731, 39.481952],
						[98.576075, 39.482914],
						[98.57189, 39.479424],
						[98.553371, 39.470159],
						[98.53062, 39.467451],
						[98.526435, 39.467518],
						[98.51263, 39.472665],
						[98.511139, 39.474098],
						[98.515564, 39.480364],
						[98.527301, 39.476604],
						[98.533506, 39.476201],
						[98.539759, 39.483183],
						[98.536969, 39.485689],
						[98.53062, 39.486763],
						[98.549716, 39.509761],
						[98.434177, 39.577479],
						[98.417919, 39.558818],
						[98.412484, 39.554571],
						[98.403874, 39.537491],
						[98.402816, 39.530068],
						[98.4032, 39.519333],
						[98.400555, 39.511953],
						[98.394735, 39.507323],
						[98.385836, 39.503363],
						[98.382325, 39.505533],
						[98.391704, 39.511662],
						[98.39536, 39.515688],
						[98.396562, 39.52962],
						[98.395119, 39.53852],
						[98.386221, 39.538698],
						[98.362315, 39.542611],
						[98.354666, 39.550123],
						[98.330135, 39.569546],
						[98.336436, 39.583043],
						[98.356975, 39.630374],
						[98.361449, 39.638323],
						[98.370732, 39.650534],
						[98.370732, 39.654262],
						[98.360968, 39.661761],
						[98.334079, 39.667474],
						[98.328836, 39.664506],
						[98.320852, 39.66531],
						[98.305026, 39.673879],
						[98.289345, 39.686553],
						[98.281072, 39.690925],
						[98.263804, 39.694405],
						[98.255915, 39.702101],
						[98.243409, 39.707923],
						[98.24288, 39.712651],
						[98.246391, 39.718003],
						[98.238791, 39.718985],
						[98.22489, 39.725429],
						[98.217579, 39.727436],
						[98.203678, 39.727369],
						[98.188237, 39.72592],
						[98.176116, 39.721772],
						[98.166255, 39.713075],
						[98.160916, 39.705737],
						[98.157549, 39.696926],
						[98.038355, 39.698599],
						[98.03595, 39.698287],
						[97.979575, 39.668211],
						[97.968368, 39.662899],
						[97.959902, 39.670353],
						[97.941143, 39.694919],
						[97.931234, 39.699068],
						[97.922239, 39.698845],
						[97.91233, 39.70141],
						[97.905163, 39.701499],
						[97.887654, 39.705113],
						[97.879237, 39.709328],
						[97.857495, 39.709707],
						[97.855619, 39.710465],
						[97.845181, 39.699625],
						[97.834118, 39.691885],
						[97.828971, 39.685348],
						[97.822333, 39.683764],
						[97.813387, 39.683451],
						[97.80824, 39.680194],
						[97.797465, 39.684031],
						[97.785536, 39.680662],
						[97.779187, 39.681644],
						[97.774906, 39.684612],
						[97.761726, 39.687869],
						[97.752972, 39.688271],
						[97.74465, 39.687177],
						[97.728633, 39.690078],
						[97.721851, 39.692152],
						[97.70718, 39.693848],
						[97.700205, 39.697082],
						[97.694577, 39.69184],
						[97.691306, 39.68334],
						[97.676588, 39.6791],
						[97.671681, 39.663256],
						[97.667352, 39.656828],
						[97.657203, 39.633031],
						[97.652922, 39.631379],
						[97.641089, 39.630329],
						[97.628679, 39.627583],
						[97.619011, 39.630597],
						[97.609775, 39.618137],
						[97.58534, 39.603105],
						[97.580241, 39.587914],
						[97.573507, 39.577166],
						[97.569419, 39.563333],
						[97.560472, 39.555845],
						[97.552102, 39.551062],
						[97.534257, 39.543595],
						[97.520596, 39.538743],
						[97.515738, 39.534182],
						[97.509196, 39.525439],
						[97.505108, 39.510991],
						[97.498229, 39.502446],
						[97.49212, 39.491238],
						[97.482164, 39.477454],
						[97.479999, 39.471658],
						[97.481779, 39.465974],
						[97.481057, 39.448267],
						[97.48048, 39.406435],
						[97.477257, 39.373207],
						[97.453928, 39.352249],
						[97.436083, 39.350702],
						[97.429253, 39.347474],
						[97.409531, 39.326665],
						[97.397121, 39.318008],
						[97.3964, 39.312131],
						[97.401691, 39.303854],
						[97.402124, 39.292995],
						[97.395053, 39.240337],
						[97.412802, 39.197998],
						[97.424202, 39.178494],
						[97.426318, 39.173774],
						[97.430263, 39.139536],
						[97.433004, 39.12602],
						[97.43969, 39.12078],
						[97.449166, 39.120195],
						[97.458835, 39.11808],
						[97.475526, 39.106068],
						[97.490677, 39.084693],
						[97.500586, 39.078211],
						[97.515834, 39.073305],
						[97.536902, 39.069276],
						[97.543348, 39.067182],
						[97.555662, 39.06115],
						[97.581444, 39.052325],
						[97.596692, 39.043544],
						[97.620165, 39.031789],
						[97.630411, 39.027622],
						[97.639261, 39.026001],
						[97.653932, 39.018635],
						[97.679233, 39.010301],
						[97.686881, 39.00548],
						[97.694962, 38.988739],
						[97.690441, 38.975915],
						[97.693327, 38.969041],
						[97.701552, 38.963293],
						[97.712423, 38.960948],
						[97.725362, 38.961129],
						[97.735944, 38.958108],
						[97.749653, 38.949563],
						[97.759081, 38.948142],
						[97.771346, 38.9444],
						[97.781351, 38.945256],
						[97.793329, 38.942889],
						[97.807663, 38.937048],
						[97.821371, 38.933282],
						[97.828971, 38.930012],
						[97.851675, 38.916095],
						[97.866827, 38.904274],
						[97.875822, 38.89825],
						[97.899776, 38.888931],
						[97.908819, 38.884508],
						[97.930512, 38.880491],
						[97.94374, 38.876992],
						[97.949079, 38.873765],
						[97.955284, 38.873675],
						[97.961586, 38.867941],
						[97.971975, 38.863336],
						[97.983375, 38.861034],
						[97.991312, 38.861666],
						[98.006608, 38.85977],
						[98.011995, 38.858054],
						[98.024117, 38.84751],
						[98.026714, 38.844258],
						[98.027821, 38.835519],
						[98.031861, 38.83177],
						[98.041385, 38.828473],
						[98.050957, 38.81928],
						[98.062501, 38.819687],
						[98.068754, 38.816231],
						[98.073468, 38.80681],
						[98.077846, 38.800778],
						[98.088476, 38.789096],
						[98.095018, 38.786271],
						[98.098433, 38.788531],
						[98.10459, 38.796214],
						[98.115461, 38.798089],
						[98.118395, 38.807533],
						[98.131334, 38.812775],
						[98.134893, 38.815824],
						[98.148554, 38.818444],
						[98.152306, 38.820161],
						[98.16207, 38.834187],
						[98.167746, 38.840149],
						[98.177078, 38.846065],
						[98.191075, 38.849745],
						[98.196895, 38.855367],
						[98.203485, 38.856631],
						[98.213779, 38.866248],
						[98.222437, 38.870853],
						[98.225467, 38.874261],
						[98.232827, 38.876225],
						[98.242351, 38.880694],
						[98.248075, 38.885749],
						[98.251298, 38.891255],
						[98.251538, 38.907839],
						[98.248171, 38.912757],
						[98.236579, 38.915938],
						[98.236194, 38.920855],
						[98.242591, 38.930418],
						[98.24947, 38.938446],
						[98.264141, 38.948887],
						[98.270105, 38.954568],
						[98.277657, 38.965254],
						[98.281024, 38.972557],
						[98.283237, 38.981482],
						[98.287518, 38.992209],
						[98.286507, 39.001154],
						[98.284487, 39.005052],
						[98.281024, 39.027082],
						[98.287037, 39.035505],
						[98.292376, 39.037982],
						[98.30392, 39.039941],
						[98.316907, 39.040526],
						[98.335715, 39.037374],
						[98.343411, 39.037554],
						[98.358418, 39.034897],
						[98.364816, 39.032082],
						[98.38396, 39.029379],
						[98.391512, 39.023366],
						[98.397284, 39.016879],
						[98.398294, 39.00771],
						[98.401132, 39.001492],
						[98.407529, 38.99845],
						[98.414889, 38.998585],
						[98.425182, 39.000546],
						[98.430714, 38.997955],
						[98.432734, 38.993583],
						[98.428405, 38.983082],
						[98.428261, 38.975983],
						[98.433696, 38.967914],
						[98.437208, 38.966494],
						[98.447357, 38.959032],
						[98.457506, 38.952945],
						[98.468906, 38.951164],
						[98.47944, 38.951254],
						[98.496179, 38.953531],
						[98.526435, 38.95556],
						[98.532544, 38.952922],
						[98.550582, 38.949383],
						[98.562799, 38.942009],
						[98.5729, 38.932403],
						[98.582665, 38.929832],
						[98.590121, 38.933124],
						[98.595941, 38.946136],
						[98.597769, 38.947624],
						[98.614844, 38.947376],
						[98.619077, 38.952359],
						[98.622973, 38.953599],
						[98.624032, 38.959257],
						[98.61749, 38.97152],
						[98.612343, 38.977087],
						[98.614556, 38.980513],
						[98.626004, 38.984592],
						[98.640146, 38.987229],
						[98.649573, 38.992367],
						[98.663282, 38.994507],
						[98.673576, 39.008949],
						[98.677905, 39.010819],
						[98.691854, 39.020843],
						[98.697626, 39.033635],
						[98.70537, 39.043296],
						[98.718887, 39.048745],
						[98.72158, 39.054441],
						[98.730527, 39.057165],
						[98.733125, 39.059957],
						[98.742456, 39.07551],
						[98.743803, 39.086876],
						[98.759773, 39.090273],
						[98.768286, 39.085773],
						[98.7806, 39.089598],
						[98.791856, 39.087798],
						[98.805517, 39.087933],
						[98.808691, 39.085998],
						[98.813213, 39.087663],
						[98.816965, 39.08566],
						[98.815377, 39.082082],
						[98.823314, 39.070986],
						[98.81783, 39.066485],
						[98.82317, 39.062185],
						[98.836157, 39.058066],
						[98.842121, 39.05336],
						[98.849144, 39.055274],
						[98.855157, 39.05309],
						[98.857177, 39.047507],
						[98.86141, 39.047101],
						[98.870453, 39.049285],
						[98.8794, 39.043791],
						[98.884306, 39.042643],
						[98.887144, 39.039243],
						[98.8908, 39.02992],
						[98.898784, 39.023816],
						[98.902825, 39.012553],
						[98.912974, 39.008611],
						[98.920237, 39.002799],
						[98.928944, 39.00192],
						[98.930483, 38.998518],
						[98.936111, 38.99444],
						[98.943037, 38.993809],
						[98.949627, 38.988468],
						[98.968146, 38.984863],
						[98.984163, 38.984795],
						[98.993255, 38.977403],
						[99.00528, 38.978913],
						[99.013938, 38.984682],
						[99.019421, 38.982992],
						[99.02654, 38.983127],
						[99.0415, 38.980175],
						[99.054391, 38.976546],
						[99.063001, 38.968184],
						[99.065502, 38.962639],
						[99.07392, 38.9568],
						[99.083251, 38.953441],
						[99.096816, 38.954816],
						[99.10735, 38.951885],
						[99.108937, 38.946361],
						[99.096335, 38.936507],
						[99.078393, 38.92602],
						[99.067234, 38.917494],
						[99.062087, 38.911606],
						[99.061654, 38.906801],
						[99.068773, 38.897077],
						[99.097345, 38.878302],
						[99.110621, 38.867986],
						[99.133228, 38.857963],
						[99.141309, 38.852771],
						[99.154729, 38.8406],
						[99.161896, 38.834977],
						[99.169304, 38.827276],
						[99.183349, 38.816457],
						[99.202878, 38.802337],
						[99.21399, 38.792508],
						[99.222119, 38.788915],
						[99.244871, 38.785277],
						[99.257713, 38.781616],
						[99.280273, 38.77045],
						[99.290999, 38.765929],
						[99.309085, 38.751868],
						[99.331308, 38.737532],
						[99.344872, 38.729503],
						[99.362141, 38.718216],
						[99.368634, 38.708489],
						[99.370751, 38.701815],
						[99.371568, 38.690569],
						[99.37407, 38.686405],
						[99.381525, 38.680295],
						[99.399226, 38.674252],
						[99.412406, 38.665514],
						[99.421497, 38.655485],
						[99.426211, 38.64738],
						[99.432176, 38.62342],
						[99.434052, 38.619026],
						[99.440497, 38.610417],
						[99.450839, 38.604482],
						[99.466327, 38.605048],
						[99.471089, 38.607223],
						[99.485183, 38.611029],
						[99.496054, 38.612932],
						[99.506155, 38.610984],
						[99.509378, 38.608718],
						[99.510773, 38.601672],
						[99.514284, 38.597685],
						[99.511398, 38.594059],
						[99.511494, 38.58708],
						[99.514765, 38.580122],
						[99.514043, 38.568449],
						[99.520248, 38.558497],
						[99.522221, 38.553215],
						[99.527512, 38.547501],
						[99.548676, 38.534236],
						[99.555699, 38.520423],
						[99.567868, 38.514639],
						[99.574843, 38.50983],
						[99.585377, 38.498531],
						[99.593554, 38.497805],
						[99.605676, 38.487594],
						[99.626119, 38.478017],
						[99.636268, 38.475974],
						[99.645984, 38.468915],
						[99.650361, 38.460584],
						[99.659645, 38.449187],
						[99.671045, 38.440944],
						[99.687736, 38.433291],
						[99.71525, 38.425161],
						[99.727179, 38.41553],
						[99.734971, 38.412599],
						[99.758252, 38.410487],
						[99.77148, 38.405148],
						[99.78134, 38.395992],
						[99.80871, 38.379744],
						[99.830692, 38.368652],
						[99.856282, 38.360241],
						[99.874175, 38.356126],
						[99.904912, 38.344622],
						[99.924633, 38.340961],
						[99.937187, 38.341575],
						[99.945172, 38.33614],
						[99.95359, 38.326338],
						[99.959795, 38.320697],
						[99.966385, 38.317809],
						[99.974225, 38.316944],
						[99.986587, 38.318286],
						[99.998516, 38.316444],
						[100.012225, 38.307891],
						[100.020161, 38.301543],
						[100.03565, 38.294331],
						[100.039017, 38.290826],
						[100.05008, 38.283249],
						[100.062346, 38.28227],
						[100.071485, 38.284568],
						[100.083847, 38.281064],
						[100.099095, 38.270344],
						[100.094525, 38.267704],
						[100.096353, 38.26174],
						[100.103424, 38.256094],
						[100.116171, 38.254159],
						[100.119105, 38.249492],
						[100.1243, 38.234782],
						[100.127908, 38.23066],
						[100.137961, 38.229544],
						[100.151188, 38.224488],
						[100.160279, 38.21704],
						[100.166388, 38.215901],
						[100.174806, 38.217496],
						[100.182887, 38.222028],
						[100.181925, 38.230432],
						[100.184186, 38.235238],
						[100.18053, 38.245393],
						[100.176874, 38.247807],
						[100.175046, 38.254796],
						[100.172545, 38.256527],
						[100.166869, 38.268637],
						[100.165571, 38.277582],
						[100.166484, 38.28161],
						[100.160039, 38.292192],
						[100.163695, 38.298608],
						[100.157874, 38.310143],
						[100.15951, 38.313282],
						[100.16509, 38.315466],
						[100.16889, 38.320629],
						[100.16432, 38.327998],
						[100.159943, 38.328044],
						[100.152728, 38.330841],
						[100.142049, 38.33257],
						[100.135652, 38.335185],
						[100.12507, 38.344372],
						[100.118672, 38.345031],
						[100.1243, 38.348237],
						[100.114632, 38.352307],
						[100.121414, 38.356149],
						[100.117806, 38.364469],
						[100.111842, 38.370698],
						[100.111168, 38.378039],
						[100.105252, 38.384948],
						[100.098374, 38.390334],
						[100.094574, 38.396514],
						[100.094958, 38.400968],
						[100.092457, 38.407806],
						[100.081827, 38.405898],
						[100.077113, 38.414303],
						[100.071918, 38.414417],
						[100.068647, 38.418528],
						[100.062683, 38.420618],
						[100.057584, 38.416529],
						[100.053928, 38.420096],
						[100.04883, 38.421072],
						[100.046328, 38.43102],
						[100.041759, 38.431179],
						[100.03969, 38.42775],
						[100.034832, 38.431656],
						[100.022326, 38.432224],
						[100.023721, 38.438946],
						[100.030744, 38.444441],
						[100.026799, 38.44594],
						[100.026559, 38.451049],
						[100.018093, 38.448892],
						[100.017275, 38.45459],
						[100.011022, 38.457315],
						[100.008136, 38.461719],
						[100.00121, 38.466985],
						[100.015784, 38.490181],
						[100.021075, 38.493789],
						[100.024106, 38.498554],
						[100.025837, 38.507969],
						[100.030984, 38.51051],
						[100.04022, 38.508786],
						[100.04907, 38.511259],
						[100.058498, 38.519493],
						[100.064029, 38.518563],
						[100.072399, 38.505315],
						[100.078893, 38.502093],
						[100.086829, 38.493153],
						[100.0901, 38.492246],
						[100.104579, 38.493494],
						[100.112275, 38.497215],
						[100.114728, 38.496262],
						[100.126176, 38.485234],
						[100.133054, 38.482556],
						[100.147677, 38.4804],
						[100.151333, 38.478357],
						[100.156191, 38.469233],
						[100.165859, 38.460062],
						[100.179712, 38.458177],
						[100.19015, 38.457905],
						[100.205158, 38.456248],
						[100.216606, 38.453047],
						[100.221079, 38.447484],
						[100.231084, 38.447121],
						[100.241185, 38.439809],
						[100.242821, 38.428477],
						[100.248545, 38.417983],
						[100.245226, 38.409555],
						[100.248833, 38.402717],
						[100.250709, 38.391742],
						[100.253018, 38.384743],
						[100.252585, 38.380357],
						[100.248593, 38.375266],
						[100.251431, 38.37138],
						[100.259656, 38.366356],
						[100.264803, 38.369084],
						[100.27298, 38.378653],
						[100.280003, 38.377698],
						[100.286544, 38.37863],
						[100.297127, 38.388561],
						[100.302129, 38.387516],
						[100.304438, 38.379244],
						[100.315982, 38.368356],
						[100.321802, 38.358968],
						[100.324881, 38.351034],
						[100.331423, 38.341757],
						[100.331326, 38.337459],
						[100.326228, 38.336845],
						[100.32339, 38.331091],
						[100.318243, 38.328362],
						[100.32339, 38.324632],
						[100.341909, 38.316398],
						[100.34999, 38.310916],
						[100.354896, 38.312167],
						[100.359802, 38.307913],
						[100.373703, 38.309051],
						[100.381496, 38.306184],
						[100.383324, 38.299541],
						[100.396696, 38.293216],
						[100.402275, 38.297425],
						[100.412569, 38.302066],
						[100.417187, 38.306457],
						[100.424161, 38.30714],
						[100.427047, 38.300974],
						[100.434022, 38.301543],
						[100.436716, 38.299427],
						[100.434407, 38.287003],
						[100.435754, 38.280973],
						[100.432435, 38.275033],
						[100.437197, 38.268045],
						[100.446336, 38.268796],
						[100.45105, 38.266088],
						[100.461151, 38.265905],
						[100.468991, 38.272848],
						[100.468414, 38.280927],
						[100.475581, 38.288847],
						[100.483229, 38.286184],
						[100.486644, 38.280745],
						[100.494918, 38.279266],
						[100.496601, 38.273644],
						[100.510935, 38.271573],
						[100.516996, 38.280563],
						[100.520555, 38.289006],
						[100.520411, 38.292237],
						[100.52729, 38.298585],
						[100.531955, 38.305297],
						[100.542971, 38.317104],
						[100.545472, 38.320925],
						[100.563077, 38.342825],
						[100.569715, 38.347646],
						[100.58756, 38.355126],
						[100.591264, 38.359377],
						[100.595449, 38.367493],
						[100.612428, 38.386925],
						[100.614545, 38.393742],
						[100.615362, 38.405625],
						[100.612043, 38.420845],
						[100.601654, 38.429862],
						[100.584866, 38.438673],
						[100.580345, 38.435971],
						[100.572986, 38.437288],
						[100.570917, 38.440626],
						[100.57111, 38.446326],
						[100.568464, 38.450753],
						[100.557834, 38.461061],
						[100.553601, 38.46635],
						[100.544317, 38.467553],
						[100.536766, 38.467054],
						[100.529406, 38.463422],
						[100.520892, 38.461742],
						[100.51488, 38.462355],
						[100.507087, 38.465964],
						[100.500738, 38.465238],
						[100.491166, 38.468484],
						[100.485634, 38.48857],
						[100.477072, 38.493811],
						[100.471925, 38.493766],
						[100.468414, 38.490544],
						[100.46192, 38.492041],
						[100.450184, 38.499711],
						[100.44648, 38.504861],
						[100.444941, 38.517361],
						[100.449029, 38.520718],
						[100.452926, 38.528044],
						[100.446721, 38.526797],
						[100.439602, 38.518677],
						[100.431136, 38.51575],
						[100.422959, 38.510215],
						[100.409058, 38.509036],
						[100.397609, 38.512506],
						[100.388374, 38.520355],
						[100.387364, 38.52564],
						[100.388951, 38.541152],
						[100.386354, 38.545642],
						[100.383901, 38.557387],
						[100.373848, 38.560175],
						[100.371154, 38.565752],
						[100.366729, 38.568744],
						[100.360235, 38.579941],
						[100.364612, 38.590637],
						[100.362496, 38.592178],
						[100.347633, 38.593787],
						[100.339936, 38.597707],
						[100.324256, 38.60344],
						[100.317137, 38.609307],
						[100.316175, 38.615061],
						[100.31324, 38.617644],
						[100.313096, 38.623782],
						[100.303861, 38.627723],
						[100.297608, 38.635401],
						[100.299051, 38.642602],
						[100.295443, 38.647629],
						[100.299724, 38.657342],
						[100.292365, 38.659787],
						[100.28818, 38.668955],
						[100.275962, 38.671785],
						[100.269372, 38.675383],
						[100.250565, 38.67475],
						[100.245707, 38.677624],
						[100.237385, 38.688374],
						[100.232287, 38.698828],
						[100.22435, 38.705005],
						[100.212228, 38.708308],
						[100.192699, 38.710683],
						[100.185773, 38.712946],
						[100.1813, 38.717199],
						[100.180001, 38.721587],
						[100.181781, 38.728417],
						[100.183416, 38.746464],
						[100.189092, 38.757475],
						[100.185532, 38.766359],
						[100.180963, 38.771287],
						[100.176297, 38.780576],
						[100.163502, 38.783695],
						[100.16076, 38.79583],
						[100.15773, 38.802292],
						[100.151525, 38.806697],
						[100.159029, 38.810041],
						[100.162011, 38.816683],
						[100.15773, 38.821787],
						[100.151814, 38.834368],
						[100.146523, 38.8392],
						[100.140991, 38.849745],
						[100.128725, 38.861621],
						[100.122232, 38.865481],
						[100.12988, 38.879859],
						[100.128677, 38.887193],
						[100.13772, 38.91217],
						[100.141664, 38.926088],
						[100.141039, 38.93026],
						[100.132189, 38.936056],
						[100.121943, 38.937296],
						[100.117373, 38.939123],
						[100.112515, 38.946091],
						[100.113622, 38.959956],
						[100.109389, 38.973368],
						[100.103857, 38.980333],
						[100.105108, 38.98617],
						[100.101741, 38.988716],
						[100.090581, 38.982947],
						[100.086589, 38.979386],
						[100.082981, 38.96877],
						[100.076247, 38.963157],
						[100.050369, 38.956778],
						[100.039498, 38.960768],
						[100.025308, 38.952156],
						[100.018863, 38.956124],
						[100.000681, 38.962729],
						[99.99741, 38.962391],
						[99.98904, 38.95565],
						[99.986876, 38.955402],
						[99.978554, 38.962256],
						[99.978458, 38.963901],
						[99.993321, 38.976839],
						[99.99741, 38.982474],
						[100.006164, 38.98777],
						[100.015015, 38.995161],
						[100.020065, 39.002618],
						[100.025308, 39.015324],
						[100.027136, 39.024447],
						[100.042095, 39.037441],
						[100.041133, 39.043656],
						[100.034399, 39.051784],
						[100.028435, 39.061825],
						[100.022951, 39.064189],
						[99.99005, 39.062185],
						[99.987501, 39.069231],
						[99.979757, 39.07353],
						[99.981969, 39.085773],
						[99.980671, 39.092119],
						[99.975716, 39.098036],
						[99.967683, 39.101366],
						[99.963787, 39.105641],
						[99.963018, 39.114526],
						[99.953349, 39.114212],
						[99.951473, 39.119835],
						[99.945701, 39.121567],
						[99.937861, 39.120667],
						[99.932137, 39.12548],
						[99.924825, 39.127797],
						[99.918813, 39.131845],
						[99.916215, 39.135825],
						[99.914917, 39.145247],
						[99.90722, 39.145157],
						[99.901689, 39.155252],
						[99.888461, 39.159411],
						[99.884084, 39.16566],
						[99.877831, 39.167503],
						[99.860322, 39.169953],
						[99.850413, 39.175235],
						[99.839013, 39.176988],
						[99.834107, 39.182089],
						[99.825497, 39.18782],
						[99.811836, 39.192157],
						[99.796203, 39.195212],
						[99.783745, 39.195617],
						[99.775472, 39.201593],
						[99.773067, 39.20521],
						[99.75628, 39.216711],
						[99.748151, 39.220395],
						[99.742763, 39.225651],
						[99.729006, 39.233376],
						[99.719819, 39.236947],
						[99.7127, 39.241999],
						[99.699617, 39.244042],
						[99.68283, 39.241078],
						[99.680521, 39.238451],
						[99.66003, 39.241146],
						[99.651564, 39.239506],
						[99.645022, 39.240786],
						[99.633959, 39.245142],
						[99.629678, 39.249924],
						[99.619817, 39.24943],
						[99.601683, 39.251743],
						[99.598316, 39.253651],
						[99.581, 39.256884],
						[99.570658, 39.256749],
						[99.556901, 39.254123],
						[99.548868, 39.251676],
						[99.546896, 39.247073],
						[99.545549, 39.194673],
						[99.544491, 39.178202],
						[99.544828, 39.163052],
						[99.537084, 39.16865],
						[99.530927, 39.168267],
						[99.527223, 39.163345],
						[99.520345, 39.150373],
						[99.522846, 39.141874],
						[99.511542, 39.138254],
						[99.504952, 39.134274],
						[99.498459, 39.123659],
						[99.488983, 39.112659],
						[99.484173, 39.10888],
						[99.478593, 39.100826],
						[99.475274, 39.100376],
						[99.468732, 39.103436],
						[99.461661, 39.110725],
						[99.456467, 39.11203],
						[99.439631, 39.113042],
						[99.430877, 39.112862],
						[99.42573, 39.109105],
						[99.42496, 39.099139],
						[99.428712, 39.091691],
						[99.428953, 39.087596],
						[99.42496, 39.08575],
						[99.399852, 39.077446],
						[99.364546, 39.071864],
						[99.342612, 39.072675],
						[99.3353, 39.071752],
						[99.330105, 39.07344],
						[99.330683, 39.081812],
						[99.328229, 39.086628],
						[99.314809, 39.091669],
						[99.306825, 39.097091],
						[99.289412, 39.105258],
						[99.277002, 39.113109],
						[99.267237, 39.141784],
						[99.264303, 39.146978],
						[99.253288, 39.153498],
						[99.236934, 39.159636],
						[99.217164, 39.161187],
						[99.211921, 39.160692],
						[99.206678, 39.157298],
						[99.194509, 39.1546],
						[99.185081, 39.155836],
						[99.185466, 39.160153],
						[99.175365, 39.168312]
					]
				],
				[
					[
						[101.114698, 37.919569],
						[101.118113, 37.916069],
						[101.126531, 37.916115],
						[101.130764, 37.913668],
						[101.139326, 37.901979],
						[101.148994, 37.897037],
						[101.152217, 37.891158],
						[101.150774, 37.877772],
						[101.15746, 37.874064],
						[101.160971, 37.867588],
						[101.168187, 37.869625],
						[101.171024, 37.867405],
						[101.171602, 37.862026],
						[101.183194, 37.860035],
						[101.185888, 37.856944],
						[101.192381, 37.85493],
						[101.202771, 37.847536],
						[101.217875, 37.846185],
						[101.226725, 37.843255],
						[101.239232, 37.843117],
						[101.25852, 37.832814],
						[101.263234, 37.833043],
						[101.279155, 37.836684],
						[101.281945, 37.834966],
						[101.283821, 37.828898],
						[101.294019, 37.825601],
						[101.301859, 37.825143],
						[101.304456, 37.818799],
						[101.309459, 37.815707],
						[101.313163, 37.810119],
						[101.319993, 37.811241],
						[101.329661, 37.805813],
						[101.338031, 37.804163],
						[101.346641, 37.800063],
						[101.354097, 37.792228],
						[101.36237, 37.791197],
						[101.367469, 37.796581],
						[101.376993, 37.802193],
						[101.375261, 37.806866],
						[101.38262, 37.822189],
						[101.389932, 37.827593],
						[101.399119, 37.829517],
						[101.402967, 37.831715],
						[101.404939, 37.840164],
						[101.409894, 37.843736],
						[101.420187, 37.846849],
						[101.437119, 37.860172],
						[101.437407, 37.864658],
						[101.44318, 37.868114],
						[101.45025, 37.866398],
						[101.454772, 37.867611],
						[101.459197, 37.866146],
						[101.459486, 37.862941],
						[101.463911, 37.857219],
						[101.470212, 37.855273],
						[101.47507, 37.855869],
						[101.482911, 37.853511],
						[101.48825, 37.856464],
						[101.497101, 37.855388],
						[101.50042, 37.857975],
						[101.509222, 37.855273],
						[101.522594, 37.84923],
						[101.525817, 37.846849],
						[101.542652, 37.838973],
						[101.551599, 37.835837],
						[101.558766, 37.837485],
						[101.574639, 37.835333],
						[101.585895, 37.830456],
						[101.598353, 37.827433],
						[101.602682, 37.818318],
						[101.618988, 37.809867],
						[101.619518, 37.805515],
						[101.630918, 37.7876],
						[101.64073, 37.775845],
						[101.650447, 37.77321],
						[101.657662, 37.768902],
						[101.661029, 37.76457],
						[101.669206, 37.759138],
						[101.67036, 37.754279],
						[101.658816, 37.741074],
						[101.659201, 37.733325],
						[101.668003, 37.728991],
						[101.678634, 37.727868],
						[101.702059, 37.720071],
						[101.750112, 37.706654],
						[101.789073, 37.697135],
						[101.791767, 37.696033],
						[101.798694, 37.68782],
						[101.813653, 37.681626],
						[101.810623, 37.673663],
						[101.811296, 37.663589],
						[101.813509, 37.655648],
						[101.816106, 37.654362],
						[101.829093, 37.655969],
						[101.841888, 37.659871],
						[101.846458, 37.662625],
						[101.856319, 37.664369],
						[101.860503, 37.659435],
						[101.861994, 37.665425],
						[101.869354, 37.672654],
						[101.872336, 37.685733],
						[101.877291, 37.686788],
						[101.897252, 37.70264],
						[101.900716, 37.701677],
						[101.908845, 37.703649],
						[101.922602, 37.712709],
						[101.92491, 37.716654],
						[101.931164, 37.721791],
						[101.946363, 37.728097],
						[101.957619, 37.728854],
						[101.968394, 37.725666],
						[101.981333, 37.727638],
						[101.999082, 37.72507],
						[101.99913, 37.71991],
						[102.00471, 37.714108],
						[102.009809, 37.714062],
						[102.016254, 37.707113],
						[102.015869, 37.697892],
						[102.018996, 37.694611],
						[102.033426, 37.688486],
						[102.036168, 37.685044],
						[102.036457, 37.679767],
						[102.034003, 37.672608],
						[102.034292, 37.66749],
						[102.03814, 37.65971],
						[102.047327, 37.654316],
						[102.048674, 37.650414],
						[102.046173, 37.64238],
						[102.038765, 37.633862],
						[102.035254, 37.627686],
						[102.038621, 37.628283],
						[102.040593, 37.632737],
						[102.050358, 37.640406],
						[102.054975, 37.652595],
						[102.048337, 37.661523],
						[102.048289, 37.664851],
						[102.053484, 37.674857],
						[102.052907, 37.682452],
						[102.061084, 37.685343],
						[102.062142, 37.689816],
						[102.066087, 37.691606],
						[102.074985, 37.688968],
						[102.078689, 37.692776],
						[102.077583, 37.697708],
						[102.079218, 37.702112],
						[102.077294, 37.706975],
						[102.079266, 37.709865],
						[102.087684, 37.711494],
						[102.084846, 37.717961],
						[102.095861, 37.728808],
						[102.099757, 37.735962],
						[102.107838, 37.74731],
						[102.110676, 37.753476],
						[102.116352, 37.760284],
						[102.122221, 37.770781],
						[102.12881, 37.775158],
						[102.141172, 37.777747],
						[102.149927, 37.785194],
						[102.15137, 37.788035],
						[102.15238, 37.800773],
						[102.155506, 37.812478],
						[102.159691, 37.819647],
						[102.168782, 37.826883],
						[102.184126, 37.834966],
						[102.187638, 37.837714],
						[102.197691, 37.841103],
						[102.205098, 37.850535],
						[102.202405, 37.854518],
						[102.182635, 37.849825],
						[102.168446, 37.844354],
						[102.162914, 37.844926],
						[102.151562, 37.851359],
						[102.147522, 37.857082],
						[102.143914, 37.866993],
						[102.137084, 37.874385],
						[102.127512, 37.88022],
						[102.122076, 37.88816],
						[102.126694, 37.894201],
						[102.129243, 37.903351],
						[102.127319, 37.91058],
						[102.123134, 37.914697],
						[102.117026, 37.917762],
						[102.100864, 37.920163],
						[102.095188, 37.918883],
						[102.087492, 37.920461],
						[102.07917, 37.927962],
						[102.074985, 37.929082],
						[102.036168, 37.933404],
						[102.030396, 37.935988],
						[102.03155, 37.941613],
						[102.039102, 37.944425],
						[102.054446, 37.948197],
						[102.071041, 37.950461],
						[102.090811, 37.955879],
						[102.095765, 37.958507],
						[102.106491, 37.966805],
						[102.122702, 37.973113],
						[102.137613, 37.982802],
						[102.14579, 37.985156],
						[102.152909, 37.989063],
						[102.166521, 37.994501],
						[102.170658, 37.999596],
						[102.169263, 38.004805],
						[102.156276, 38.006998],
						[102.132129, 38.00549],
						[102.119767, 38.009716],
						[102.110099, 38.011886],
						[102.107502, 38.020086],
						[102.10981, 38.025248],
						[102.102692, 38.027782],
						[102.094466, 38.034519],
						[102.09158, 38.029655],
						[102.085519, 38.025065],
						[102.079988, 38.026732],
						[102.084654, 38.028239],
						[102.075996, 38.031596],
						[102.070271, 38.029061],
						[102.065846, 38.030295],
						[102.055505, 38.027691],
						[102.040449, 38.029655],
						[102.03232, 38.038218],
						[102.026163, 38.043127],
						[102.026259, 38.057396],
						[102.017505, 38.06712],
						[102.015533, 38.074104],
						[102.017312, 38.076957],
						[102.015773, 38.081978],
						[102.010145, 38.083187],
						[102.003604, 38.094825],
						[101.998264, 38.093319],
						[101.986624, 38.096034],
						[101.981237, 38.093843],
						[101.975224, 38.085561],
						[101.967576, 38.084944],
						[101.964642, 38.081613],
						[101.945353, 38.080289],
						[101.936166, 38.084351],
						[101.91707, 38.089965],
						[101.912452, 38.095783],
						[101.90365, 38.097699],
						[101.897493, 38.097517],
						[101.885804, 38.102992],
						[101.876858, 38.099502],
						[101.869017, 38.09957],
						[101.861706, 38.097996],
						[101.855357, 38.099502],
						[101.845352, 38.093935],
						[101.840878, 38.088755],
						[101.83501, 38.075268],
						[101.830055, 38.074264],
						[101.821445, 38.067371],
						[101.812306, 38.064952],
						[101.799704, 38.066299],
						[101.796529, 38.069563],
						[101.781522, 38.072872],
						[101.779549, 38.07714],
						[101.766658, 38.079399],
						[101.75877, 38.08839],
						[101.742848, 38.089599],
						[101.740155, 38.096057],
						[101.733276, 38.09487],
						[101.73116, 38.09074],
						[101.726686, 38.091995],
						[101.719952, 38.089805],
						[101.71014, 38.092474],
						[101.706388, 38.09179],
						[101.694074, 38.077528],
						[101.690611, 38.066664],
						[101.670889, 38.081248],
						[101.664107, 38.085629],
						[101.651312, 38.09001],
						[101.646695, 38.087546],
						[101.641163, 38.077208],
						[101.636786, 38.071457],
						[101.623702, 38.064176],
						[101.612591, 38.05977],
						[101.592196, 38.057237],
						[101.567472, 38.057008],
						[101.549723, 38.058903],
						[101.544432, 38.060501],
						[101.537073, 38.0592],
						[101.530819, 38.06082],
						[101.516052, 38.061437],
						[101.500853, 38.053561],
						[101.498207, 38.053219],
						[101.489741, 38.056985],
						[101.481276, 38.05573],
						[101.469683, 38.051141],
						[101.459726, 38.044201],
						[101.447028, 38.039885],
						[101.441207, 38.040114],
						[101.432068, 38.046895],
						[101.419081, 38.058834],
						[101.412635, 38.062281],
						[101.396618, 38.066983],
						[101.385458, 38.065774],
						[101.382188, 38.059474],
						[101.365881, 38.053881],
						[101.359243, 38.049749],
						[101.350008, 38.041346],
						[101.344284, 38.037876],
						[101.32918, 38.033811],
						[101.321965, 38.035204],
						[101.293249, 38.036643],
						[101.277809, 38.036711],
						[101.257943, 38.035113],
						[101.241781, 38.032236],
						[101.231199, 38.024836],
						[101.219895, 38.009419],
						[101.210371, 38.004965],
						[101.190505, 37.997426],
						[101.175931, 37.990411],
						[101.162751, 37.982642],
						[101.153131, 37.971307],
						[101.15087, 37.961753],
						[101.139037, 37.941796],
						[101.13466, 37.930271],
						[101.129706, 37.924257],
						[101.114698, 37.919569]
					]
				],
				[
					[
						[100.716134, 38.253134],
						[100.737731, 38.266793],
						[100.744994, 38.270685],
						[100.751392, 38.270481],
						[100.763706, 38.259736],
						[100.774913, 38.257756],
						[100.782417, 38.265837],
						[100.791171, 38.270367],
						[100.79223, 38.277172],
						[100.806131, 38.281997],
						[100.819695, 38.288483],
						[100.825852, 38.294308],
						[100.824553, 38.29656],
						[100.828786, 38.300428],
						[100.829364, 38.310848],
						[100.831143, 38.31401],
						[100.832586, 38.331887],
						[100.820513, 38.370448],
						[100.816857, 38.367947],
						[100.809305, 38.3589],
						[100.801369, 38.354558],
						[100.795741, 38.353944],
						[100.780204, 38.368879],
						[100.771883, 38.37188],
						[100.762888, 38.364106],
						[100.758463, 38.367334],
						[100.751488, 38.365288],
						[100.743263, 38.360218],
						[100.739559, 38.365742],
						[100.739992, 38.37613],
						[100.738164, 38.38438],
						[100.732248, 38.399582],
						[100.72763, 38.394969],
						[100.724022, 38.394287],
						[100.71926, 38.399968],
						[100.706514, 38.396401],
						[100.69901, 38.392492],
						[100.689871, 38.384971],
						[100.681213, 38.369857],
						[100.673613, 38.346236],
						[100.670342, 38.320902],
						[100.666782, 38.313214],
						[100.650765, 38.303136],
						[100.640904, 38.292874],
						[100.632198, 38.275488],
						[100.632053, 38.271254],
						[100.624742, 38.266566],
						[100.632823, 38.265405],
						[100.639942, 38.260988],
						[100.647782, 38.260897],
						[100.659567, 38.258484],
						[100.66356, 38.256527],
						[100.674286, 38.256026],
						[100.686456, 38.249446],
						[100.701319, 38.248763],
						[100.708197, 38.249423],
						[100.711805, 38.252656],
						[100.716134, 38.253134]
					]
				],
				[
					[
						[98.959199, 39.779793],
						[98.958093, 39.771169],
						[98.956024, 39.74001],
						[98.953042, 39.727034],
						[98.949483, 39.701499],
						[98.94929, 39.673634],
						[98.949819, 39.665734],
						[98.946597, 39.664484],
						[98.931252, 39.666068],
						[98.917784, 39.664997],
						[98.905374, 39.667318],
						[98.881516, 39.665421],
						[98.867519, 39.668122],
						[98.856215, 39.669037],
						[98.837311, 39.673232],
						[98.83, 39.676334],
						[98.824661, 39.676423],
						[98.820428, 39.673053],
						[98.817157, 39.661203],
						[98.807874, 39.643725],
						[98.804266, 39.6289],
						[98.810711, 39.600871],
						[98.815954, 39.59799],
						[98.816147, 39.592092],
						[98.851934, 39.59198],
						[98.865066, 39.590975],
						[98.872136, 39.594036],
						[98.882189, 39.592427],
						[98.900227, 39.586842],
						[98.938131, 39.577882],
						[98.942556, 39.589746],
						[98.946693, 39.594952],
						[98.977814, 39.619588],
						[98.984885, 39.621911],
						[99.001143, 39.622826],
						[99.008166, 39.626399],
						[99.025145, 39.629659],
						[99.036257, 39.628856],
						[99.053621, 39.623161],
						[99.06377, 39.616797],
						[99.064684, 39.609985],
						[99.057662, 39.596515],
						[99.056507, 39.587668],
						[99.067763, 39.565903],
						[99.072862, 39.554862],
						[99.080413, 39.547261],
						[99.089216, 39.540577],
						[99.097489, 39.530716],
						[99.101385, 39.519714],
						[99.106147, 39.5141],
						[99.117259, 39.50786],
						[99.135297, 39.503677],
						[99.141454, 39.499874],
						[99.173874, 39.481975],
						[99.183398, 39.47544],
						[99.214038, 39.465011],
						[99.235924, 39.458431],
						[99.242562, 39.448245],
						[99.264159, 39.438058],
						[99.326354, 39.398482],
						[99.389991, 39.368119],
						[99.42015, 39.362874],
						[99.457477, 39.37361],
						[99.480758, 39.387974],
						[99.499709, 39.394091],
						[99.54502, 39.400924],
						[99.557863, 39.4203],
						[99.553438, 39.490298],
						[99.517122, 39.621129],
						[99.495284, 39.649507],
						[99.431069, 39.652409],
						[99.38013, 39.661538],
						[99.369211, 39.635844],
						[99.32467, 39.631267],
						[99.317118, 39.633165],
						[99.218848, 39.662855],
						[99.156317, 39.711068],
						[99.083396, 39.71138],
						[99.008887, 39.750109],
						[99.001143, 39.754566],
						[98.998498, 39.758534],
						[98.992292, 39.762768],
						[98.959199, 39.779793]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620722,
			"name": "民乐县",
			"center": [100.816623, 38.434454],
			"centroid": [100.769097, 38.476352],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 2,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[101.031291, 37.976015],
						[101.028309, 37.978917],
						[101.026193, 37.993861],
						[101.027251, 38.013074],
						[101.029271, 38.018738],
						[101.031628, 38.035615],
						[101.035236, 38.047648],
						[101.034899, 38.058218],
						[101.032109, 38.071571],
						[101.028742, 38.079696],
						[101.021815, 38.086314],
						[101.010848, 38.09398],
						[100.974388, 38.116611],
						[100.963565, 38.127262],
						[100.958996, 38.134263],
						[100.956013, 38.149928],
						[100.957216, 38.161805],
						[100.957697, 38.176461],
						[100.962122, 38.188471],
						[100.973426, 38.197995],
						[100.979006, 38.198724],
						[100.992426, 38.2036],
						[101.005221, 38.213077],
						[101.007096, 38.221026],
						[101.007577, 38.245758],
						[101.009357, 38.263356],
						[101.008058, 38.277377],
						[101.011041, 38.288733],
						[101.014167, 38.296219],
						[101.008443, 38.306958],
						[100.997957, 38.318173],
						[100.997669, 38.313055],
						[100.994686, 38.307481],
						[100.991416, 38.311712],
						[100.994927, 38.314692],
						[100.988193, 38.314897],
						[100.987567, 38.30946],
						[100.983431, 38.310575],
						[100.986269, 38.319651],
						[100.995504, 38.332683],
						[100.999689, 38.337141],
						[101.001565, 38.345827],
						[100.997621, 38.350488],
						[100.983479, 38.356467],
						[100.966836, 38.372948],
						[100.966692, 38.37638],
						[100.958755, 38.385243],
						[100.96039, 38.38638],
						[100.97179, 38.382607],
						[100.96674, 38.392447],
						[100.971502, 38.397309],
						[100.979198, 38.401717],
						[100.981459, 38.404875],
						[100.984345, 38.425047],
						[100.986317, 38.424934],
						[100.990646, 38.415053],
						[100.99536, 38.410941],
						[101.001517, 38.412236],
						[101.004547, 38.418778],
						[101.003296, 38.428636],
						[101.005653, 38.44015],
						[101.003056, 38.452456],
						[101.002527, 38.466985],
						[100.997332, 38.476746],
						[100.998871, 38.49397],
						[100.996274, 38.50595],
						[100.994927, 38.524778],
						[100.98954, 38.539383],
						[100.971838, 38.560311],
						[100.968087, 38.56684],
						[100.96674, 38.585901],
						[100.965104, 38.593289],
						[100.959958, 38.607178],
						[100.959717, 38.613838],
						[100.961593, 38.621812],
						[100.958082, 38.626953],
						[100.954378, 38.645863],
						[100.953849, 38.652972],
						[100.950434, 38.665922],
						[100.948317, 38.681336],
						[100.948125, 38.688917],
						[100.949856, 38.694371],
						[100.95356, 38.697674],
						[100.959188, 38.698625],
						[100.967846, 38.706838],
						[100.966499, 38.711928],
						[100.949616, 38.720501],
						[100.941294, 38.730091],
						[100.931241, 38.746961],
						[100.923738, 38.753269],
						[100.915801, 38.75501],
						[100.907383, 38.754468],
						[100.882563, 38.754694],
						[100.858753, 38.758695],
						[100.849662, 38.758311],
						[100.841822, 38.759939],
						[100.833596, 38.765477],
						[100.827969, 38.775536],
						[100.808584, 38.785797],
						[100.796655, 38.787785],
						[100.785207, 38.786113],
						[100.734797, 38.792734],
						[100.714498, 38.796982],
						[100.68939, 38.805274],
						[100.691987, 38.797027],
						[100.647734, 38.770925],
						[100.644031, 38.766404],
						[100.63441, 38.763714],
						[100.631909, 38.757068],
						[100.611947, 38.73812],
						[100.608051, 38.73631],
						[100.598623, 38.736446],
						[100.590542, 38.740607],
						[100.582702, 38.739974],
						[100.57313, 38.736152],
						[100.530368, 38.734072],
						[100.527626, 38.732127],
						[100.524548, 38.706046],
						[100.514783, 38.694982],
						[100.505211, 38.689076],
						[100.50449, 38.683418],
						[100.507376, 38.673641],
						[100.513196, 38.668638],
						[100.509733, 38.656844],
						[100.512234, 38.655961],
						[100.516371, 38.663386],
						[100.519305, 38.66067],
						[100.515361, 38.640541],
						[100.512426, 38.632751],
						[100.49232, 38.615786],
						[100.486452, 38.612638],
						[100.471204, 38.601831],
						[100.46447, 38.594807],
						[100.461391, 38.587941],
						[100.452926, 38.581867],
						[100.446769, 38.579737],
						[100.425123, 38.568495],
						[100.407759, 38.556593],
						[100.398427, 38.552444],
						[100.386354, 38.545642],
						[100.388951, 38.541152],
						[100.387364, 38.52564],
						[100.388374, 38.520355],
						[100.397609, 38.512506],
						[100.409058, 38.509036],
						[100.422959, 38.510215],
						[100.431136, 38.51575],
						[100.439602, 38.518677],
						[100.446721, 38.526797],
						[100.452926, 38.528044],
						[100.449029, 38.520718],
						[100.444941, 38.517361],
						[100.44648, 38.504861],
						[100.450184, 38.499711],
						[100.46192, 38.492041],
						[100.468414, 38.490544],
						[100.471925, 38.493766],
						[100.477072, 38.493811],
						[100.485634, 38.48857],
						[100.491166, 38.468484],
						[100.500738, 38.465238],
						[100.507087, 38.465964],
						[100.51488, 38.462355],
						[100.520892, 38.461742],
						[100.529406, 38.463422],
						[100.536766, 38.467054],
						[100.544317, 38.467553],
						[100.553601, 38.46635],
						[100.557834, 38.461061],
						[100.568464, 38.450753],
						[100.57111, 38.446326],
						[100.570917, 38.440626],
						[100.572986, 38.437288],
						[100.580345, 38.435971],
						[100.584866, 38.438673],
						[100.601654, 38.429862],
						[100.612043, 38.420845],
						[100.615362, 38.405625],
						[100.614545, 38.393742],
						[100.612428, 38.386925],
						[100.595449, 38.367493],
						[100.591264, 38.359377],
						[100.58756, 38.355126],
						[100.569715, 38.347646],
						[100.563077, 38.342825],
						[100.545472, 38.320925],
						[100.542971, 38.317104],
						[100.531955, 38.305297],
						[100.52729, 38.298585],
						[100.520411, 38.292237],
						[100.520555, 38.289006],
						[100.516996, 38.280563],
						[100.510935, 38.271573],
						[100.520604, 38.27105],
						[100.525269, 38.264767],
						[100.530079, 38.263265],
						[100.535371, 38.256959],
						[100.540036, 38.254182],
						[100.546578, 38.246896],
						[100.551821, 38.249651],
						[100.563846, 38.247716],
						[100.567598, 38.250676],
						[100.574477, 38.251427],
						[100.580682, 38.247716],
						[100.595112, 38.242274],
						[100.600836, 38.248034],
						[100.601557, 38.254],
						[100.619018, 38.265723],
						[100.624742, 38.266566],
						[100.632053, 38.271254],
						[100.632198, 38.275488],
						[100.640904, 38.292874],
						[100.650765, 38.303136],
						[100.666782, 38.313214],
						[100.670342, 38.320902],
						[100.673613, 38.346236],
						[100.681213, 38.369857],
						[100.689871, 38.384971],
						[100.69901, 38.392492],
						[100.706514, 38.396401],
						[100.71926, 38.399968],
						[100.724022, 38.394287],
						[100.72763, 38.394969],
						[100.732248, 38.399582],
						[100.738164, 38.38438],
						[100.739992, 38.37613],
						[100.739559, 38.365742],
						[100.743263, 38.360218],
						[100.751488, 38.365288],
						[100.758463, 38.367334],
						[100.762888, 38.364106],
						[100.771883, 38.37188],
						[100.780204, 38.368879],
						[100.795741, 38.353944],
						[100.801369, 38.354558],
						[100.809305, 38.3589],
						[100.816857, 38.367947],
						[100.820513, 38.370448],
						[100.832586, 38.331887],
						[100.831143, 38.31401],
						[100.829364, 38.310848],
						[100.828786, 38.300428],
						[100.824553, 38.29656],
						[100.825852, 38.294308],
						[100.819695, 38.288483],
						[100.806131, 38.281997],
						[100.79223, 38.277172],
						[100.791171, 38.270367],
						[100.782417, 38.265837],
						[100.774913, 38.257756],
						[100.763706, 38.259736],
						[100.751392, 38.270481],
						[100.744994, 38.270685],
						[100.737731, 38.266793],
						[100.716134, 38.253134],
						[100.73523, 38.244232],
						[100.741579, 38.238585],
						[100.751825, 38.23879],
						[100.766255, 38.225194],
						[100.774384, 38.220821],
						[100.780252, 38.213555],
						[100.781984, 38.204579],
						[100.78766, 38.203349],
						[100.789199, 38.193507],
						[100.801754, 38.185486],
						[100.810123, 38.181224],
						[100.81527, 38.171287],
						[100.818974, 38.168233],
						[100.822052, 38.161965],
						[100.825612, 38.158887],
						[100.830374, 38.158181],
						[100.833789, 38.154715],
						[100.843842, 38.149084],
						[100.860437, 38.148377],
						[100.863034, 38.149289],
						[100.868854, 38.156676],
						[100.881505, 38.161532],
						[100.883573, 38.165771],
						[100.893674, 38.170011],
						[100.895598, 38.175185],
						[100.901707, 38.18013],
						[100.913252, 38.178672],
						[100.925469, 38.170923],
						[100.934272, 38.16641],
						[100.938072, 38.160392],
						[100.934608, 38.154784],
						[100.924988, 38.148902],
						[100.924796, 38.140602],
						[100.921573, 38.137615],
						[100.918591, 38.128927],
						[100.916234, 38.113965],
						[100.917869, 38.10792],
						[100.921765, 38.101715],
						[100.921862, 38.095486],
						[100.92393, 38.090216],
						[100.921862, 38.084762],
						[100.914791, 38.083484],
						[100.908586, 38.07714],
						[100.907672, 38.073488],
						[100.894925, 38.06324],
						[100.888864, 38.055867],
						[100.887325, 38.049589],
						[100.889826, 38.042579],
						[100.890163, 38.036095],
						[100.896897, 38.029472],
						[100.896993, 38.024471],
						[100.894204, 38.018122],
						[100.894781, 38.013554],
						[100.901948, 38.007089],
						[100.909836, 38.00597],
						[100.918014, 37.999733],
						[100.927826, 38.007957],
						[100.937062, 38.007432],
						[100.943555, 38.003822],
						[100.951396, 38.007203],
						[100.956542, 38.006107],
						[100.957697, 38.00967],
						[100.964142, 38.011041],
						[100.972897, 38.007774],
						[100.980352, 38.006815],
						[100.985211, 37.99955],
						[100.991608, 37.998111],
						[100.997572, 37.988401],
						[101.00421, 37.986093],
						[101.020998, 37.975467],
						[101.025182, 37.974438],
						[101.031291, 37.976015]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620723,
			"name": "临泽县",
			"center": [100.166333, 39.152151],
			"centroid": [100.176927, 39.346212],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 3,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[100.499102, 39.400543],
						[100.500545, 39.48137],
						[100.443257, 39.4856],
						[100.326276, 39.509112],
						[100.301071, 39.572317],
						[100.314202, 39.606925],
						[100.277598, 39.651851],
						[100.250036, 39.68508],
						[100.127908, 39.702168],
						[100.118047, 39.706808],
						[100.116844, 39.701053],
						[100.113285, 39.694673],
						[100.111168, 39.68209],
						[100.102606, 39.676713],
						[100.100009, 39.672205],
						[100.09568, 39.670085],
						[100.084184, 39.667876],
						[100.065954, 39.657788],
						[100.047916, 39.652007],
						[100.037814, 39.65002],
						[100.029108, 39.646002],
						[100.025212, 39.646293],
						[100.009483, 39.64243],
						[100.005683, 39.639126],
						[100.002893, 39.629525],
						[99.979035, 39.60956],
						[99.967347, 39.593924],
						[99.958111, 39.584719],
						[99.953638, 39.581725],
						[99.949982, 39.572451],
						[99.952051, 39.562305],
						[99.957149, 39.553722],
						[99.959458, 39.538229],
						[99.954071, 39.491797],
						[99.95359, 39.481505],
						[99.951329, 39.469331],
						[99.947, 39.432012],
						[99.943681, 39.406458],
						[99.943344, 39.387638],
						[99.937668, 39.369957],
						[99.937476, 39.366931],
						[99.955995, 39.363098],
						[99.953205, 39.355813],
						[99.949597, 39.355791],
						[99.932233, 39.351756],
						[99.929106, 39.348281],
						[99.931656, 39.346644],
						[99.938005, 39.327854],
						[99.943392, 39.320408],
						[99.952291, 39.315271],
						[99.967106, 39.303293],
						[99.940073, 39.294363],
						[99.927567, 39.293578],
						[99.924008, 39.289651],
						[99.927663, 39.267097],
						[99.942767, 39.254033],
						[99.939304, 39.248353],
						[99.92343, 39.231939],
						[99.918236, 39.230973],
						[99.913377, 39.233219],
						[99.909722, 39.230389],
						[99.903661, 39.21314],
						[99.889471, 39.200133],
						[99.873117, 39.186921],
						[99.867345, 39.177752],
						[99.860322, 39.169953],
						[99.877831, 39.167503],
						[99.884084, 39.16566],
						[99.888461, 39.159411],
						[99.901689, 39.155252],
						[99.90722, 39.145157],
						[99.914917, 39.145247],
						[99.916215, 39.135825],
						[99.918813, 39.131845],
						[99.924825, 39.127797],
						[99.932137, 39.12548],
						[99.937861, 39.120667],
						[99.945701, 39.121567],
						[99.951473, 39.119835],
						[99.953349, 39.114212],
						[99.963018, 39.114526],
						[99.963787, 39.105641],
						[99.967683, 39.101366],
						[99.975716, 39.098036],
						[99.980671, 39.092119],
						[99.981969, 39.085773],
						[99.979757, 39.07353],
						[99.987501, 39.069231],
						[99.99005, 39.062185],
						[100.022951, 39.064189],
						[100.028435, 39.061825],
						[100.034399, 39.051784],
						[100.041133, 39.043656],
						[100.042095, 39.037441],
						[100.027136, 39.024447],
						[100.025308, 39.015324],
						[100.020065, 39.002618],
						[100.015015, 38.995161],
						[100.006164, 38.98777],
						[99.99741, 38.982474],
						[99.993321, 38.976839],
						[99.978458, 38.963901],
						[99.978554, 38.962256],
						[99.986876, 38.955402],
						[99.98904, 38.95565],
						[99.99741, 38.962391],
						[100.000681, 38.962729],
						[100.018863, 38.956124],
						[100.025308, 38.952156],
						[100.039498, 38.960768],
						[100.050369, 38.956778],
						[100.076247, 38.963157],
						[100.082981, 38.96877],
						[100.086589, 38.979386],
						[100.090581, 38.982947],
						[100.101741, 38.988716],
						[100.107368, 38.992276],
						[100.127523, 38.995003],
						[100.129591, 38.992795],
						[100.145561, 38.992997],
						[100.15191, 38.994349],
						[100.176297, 38.995296],
						[100.197125, 38.995161],
						[100.216317, 38.997166],
						[100.229737, 39.001154],
						[100.233826, 39.007913],
						[100.232575, 39.019874],
						[100.222426, 39.03046],
						[100.218049, 39.037666],
						[100.211026, 39.052077],
						[100.201935, 39.06653],
						[100.196932, 39.079517],
						[100.193421, 39.08503],
						[100.197269, 39.088856],
						[100.196932, 39.096281],
						[100.198472, 39.100939],
						[100.19015, 39.105551],
						[100.183127, 39.107463],
						[100.18813, 39.117406],
						[100.189717, 39.126447],
						[100.193469, 39.133644],
						[100.191497, 39.139671],
						[100.194094, 39.143493],
						[100.20458, 39.147563],
						[100.211122, 39.156466],
						[100.215644, 39.158264],
						[100.225023, 39.167054],
						[100.225312, 39.174179],
						[100.222618, 39.17755],
						[100.222282, 39.187752],
						[100.220021, 39.193392],
						[100.219251, 39.200605],
						[100.221993, 39.214263],
						[100.229545, 39.217026],
						[100.262013, 39.212331],
						[100.275048, 39.201908],
						[100.277117, 39.197414],
						[100.27702, 39.190426],
						[100.282889, 39.182854],
						[100.287939, 39.180494],
						[100.305015, 39.177617],
						[100.312134, 39.172718],
						[100.319253, 39.165076],
						[100.325458, 39.161546],
						[100.335655, 39.159478],
						[100.349028, 39.159366],
						[100.35023, 39.156826],
						[100.359369, 39.156084],
						[100.369663, 39.153206],
						[100.382265, 39.146011],
						[100.388518, 39.146079],
						[100.401361, 39.134589],
						[100.401939, 39.128786],
						[100.409683, 39.129394],
						[100.417475, 39.131935],
						[100.439457, 39.142526],
						[100.44725, 39.152149],
						[100.446817, 39.161794],
						[100.437678, 39.174673],
						[100.438399, 39.183123],
						[100.453262, 39.199863],
						[100.461343, 39.221608],
						[100.466682, 39.228548],
						[100.4827, 39.244334],
						[100.486789, 39.249475],
						[100.488809, 39.254908],
						[100.488905, 39.270015],
						[100.490829, 39.278903],
						[100.490733, 39.29037],
						[100.492272, 39.304055],
						[100.497659, 39.324512],
						[100.499247, 39.34003],
						[100.497948, 39.356127],
						[100.497323, 39.373789],
						[100.495976, 39.389632],
						[100.49713, 39.401507],
						[100.499102, 39.400543]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620724,
			"name": "高台县",
			"center": [99.81665, 39.376308],
			"centroid": [99.593611, 39.540119],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 4,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[100.118047, 39.706808],
						[100.040749, 39.75704],
						[99.958688, 39.769454],
						[99.904382, 39.785786],
						[99.821986, 39.860067],
						[99.778358, 39.865786],
						[99.748103, 39.872372],
						[99.712027, 39.877601],
						[99.690237, 39.885877],
						[99.672536, 39.888057],
						[99.648726, 39.886099],
						[99.610005, 39.883964],
						[99.56681, 39.882095],
						[99.532899, 39.879714],
						[99.488021, 39.876021],
						[99.469117, 39.875331],
						[99.45613, 39.877312],
						[99.444489, 39.874286],
						[99.424864, 39.874931],
						[99.400381, 39.872439],
						[99.385999, 39.869947],
						[99.381189, 39.870258],
						[99.365315, 39.868478],
						[99.358725, 39.866765],
						[99.343526, 39.858086],
						[99.320485, 39.847714],
						[99.311779, 39.8458],
						[99.287488, 39.84186],
						[99.279118, 39.841994],
						[99.247708, 39.838009],
						[99.24386, 39.84442],
						[99.237896, 39.850096],
						[99.229863, 39.851609],
						[99.223754, 39.846112],
						[99.220435, 39.840458],
						[99.215721, 39.839857],
						[99.212499, 39.834848],
						[99.206245, 39.829994],
						[99.197491, 39.813049],
						[99.193162, 39.80913],
						[99.181762, 39.807147],
						[99.148236, 39.799998],
						[99.140972, 39.801446],
						[99.113844, 39.835048],
						[99.102299, 39.841482],
						[99.088783, 39.839879],
						[99.083299, 39.837297],
						[99.071419, 39.846089],
						[99.069158, 39.850096],
						[99.055449, 39.850274],
						[99.045829, 39.852767],
						[99.026829, 39.853969],
						[99.005472, 39.841905],
						[99.001143, 39.837274],
						[98.987146, 39.832733],
						[98.976756, 39.822246],
						[98.970503, 39.811334],
						[98.964683, 39.794719],
						[98.960065, 39.788593],
						[98.959199, 39.779793],
						[98.992292, 39.762768],
						[98.998498, 39.758534],
						[99.001143, 39.754566],
						[99.008887, 39.750109],
						[99.083396, 39.71138],
						[99.156317, 39.711068],
						[99.218848, 39.662855],
						[99.317118, 39.633165],
						[99.32467, 39.631267],
						[99.369211, 39.635844],
						[99.38013, 39.661538],
						[99.431069, 39.652409],
						[99.495284, 39.649507],
						[99.517122, 39.621129],
						[99.553438, 39.490298],
						[99.557863, 39.4203],
						[99.54502, 39.400924],
						[99.499709, 39.394091],
						[99.480758, 39.387974],
						[99.457477, 39.37361],
						[99.42015, 39.362874],
						[99.389991, 39.368119],
						[99.326354, 39.398482],
						[99.264159, 39.438058],
						[99.242562, 39.448245],
						[99.256222, 39.427444],
						[99.28542, 39.38896],
						[99.308075, 39.357495],
						[99.305189, 39.333101],
						[99.29302, 39.300107],
						[99.280754, 39.289158],
						[99.246987, 39.285568],
						[99.207256, 39.283795],
						[99.199559, 39.280272],
						[99.198982, 39.275918],
						[99.205091, 39.263551],
						[99.210575, 39.242897],
						[99.213605, 39.226616],
						[99.213316, 39.218419],
						[99.207159, 39.205727],
						[99.192296, 39.189999],
						[99.1846, 39.179887],
						[99.176279, 39.171594],
						[99.175365, 39.168312],
						[99.185466, 39.160153],
						[99.185081, 39.155836],
						[99.194509, 39.1546],
						[99.206678, 39.157298],
						[99.211921, 39.160692],
						[99.217164, 39.161187],
						[99.236934, 39.159636],
						[99.253288, 39.153498],
						[99.264303, 39.146978],
						[99.267237, 39.141784],
						[99.277002, 39.113109],
						[99.289412, 39.105258],
						[99.306825, 39.097091],
						[99.314809, 39.091669],
						[99.328229, 39.086628],
						[99.330683, 39.081812],
						[99.330105, 39.07344],
						[99.3353, 39.071752],
						[99.342612, 39.072675],
						[99.364546, 39.071864],
						[99.399852, 39.077446],
						[99.42496, 39.08575],
						[99.428953, 39.087596],
						[99.428712, 39.091691],
						[99.42496, 39.099139],
						[99.42573, 39.109105],
						[99.430877, 39.112862],
						[99.439631, 39.113042],
						[99.456467, 39.11203],
						[99.461661, 39.110725],
						[99.468732, 39.103436],
						[99.475274, 39.100376],
						[99.478593, 39.100826],
						[99.484173, 39.10888],
						[99.488983, 39.112659],
						[99.498459, 39.123659],
						[99.504952, 39.134274],
						[99.511542, 39.138254],
						[99.522846, 39.141874],
						[99.520345, 39.150373],
						[99.527223, 39.163345],
						[99.530927, 39.168267],
						[99.537084, 39.16865],
						[99.544828, 39.163052],
						[99.544491, 39.178202],
						[99.545549, 39.194673],
						[99.546896, 39.247073],
						[99.548868, 39.251676],
						[99.556901, 39.254123],
						[99.570658, 39.256749],
						[99.581, 39.256884],
						[99.598316, 39.253651],
						[99.601683, 39.251743],
						[99.619817, 39.24943],
						[99.629678, 39.249924],
						[99.633959, 39.245142],
						[99.645022, 39.240786],
						[99.651564, 39.239506],
						[99.66003, 39.241146],
						[99.680521, 39.238451],
						[99.68283, 39.241078],
						[99.699617, 39.244042],
						[99.7127, 39.241999],
						[99.719819, 39.236947],
						[99.729006, 39.233376],
						[99.742763, 39.225651],
						[99.748151, 39.220395],
						[99.75628, 39.216711],
						[99.773067, 39.20521],
						[99.775472, 39.201593],
						[99.783745, 39.195617],
						[99.796203, 39.195212],
						[99.811836, 39.192157],
						[99.825497, 39.18782],
						[99.834107, 39.182089],
						[99.839013, 39.176988],
						[99.850413, 39.175235],
						[99.860322, 39.169953],
						[99.867345, 39.177752],
						[99.873117, 39.186921],
						[99.889471, 39.200133],
						[99.903661, 39.21314],
						[99.909722, 39.230389],
						[99.913377, 39.233219],
						[99.918236, 39.230973],
						[99.92343, 39.231939],
						[99.939304, 39.248353],
						[99.942767, 39.254033],
						[99.927663, 39.267097],
						[99.924008, 39.289651],
						[99.927567, 39.293578],
						[99.940073, 39.294363],
						[99.967106, 39.303293],
						[99.952291, 39.315271],
						[99.943392, 39.320408],
						[99.938005, 39.327854],
						[99.931656, 39.346644],
						[99.929106, 39.348281],
						[99.932233, 39.351756],
						[99.949597, 39.355791],
						[99.953205, 39.355813],
						[99.955995, 39.363098],
						[99.937476, 39.366931],
						[99.937668, 39.369957],
						[99.943344, 39.387638],
						[99.943681, 39.406458],
						[99.947, 39.432012],
						[99.951329, 39.469331],
						[99.95359, 39.481505],
						[99.954071, 39.491797],
						[99.959458, 39.538229],
						[99.957149, 39.553722],
						[99.952051, 39.562305],
						[99.949982, 39.572451],
						[99.953638, 39.581725],
						[99.958111, 39.584719],
						[99.967347, 39.593924],
						[99.979035, 39.60956],
						[100.002893, 39.629525],
						[100.005683, 39.639126],
						[100.009483, 39.64243],
						[100.025212, 39.646293],
						[100.029108, 39.646002],
						[100.037814, 39.65002],
						[100.047916, 39.652007],
						[100.065954, 39.657788],
						[100.084184, 39.667876],
						[100.09568, 39.670085],
						[100.100009, 39.672205],
						[100.102606, 39.676713],
						[100.111168, 39.68209],
						[100.113285, 39.694673],
						[100.116844, 39.701053],
						[100.118047, 39.706808]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620725,
			"name": "山丹县",
			"center": [101.088442, 38.784839],
			"centroid": [101.178076, 38.523105],
			"childrenNum": 0,
			"level": "district",
			"parent": {
				"adcode": 620700
			},
			"subFeatureIndex": 5,
			"acroutes": [100000, 620000, 620700]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[101.385458, 38.065774],
						[101.386228, 38.071252],
						[101.403641, 38.102354],
						[101.402438, 38.132963],
						[101.409942, 38.15182],
						[101.419562, 38.164107],
						[101.4414, 38.179857],
						[101.460255, 38.197608],
						[101.46266, 38.201458],
						[101.478197, 38.207404],
						[101.487288, 38.21925],
						[101.491232, 38.228337],
						[101.487962, 38.238175],
						[101.468, 38.250721],
						[101.443276, 38.260283],
						[101.433848, 38.26611],
						[101.4186, 38.272643],
						[101.416339, 38.275556],
						[101.415089, 38.28384],
						[101.403592, 38.284341],
						[101.399504, 38.287641],
						[101.398061, 38.303272],
						[101.392241, 38.316285],
						[101.376993, 38.317467],
						[101.347074, 38.317308],
						[101.342841, 38.33075],
						[101.34159, 38.346395],
						[101.339426, 38.360559],
						[101.336684, 38.36572],
						[101.33779, 38.369766],
						[101.342697, 38.370243],
						[101.356357, 38.364856],
						[101.361216, 38.368857],
						[101.370162, 38.370107],
						[101.367276, 38.382403],
						[101.37098, 38.388038],
						[101.381177, 38.387652],
						[101.386998, 38.390038],
						[101.394742, 38.388538],
						[101.404699, 38.390584],
						[101.415233, 38.394492],
						[101.426344, 38.394287],
						[101.442554, 38.387493],
						[101.447268, 38.388448],
						[101.466941, 38.400763],
						[101.487432, 38.412531],
						[101.518506, 38.436266],
						[101.523749, 38.445236],
						[101.525095, 38.452797],
						[101.529665, 38.462582],
						[101.52447, 38.466395],
						[101.511627, 38.463739],
						[101.503979, 38.463785],
						[101.501574, 38.470458],
						[101.501141, 38.48301],
						[101.50244, 38.487004],
						[101.510713, 38.493017],
						[101.533561, 38.489886],
						[101.541738, 38.491724],
						[101.547318, 38.498622],
						[101.543999, 38.513414],
						[101.538131, 38.525118],
						[101.52827, 38.535324],
						[101.517351, 38.544599],
						[101.516293, 38.548295],
						[101.541835, 38.564278],
						[101.567232, 38.575703],
						[101.568675, 38.57849],
						[101.56829, 38.586853],
						[101.563961, 38.603938],
						[101.564346, 38.608379],
						[101.575505, 38.621676],
						[101.587723, 38.639228],
						[101.591427, 38.642353],
						[101.60374, 38.645025],
						[101.608358, 38.647697],
						[101.613072, 38.655712],
						[101.605809, 38.653131],
						[101.601768, 38.655123],
						[101.585558, 38.677896],
						[101.570599, 38.701951],
						[101.562422, 38.713014],
						[101.557708, 38.715027],
						[101.514369, 38.728463],
						[101.50167, 38.731652],
						[101.487288, 38.736446],
						[101.474493, 38.738052],
						[101.466797, 38.7428],
						[101.463238, 38.747911],
						[101.445056, 38.754513],
						[101.439331, 38.757316],
						[101.412347, 38.764189],
						[101.39681, 38.773208],
						[101.383246, 38.769795],
						[101.368335, 38.773298],
						[101.354578, 38.773863],
						[101.341446, 38.778768],
						[101.331249, 38.777321],
						[101.316626, 38.783717],
						[101.312345, 38.787152],
						[101.307775, 38.79418],
						[101.306332, 38.80193],
						[101.320041, 38.804348],
						[101.330094, 38.807737],
						[101.336011, 38.813949],
						[101.341446, 38.822239],
						[101.341879, 38.826169],
						[101.339618, 38.836355],
						[101.33399, 38.848503],
						[101.284879, 38.852839],
						[101.277376, 38.854374],
						[101.259674, 38.855096],
						[101.241733, 38.861553],
						[101.239857, 38.865752],
						[101.237692, 38.90732],
						[101.198538, 38.94325],
						[101.217394, 38.994057],
						[101.228601, 39.020753],
						[101.225571, 39.021789],
						[101.217634, 39.019154],
						[101.20508, 39.011945],
						[101.184637, 39.003542],
						[101.159673, 38.992434],
						[101.146878, 38.987972],
						[101.117296, 38.975172],
						[101.086319, 38.9685],
						[101.059575, 38.964532],
						[101.017967, 38.956552],
						[100.976552, 38.947105],
						[100.969241, 38.946993],
						[100.972849, 38.964194],
						[100.972656, 38.981865],
						[100.969385, 38.996648],
						[100.966644, 39.001965],
						[100.961545, 39.006088],
						[100.912867, 39.027262],
						[100.904112, 39.030145],
						[100.899398, 39.026924],
						[100.896609, 39.02037],
						[100.889153, 39.007395],
						[100.881938, 39.001514],
						[100.875444, 39.002416],
						[100.867989, 39.006786],
						[100.858609, 39.0094],
						[100.843457, 38.991623],
						[100.835713, 38.983848],
						[100.822581, 38.973977],
						[100.811422, 38.962887],
						[100.800695, 38.954523],
						[100.790161, 38.942956],
						[100.783764, 38.932606],
						[100.771787, 38.917178],
						[100.760291, 38.904929],
						[100.745235, 38.893625],
						[100.738789, 38.884079],
						[100.73345, 38.878775],
						[100.733065, 38.873201],
						[100.735519, 38.865707],
						[100.72763, 38.852229],
						[100.71724, 38.836265],
						[100.705359, 38.820432],
						[100.68939, 38.805274],
						[100.714498, 38.796982],
						[100.734797, 38.792734],
						[100.785207, 38.786113],
						[100.796655, 38.787785],
						[100.808584, 38.785797],
						[100.827969, 38.775536],
						[100.833596, 38.765477],
						[100.841822, 38.759939],
						[100.849662, 38.758311],
						[100.858753, 38.758695],
						[100.882563, 38.754694],
						[100.907383, 38.754468],
						[100.915801, 38.75501],
						[100.923738, 38.753269],
						[100.931241, 38.746961],
						[100.941294, 38.730091],
						[100.949616, 38.720501],
						[100.966499, 38.711928],
						[100.967846, 38.706838],
						[100.959188, 38.698625],
						[100.95356, 38.697674],
						[100.949856, 38.694371],
						[100.948125, 38.688917],
						[100.948317, 38.681336],
						[100.950434, 38.665922],
						[100.953849, 38.652972],
						[100.954378, 38.645863],
						[100.958082, 38.626953],
						[100.961593, 38.621812],
						[100.959717, 38.613838],
						[100.959958, 38.607178],
						[100.965104, 38.593289],
						[100.96674, 38.585901],
						[100.968087, 38.56684],
						[100.971838, 38.560311],
						[100.98954, 38.539383],
						[100.994927, 38.524778],
						[100.996274, 38.50595],
						[100.998871, 38.49397],
						[100.997332, 38.476746],
						[101.002527, 38.466985],
						[101.003056, 38.452456],
						[101.005653, 38.44015],
						[101.003296, 38.428636],
						[101.004547, 38.418778],
						[101.001517, 38.412236],
						[100.99536, 38.410941],
						[100.990646, 38.415053],
						[100.986317, 38.424934],
						[100.984345, 38.425047],
						[100.981459, 38.404875],
						[100.979198, 38.401717],
						[100.971502, 38.397309],
						[100.96674, 38.392447],
						[100.97179, 38.382607],
						[100.96039, 38.38638],
						[100.958755, 38.385243],
						[100.966692, 38.37638],
						[100.966836, 38.372948],
						[100.983479, 38.356467],
						[100.997621, 38.350488],
						[101.001565, 38.345827],
						[100.999689, 38.337141],
						[100.995504, 38.332683],
						[100.986269, 38.319651],
						[100.983431, 38.310575],
						[100.987567, 38.30946],
						[100.988193, 38.314897],
						[100.994927, 38.314692],
						[100.991416, 38.311712],
						[100.994686, 38.307481],
						[100.997669, 38.313055],
						[100.997957, 38.318173],
						[101.008443, 38.306958],
						[101.014167, 38.296219],
						[101.011041, 38.288733],
						[101.008058, 38.277377],
						[101.009357, 38.263356],
						[101.007577, 38.245758],
						[101.007096, 38.221026],
						[101.005221, 38.213077],
						[100.992426, 38.2036],
						[100.979006, 38.198724],
						[100.973426, 38.197995],
						[100.962122, 38.188471],
						[100.957697, 38.176461],
						[100.957216, 38.161805],
						[100.956013, 38.149928],
						[100.958996, 38.134263],
						[100.963565, 38.127262],
						[100.974388, 38.116611],
						[101.010848, 38.09398],
						[101.021815, 38.086314],
						[101.028742, 38.079696],
						[101.032109, 38.071571],
						[101.034899, 38.058218],
						[101.035236, 38.047648],
						[101.031628, 38.035615],
						[101.029271, 38.018738],
						[101.027251, 38.013074],
						[101.026193, 37.993861],
						[101.028309, 37.978917],
						[101.031291, 37.976015],
						[101.034562, 37.976586],
						[101.042547, 37.966439],
						[101.058276, 37.960268],
						[101.059959, 37.95597],
						[101.073861, 37.943556],
						[101.077131, 37.941842],
						[101.09161, 37.94031],
						[101.10301, 37.946528],
						[101.11061, 37.937269],
						[101.114313, 37.928534],
						[101.114698, 37.919569],
						[101.129706, 37.924257],
						[101.13466, 37.930271],
						[101.139037, 37.941796],
						[101.15087, 37.961753],
						[101.153131, 37.971307],
						[101.162751, 37.982642],
						[101.175931, 37.990411],
						[101.190505, 37.997426],
						[101.210371, 38.004965],
						[101.219895, 38.009419],
						[101.231199, 38.024836],
						[101.241781, 38.032236],
						[101.257943, 38.035113],
						[101.277809, 38.036711],
						[101.293249, 38.036643],
						[101.321965, 38.035204],
						[101.32918, 38.033811],
						[101.344284, 38.037876],
						[101.350008, 38.041346],
						[101.359243, 38.049749],
						[101.365881, 38.053881],
						[101.382188, 38.059474],
						[101.385458, 38.065774]
					]
				]
			]
		}
	}]
};

//西和县json
var xiheJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 621225,
			"name": "西和县",
			"center": [105.299737, 34.013718],
			"centroid": [105.331569, 33.911563],
			"childrenNum": 0,
			"level": "district",
			"acroutes": [100000, 620000, 621200],
			"parent": {
				"adcode": 621200
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.063389, 33.62501],
						[105.073415, 33.629982],
						[105.085518, 33.631426],
						[105.091015, 33.631909],
						[105.096798, 33.630562],
						[105.104775, 33.630598],
						[105.111369, 33.630852],
						[105.117678, 33.631794],
						[105.125369, 33.632048],
						[105.130568, 33.633444],
						[105.138528, 33.633691],
						[105.144288, 33.634622],
						[105.150042, 33.636017],
						[105.155241, 33.63763],
						[105.161806, 33.639249],
						[105.166189, 33.641786],
						[105.170834, 33.644081],
						[105.174113, 33.647989],
						[105.177393, 33.650061],
						[105.181215, 33.652815],
						[105.184495, 33.655569],
						[105.18914, 33.658559],
						[105.192134, 33.662007],
						[105.20143, 33.669362],
						[105.206361, 33.67281],
						[105.212908, 33.678323],
						[105.220302, 33.683159],
						[105.22797, 33.68776],
						[105.230987, 33.689372],
						[105.243627, 33.69009],
						[105.249118, 33.692861],
						[105.252678, 33.695849],
						[105.256512, 33.699761],
						[105.26282, 33.703449],
						[105.268585, 33.705073],
						[105.273546, 33.70532],
						[105.27906, 33.704427],
						[105.283203, 33.701004],
						[105.286786, 33.69827],
						[105.29233, 33.691412],
						[105.296491, 33.685465],
						[105.304497, 33.680001],
						[105.311115, 33.676131],
						[105.313607, 33.674308],
						[105.315818, 33.673166],
						[105.320236, 33.66906],
						[105.322716, 33.667007],
						[105.324379, 33.664948],
						[105.325214, 33.66243],
						[105.323568, 33.661053],
						[105.320545, 33.659893],
						[105.315859, 33.659187],
						[105.308711, 33.656173],
						[105.306785, 33.653872],
						[105.310386, 33.651595],
						[105.313414, 33.650695],
						[105.322506, 33.650731],
						[105.324899, 33.650864],
						[105.327069, 33.650121],
						[105.332619, 33.650429],
						[105.337013, 33.649988],
						[105.337836, 33.648962],
						[105.342504, 33.648345],
						[105.347441, 33.647168],
						[105.349291, 33.647113],
						[105.357514, 33.647832],
						[105.359299, 33.647784],
						[105.362731, 33.647101],
						[105.365631, 33.647113],
						[105.368093, 33.646521],
						[105.369937, 33.647627],
						[105.372739, 33.645676],
						[105.374693, 33.645863],
						[105.379689, 33.648219],
						[105.385361, 33.649197],
						[105.386948, 33.651208],
						[105.388179, 33.651607],
						[105.393291, 33.654264],
						[105.395649, 33.656378],
						[105.400819, 33.656312],
						[105.404128, 33.658094],
						[105.405844, 33.658317],
						[105.410512, 33.660105],
						[105.414101, 33.660376],
						[105.416354, 33.6615],
						[105.41912, 33.663233],
						[105.423613, 33.665455],
						[105.425778, 33.666029],
						[105.426315, 33.667194],
						[105.423625, 33.666778],
						[105.418694, 33.666935],
						[105.415367, 33.666826],
						[105.413325, 33.667134],
						[105.412234, 33.667859],
						[105.41479, 33.672478],
						[105.416161, 33.67592],
						[105.418075, 33.679591],
						[105.421366, 33.682573],
						[105.423829, 33.685791],
						[105.424646, 33.688315],
						[105.426566, 33.691062],
						[105.43232, 33.694962],
						[105.434514, 33.700467],
						[105.436965, 33.703908],
						[105.440256, 33.708954],
						[105.44217, 33.712165],
						[105.44381, 33.716293],
						[105.445998, 33.719727],
						[105.447358, 33.724313],
						[105.448998, 33.728441],
						[105.452003, 33.734397],
						[105.454466, 33.738753],
						[105.456105, 33.741275],
						[105.458568, 33.74425],
						[105.460482, 33.749981],
						[105.461019, 33.75319],
						[105.462665, 33.756623],
						[105.462659, 33.760755],
						[105.464561, 33.768777],
						[105.46483, 33.771986],
						[105.465378, 33.774507],
						[105.465915, 33.779778],
						[105.468103, 33.783216],
						[105.475229, 33.788474],
						[105.479885, 33.790765],
						[105.483999, 33.793051],
						[105.487011, 33.795565],
						[105.488925, 33.797856],
						[105.491667, 33.802668],
						[105.492204, 33.806563],
						[105.493844, 33.812061],
						[105.493844, 33.815503],
						[105.494929, 33.820313],
						[105.493546, 33.827649],
						[105.492992, 33.832694],
						[105.491889, 33.837509],
						[105.491055, 33.844391],
						[105.490775, 33.851044],
						[105.489666, 33.856997],
						[105.488289, 33.861818],
						[105.488545, 33.868463],
						[105.487162, 33.874656],
						[105.48634, 33.880848],
						[105.485225, 33.886348],
						[105.484951, 33.890702],
						[105.485488, 33.895057],
						[105.48603, 33.901019],
						[105.485202, 33.906523],
						[105.486293, 33.91225],
						[105.486007, 33.917296],
						[105.486818, 33.922106],
						[105.489286, 33.926688],
						[105.492858, 33.930806],
						[105.49532, 33.933093],
						[105.498343, 33.935381],
						[105.501909, 33.938812],
						[105.505754, 33.940871],
						[105.511508, 33.944525],
						[105.517005, 33.946348],
						[105.5236, 33.947943],
						[105.537056, 33.947456],
						[105.544211, 33.948822],
						[105.550805, 33.94881],
						[105.563468, 33.949713],
						[105.56732, 33.949713],
						[105.575303, 33.950387],
						[105.582183, 33.949466],
						[105.586326, 33.949466],
						[105.593475, 33.949695],
						[105.597064, 33.950387],
						[105.605052, 33.954058],
						[105.608641, 33.960708],
						[105.609744, 33.965059],
						[105.614442, 33.970108],
						[105.617196, 33.973315],
						[105.621065, 33.979049],
						[105.630169, 33.988688],
						[105.635415, 33.994655],
						[105.637352, 33.99741],
						[105.638765, 33.997964],
						[105.636354, 34.003606],
						[105.633874, 34.007269],
						[105.631937, 34.010475],
						[105.630005, 34.014601],
						[105.625868, 34.017349],
						[105.621999, 34.021012],
						[105.618678, 34.024445],
						[105.615376, 34.028113],
						[105.611226, 34.030404],
						[105.605157, 34.035443],
						[105.60322, 34.039339],
						[105.599911, 34.043241],
						[105.595774, 34.047137],
						[105.594128, 34.049085],
						[105.591952, 34.048237],
						[105.590108, 34.049007],
						[105.585772, 34.054141],
						[105.584768, 34.055529],
						[105.584266, 34.057591],
						[105.584896, 34.060278],
						[105.584861, 34.062003],
						[105.584284, 34.063764],
						[105.584529, 34.065015],
						[105.586489, 34.067281],
						[105.587814, 34.068266],
						[105.588077, 34.069955],
						[105.589763, 34.071981],
						[105.589757, 34.073573],
						[105.589133, 34.074895],
						[105.5866, 34.077492],
						[105.585182, 34.078201],
						[105.580677, 34.078676],
						[105.578699, 34.079571],
						[105.578582, 34.080767],
						[105.581815, 34.082251],
						[105.580613, 34.082894],
						[105.57413, 34.084505],
						[105.56938, 34.08632],
						[105.563532, 34.086344],
						[105.563532, 34.088855],
						[105.564723, 34.090249],
						[105.564034, 34.092046],
						[105.560521, 34.094245],
						[105.558385, 34.096967],
						[105.555456, 34.098613],
						[105.555223, 34.099298],
						[105.55325, 34.099016],
						[105.549054, 34.099268],
						[105.545413, 34.099797],
						[105.54211, 34.099755],
						[105.541281, 34.099304],
						[105.540377, 34.096847],
						[105.539694, 34.096294],
						[105.537366, 34.098187],
						[105.532236, 34.105468],
						[105.529167, 34.108935],
						[105.526751, 34.111073],
						[105.524125, 34.111488],
						[105.522543, 34.11034],
						[105.522018, 34.108965],
						[105.521785, 34.10536],
						[105.520238, 34.104495],
						[105.519264, 34.104501],
						[105.516539, 34.105907],
						[105.515173, 34.105835],
						[105.514484, 34.105192],
						[105.514473, 34.102909],
						[105.513586, 34.101611],
						[105.511718, 34.100668],
						[105.510172, 34.100578],
						[105.506822, 34.101035],
						[105.505789, 34.10253],
						[105.503175, 34.102603],
						[105.501862, 34.100494],
						[105.501716, 34.096318],
						[105.503222, 34.092923],
						[105.504733, 34.091139],
						[105.504657, 34.089703],
						[105.503554, 34.087816],
						[105.501407, 34.085496],
						[105.497094, 34.08162],
						[105.493342, 34.079108],
						[105.492099, 34.077119],
						[105.490792, 34.077233],
						[105.488324, 34.078736],
						[105.48432, 34.080406],
						[105.480813, 34.080184],
						[105.477785, 34.079307],
						[105.477102, 34.079391],
						[105.475258, 34.081037],
						[105.472982, 34.081939],
						[105.469078, 34.08147],
						[105.464678, 34.080328],
						[105.461924, 34.081482],
						[105.458072, 34.084228],
						[105.453929, 34.085845],
						[105.45034, 34.088825],
						[105.444819, 34.096162],
						[105.441779, 34.099136],
						[105.439019, 34.103954],
						[105.437904, 34.105564],
						[105.437064, 34.108544],
						[105.434852, 34.113356],
						[105.433189, 34.116564],
						[105.4318, 34.120919],
						[105.432903, 34.124132],
						[105.430131, 34.128943],
						[105.429005, 34.133988],
						[105.428451, 34.137658],
						[105.427056, 34.142012],
						[105.425667, 34.147056],
						[105.425101, 34.15049],
						[105.422055, 34.156915],
						[105.419837, 34.161034],
						[105.418723, 34.164702],
						[105.417614, 34.167223],
						[105.415659, 34.173869],
						[105.415099, 34.174649],
						[105.414714, 34.176912],
						[105.414801, 34.181024],
						[105.413634, 34.182909],
						[105.412683, 34.183395],
						[105.412525, 34.185946],
						[105.40889, 34.190729],
						[105.40711, 34.196341],
						[105.405213, 34.198285],
						[105.404268, 34.199989],
						[105.401397, 34.20329],
						[105.399897, 34.20644],
						[105.398783, 34.209806],
						[105.396513, 34.212476],
						[105.395357, 34.21541],
						[105.395351, 34.217852],
						[105.3944, 34.217894],
						[105.391692, 34.217072],
						[105.39014, 34.217174],
						[105.388518, 34.217882],
						[105.386102, 34.219652],
						[105.386581, 34.221068],
						[105.388868, 34.222838],
						[105.389312, 34.223582],
						[105.38895, 34.22507],
						[105.387304, 34.22675],
						[105.385647, 34.227044],
						[105.381749, 34.226618],
						[105.380704, 34.225958],
						[105.376794, 34.225244],
						[105.374869, 34.224506],
						[105.371017, 34.222196],
						[105.368893, 34.22168],
						[105.366699, 34.21952],
						[105.363227, 34.218698],
						[105.360163, 34.217006],
						[105.356702, 34.216034],
						[105.355068, 34.214774],
						[105.351637, 34.215032],
						[105.348854, 34.213082],
						[105.346893, 34.213022],
						[105.345953, 34.212578],
						[105.342575, 34.21289],
						[105.339931, 34.21115],
						[105.337445, 34.210688],
						[105.335648, 34.21001],
						[105.334142, 34.20878],
						[105.33193, 34.20602],
						[105.331574, 34.205108],
						[105.331458, 34.202462],
						[105.33193, 34.200601],
						[105.331452, 34.199761],
						[105.331907, 34.197433],
						[105.333028, 34.194522],
						[105.333605, 34.190237],
						[105.334732, 34.185736],
						[105.335694, 34.183983],
						[105.338741, 34.171546],
						[105.338332, 34.169481],
						[105.337299, 34.168286],
						[105.334749, 34.167247],
						[105.331499, 34.167127],
						[105.330261, 34.168214],
						[105.327857, 34.167614],
						[105.325307, 34.162961],
						[105.323673, 34.16176],
						[105.320726, 34.161856],
						[105.319507, 34.16146],
						[105.317692, 34.159809],
						[105.316233, 34.157858],
						[105.314056, 34.156357],
						[105.310718, 34.154495],
						[105.309341, 34.153985],
						[105.302706, 34.152598],
						[105.3005, 34.152256],
						[105.296147, 34.152826],
						[105.292908, 34.153054],
						[105.290008, 34.150929],
						[105.289593, 34.150124],
						[105.287318, 34.148407],
						[105.283379, 34.144047],
						[105.282136, 34.140901],
						[105.280408, 34.138721],
						[105.275436, 34.136144],
						[105.272676, 34.136366],
						[105.270196, 34.138372],
						[105.268679, 34.139111],
						[105.26799, 34.138829],
						[105.266887, 34.137003],
						[105.264606, 34.136715],
						[105.262534, 34.135904],
						[105.260334, 34.137916],
						[105.256815, 34.137279],
						[105.255298, 34.137856],
						[105.252339, 34.140036],
						[105.249655, 34.141123],
						[105.248062, 34.140384],
						[105.245173, 34.138312],
						[105.242833, 34.138775],
						[105.24138, 34.138378],
						[105.239104, 34.136144],
						[105.237383, 34.13322],
						[105.235731, 34.132018],
						[105.232831, 34.129045],
						[105.230491, 34.124409],
						[105.22724, 34.116792],
						[105.226914, 34.116342],
						[105.223558, 34.116576],
						[105.217221, 34.114726],
						[105.212815, 34.112882],
						[105.207586, 34.110352],
						[105.203466, 34.107823],
						[105.200724, 34.105288],
						[105.195221, 34.101611],
						[105.192204, 34.097934],
						[105.182604, 34.088062],
						[105.182622, 34.085773],
						[105.181536, 34.081638],
						[105.182388, 34.077972],
						[105.182406, 34.074992],
						[105.184361, 34.068122],
						[105.187144, 34.063536],
						[105.188533, 34.061937],
						[105.189928, 34.058499],
						[105.190517, 34.050474],
						[105.190535, 34.046578],
						[105.190009, 34.042448],
						[105.190301, 34.039009],
						[105.189496, 34.03465],
						[105.189309, 34.031775],
						[105.188924, 34.030958],
						[105.185639, 34.027007],
						[105.184892, 34.024487],
						[105.184145, 34.023513],
						[105.182161, 34.022322],
						[105.180655, 34.020999],
						[105.178671, 34.019797],
						[105.176068, 34.01872],
						[105.174644, 34.017746],
						[105.174032, 34.015912],
						[105.172118, 34.014601],
						[105.169451, 34.013458],
						[105.165343, 34.013181],
						[105.16239, 34.012664],
						[105.160266, 34.011696],
						[105.15677, 34.011467],
						[105.154033, 34.008045],
						[105.155556, 34.005573],
						[105.1553, 33.994439],
						[105.154413, 33.990601],
						[105.1538, 33.989391],
						[105.150036, 33.985601],
						[105.148524, 33.984741],
						[105.144416, 33.981865],
						[105.142701, 33.981233],
						[105.140174, 33.979452],
						[105.140174, 33.977732],
						[105.140722, 33.976534],
						[105.147252, 33.970132],
						[105.148285, 33.96864],
						[105.14877, 33.966347],
						[105.148735, 33.962917],
						[105.151979, 33.961154],
						[105.155165, 33.955984],
						[105.1545, 33.953463],
						[105.153082, 33.951332],
						[105.151629, 33.949954],
						[105.148904, 33.949063],
						[105.148262, 33.94739],
						[105.144025, 33.943261],
						[105.143208, 33.941659],
						[105.142934, 33.939817],
						[105.144113, 33.936212],
						[105.146383, 33.933184],
						[105.146389, 33.93198],
						[105.143926, 33.928139],
						[105.143115, 33.926182],
						[105.144224, 33.923154],
						[105.146488, 33.921378],
						[105.147865, 33.920872],
						[105.148624, 33.919222],
						[105.146394, 33.917904],
						[105.145111, 33.916483],
						[105.144276, 33.913562],
						[105.142082, 33.912039],
						[105.140226, 33.91119],
						[105.137017, 33.911112],
						[105.129728, 33.911184],
						[105.120018, 33.910311],
						[105.118419, 33.909227],
						[105.117608, 33.90733],
						[105.117415, 33.904536],
						[105.117578, 33.900851],
						[105.118442, 33.895774],
						[105.117777, 33.892112],
						[105.118115, 33.887191],
						[105.115594, 33.879879],
						[105.116335, 33.874445],
						[105.118098, 33.866661],
						[105.119212, 33.862998],
						[105.121692, 33.861342],
						[105.12506, 33.860149],
						[105.128491, 33.85798],
						[105.130358, 33.855021],
						[105.130376, 33.85334],
						[105.128468, 33.851147],
						[105.125853, 33.849146],
						[105.123653, 33.849013],
						[105.120123, 33.843861],
						[105.120578, 33.843391],
						[105.123467, 33.843879],
						[105.12513, 33.842457],
						[105.123764, 33.837353],
						[105.121512, 33.832254],
						[105.121512, 33.830488],
						[105.122288, 33.829542],
						[105.127441, 33.827625],
						[105.128701, 33.826522],
						[105.129921, 33.824376],
						[105.128427, 33.820838],
						[105.128508, 33.820446],
						[105.124575, 33.819144],
						[105.123647, 33.817432],
						[105.125346, 33.81317],
						[105.126974, 33.811699],
						[105.131152, 33.811753],
						[105.136229, 33.810801],
						[105.139117, 33.811018],
						[105.142473, 33.810258],
						[105.143862, 33.810385],
						[105.147632, 33.809155],
						[105.150024, 33.810264],
						[105.150468, 33.809933],
						[105.151985, 33.806364],
						[105.15223, 33.804247],
						[105.155766, 33.80227],
						[105.155673, 33.80054],
						[105.152049, 33.796862],
						[105.151565, 33.79284],
						[105.15167, 33.787974],
						[105.152732, 33.783915],
						[105.153922, 33.781226],
						[105.15324, 33.78008],
						[105.150509, 33.779211],
						[105.149423, 33.779205],
						[105.146826, 33.777824],
						[105.144241, 33.775816],
						[105.142887, 33.774266],
						[105.14046, 33.770424],
						[105.13952, 33.767788],
						[105.139065, 33.764857],
						[105.13903, 33.76096],
						[105.137904, 33.756321],
						[105.137793, 33.753178],
						[105.137338, 33.751338],
						[105.137501, 33.747326],
						[105.138289, 33.745981],
						[105.143342, 33.743972],
						[105.147637, 33.740593],
						[105.150771, 33.740255],
						[105.154564, 33.739163],
						[105.15593, 33.738011],
						[105.158136, 33.733715],
						[105.159647, 33.731138],
						[105.161304, 33.726208],
						[105.16159, 33.720795],
						[105.160931, 33.718164],
						[105.159711, 33.716902],
						[105.159244, 33.715345],
						[105.159262, 33.713523],
						[105.160096, 33.711114],
						[105.163423, 33.704934],
						[105.163493, 33.702236],
						[105.162401, 33.700195],
						[105.160044, 33.698614],
						[105.157885, 33.698463],
						[105.155772, 33.69891],
						[105.147136, 33.706895],
						[105.14549, 33.707885],
						[105.142648, 33.707433],
						[105.14036, 33.706334],
						[105.138236, 33.705936],
						[105.136935, 33.707028],
						[105.131613, 33.709364],
						[105.125305, 33.711477],
						[105.120835, 33.711803],
						[105.117001, 33.713028],
						[105.111766, 33.715303],
						[105.108732, 33.716208],
						[105.10516, 33.71642],
						[105.102954, 33.716872],
						[105.090035, 33.714518],
						[105.08592, 33.711972],
						[105.082909, 33.708978],
						[105.077453, 33.701837],
						[105.072825, 33.693785],
						[105.070643, 33.690331],
						[105.069558, 33.686661],
						[105.067941, 33.682525],
						[105.065753, 33.679754],
						[105.063594, 33.673094],
						[105.06168, 33.670099],
						[105.060326, 33.666651],
						[105.0598, 33.663668],
						[105.058995, 33.660678],
						[105.058744, 33.657236],
						[105.057933, 33.654482],
						[105.056025, 33.651486],
						[105.055214, 33.648503],
						[105.055786, 33.644836],
						[105.056381, 33.639333],
						[105.058873, 33.637292],
						[105.060267, 33.63386],
						[105.062216, 33.631347],
						[105.063331, 33.629293],
						[105.063389, 33.62501]
					]
				]
			]
		}
	}]
};

//甘肃省json
var gansuJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 620100,
			"name": "兰州市",
			"center": [103.823557, 36.058039],
			"centroid": [103.644112, 36.355083],
			"childrenNum": 8,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 0,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.564881, 36.973787],
						[103.528532, 36.970481],
						[103.511832, 36.961493],
						[103.483669, 36.966452],
						[103.450104, 36.981946],
						[103.440607, 36.995992],
						[103.404586, 36.999193],
						[103.359396, 36.996715],
						[103.317152, 36.986697],
						[103.309457, 36.949818],
						[103.323702, 36.946718],
						[103.348098, 36.958291],
						[103.348589, 36.926773],
						[103.368237, 36.907856],
						[103.383464, 36.920364],
						[103.407861, 36.923465],
						[103.44159, 36.950542],
						[103.455998, 36.935868],
						[103.479576, 36.940208],
						[103.499879, 36.913335],
						[103.501353, 36.895448],
						[103.519691, 36.902686],
						[103.541631, 36.878799],
						[103.518053, 36.849938],
						[103.47319, 36.874248],
						[103.472535, 36.861732],
						[103.450759, 36.831209],
						[103.399019, 36.826034],
						[103.377897, 36.853352],
						[103.380353, 36.878902],
						[103.348425, 36.895862],
						[103.347607, 36.916126],
						[103.313223, 36.907132],
						[103.281131, 36.915196],
						[103.26574, 36.907959],
						[103.248057, 36.916643],
						[103.276219, 36.954158],
						[103.258208, 36.958704],
						[103.230537, 36.937211],
						[103.206141, 36.941242],
						[103.201393, 36.92977],
						[103.176833, 36.932974],
						[103.180271, 36.945685],
						[103.128695, 36.951678],
						[103.074336, 36.945272],
						[103.068114, 36.959737],
						[103.004421, 36.946925],
						[102.975932, 36.947855],
						[102.954974, 36.92884],
						[102.919607, 36.935454],
						[102.883095, 36.901342],
						[102.903398, 36.878695],
						[102.902415, 36.865146],
						[102.877855, 36.856042],
						[102.863447, 36.838142],
						[102.843471, 36.845179],
						[102.810397, 36.841143],
						[102.846255, 36.808645],
						[102.822677, 36.794876],
						[102.84298, 36.77458],
						[102.833156, 36.762358],
						[102.813508, 36.762773],
						[102.807614, 36.773544],
						[102.778305, 36.761737],
						[102.756856, 36.717598],
						[102.778142, 36.691579],
						[102.772575, 36.673434],
						[102.730659, 36.672811],
						[102.688743, 36.684218],
						[102.666475, 36.707648],
						[102.684977, 36.743918],
						[102.715268, 36.745576],
						[102.731477, 36.762358],
						[102.720671, 36.770023],
						[102.692509, 36.775305],
						[102.636676, 36.733143],
						[102.613426, 36.738634],
						[102.601309, 36.709928],
						[102.609005, 36.6781],
						[102.630618, 36.650927],
						[102.66582, 36.633913],
						[102.684486, 36.618971],
						[102.724273, 36.61399],
						[102.714777, 36.600289],
						[102.764552, 36.575477],
						[102.737699, 36.57122],
						[102.734425, 36.562289],
						[102.75309, 36.525933],
						[102.777323, 36.516893],
						[102.779124, 36.502136],
						[102.793041, 36.499434],
						[102.788784, 36.481867],
						[102.76668, 36.465543],
						[102.787966, 36.447448],
						[102.793532, 36.427061],
						[102.809742, 36.407916],
						[102.826279, 36.406251],
						[102.813017, 36.388455],
						[102.829718, 36.365345],
						[102.831846, 36.365345],
						[102.847401, 36.355974],
						[102.838887, 36.345769],
						[102.836431, 36.344623],
						[102.845436, 36.332229],
						[102.896685, 36.331812],
						[102.915841, 36.315145],
						[102.923701, 36.29764],
						[102.971347, 36.283571],
						[102.99165, 36.264392],
						[103.023578, 36.257407],
						[103.02145, 36.232693],
						[103.048302, 36.226435],
						[103.070897, 36.206929],
						[103.102661, 36.211623],
						[103.10741, 36.221637],
						[103.123128, 36.195661],
						[103.155711, 36.19013],
						[103.165863, 36.176146],
						[103.19075, 36.180321],
						[103.200902, 36.170301],
						[103.230374, 36.168318],
						[103.257881, 36.15955],
						[103.259846, 36.146605],
						[103.278184, 36.151929],
						[103.298323, 36.145038],
						[103.312895, 36.152556],
						[103.343022, 36.125198],
						[103.365617, 36.119872],
						[103.396727, 36.128958],
						[103.412282, 36.123005],
						[103.41048, 36.07777],
						[103.438315, 36.069201],
						[103.475646, 36.110785],
						[103.483342, 36.098354],
						[103.496604, 36.108382],
						[103.521819, 36.101697],
						[103.538848, 36.105039],
						[103.571267, 36.091876],
						[103.575033, 36.06293],
						[103.596318, 36.069514],
						[103.621697, 36.025922],
						[103.633322, 36.017451],
						[103.622352, 35.99444],
						[103.632831, 35.982409],
						[103.616785, 35.959284],
						[103.623989, 35.934895],
						[103.643801, 35.931336],
						[103.660993, 35.914269],
						[103.702581, 35.927253],
						[103.714697, 35.909975],
						[103.76742, 35.89039],
						[103.776425, 35.896256],
						[103.779863, 35.848166],
						[103.795909, 35.852463],
						[103.799184, 35.841039],
						[103.837334, 35.841773],
						[103.837498, 35.815985],
						[103.849614, 35.803927],
						[103.848959, 35.774979],
						[103.865005, 35.794803],
						[103.901354, 35.774979],
						[103.919855, 35.757354],
						[103.952111, 35.746756],
						[103.963736, 35.735318],
						[103.980928, 35.735737],
						[103.997956, 35.716109],
						[104.019569, 35.713589],
						[104.040036, 35.68902],
						[104.053135, 35.68608],
						[104.067543, 35.664759],
						[104.092431, 35.657615],
						[104.101436, 35.636076],
						[104.110769, 35.638178],
						[104.138931, 35.618525],
						[104.148591, 35.635025],
						[104.173151, 35.649421],
						[104.202787, 35.614111],
						[104.198039, 35.598973],
						[104.225382, 35.578575],
						[104.282198, 35.571109],
						[104.290057, 35.589616],
						[104.310196, 35.601812],
						[104.305939, 35.643327],
						[104.331809, 35.658561],
						[104.317564, 35.66791],
						[104.316746, 35.705296],
						[104.331154, 35.732379],
						[104.357351, 35.74109],
						[104.369959, 35.766692],
						[104.384695, 35.767426],
						[104.401068, 35.793964],
						[104.398612, 35.808855],
						[104.421371, 35.865456],
						[104.439055, 35.864618],
						[104.448879, 35.875619],
						[104.44282, 35.89657],
						[104.42612, 35.916154],
						[104.441019, 35.974771],
						[104.483754, 35.993708],
						[104.484572, 36.020693],
						[104.500618, 36.02017],
						[104.507331, 36.037946],
						[104.522722, 36.043696],
						[104.519284, 36.060212],
						[104.53795, 36.08404],
						[104.5612, 36.09219],
						[104.567422, 36.112456],
						[104.559399, 36.130106],
						[104.568895, 36.139296],
						[104.577246, 36.168109],
						[104.530909, 36.168005],
						[104.512571, 36.202547],
						[104.543025, 36.237699],
						[104.531728, 36.26116],
						[104.522231, 36.262098],
						[104.517155, 36.290241],
						[104.502419, 36.316083],
						[104.501764, 36.350767],
						[104.510442, 36.373153],
						[104.507168, 36.428621],
						[104.489812, 36.44256],
						[104.439382, 36.408541],
						[104.429067, 36.386581],
						[104.415477, 36.391369],
						[104.349165, 36.375547],
						[104.318055, 36.377421],
						[104.313962, 36.363887],
						[104.296279, 36.354308],
						[104.258948, 36.362221],
						[104.232095, 36.359306],
						[104.218178, 36.349622],
						[104.221453, 36.337541],
						[104.184121, 36.341915],
						[104.164965, 36.32275],
						[104.163327, 36.305351],
						[104.141551, 36.293785],
						[104.130253, 36.250942],
						[104.113389, 36.26043],
						[104.125669, 36.29837],
						[104.114371, 36.306914],
						[104.111096, 36.327438],
						[104.128616, 36.335979],
						[104.095214, 36.371696],
						[104.050024, 36.414056],
						[104.042492, 36.457224],
						[104.051825, 36.464295],
						[104.041018, 36.481243],
						[104.016622, 36.4959],
						[104.022025, 36.520634],
						[104.034141, 36.535699],
						[104.028575, 36.554292],
						[104.040855, 36.573712],
						[103.974051, 36.58451],
						[103.951456, 36.61181],
						[103.960789, 36.62582],
						[103.942123, 36.635573],
						[103.924767, 36.656217],
						[103.899225, 36.671774],
						[103.915435, 36.693238],
						[103.89726, 36.704227],
						[103.897424, 36.715629],
						[103.930662, 36.719774],
						[103.940813, 36.748684],
						[103.922639, 36.751999],
						[103.92051, 36.766812],
						[103.897097, 36.77023],
						[103.891366, 36.787731],
						[103.903482, 36.803469],
						[103.859765, 36.803676],
						[103.832422, 36.812475],
						[103.825709, 36.7985],
						[103.815066, 36.82324],
						[103.790015, 36.829657],
						[103.777244, 36.85149],
						[103.757923, 36.844247],
						[103.761853, 36.828104],
						[103.7964, 36.80378],
						[103.800494, 36.791666],
						[103.740895, 36.799328],
						[103.731234, 36.805125],
						[103.712078, 36.7839],
						[103.676875, 36.790631],
						[103.669507, 36.812889],
						[103.628246, 36.822101],
						[103.604505, 36.847248],
						[103.62317, 36.86887],
						[103.592388, 36.882419],
						[103.575196, 36.923465],
						[103.547689, 36.950025],
						[103.564881, 36.973787]
					]
				],
				[
					[
						[102.831846, 36.365345],
						[102.829718, 36.365345],
						[102.836431, 36.344623],
						[102.838887, 36.345769],
						[102.831846, 36.365345]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620200,
			"name": "嘉峪关市",
			"center": [98.277304, 39.786529],
			"centroid": [98.211266, 39.829379],
			"childrenNum": 0,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 1,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[97.862533, 39.715005],
						[97.857458, 39.711823],
						[97.855657, 39.71043],
						[97.939979, 39.695807],
						[97.969288, 39.66277],
						[98.038383, 39.698593],
						[98.157581, 39.696902],
						[98.166259, 39.713116],
						[98.188199, 39.725945],
						[98.217671, 39.727436],
						[98.246325, 39.718884],
						[98.243378, 39.707943],
						[98.281036, 39.690932],
						[98.320824, 39.665258],
						[98.33556, 39.667547],
						[98.370762, 39.654309],
						[98.381732, 39.663765],
						[98.391229, 39.690733],
						[98.413824, 39.710331],
						[98.406947, 39.731016],
						[98.361102, 39.756169],
						[98.355535, 39.78002],
						[98.456395, 39.823429],
						[98.491106, 39.840705],
						[98.484557, 39.864428],
						[98.518777, 39.892905],
						[98.520087, 39.909469],
						[98.497328, 39.916114],
						[98.497001, 39.950219],
						[98.474897, 39.969247],
						[98.444115, 39.955769],
						[98.420701, 39.955373],
						[98.392539, 39.965779],
						[98.371745, 39.957454],
						[98.329501, 39.955868],
						[98.296591, 39.962806],
						[98.162002, 39.971625],
						[98.062943, 39.99976],
						[98.068674, 39.983217],
						[98.066382, 39.954084],
						[98.024793, 39.946551],
						[98.004818, 39.922956],
						[98.036255, 39.914725],
						[97.990901, 39.891913],
						[97.98386, 39.882785],
						[98.031179, 39.827996],
						[97.99221, 39.808631],
						[97.974363, 39.780616],
						[97.862533, 39.715005]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620300,
			"name": "金昌市",
			"center": [102.187888, 38.514238],
			"centroid": [102.045658, 38.43382],
			"childrenNum": 2,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 2,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[102.071959, 38.892926],
						[102.07507, 38.891517],
						[102.00974, 38.854474],
						[101.996478, 38.842491],
						[101.941463, 38.808848],
						[101.874005, 38.733949],
						[101.775601, 38.660588],
						[101.744328, 38.679062],
						[101.731393, 38.674721],
						[101.678998, 38.690971],
						[101.64969, 38.686127],
						[101.613014, 38.655742],
						[101.591401, 38.642312],
						[101.564385, 38.608372],
						[101.567168, 38.57573],
						[101.516247, 38.548332],
						[101.538188, 38.525172],
						[101.547357, 38.498665],
						[101.533603, 38.489861],
						[101.502494, 38.487027],
						[101.503967, 38.463746],
						[101.529673, 38.462531],
						[101.518539, 38.436305],
						[101.48743, 38.412502],
						[101.447315, 38.388487],
						[101.424065, 38.394871],
						[101.372162, 38.388487],
						[101.371179, 38.37227],
						[101.35628, 38.36487],
						[101.337778, 38.369736],
						[101.34711, 38.317309],
						[101.392301, 38.316294],
						[101.403599, 38.284332],
						[101.417188, 38.273675],
						[101.467946, 38.250731],
						[101.491196, 38.228389],
						[101.478261, 38.207362],
						[101.462706, 38.201469],
						[101.419481, 38.164069],
						[101.402452, 38.132955],
						[101.403599, 38.102336],
						[101.386243, 38.071298],
						[101.419153, 38.058879],
						[101.441257, 38.040144],
						[101.481208, 38.055723],
						[101.516083, 38.061424],
						[101.576665, 38.056741],
						[101.612523, 38.059795],
						[101.636755, 38.071501],
						[101.651327, 38.090024],
						[101.690623, 38.066616],
						[101.706342, 38.091754],
						[101.740071, 38.096028],
						[101.766596, 38.07944],
						[101.812277, 38.064987],
						[101.835036, 38.075267],
						[101.855339, 38.099487],
						[101.885794, 38.103048],
						[101.945393, 38.080255],
						[101.975192, 38.085547],
						[101.986654, 38.096028],
						[102.003682, 38.094807],
						[102.015798, 38.081985],
						[102.026113, 38.043097],
						[102.040522, 38.029655],
						[102.094554, 38.034544],
						[102.10929, 38.042996],
						[102.135979, 38.045338],
						[102.162503, 38.061729],
						[102.17462, 38.050938],
						[102.185917, 38.062645],
						[102.207039, 38.055519],
						[102.218337, 38.088905],
						[102.232254, 38.109255],
						[102.223412, 38.113832],
						[102.253867, 38.12492],
						[102.305115, 38.134582],
						[102.344248, 38.146988],
						[102.388947, 38.143124],
						[102.409414, 38.130514],
						[102.409905, 38.11607],
						[102.431681, 38.110882],
						[102.447236, 38.115969],
						[102.458206, 38.134175],
						[102.519934, 38.170269],
						[102.531886, 38.184905],
						[102.557265, 38.183076],
						[102.575276, 38.173522],
						[102.612443, 38.173116],
						[102.649938, 38.158172],
						[102.678592, 38.157867],
						[102.675153, 38.188666],
						[102.706754, 38.186836],
						[102.719361, 38.19588],
						[102.723782, 38.238241],
						[102.700859, 38.277938],
						[102.686942, 38.289508],
						[102.695784, 38.335972],
						[102.693328, 38.347735],
						[102.704134, 38.396594],
						[102.700859, 38.411488],
						[102.622431, 38.417769],
						[102.572656, 38.416149],
						[102.616209, 38.470023],
						[102.536143, 38.500183],
						[102.496684, 38.545804],
						[102.478509, 38.58513],
						[102.459025, 38.595943],
						[102.447072, 38.631606],
						[102.397789, 38.665232],
						[102.408922, 38.727192],
						[102.411378, 38.773475],
						[102.439868, 38.808545],
						[102.425132, 38.877527],
						[102.412361, 38.885378],
						[102.43643, 38.918281],
						[102.376503, 38.926127],
						[102.336716, 38.940007],
						[102.283666, 38.948052],
						[102.269421, 38.913955],
						[102.144984, 38.939906],
						[102.094718, 38.960218],
						[102.087514, 38.981026],
						[101.96062, 38.996804],
						[102.071959, 38.892926]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620400,
			"name": "白银市",
			"center": [104.173606, 36.54568],
			"centroid": [104.622687, 36.618375],
			"childrenNum": 5,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 3,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.485967, 35.726396],
						[105.472704, 35.750639],
						[105.453875, 35.747596],
						[105.457313, 35.771623],
						[105.431771, 35.787566],
						[105.430625, 35.813049],
						[105.408684, 35.822275],
						[105.383961, 35.792496],
						[105.374955, 35.804346],
						[105.386253, 35.817662],
						[105.371026, 35.844288],
						[105.398369, 35.855187],
						[105.390838, 35.866504],
						[105.350232, 35.875934],
						[105.334513, 35.88641],
						[105.329274, 35.907881],
						[105.340244, 35.909242],
						[105.325017, 35.941804],
						[105.33173, 35.951434],
						[105.333203, 36.000612],
						[105.341881, 36.005947],
						[105.34401, 36.033868],
						[105.36595, 36.034705],
						[105.360383, 36.044219],
						[105.391329, 36.074844],
						[105.40803, 36.075785],
						[105.43128, 36.104099],
						[105.49137, 36.10107],
						[105.514948, 36.147335],
						[105.502013, 36.157671],
						[105.47909, 36.212875],
						[105.462062, 36.222159],
						[105.465827, 36.251985],
						[105.459769, 36.264496],
						[105.473195, 36.275546],
						[105.475324, 36.295035],
						[105.454202, 36.32275],
						[105.425713, 36.330146],
						[105.401644, 36.369926],
						[105.419491, 36.377317],
						[105.402135, 36.385124],
						[105.399515, 36.428829],
						[105.384779, 36.44048],
						[105.368242, 36.432158],
						[105.371026, 36.461696],
						[105.361365, 36.498186],
						[105.320105, 36.53601],
						[105.303895, 36.524686],
						[105.281136, 36.522608],
						[105.260178, 36.533621],
						[105.252155, 36.55315],
						[105.275897, 36.56312],
						[105.261161, 36.602677],
						[105.250027, 36.601431],
						[105.241513, 36.62582],
						[105.221865, 36.62997],
						[105.225467, 36.664515],
						[105.208602, 36.680174],
						[105.200907, 36.702154],
						[105.215315, 36.727858],
						[105.240039, 36.741432],
						[105.272294, 36.73936],
						[105.275897, 36.75231],
						[105.319613, 36.742882],
						[105.341063, 36.764741],
						[105.332712, 36.806057],
						[105.300129, 36.824171],
						[105.296691, 36.844247],
						[105.27868, 36.852628],
						[105.274587, 36.870835],
						[105.240694, 36.896793],
						[105.226285, 36.886452],
						[105.207783, 36.897516],
						[105.178966, 36.892243],
						[105.184042, 36.902376],
						[105.177656, 36.92915],
						[105.185679, 36.942068],
						[105.168651, 36.967279],
						[105.165376, 36.994856],
						[105.129355, 36.996302],
						[105.075978, 37.013132],
						[105.059605, 37.022836],
						[105.039793, 37.007247],
						[105.010976, 37.017261],
						[105.004426, 37.035429],
						[104.965294, 37.031713],
						[104.954488, 37.04028],
						[104.953833, 37.077321],
						[104.9147, 37.097846],
						[104.915519, 37.116201],
						[104.898982, 37.127129],
						[104.887521, 37.159182],
						[104.866072, 37.17134],
						[104.856411, 37.211715],
						[104.806636, 37.234675],
						[104.793701, 37.229219],
						[104.775199, 37.246821],
						[104.717238, 37.208523],
						[104.683181, 37.202962],
						[104.663697, 37.208317],
						[104.626038, 37.205846],
						[104.60066, 37.242704],
						[104.603607, 37.262463],
						[104.619816, 37.29055],
						[104.632424, 37.298882],
						[104.644376, 37.291168],
						[104.664679, 37.299602],
						[104.665989, 37.310812],
						[104.714618, 37.330348],
						[104.717729, 37.350393],
						[104.702829, 37.34546],
						[104.668281, 37.356046],
						[104.661405, 37.376598],
						[104.679907, 37.407827],
						[104.605244, 37.426208],
						[104.564802, 37.430418],
						[104.544335, 37.42323],
						[104.521085, 37.434833],
						[104.499472, 37.421177],
						[104.45068, 37.423641],
						[104.437745, 37.445817],
						[104.404834, 37.438323],
						[104.365538, 37.418096],
						[104.345071, 37.420458],
						[104.298407, 37.413988],
						[104.285309, 37.43052],
						[104.237826, 37.411935],
						[104.18363, 37.406799],
						[104.082934, 37.469321],
						[103.933609, 37.574123],
						[103.87139, 37.605781],
						[103.850269, 37.633126],
						[103.79067, 37.586317],
						[103.762671, 37.541939],
						[103.759233, 37.521843],
						[103.771513, 37.506767],
						[103.773478, 37.473836],
						[103.764472, 37.44633],
						[103.767747, 37.425489],
						[103.746953, 37.421793],
						[103.732708, 37.394782],
						[103.735983, 37.378242],
						[103.770039, 37.355018],
						[103.763654, 37.34217],
						[103.775934, 37.329731],
						[103.765127, 37.30207],
						[103.747608, 37.307418],
						[103.757596, 37.27728],
						[103.743351, 37.283555],
						[103.723048, 37.261331],
						[103.746298, 37.242806],
						[103.725013, 37.229425],
						[103.692757, 37.238277],
						[103.675565, 37.209553],
						[103.65559, 37.148568],
						[103.64642, 37.133004],
						[103.622188, 37.125479],
						[103.634304, 37.113211],
						[103.634959, 37.084851],
						[103.618586, 37.0636],
						[103.590587, 37.068759],
						[103.581418, 37.047607],
						[103.559642, 37.027275],
						[103.580927, 37.002497],
						[103.578471, 36.985974],
						[103.564881, 36.973787],
						[103.547689, 36.950025],
						[103.575196, 36.923465],
						[103.592388, 36.882419],
						[103.62317, 36.86887],
						[103.604505, 36.847248],
						[103.628246, 36.822101],
						[103.669507, 36.812889],
						[103.676875, 36.790631],
						[103.712078, 36.7839],
						[103.731234, 36.805125],
						[103.740895, 36.799328],
						[103.800494, 36.791666],
						[103.7964, 36.80378],
						[103.761853, 36.828104],
						[103.757923, 36.844247],
						[103.777244, 36.85149],
						[103.790015, 36.829657],
						[103.815066, 36.82324],
						[103.825709, 36.7985],
						[103.832422, 36.812475],
						[103.859765, 36.803676],
						[103.903482, 36.803469],
						[103.891366, 36.787731],
						[103.897097, 36.77023],
						[103.92051, 36.766812],
						[103.922639, 36.751999],
						[103.940813, 36.748684],
						[103.930662, 36.719774],
						[103.897424, 36.715629],
						[103.89726, 36.704227],
						[103.915435, 36.693238],
						[103.899225, 36.671774],
						[103.924767, 36.656217],
						[103.942123, 36.635573],
						[103.960789, 36.62582],
						[103.951456, 36.61181],
						[103.974051, 36.58451],
						[104.040855, 36.573712],
						[104.028575, 36.554292],
						[104.034141, 36.535699],
						[104.022025, 36.520634],
						[104.016622, 36.4959],
						[104.041018, 36.481243],
						[104.051825, 36.464295],
						[104.042492, 36.457224],
						[104.050024, 36.414056],
						[104.095214, 36.371696],
						[104.128616, 36.335979],
						[104.111096, 36.327438],
						[104.114371, 36.306914],
						[104.125669, 36.29837],
						[104.113389, 36.26043],
						[104.130253, 36.250942],
						[104.141551, 36.293785],
						[104.163327, 36.305351],
						[104.164965, 36.32275],
						[104.184121, 36.341915],
						[104.221453, 36.337541],
						[104.218178, 36.349622],
						[104.232095, 36.359306],
						[104.258948, 36.362221],
						[104.296279, 36.354308],
						[104.313962, 36.363887],
						[104.318055, 36.377421],
						[104.349165, 36.375547],
						[104.415477, 36.391369],
						[104.429067, 36.386581],
						[104.439382, 36.408541],
						[104.489812, 36.44256],
						[104.507168, 36.428621],
						[104.510442, 36.373153],
						[104.501764, 36.350767],
						[104.502419, 36.316083],
						[104.517155, 36.290241],
						[104.522231, 36.262098],
						[104.531728, 36.26116],
						[104.543025, 36.237699],
						[104.512571, 36.202547],
						[104.530909, 36.168005],
						[104.577246, 36.168109],
						[104.568895, 36.139296],
						[104.559399, 36.130106],
						[104.567422, 36.112456],
						[104.5612, 36.09219],
						[104.53795, 36.08404],
						[104.519284, 36.060212],
						[104.522722, 36.043696],
						[104.507331, 36.037946],
						[104.500618, 36.02017],
						[104.532383, 36.014627],
						[104.561855, 36.028013],
						[104.584941, 36.029477],
						[104.61867, 36.044846],
						[104.633242, 36.035541],
						[104.663369, 36.041501],
						[104.680725, 36.033764],
						[104.676141, 36.022994],
						[104.648797, 36.010758],
						[104.646505, 35.996533],
						[104.676959, 35.986804],
						[104.709379, 35.94955],
						[104.72788, 35.951958],
						[104.738032, 35.931754],
						[104.769305, 35.91741],
						[104.768978, 35.887457],
						[104.811385, 35.877924],
						[104.807291, 35.865875],
						[104.853628, 35.854873],
						[104.865744, 35.832444],
						[104.864762, 35.804031],
						[104.884246, 35.79344],
						[104.891941, 35.767112],
						[104.937296, 35.738256],
						[104.980358, 35.716634],
						[104.985597, 35.700361],
						[104.986743, 35.635025],
						[104.967095, 35.608435],
						[104.954979, 35.57216],
						[104.95285, 35.548179],
						[104.937132, 35.544602],
						[104.933202, 35.51293],
						[104.946465, 35.491562],
						[104.966768, 35.489983],
						[104.975446, 35.476402],
						[104.996731, 35.471347],
						[105.000333, 35.456183],
						[105.044541, 35.448916],
						[105.070738, 35.454814],
						[105.083673, 35.418575],
						[105.123461, 35.420156],
						[105.117894, 35.440278],
						[105.135413, 35.449126],
						[105.1752, 35.441858],
						[105.232998, 35.482719],
						[105.271476, 35.475138],
						[105.303404, 35.500299],
						[105.319777, 35.482824],
						[105.345483, 35.485351],
						[105.355471, 35.495668],
						[105.384288, 35.490088],
						[105.415398, 35.497457],
						[105.406065, 35.514403],
						[105.414251, 35.526821],
						[105.447326, 35.537553],
						[105.451583, 35.551124],
						[105.473687, 35.553859],
						[105.476143, 35.60034],
						[105.520678, 35.608014],
						[105.456658, 35.68902],
						[105.457313, 35.715374],
						[105.485967, 35.726396]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620500,
			"name": "天水市",
			"center": [105.724998, 34.578529],
			"centroid": [105.741074, 34.647312],
			"childrenNum": 7,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 4,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[106.488671, 35.02089],
						[106.46231, 35.040583],
						[106.446755, 35.033807],
						[106.405985, 35.035395],
						[106.382408, 35.059318],
						[106.398781, 35.083127],
						[106.370128, 35.10492],
						[106.365707, 35.13284],
						[106.330177, 35.112642],
						[106.315113, 35.120997],
						[106.302997, 35.150603],
						[106.27549, 35.171638],
						[106.211797, 35.152294],
						[106.191331, 35.162654],
						[106.177413, 35.152294],
						[106.157765, 35.12142],
						[106.147778, 35.144471],
						[106.116668, 35.122371],
						[106.087196, 35.11444],
						[106.064437, 35.123958],
						[106.018592, 35.089581],
						[106.004675, 35.090216],
						[106.006639, 35.112747],
						[105.991576, 35.120785],
						[105.961285, 35.097516],
						[105.934924, 35.096352],
						[105.92903, 35.06027],
						[105.898739, 35.063445],
						[105.887605, 35.052015],
						[105.849619, 35.058789],
						[105.844052, 35.070959],
						[105.803119, 35.074028],
						[105.784125, 35.062916],
						[105.774793, 35.024385],
						[105.75449, 35.023749],
						[105.738608, 35.047781],
						[105.725345, 35.027349],
						[105.707334, 35.044076],
						[105.706516, 35.071805],
						[105.646262, 35.104391],
						[105.635947, 35.120362],
						[105.638403, 35.139396],
						[105.609094, 35.152929],
						[105.572418, 35.181361],
						[105.558173, 35.1821],
						[105.558501, 35.161385],
						[105.539508, 35.152717],
						[105.535578, 35.138762],
						[105.559974, 35.127659],
						[105.541636, 35.07244],
						[105.52428, 35.063339],
						[105.505615, 35.085561],
						[105.484984, 35.093178],
						[105.456495, 35.130831],
						[105.42031, 35.114334],
						[105.41114, 35.079424],
						[105.396568, 35.089475],
						[105.391656, 35.064927],
						[105.379867, 35.072017],
						[105.354489, 35.04831],
						[105.336478, 35.049369],
						[105.321415, 35.03836],
						[105.297346, 35.046722],
						[105.299147, 35.01962],
						[105.290141, 35.006806],
						[105.27606, 35.033596],
						[105.261816, 35.028196],
						[105.249699, 35.00956],
						[105.259851, 34.979797],
						[105.254611, 34.964646],
						[105.217771, 34.93211],
						[105.192884, 34.937516],
						[105.193539, 34.954897],
						[105.16816, 34.969308],
						[105.130501, 34.963904],
						[105.092515, 34.969096],
						[105.058131, 34.981915],
						[105.073686, 34.955639],
						[105.070738, 34.943452],
						[105.035372, 34.925432],
						[105.007865, 34.928718],
						[105.006391, 34.939636],
						[104.970042, 34.940484],
						[104.971352, 34.953202],
						[104.933694, 34.93635],
						[104.920922, 34.950022],
						[104.898818, 34.924584],
						[104.909788, 34.903909],
						[104.895871, 34.862439],
						[104.878679, 34.856073],
						[104.850189, 34.865833],
						[104.794356, 34.869334],
						[104.757844, 34.86212],
						[104.740979, 34.85289],
						[104.728863, 34.86212],
						[104.697262, 34.859574],
						[104.657803, 34.872304],
						[104.620144, 34.86456],
						[104.598858, 34.838883],
						[104.597385, 34.804387],
						[104.584286, 34.787292],
						[104.584777, 34.767221],
						[104.60639, 34.745763],
						[104.591818, 34.726106],
						[104.577246, 34.721218],
						[104.601642, 34.710058],
						[104.589362, 34.699535],
						[104.601642, 34.679017],
						[104.595584, 34.654027],
						[104.646177, 34.655941],
						[104.699555, 34.6737],
						[104.685965, 34.628497],
						[104.690877, 34.618176],
						[104.671556, 34.575816],
						[104.695952, 34.544725],
						[104.716255, 34.541423],
						[104.738523, 34.555587],
						[104.753914, 34.52747],
						[104.748347, 34.472914],
						[104.783222, 34.487089],
						[104.793046, 34.482293],
						[104.791573, 34.431866],
						[104.837909, 34.445622],
						[104.88572, 34.422908],
						[104.918139, 34.438691],
						[104.966768, 34.437198],
						[104.989035, 34.425574],
						[105.013104, 34.420455],
						[105.038974, 34.423441],
						[105.06861, 34.44189],
						[105.084001, 34.460548],
						[105.108725, 34.460975],
						[105.128373, 34.508401],
						[105.160792, 34.527364],
						[105.20631, 34.518948],
						[105.227759, 34.533009],
						[105.243969, 34.528429],
						[105.24053, 34.512343],
						[105.254284, 34.49977],
						[105.260342, 34.452979],
						[105.290633, 34.439331],
						[105.291615, 34.428667],
						[105.312082, 34.43048],
						[105.31159, 34.442423],
						[105.350887, 34.43144],
						[105.384943, 34.408615],
						[105.408193, 34.420988],
						[105.460261, 34.391653],
						[105.491861, 34.352166],
						[105.501521, 34.328786],
						[105.522807, 34.304972],
						[105.546384, 34.319496],
						[105.558009, 34.306788],
						[105.547039, 34.291621],
						[105.527391, 34.28457],
						[105.530338, 34.273245],
						[105.554899, 34.258072],
						[105.540163, 34.248668],
						[105.555226, 34.197245],
						[105.547858, 34.152745],
						[105.563085, 34.137229],
						[105.552606, 34.113682],
						[105.563576, 34.086381],
						[105.591739, 34.084453],
						[105.596978, 34.105868],
						[105.623994, 34.096232],
						[105.61548, 34.081348],
						[105.640859, 34.081241],
						[105.651665, 34.119034],
						[105.667711, 34.144613],
						[105.704715, 34.162054],
						[105.718141, 34.158844],
						[105.72338, 34.174035],
						[105.740409, 34.176602],
						[105.771027, 34.164407],
						[105.772664, 34.136694],
						[105.781997, 34.11957],
						[105.815235, 34.147502],
						[105.86108, 34.15328],
						[105.86501, 34.125136],
						[105.90316, 34.119034],
						[105.945076, 34.144185],
						[105.9716, 34.146111],
						[106.017773, 34.159058],
						[106.041351, 34.158737],
						[106.071805, 34.146646],
						[106.082121, 34.124814],
						[106.100622, 34.125457],
						[106.117323, 34.111434],
						[106.139755, 34.113575],
						[106.14876, 34.124279],
						[106.189693, 34.110471],
						[106.229972, 34.118071],
						[106.246836, 34.132199],
						[106.244708, 34.152638],
						[106.266648, 34.161412],
						[106.276963, 34.191256],
						[106.270742, 34.206869],
						[106.282039, 34.225472],
						[106.323627, 34.230497],
						[106.330177, 34.203447],
						[106.344585, 34.179277],
						[106.327393, 34.140868],
						[106.336562, 34.109829],
						[106.363087, 34.100622],
						[106.402874, 34.109829],
						[106.453959, 34.135517],
						[106.472298, 34.154885],
						[106.475081, 34.180025],
						[106.494238, 34.201415],
						[106.494238, 34.241827],
						[106.49653, 34.25508],
						[106.526493, 34.291941],
						[106.577087, 34.280938],
						[106.586747, 34.257431],
						[106.602466, 34.250912],
						[106.633575, 34.259889],
						[106.663866, 34.24311],
						[106.684169, 34.259996],
						[106.701197, 34.290125],
						[106.704635, 34.30871],
						[106.690227, 34.334018],
						[106.711021, 34.344374],
						[106.717407, 34.369244],
						[106.697267, 34.370631],
						[106.680075, 34.383757],
						[106.663375, 34.380982],
						[106.637341, 34.391973],
						[106.621786, 34.420455],
						[106.611798, 34.452766],
						[106.591659, 34.456604],
						[106.599355, 34.465985],
						[106.567918, 34.474832],
						[106.552363, 34.48922],
						[106.515196, 34.497213],
						[106.513886, 34.512875],
						[106.453959, 34.531305],
						[106.407787, 34.523103],
						[106.399927, 34.510105],
						[106.380443, 34.521292],
						[106.366034, 34.512343],
						[106.334434, 34.517883],
						[106.343767, 34.53663],
						[106.340983, 34.568044],
						[106.313967, 34.578797],
						[106.323136, 34.589868],
						[106.368163, 34.610302],
						[106.378314, 34.623815],
						[106.4145, 34.638178],
						[106.425306, 34.654346],
						[106.44872, 34.636476],
						[106.467222, 34.640943],
						[106.470496, 34.654133],
						[106.445609, 34.669447],
						[106.441352, 34.681675],
						[106.45969, 34.705594],
						[106.48687, 34.71516],
						[106.505863, 34.746932],
						[106.539592, 34.745657],
						[106.548597, 34.761697],
						[106.574958, 34.770088],
						[106.578397, 34.788991],
						[106.565789, 34.796636],
						[106.55089, 34.829544],
						[106.555965, 34.861272],
						[106.520599, 34.885245],
						[106.510284, 34.925114],
						[106.493092, 34.94112],
						[106.483104, 34.980114],
						[106.502097, 34.99558],
						[106.488671, 35.02089]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620600,
			"name": "武威市",
			"center": [102.634697, 37.929996],
			"centroid": [103.059993, 38.183694],
			"childrenNum": 4,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 5,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[103.564881, 36.973787],
						[103.578471, 36.985974],
						[103.580927, 37.002497],
						[103.559642, 37.027275],
						[103.581418, 37.047607],
						[103.590587, 37.068759],
						[103.618586, 37.0636],
						[103.634959, 37.084851],
						[103.634304, 37.113211],
						[103.622188, 37.125479],
						[103.64642, 37.133004],
						[103.65559, 37.148568],
						[103.675565, 37.209553],
						[103.692757, 37.238277],
						[103.725013, 37.229425],
						[103.746298, 37.242806],
						[103.723048, 37.261331],
						[103.743351, 37.283555],
						[103.757596, 37.27728],
						[103.747608, 37.307418],
						[103.765127, 37.30207],
						[103.775934, 37.329731],
						[103.763654, 37.34217],
						[103.770039, 37.355018],
						[103.735983, 37.378242],
						[103.732708, 37.394782],
						[103.746953, 37.421793],
						[103.767747, 37.425489],
						[103.764472, 37.44633],
						[103.773478, 37.473836],
						[103.771513, 37.506767],
						[103.759233, 37.521843],
						[103.762671, 37.541939],
						[103.79067, 37.586317],
						[103.850269, 37.633126],
						[103.840936, 37.647459],
						[103.683261, 37.777973],
						[103.669998, 37.786659],
						[103.628246, 37.797592],
						[103.401803, 37.862031],
						[103.385429, 37.947012],
						[103.368237, 37.985645],
						[103.371676, 38.008265],
						[103.362343, 38.041366],
						[103.368728, 38.088905],
						[103.48105, 38.135701],
						[103.507738, 38.142209],
						[103.534918, 38.156749],
						[103.507902, 38.280881],
						[103.465331, 38.353109],
						[103.416375, 38.405004],
						[103.574378, 38.489861],
						[103.859765, 38.644533],
						[103.980928, 38.814187],
						[104.011546, 38.859105],
						[104.044457, 38.895039],
						[104.108477, 38.916772],
						[104.167912, 38.940409],
						[104.196401, 38.988262],
						[104.190998, 39.042209],
						[104.207372, 39.083671],
						[104.177572, 39.152185],
						[104.047568, 39.297719],
						[104.073274, 39.351829],
						[104.090957, 39.418483],
						[104.082443, 39.422479],
						[103.965046, 39.455231],
						[103.853707, 39.46142],
						[103.824071, 39.45573],
						[103.729106, 39.430069],
						[103.595336, 39.386713],
						[103.511504, 39.371322],
						[103.473518, 39.359227],
						[103.428819, 39.353528],
						[103.35694, 39.33663],
						[103.339911, 39.327529],
						[103.257881, 39.26299],
						[103.187967, 39.215424],
						[103.133116, 39.19268],
						[103.082195, 39.159203],
						[103.051249, 39.129923],
						[103.013427, 39.101132],
						[102.947115, 39.106851],
						[102.896521, 39.116281],
						[102.765698, 39.144564],
						[102.6167, 39.171734],
						[102.583462, 39.180755],
						[102.537944, 39.209713],
						[102.453622, 39.255282],
						[102.35489, 39.232051],
						[102.280719, 39.190275],
						[102.197706, 39.171934],
						[102.072777, 39.146971],
						[102.008103, 39.12581],
						[101.897583, 39.111064],
						[101.830943, 39.094007],
						[101.926236, 39.000622],
						[101.955053, 38.986051],
						[102.003191, 38.945035],
						[102.045761, 38.904699],
						[102.071959, 38.892926],
						[101.96062, 38.996804],
						[102.087514, 38.981026],
						[102.094718, 38.960218],
						[102.144984, 38.939906],
						[102.269421, 38.913955],
						[102.283666, 38.948052],
						[102.336716, 38.940007],
						[102.376503, 38.926127],
						[102.43643, 38.918281],
						[102.412361, 38.885378],
						[102.425132, 38.877527],
						[102.439868, 38.808545],
						[102.411378, 38.773475],
						[102.408922, 38.727192],
						[102.397789, 38.665232],
						[102.447072, 38.631606],
						[102.459025, 38.595943],
						[102.478509, 38.58513],
						[102.496684, 38.545804],
						[102.536143, 38.500183],
						[102.616209, 38.470023],
						[102.572656, 38.416149],
						[102.622431, 38.417769],
						[102.700859, 38.411488],
						[102.704134, 38.396594],
						[102.693328, 38.347735],
						[102.695784, 38.335972],
						[102.686942, 38.289508],
						[102.700859, 38.277938],
						[102.723782, 38.238241],
						[102.719361, 38.19588],
						[102.706754, 38.186836],
						[102.675153, 38.188666],
						[102.678592, 38.157867],
						[102.649938, 38.158172],
						[102.612443, 38.173116],
						[102.575276, 38.173522],
						[102.557265, 38.183076],
						[102.531886, 38.184905],
						[102.519934, 38.170269],
						[102.458206, 38.134175],
						[102.447236, 38.115969],
						[102.431681, 38.110882],
						[102.409905, 38.11607],
						[102.409414, 38.130514],
						[102.388947, 38.143124],
						[102.344248, 38.146988],
						[102.305115, 38.134582],
						[102.253867, 38.12492],
						[102.223412, 38.113832],
						[102.232254, 38.109255],
						[102.218337, 38.088905],
						[102.207039, 38.055519],
						[102.185917, 38.062645],
						[102.17462, 38.050938],
						[102.162503, 38.061729],
						[102.135979, 38.045338],
						[102.10929, 38.042996],
						[102.094554, 38.034544],
						[102.097501, 38.032303],
						[102.108471, 38.026091],
						[102.110109, 38.011932],
						[102.132049, 38.005514],
						[102.169217, 38.004801],
						[102.166597, 37.99451],
						[102.137616, 37.982792],
						[102.090788, 37.955882],
						[102.031517, 37.941608],
						[102.036265, 37.933349],
						[102.07507, 37.929065],
						[102.087514, 37.920498],
						[102.116986, 37.917744],
						[102.129266, 37.903361],
						[102.122061, 37.888158],
						[102.151533, 37.851312],
						[102.168398, 37.84437],
						[102.202454, 37.854477],
						[102.197706, 37.841102],
						[102.15972, 37.819657],
						[102.15137, 37.78809],
						[102.122225, 37.77082],
						[102.095864, 37.728802],
						[102.079327, 37.709881],
						[102.079163, 37.693616],
						[102.052966, 37.682463],
						[102.049691, 37.639576],
						[102.035283, 37.627699],
						[102.070158, 37.601377],
						[102.066392, 37.590108],
						[102.089642, 37.578837],
						[102.101595, 37.582423],
						[102.106998, 37.564285],
						[102.130903, 37.54686],
						[102.118132, 37.531584],
						[102.122225, 37.515895],
						[102.103396, 37.492817],
						[102.106507, 37.481326],
						[102.125172, 37.485533],
						[102.176585, 37.458853],
						[102.197379, 37.420561],
						[102.248791, 37.411524],
						[102.271223, 37.39283],
						[102.30004, 37.391289],
						[102.298893, 37.370022],
						[102.341137, 37.348029],
						[102.368317, 37.327675],
						[102.393531, 37.325002],
						[102.428243, 37.308344],
						[102.419238, 37.296002],
						[102.453622, 37.27121],
						[102.461481, 37.246512],
						[102.479983, 37.241057],
						[102.489807, 37.223659],
						[102.533196, 37.217276],
						[102.579533, 37.172473],
						[102.600982, 37.174328],
						[102.62767, 37.126098],
						[102.637331, 37.121974],
						[102.642079, 37.099702],
						[102.583626, 37.105374],
						[102.577241, 37.098465],
						[102.531886, 37.08743],
						[102.497993, 37.090421],
						[102.488497, 37.078559],
						[102.498976, 37.058442],
						[102.494228, 37.043789],
						[102.505525, 37.023559],
						[102.467212, 36.988556],
						[102.467375, 36.976575],
						[102.450347, 36.968518],
						[102.467867, 36.954365],
						[102.498485, 36.956224],
						[102.499795, 36.943515],
						[102.5237, 36.939795],
						[102.527793, 36.927703],
						[102.560867, 36.919537],
						[102.570691, 36.8879],
						[102.595579, 36.871455],
						[102.637494, 36.853663],
						[102.658125, 36.823861],
						[102.704461, 36.792184],
						[102.720671, 36.770023],
						[102.731477, 36.762358],
						[102.715268, 36.745576],
						[102.684977, 36.743918],
						[102.666475, 36.707648],
						[102.688743, 36.684218],
						[102.730659, 36.672811],
						[102.772575, 36.673434],
						[102.778142, 36.691579],
						[102.756856, 36.717598],
						[102.778305, 36.761737],
						[102.807614, 36.773544],
						[102.813508, 36.762773],
						[102.833156, 36.762358],
						[102.84298, 36.77458],
						[102.822677, 36.794876],
						[102.846255, 36.808645],
						[102.810397, 36.841143],
						[102.843471, 36.845179],
						[102.863447, 36.838142],
						[102.877855, 36.856042],
						[102.902415, 36.865146],
						[102.903398, 36.878695],
						[102.883095, 36.901342],
						[102.919607, 36.935454],
						[102.954974, 36.92884],
						[102.975932, 36.947855],
						[103.004421, 36.946925],
						[103.068114, 36.959737],
						[103.074336, 36.945272],
						[103.128695, 36.951678],
						[103.180271, 36.945685],
						[103.176833, 36.932974],
						[103.201393, 36.92977],
						[103.206141, 36.941242],
						[103.230537, 36.937211],
						[103.258208, 36.958704],
						[103.276219, 36.954158],
						[103.248057, 36.916643],
						[103.26574, 36.907959],
						[103.281131, 36.915196],
						[103.313223, 36.907132],
						[103.347607, 36.916126],
						[103.348425, 36.895862],
						[103.380353, 36.878902],
						[103.377897, 36.853352],
						[103.399019, 36.826034],
						[103.450759, 36.831209],
						[103.472535, 36.861732],
						[103.47319, 36.874248],
						[103.518053, 36.849938],
						[103.541631, 36.878799],
						[103.519691, 36.902686],
						[103.501353, 36.895448],
						[103.499879, 36.913335],
						[103.479576, 36.940208],
						[103.455998, 36.935868],
						[103.44159, 36.950542],
						[103.407861, 36.923465],
						[103.383464, 36.920364],
						[103.368237, 36.907856],
						[103.348589, 36.926773],
						[103.348098, 36.958291],
						[103.323702, 36.946718],
						[103.309457, 36.949818],
						[103.317152, 36.986697],
						[103.359396, 36.996715],
						[103.404586, 36.999193],
						[103.440607, 36.995992],
						[103.450104, 36.981946],
						[103.483669, 36.966452],
						[103.511832, 36.961493],
						[103.528532, 36.970481],
						[103.564881, 36.973787]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620700,
			"name": "张掖市",
			"center": [100.455472, 38.932897],
			"centroid": [99.818538, 38.961729],
			"childrenNum": 6,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 6,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[102.035283, 37.627699],
						[102.049691, 37.639576],
						[102.052966, 37.682463],
						[102.079163, 37.693616],
						[102.079327, 37.709881],
						[102.095864, 37.728802],
						[102.122225, 37.77082],
						[102.15137, 37.78809],
						[102.15972, 37.819657],
						[102.197706, 37.841102],
						[102.202454, 37.854477],
						[102.168398, 37.84437],
						[102.151533, 37.851312],
						[102.122061, 37.888158],
						[102.129266, 37.903361],
						[102.116986, 37.917744],
						[102.087514, 37.920498],
						[102.07507, 37.929065],
						[102.036265, 37.933349],
						[102.031517, 37.941608],
						[102.090788, 37.955882],
						[102.137616, 37.982792],
						[102.166597, 37.99451],
						[102.169217, 38.004801],
						[102.132049, 38.005514],
						[102.110109, 38.011932],
						[102.108471, 38.026091],
						[102.097501, 38.032303],
						[102.094554, 38.034544],
						[102.040522, 38.029655],
						[102.026113, 38.043097],
						[102.015798, 38.081985],
						[102.003682, 38.094807],
						[101.986654, 38.096028],
						[101.975192, 38.085547],
						[101.945393, 38.080255],
						[101.885794, 38.103048],
						[101.855339, 38.099487],
						[101.835036, 38.075267],
						[101.812277, 38.064987],
						[101.766596, 38.07944],
						[101.740071, 38.096028],
						[101.706342, 38.091754],
						[101.690623, 38.066616],
						[101.651327, 38.090024],
						[101.636755, 38.071501],
						[101.612523, 38.059795],
						[101.576665, 38.056741],
						[101.516083, 38.061424],
						[101.481208, 38.055723],
						[101.441257, 38.040144],
						[101.419153, 38.058879],
						[101.386243, 38.071298],
						[101.403599, 38.102336],
						[101.402452, 38.132955],
						[101.419481, 38.164069],
						[101.462706, 38.201469],
						[101.478261, 38.207362],
						[101.491196, 38.228389],
						[101.467946, 38.250731],
						[101.417188, 38.273675],
						[101.403599, 38.284332],
						[101.392301, 38.316294],
						[101.34711, 38.317309],
						[101.337778, 38.369736],
						[101.35628, 38.36487],
						[101.371179, 38.37227],
						[101.372162, 38.388487],
						[101.424065, 38.394871],
						[101.447315, 38.388487],
						[101.48743, 38.412502],
						[101.518539, 38.436305],
						[101.529673, 38.462531],
						[101.503967, 38.463746],
						[101.502494, 38.487027],
						[101.533603, 38.489861],
						[101.547357, 38.498665],
						[101.538188, 38.525172],
						[101.516247, 38.548332],
						[101.567168, 38.57573],
						[101.564385, 38.608372],
						[101.591401, 38.642312],
						[101.613014, 38.655742],
						[101.601716, 38.655136],
						[101.56242, 38.712968],
						[101.487266, 38.736471],
						[101.412276, 38.7642],
						[101.331228, 38.777305],
						[101.316656, 38.783756],
						[101.306341, 38.801895],
						[101.330082, 38.807739],
						[101.34138, 38.822246],
						[101.334012, 38.848533],
						[101.259677, 38.855078],
						[101.239865, 38.86575],
						[101.237736, 38.907315],
						[101.198604, 38.943225],
						[101.228567, 39.020715],
						[101.117229, 38.975196],
						[100.969213, 38.946945],
						[100.969377, 38.996703],
						[100.961518, 39.006048],
						[100.901755, 39.030057],
						[100.888984, 39.007254],
						[100.875394, 39.002431],
						[100.835116, 39.026039],
						[100.829549, 39.035581],
						[100.829385, 39.074939],
						[100.864424, 39.106951],
						[100.865734, 39.124707],
						[100.85329, 39.151684],
						[100.842811, 39.200095],
						[100.842156, 39.405697],
						[100.707895, 39.404598],
						[100.658775, 39.392009],
						[100.61997, 39.387612],
						[100.56954, 39.395107],
						[100.499135, 39.400502],
						[100.500608, 39.481382],
						[100.443301, 39.485573],
						[100.326232, 39.509119],
						[100.301017, 39.572335],
						[100.314116, 39.606909],
						[100.250096, 39.685062],
						[100.127951, 39.702174],
						[100.040681, 39.757063],
						[99.95865, 39.769487],
						[99.904454, 39.785783],
						[99.821933, 39.860061],
						[99.712067, 39.877626],
						[99.672608, 39.888044],
						[99.48808, 39.876038],
						[99.455988, 39.877427],
						[99.35873, 39.86681],
						[99.320581, 39.847753],
						[99.247719, 39.838024],
						[99.229872, 39.851624],
						[99.206295, 39.829982],
						[99.193196, 39.809128],
						[99.140965, 39.80148],
						[99.113785, 39.835046],
						[99.083331, 39.837329],
						[99.06925, 39.850136],
						[99.026843, 39.854007],
						[98.987055, 39.832762],
						[98.960039, 39.788565],
						[98.94956, 39.701478],
						[98.94956, 39.66496],
						[98.881447, 39.665457],
						[98.824632, 39.676405],
						[98.804492, 39.627028],
						[98.816118, 39.592065],
						[98.872114, 39.594058],
						[98.938099, 39.577916],
						[98.946613, 39.594955],
						[98.977886, 39.619559],
						[99.025205, 39.629617],
						[99.053695, 39.623144],
						[99.064665, 39.609997],
						[99.056478, 39.587681],
						[99.072852, 39.554891],
						[99.097575, 39.530763],
						[99.10609, 39.514107],
						[99.135234, 39.503633],
						[99.183372, 39.475394],
						[99.23593, 39.458426],
						[99.256233, 39.427472],
						[99.308137, 39.357527],
						[99.30519, 39.33313],
						[99.293073, 39.30012],
						[99.280793, 39.289113],
						[99.207277, 39.283809],
						[99.198927, 39.275903],
						[99.213663, 39.226642],
						[99.207113, 39.205706],
						[99.176331, 39.171634],
						[99.179115, 39.181556],
						[99.143585, 39.208211],
						[99.141292, 39.24607],
						[99.120498, 39.261088],
						[99.080711, 39.267795],
						[99.060244, 39.257885],
						[99.046491, 39.285511],
						[99.023568, 39.30032],
						[98.985418, 39.312926],
						[98.975758, 39.33073],
						[98.906498, 39.33253],
						[98.902078, 39.316527],
						[98.880956, 39.33003],
						[98.866547, 39.324229],
						[98.838713, 39.34423],
						[98.800235, 39.360426],
						[98.752589, 39.389811],
						[98.72852, 39.399203],
						[98.710509, 39.414788],
						[98.660407, 39.43646],
						[98.612269, 39.444548],
						[98.57019, 39.460622],
						[98.579686, 39.481981],
						[98.553325, 39.470204],
						[98.526473, 39.467509],
						[98.515503, 39.480384],
						[98.530566, 39.486771],
						[98.549723, 39.509718],
						[98.434127, 39.577517],
						[98.410058, 39.550904],
						[98.402035, 39.514406],
						[98.396632, 39.535549],
						[98.362412, 39.542629],
						[98.330156, 39.569544],
						[98.357009, 39.630315],
						[98.370762, 39.654309],
						[98.33556, 39.667547],
						[98.320824, 39.665258],
						[98.281036, 39.690932],
						[98.243378, 39.707943],
						[98.246325, 39.718884],
						[98.217671, 39.727436],
						[98.188199, 39.725945],
						[98.166259, 39.713116],
						[98.157581, 39.696902],
						[98.038383, 39.698593],
						[97.969288, 39.66277],
						[97.939979, 39.695807],
						[97.855657, 39.71043],
						[97.828968, 39.68536],
						[97.785579, 39.680684],
						[97.700273, 39.697101],
						[97.676532, 39.679092],
						[97.656229, 39.632007],
						[97.619062, 39.630613],
						[97.585333, 39.603124],
						[97.569942, 39.564162],
						[97.557825, 39.554094],
						[97.520494, 39.53874],
						[97.480216, 39.472999],
						[97.480543, 39.406396],
						[97.477268, 39.373221],
						[97.453855, 39.352229],
						[97.429295, 39.347429],
						[97.397039, 39.318027],
						[97.402115, 39.293016],
						[97.395074, 39.240363],
						[97.426347, 39.173738],
						[97.43306, 39.126011],
						[97.458767, 39.118087],
						[97.504939, 39.076545],
						[97.543417, 39.067209],
						[97.581403, 39.052351],
						[97.620208, 39.031764],
						[97.679152, 39.010268],
						[97.695034, 38.988765],
						[97.690449, 38.9759],
						[97.701583, 38.963334],
						[97.735967, 38.958106],
						[97.749721, 38.94956],
						[97.793274, 38.942923],
						[97.828968, 38.93005],
						[97.875796, 38.898259],
						[97.90887, 38.884472],
						[97.95537, 38.873702],
						[97.971907, 38.863334],
						[98.012022, 38.858098],
						[98.027741, 38.835542],
						[98.050991, 38.819224],
						[98.062452, 38.819728],
						[98.095035, 38.786276],
						[98.117303, 38.805623],
						[98.152342, 38.820131],
						[98.167733, 38.840175],
						[98.203427, 38.856588],
						[98.251237, 38.891215],
						[98.249763, 38.911842],
						[98.236173, 38.920896],
						[98.270066, 38.954587],
						[98.287586, 38.992181],
						[98.281036, 39.027044],
						[98.292334, 39.037991],
						[98.316894, 39.040502],
						[98.384025, 39.029354],
						[98.401053, 39.001527],
						[98.43249, 38.9961],
						[98.428233, 38.976],
						[98.457541, 38.952979],
						[98.526473, 38.955593],
						[98.550542, 38.949359],
						[98.572973, 38.932363],
						[98.590165, 38.933168],
						[98.597697, 38.947649],
						[98.614889, 38.947348],
						[98.624058, 38.959212],
						[98.614562, 38.980523],
						[98.663354, 38.994493],
						[98.691844, 39.020816],
						[98.705434, 39.043314],
						[98.730485, 39.05717],
						[98.743747, 39.086882],
						[98.759793, 39.090294],
						[98.81317, 39.087685],
						[98.817755, 39.066507],
						[98.857215, 39.047531],
						[98.887178, 39.039196],
						[98.902896, 39.012578],
						[98.94956, 38.988463],
						[98.984108, 38.984845],
						[98.993277, 38.977407],
						[99.013908, 38.984644],
						[99.056478, 38.975598],
						[99.065484, 38.96263],
						[99.108873, 38.946342],
						[99.062045, 38.911641],
						[99.068758, 38.897052],
						[99.110674, 38.867965],
						[99.141292, 38.852762],
						[99.169291, 38.827283],
						[99.222177, 38.788896],
						[99.257707, 38.781639],
						[99.290945, 38.765914],
						[99.362169, 38.718214],
						[99.371502, 38.690567],
						[99.412435, 38.665535],
						[99.426189, 38.647361],
						[99.432247, 38.623425],
						[99.450912, 38.604431],
						[99.496103, 38.612918],
						[99.514277, 38.597661],
						[99.514114, 38.568452],
						[99.529013, 38.546107],
						[99.548661, 38.534275],
						[99.555702, 38.520418],
						[99.585338, 38.498564],
						[99.63937, 38.474578],
						[99.659673, 38.449167],
						[99.679157, 38.436609],
						[99.715342, 38.425164],
						[99.73499, 38.412603],
						[99.75824, 38.410475],
						[99.830774, 38.368621],
						[99.909203, 38.343375],
						[99.937201, 38.34155],
						[99.959796, 38.320656],
						[100.001712, 38.314975],
						[100.050177, 38.283215],
						[100.071463, 38.284535],
						[100.099133, 38.270325],
						[100.116162, 38.254183],
						[100.127951, 38.230624],
						[100.160206, 38.217013],
						[100.183129, 38.222397],
						[100.180509, 38.245451],
						[100.169211, 38.262001],
						[100.157914, 38.310511],
						[100.164627, 38.327452],
						[100.135646, 38.33516],
						[100.116653, 38.35027],
						[100.111414, 38.377338],
						[100.091602, 38.408449],
						[100.047885, 38.421518],
						[100.047557, 38.430229],
						[100.022015, 38.432558],
						[100.025945, 38.451293],
						[100.001221, 38.466986],
						[100.025781, 38.507974],
						[100.064095, 38.518597],
						[100.090128, 38.49229],
						[100.112232, 38.497248],
						[100.12615, 38.485206],
						[100.151364, 38.478323],
						[100.164791, 38.460507],
						[100.205069, 38.456254],
						[100.241254, 38.43985],
						[100.259592, 38.366391],
						[100.274001, 38.379163],
						[100.300853, 38.389095],
						[100.331308, 38.337493],
						[100.318209, 38.328365],
						[100.359797, 38.307874],
						[100.373715, 38.309091],
						[100.396637, 38.293262],
						[100.424145, 38.307163],
						[100.435278, 38.301279],
						[100.437243, 38.26799],
						[100.461148, 38.265858],
						[100.474411, 38.288696],
						[100.496515, 38.273675],
						[100.520584, 38.271035],
						[100.546617, 38.246872],
						[100.574452, 38.251442],
						[100.595082, 38.242303],
						[100.618987, 38.265757],
						[100.673838, 38.256214],
						[100.686282, 38.249614],
						[100.714935, 38.253574],
						[100.751775, 38.238749],
						[100.780265, 38.213559],
						[100.789107, 38.193543],
						[100.810064, 38.181247],
						[100.822017, 38.161934],
						[100.843794, 38.149123],
						[100.860494, 38.148412],
						[100.911743, 38.179214],
						[100.938104, 38.160409],
						[100.925005, 38.14892],
						[100.916164, 38.115053],
						[100.922713, 38.085547],
						[100.894878, 38.063256],
						[100.887347, 38.049614],
						[100.89668, 38.029757],
						[100.894715, 38.013562],
						[100.917965, 37.999707],
						[100.964138, 38.011015],
						[100.980347, 38.006838],
						[100.997539, 37.988396],
						[101.020953, 37.975454],
						[101.034543, 37.976575],
						[101.077114, 37.941812],
						[101.102984, 37.946503],
						[101.114281, 37.920192],
						[101.130818, 37.913664],
						[101.152268, 37.891117],
						[101.150794, 37.877749],
						[101.172734, 37.860908],
						[101.202697, 37.847535],
						[101.23921, 37.843144],
						[101.258531, 37.832831],
						[101.279161, 37.836712],
						[101.319931, 37.811281],
						[101.362338, 37.791257],
						[101.376746, 37.801066],
						[101.382641, 37.82221],
						[101.402944, 37.831708],
						[101.443222, 37.868155],
						[101.482846, 37.853558],
						[101.500365, 37.857948],
						[101.542608, 37.838958],
						[101.598278, 37.827419],
						[101.619072, 37.809851],
						[101.640685, 37.775827],
						[101.67032, 37.754261],
						[101.659187, 37.733301],
						[101.791811, 37.696071],
						[101.813587, 37.681644],
						[101.816043, 37.654318],
						[101.854357, 37.664656],
						[101.872368, 37.685737],
						[101.90888, 37.703641],
						[101.946375, 37.728086],
						[101.999097, 37.725018],
						[102.033481, 37.6885],
						[102.0343, 37.667522],
						[102.047399, 37.654318],
						[102.035283, 37.627699]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620800,
			"name": "平凉市",
			"center": [106.684691, 35.54279],
			"centroid": [106.651661, 35.305521],
			"childrenNum": 7,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 7,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[106.083103, 35.421842],
						[106.072951, 35.420788],
						[106.067876, 35.436065],
						[106.072951, 35.447546],
						[106.072133, 35.463555],
						[106.053958, 35.454709],
						[106.034474, 35.469241],
						[106.017282, 35.463766],
						[106.00402, 35.439014],
						[105.965542, 35.425635],
						[105.930667, 35.425846],
						[105.894646, 35.413834],
						[105.889734, 35.439436],
						[105.897593, 35.451549],
						[105.925591, 35.450812],
						[105.988465, 35.475559],
						[106.048555, 35.489036],
						[106.047736, 35.498089],
						[106.020557, 35.493878],
						[106.016136, 35.522191],
						[105.913311, 35.539657],
						[105.902832, 35.547337],
						[105.868612, 35.539973],
						[105.862063, 35.515035],
						[105.846999, 35.49051],
						[105.83652, 35.494826],
						[105.834719, 35.541025],
						[105.816381, 35.575105],
						[105.798207, 35.565745],
						[105.777576, 35.586777],
						[105.785763, 35.591929],
						[105.762185, 35.602968],
						[105.759074, 35.634395],
						[105.742046, 35.626303],
						[105.744011, 35.639964],
						[105.714702, 35.647004],
						[105.722889, 35.673477],
						[105.704224, 35.68587],
						[105.69047, 35.683979],
						[105.723708, 35.725871],
						[105.728456, 35.699626],
						[105.737625, 35.697421],
						[105.758911, 35.725032],
						[105.734842, 35.724402],
						[105.707826, 35.737941],
						[105.679827, 35.737626],
						[105.668857, 35.750009],
						[105.595668, 35.715584],
						[105.570126, 35.716319],
						[105.575038, 35.701306],
						[105.564395, 35.687655],
						[105.561284, 35.724612],
						[105.530175, 35.726921],
						[105.509381, 35.718943],
						[105.485967, 35.726396],
						[105.457313, 35.715374],
						[105.456658, 35.68902],
						[105.520678, 35.608014],
						[105.476143, 35.60034],
						[105.473687, 35.553859],
						[105.451583, 35.551124],
						[105.447326, 35.537553],
						[105.414251, 35.526821],
						[105.406065, 35.514403],
						[105.415398, 35.497457],
						[105.384288, 35.490088],
						[105.355471, 35.495668],
						[105.345483, 35.485351],
						[105.383797, 35.458921],
						[105.393457, 35.425003],
						[105.404427, 35.407406],
						[105.426859, 35.398342],
						[105.427841, 35.380107],
						[105.440285, 35.373782],
						[105.456331, 35.345101],
						[105.477289, 35.352166],
						[105.47778, 35.388435],
						[105.489569, 35.387591],
						[105.506925, 35.358915],
						[105.54049, 35.342148],
						[105.532631, 35.311873],
						[105.559483, 35.293301],
						[105.549495, 35.283697],
						[105.545893, 35.257941],
						[105.573564, 35.207459],
						[105.607457, 35.223304],
						[105.614661, 35.216438],
						[105.617117, 35.1821],
						[105.63873, 35.173117],
						[105.648227, 35.145845],
						[105.638403, 35.139396],
						[105.635947, 35.120362],
						[105.646262, 35.104391],
						[105.706516, 35.071805],
						[105.707334, 35.044076],
						[105.725345, 35.027349],
						[105.738608, 35.047781],
						[105.75449, 35.023749],
						[105.774793, 35.024385],
						[105.784125, 35.062916],
						[105.803119, 35.074028],
						[105.844052, 35.070959],
						[105.849619, 35.058789],
						[105.887605, 35.052015],
						[105.898739, 35.063445],
						[105.92903, 35.06027],
						[105.934924, 35.096352],
						[105.961285, 35.097516],
						[105.991576, 35.120785],
						[106.006639, 35.112747],
						[106.004675, 35.090216],
						[106.018592, 35.089581],
						[106.064437, 35.123958],
						[106.087196, 35.11444],
						[106.116668, 35.122371],
						[106.147778, 35.144471],
						[106.157765, 35.12142],
						[106.177413, 35.152294],
						[106.191331, 35.162654],
						[106.211797, 35.152294],
						[106.27549, 35.171638],
						[106.302997, 35.150603],
						[106.315113, 35.120997],
						[106.330177, 35.112642],
						[106.365707, 35.13284],
						[106.370128, 35.10492],
						[106.398781, 35.083127],
						[106.382408, 35.059318],
						[106.405985, 35.035395],
						[106.446755, 35.033807],
						[106.46231, 35.040583],
						[106.488671, 35.02089],
						[106.503571, 35.033807],
						[106.521418, 35.027773],
						[106.545978, 35.070536],
						[106.543522, 35.085032],
						[106.575777, 35.08937],
						[106.615401, 35.071065],
						[106.640124, 35.071488],
						[106.706436, 35.081858],
						[106.714459, 35.105555],
						[106.777824, 35.094236],
						[106.838406, 35.079847],
						[106.856908, 35.091274],
						[106.900624, 35.094553],
						[106.911103, 35.080694],
						[106.945979, 35.077414],
						[106.950072, 35.066938],
						[106.990842, 35.068525],
						[107.012454, 35.029361],
						[107.032757, 35.030102],
						[107.050932, 35.040794],
						[107.048312, 35.028302],
						[107.088754, 35.020785],
						[107.097596, 34.998228],
						[107.089573, 34.976724],
						[107.119536, 34.950234],
						[107.162434, 34.944088],
						[107.179954, 34.928294],
						[107.189614, 34.893305],
						[107.201075, 34.881639],
						[107.223016, 34.878138],
						[107.231202, 34.892563],
						[107.251997, 34.881108],
						[107.262312, 34.907515],
						[107.282942, 34.911756],
						[107.286708, 34.931898],
						[107.322402, 34.938152],
						[107.350237, 34.934124],
						[107.372013, 34.918011],
						[107.392971, 34.932428],
						[107.426045, 34.928718],
						[107.455517, 34.916739],
						[107.474838, 34.919389],
						[107.523958, 34.909847],
						[107.536729, 34.915361],
						[107.537875, 34.932534],
						[107.551138, 34.940272],
						[107.562108, 34.966553],
						[107.572096, 34.971427],
						[107.605661, 34.958712],
						[107.619742, 34.964646],
						[107.633332, 34.953943],
						[107.6258, 34.918965],
						[107.639881, 34.918753],
						[107.637753, 34.933276],
						[107.65429, 34.933594],
						[107.675412, 34.95087],
						[107.74156, 34.95352],
						[107.778564, 34.964752],
						[107.804761, 34.956805],
						[107.80689, 34.973652],
						[107.842092, 34.978949],
						[107.863378, 34.999181],
						[107.84373, 35.002252],
						[107.848314, 35.023855],
						[107.82752, 35.022161],
						[107.80034, 35.033384],
						[107.759407, 35.071171],
						[107.754004, 35.095082],
						[107.722567, 35.114863],
						[107.727643, 35.120151],
						[107.715854, 35.16815],
						[107.6872, 35.216649],
						[107.670336, 35.214431],
						[107.651998, 35.239779],
						[107.66264, 35.255407],
						[107.69244, 35.251183],
						[107.720111, 35.269237],
						[107.737303, 35.267442],
						[107.736812, 35.296151],
						[107.718637, 35.303221],
						[107.745817, 35.311662],
						[107.737139, 35.326748],
						[107.744343, 35.338034],
						[107.736812, 35.353643],
						[107.721912, 35.353432],
						[107.707667, 35.371251],
						[107.690639, 35.407195],
						[107.700626, 35.424581],
						[107.678522, 35.43459],
						[107.665096, 35.427637],
						[107.634969, 35.431851],
						[107.636279, 35.444281],
						[107.617614, 35.462186],
						[107.594527, 35.462397],
						[107.598129, 35.487141],
						[107.585031, 35.482508],
						[107.592726, 35.467135],
						[107.570622, 35.46345],
						[107.542951, 35.495247],
						[107.53018, 35.497984],
						[107.504474, 35.480087],
						[107.500708, 35.459974],
						[107.479586, 35.461659],
						[107.482861, 35.485983],
						[107.451752, 35.485351],
						[107.423589, 35.502089],
						[107.405251, 35.50051],
						[107.383802, 35.48114],
						[107.352365, 35.490931],
						[107.332553, 35.488825],
						[107.290638, 35.518192],
						[107.255108, 35.522085],
						[107.256745, 35.499878],
						[107.233986, 35.513561],
						[107.198783, 35.509562],
						[107.189287, 35.517981],
						[107.171112, 35.474401],
						[107.126413, 35.493141],
						[107.096613, 35.466609],
						[107.064522, 35.478929],
						[107.056499, 35.465451],
						[107.052242, 35.491036],
						[106.990187, 35.532187],
						[106.989368, 35.539131],
						[106.926003, 35.579101],
						[106.90308, 35.611168],
						[106.876719, 35.632188],
						[106.823833, 35.661607],
						[106.754738, 35.691225],
						[106.737546, 35.68944],
						[106.674836, 35.728076],
						[106.662392, 35.707605],
						[106.633248, 35.714849],
						[106.620968, 35.743818],
						[106.6136, 35.729755],
						[106.599682, 35.743713],
						[106.597554, 35.727971],
						[106.566608, 35.738781],
						[106.530423, 35.741824],
						[106.506354, 35.737521],
						[106.504226, 35.736157],
						[106.498004, 35.732484],
						[106.4926, 35.732799],
						[106.465912, 35.717999],
						[106.44872, 35.694166],
						[106.434966, 35.688495],
						[106.439387, 35.661817],
						[106.459854, 35.643852],
						[106.454287, 35.62914],
						[106.482449, 35.575526],
						[106.460509, 35.579417],
						[106.451012, 35.553544],
						[106.454778, 35.537658],
						[106.440697, 35.52661],
						[106.462637, 35.50272],
						[106.465584, 35.481034],
						[106.490144, 35.480403],
						[106.483431, 35.450601],
						[106.503571, 35.414993],
						[106.494893, 35.401399],
						[106.496039, 35.376101],
						[106.509301, 35.35881],
						[106.493747, 35.351955],
						[106.490472, 35.329596],
						[106.472298, 35.310712],
						[106.430545, 35.292985],
						[106.417774, 35.275992],
						[106.38732, 35.269764],
						[106.368163, 35.273459],
						[106.375695, 35.248544],
						[106.363578, 35.238301],
						[106.335907, 35.251078],
						[106.318715, 35.267125],
						[106.32068, 35.277681],
						[106.285641, 35.301532],
						[106.275326, 35.329174],
						[106.261736, 35.330334],
						[106.241433, 35.358493],
						[106.24962, 35.366823],
						[106.237504, 35.409513],
						[106.191986, 35.412253],
						[106.17463, 35.438382],
						[106.166934, 35.420999],
						[106.134515, 35.397815],
						[106.123873, 35.373465],
						[106.106517, 35.36714],
						[106.100295, 35.402031],
						[106.08736, 35.402347],
						[106.083103, 35.421842]
					]
				],
				[
					[
						[106.047736, 35.498089],
						[106.048555, 35.489036],
						[106.053958, 35.454709],
						[106.072133, 35.463555],
						[106.068858, 35.489141],
						[106.099476, 35.499668],
						[106.078518, 35.509667],
						[106.047736, 35.498089]
					]
				],
				[
					[
						[106.072951, 35.447546],
						[106.067876, 35.436065],
						[106.072951, 35.420788],
						[106.083103, 35.421842],
						[106.072951, 35.447546]
					]
				],
				[
					[
						[106.504226, 35.736157],
						[106.506354, 35.737521],
						[106.4926, 35.732799],
						[106.498004, 35.732484],
						[106.504226, 35.736157]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 620900,
			"name": "酒泉市",
			"center": [98.510795, 39.744023],
			"centroid": [96.063265, 40.283136],
			"childrenNum": 7,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 8,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[99.455988, 39.877427],
						[99.440925, 39.88596],
						[99.45959, 39.898063],
						[99.491355, 39.884274],
						[99.524756, 39.888143],
						[99.55341, 39.904213],
						[99.621195, 39.928211],
						[99.714032, 39.97212],
						[99.7512, 40.006891],
						[99.836996, 40.012635],
						[99.881368, 40.030853],
						[99.927704, 40.063912],
						[99.955867, 40.150836],
						[100.001712, 40.196972],
						[100.169703, 40.277611],
						[100.169703, 40.541356],
						[100.242564, 40.618639],
						[100.237325, 40.716808],
						[100.224717, 40.727489],
						[100.107975, 40.875572],
						[100.057054, 40.908021],
						[99.98583, 40.909682],
						[99.828482, 40.921993],
						[99.673263, 40.932934],
						[99.566017, 40.846725],
						[99.36266, 40.852006],
						[99.174694, 40.858363],
						[99.173057, 40.747278],
						[99.125574, 40.715142],
						[99.10216, 40.67642],
						[99.041579, 40.693774],
						[98.985091, 40.782826],
						[98.791066, 40.705341],
						[98.789265, 40.678872],
						[98.807276, 40.659356],
						[98.796142, 40.633359],
						[98.803019, 40.607843],
						[98.758156, 40.642189],
						[98.715585, 40.66171],
						[98.687914, 40.696813],
						[98.668594, 40.772937],
						[98.570026, 40.746887],
						[98.627988, 40.677891],
						[98.344237, 40.568371],
						[98.333267, 40.91916],
						[98.293808, 40.932153],
						[98.250254, 40.939185],
						[98.184761, 40.988003],
						[98.142354, 41.00186],
						[97.972071, 41.097904],
						[97.910671, 41.160914],
						[97.629541, 41.440562],
						[97.63478, 41.451901],
						[97.616442, 41.464304],
						[97.61415, 41.477189],
						[97.665235, 41.517765],
						[97.846979, 41.656635],
						[97.663761, 41.969056],
						[97.500846, 42.243878],
						[97.35938, 42.476993],
						[97.247878, 42.668756],
						[97.172724, 42.795163],
						[97.073502, 42.774287],
						[96.982629, 42.757392],
						[96.856882, 42.755493],
						[96.742105, 42.757107],
						[96.597692, 42.74372],
						[96.49192, 42.736598],
						[96.386148, 42.727765],
						[96.354711, 42.708482],
						[96.281522, 42.677882],
						[96.18934, 42.634427],
						[96.168055, 42.631763],
						[96.165272, 42.622345],
						[96.103544, 42.604171],
						[96.072435, 42.56933],
						[96.023806, 42.542472],
						[96.017584, 42.482142],
						[95.978779, 42.436737],
						[96.066213, 42.4145],
						[96.042144, 42.3529],
						[96.041162, 42.326522],
						[96.17837, 42.217934],
						[96.077183, 42.149623],
						[96.138911, 42.054172],
						[96.137437, 42.019601],
						[96.115988, 41.984724],
						[96.039197, 41.925301],
						[96.009889, 41.911255],
						[95.918361, 41.876029],
						[95.883977, 41.867845],
						[95.855652, 41.849645],
						[95.801456, 41.848104],
						[95.759212, 41.836063],
						[95.676036, 41.830187],
						[95.650985, 41.823732],
						[95.610706, 41.805133],
						[95.571901, 41.796169],
						[95.562405, 41.785373],
						[95.534898, 41.77467],
						[95.510174, 41.756347],
						[95.39425, 41.693526],
						[95.359539, 41.668033],
						[95.33547, 41.644172],
						[95.300104, 41.566152],
						[95.250329, 41.608992],
						[95.212015, 41.676918],
						[95.194168, 41.694974],
						[95.199571, 41.719395],
						[95.16486, 41.735317],
						[95.13768, 41.772452],
						[95.110664, 41.768402],
						[95.011278, 41.726343],
						[94.968871, 41.71872],
						[94.861953, 41.668516],
						[94.809885, 41.619336],
						[94.750123, 41.538285],
						[94.534158, 41.505953],
						[94.281354, 41.335216],
						[94.184096, 41.268583],
						[94.010866, 41.114855],
						[93.908205, 40.983415],
						[93.809965, 40.879482],
						[93.821099, 40.793692],
						[93.760845, 40.664848],
						[93.506403, 40.648468],
						[92.928423, 40.572693],
						[92.920564, 40.39184],
						[92.906811, 40.310648],
						[92.796454, 40.153801],
						[92.769929, 40.001047],
						[92.745533, 39.868298],
						[92.687735, 39.657395],
						[92.639925, 39.514306],
						[92.525475, 39.368623],
						[92.4608, 39.322529],
						[92.378606, 39.258485],
						[92.340129, 39.238059],
						[92.346351, 39.206808],
						[92.341439, 39.182057],
						[92.345696, 39.141556],
						[92.366162, 39.096014],
						[92.351099, 39.08357],
						[92.353719, 39.069518],
						[92.37484, 39.057672],
						[92.389249, 39.05958],
						[92.410698, 39.038594],
						[92.423142, 39.046627],
						[92.458999, 39.042711],
						[92.460473, 39.066206],
						[92.494038, 39.102135],
						[92.536282, 39.10073],
						[92.545778, 39.111265],
						[92.610453, 39.108957],
						[92.645328, 39.119993],
						[92.663503, 39.110864],
						[92.715242, 39.126813],
						[92.72785, 39.121597],
						[92.765672, 39.137144],
						[92.831166, 39.143862],
						[92.86686, 39.138648],
						[92.889127, 39.159905],
						[92.939066, 39.169629],
						[92.959042, 39.165218],
						[92.968702, 39.149277],
						[92.993589, 39.151784],
						[93.043201, 39.14647],
						[93.115407, 39.179552],
						[93.142423, 39.160707],
						[93.126705, 39.122801],
						[93.131944, 39.107954],
						[93.165673, 39.090696],
						[93.175497, 39.069418],
						[93.198093, 39.046426],
						[93.185649, 38.947348],
						[93.179263, 38.923914],
						[93.206934, 38.915867],
						[93.23788, 38.916168],
						[93.273901, 38.896146],
						[93.302555, 38.894033],
						[93.33219, 38.904095],
						[93.453189, 38.915464],
						[93.72908, 38.924518],
						[93.748073, 38.912345],
						[93.834361, 38.867663],
						[93.884627, 38.867663],
						[93.884136, 38.826175],
						[93.772961, 38.820937],
						[93.756424, 38.807639],
						[93.77509, 38.770047],
						[93.800304, 38.750791],
						[93.871856, 38.722552],
						[93.951431, 38.715187],
						[93.972225, 38.724872],
						[94.281354, 38.760067],
						[94.334894, 38.755631],
						[94.370097, 38.762789],
						[94.428059, 38.634434],
						[94.511072, 38.445116],
						[94.527118, 38.426076],
						[94.529901, 38.360815],
						[94.552005, 38.35027],
						[94.583115, 38.369229],
						[94.611277, 38.371358],
						[94.636983, 38.380886],
						[94.678735, 38.387271],
						[94.729329, 38.389602],
						[94.75045, 38.385041],
						[94.812178, 38.385548],
						[94.861462, 38.393757],
						[94.883893, 38.414832],
						[94.902231, 38.420505],
						[94.973455, 38.43033],
						[94.981969, 38.424962],
						[95.0175, 38.426177],
						[95.031581, 38.412704],
						[95.045334, 38.418782],
						[95.072678, 38.402471],
						[95.122125, 38.416959],
						[95.140791, 38.392338],
						[95.169117, 38.387575],
						[95.192367, 38.372067],
						[95.188601, 38.364464],
						[95.204647, 38.331611],
						[95.229698, 38.330495],
						[95.259989, 38.302293],
						[95.315495, 38.318526],
						[95.335634, 38.308077],
						[95.361667, 38.313352],
						[95.388683, 38.301177],
						[95.408168, 38.300365],
						[95.424541, 38.311526],
						[95.440914, 38.310917],
						[95.454996, 38.291639],
						[95.487906, 38.31457],
						[95.501005, 38.313149],
						[95.516232, 38.294785],
						[95.536044, 38.313251],
						[95.54947, 38.315178],
						[95.590076, 38.344288],
						[95.608414, 38.339217],
						[95.627734, 38.349155],
						[95.640178, 38.365985],
						[95.662446, 38.365275],
						[95.674398, 38.390615],
						[95.704034, 38.400141],
						[95.723846, 38.378555],
						[95.761832, 38.365884],
						[95.776077, 38.355948],
						[95.808333, 38.349459],
						[95.823232, 38.355137],
						[95.837641, 38.342462],
						[95.856143, 38.284433],
						[95.896421, 38.290117],
						[95.933752, 38.257838],
						[95.938501, 38.237327],
						[95.970429, 38.226663],
						[95.984019, 38.210918],
						[96.006941, 38.20726],
						[96.044109, 38.180535],
						[96.064739, 38.172811],
						[96.073745, 38.188157],
						[96.101743, 38.188056],
						[96.115497, 38.180637],
						[96.15512, 38.174437],
						[96.209316, 38.150242],
						[96.222087, 38.149123],
						[96.227654, 38.16966],
						[96.252542, 38.167423],
						[96.26433, 38.14587],
						[96.313123, 38.161934],
						[96.301825, 38.183178],
						[96.335718, 38.246162],
						[96.378289, 38.277329],
						[96.399738, 38.281795],
						[96.463594, 38.277735],
						[96.52483, 38.262001],
						[96.66515, 38.230218],
						[96.663349, 38.259666],
						[96.65418, 38.297727],
						[96.638625, 38.307671],
						[96.625363, 38.339217],
						[96.627, 38.356455],
						[96.663513, 38.388487],
						[96.679722, 38.411691],
						[96.698061, 38.422125],
						[96.708048, 38.45919],
						[96.666296, 38.483688],
						[96.680214, 38.498766],
						[96.700844, 38.497046],
						[96.712797, 38.506659],
						[96.780582, 38.504331],
						[96.794991, 38.510301],
						[96.800558, 38.527802],
						[96.76732, 38.552478],
						[96.783038, 38.566936],
						[96.805306, 38.570575],
						[96.794336, 38.607968],
						[96.846731, 38.599379],
						[96.876858, 38.580683],
						[96.899125, 38.580683],
						[96.92565, 38.564408],
						[96.960689, 38.557837],
						[97.055982, 38.594529],
						[97.047304, 38.653924],
						[97.057456, 38.672803],
						[97.043866, 38.685521],
						[97.019961, 38.686228],
						[97.009154, 38.702677],
						[97.021598, 38.730924],
						[97.023072, 38.75553],
						[97.00064, 38.761075],
						[96.987705, 38.793028],
						[96.9936, 38.83534],
						[96.983776, 38.870985],
						[96.993108, 38.884774],
						[96.966256, 38.886787],
						[96.940877, 38.907919],
						[96.949228, 38.939202],
						[96.939076, 38.955492],
						[96.948737, 38.992282],
						[96.965601, 39.016999],
						[96.957742, 39.041707],
						[96.969203, 39.079054],
						[96.969858, 39.09782],
						[97.011938, 39.141857],
						[96.997857, 39.151884],
						[96.983612, 39.17855],
						[96.962981, 39.198392],
						[97.017505, 39.208311],
						[97.047632, 39.20771],
						[97.060403, 39.19759],
						[97.141123, 39.199995],
						[97.163555, 39.194885],
						[97.220862, 39.193081],
						[97.3006, 39.16592],
						[97.342025, 39.168326],
						[97.365275, 39.143562],
						[97.401296, 39.14667],
						[97.43306, 39.126011],
						[97.426347, 39.173738],
						[97.395074, 39.240363],
						[97.402115, 39.293016],
						[97.397039, 39.318027],
						[97.429295, 39.347429],
						[97.453855, 39.352229],
						[97.477268, 39.373221],
						[97.480543, 39.406396],
						[97.480216, 39.472999],
						[97.520494, 39.53874],
						[97.557825, 39.554094],
						[97.569942, 39.564162],
						[97.585333, 39.603124],
						[97.619062, 39.630613],
						[97.656229, 39.632007],
						[97.676532, 39.679092],
						[97.700273, 39.697101],
						[97.785579, 39.680684],
						[97.828968, 39.68536],
						[97.855657, 39.71043],
						[97.857458, 39.711823],
						[97.855493, 39.713016],
						[97.85975, 39.716895],
						[97.862533, 39.715005],
						[97.974363, 39.780616],
						[97.99221, 39.808631],
						[98.031179, 39.827996],
						[97.98386, 39.882785],
						[97.990901, 39.891913],
						[98.036255, 39.914725],
						[98.004818, 39.922956],
						[98.024793, 39.946551],
						[98.066382, 39.954084],
						[98.068674, 39.983217],
						[98.062943, 39.99976],
						[98.162002, 39.971625],
						[98.296591, 39.962806],
						[98.329501, 39.955868],
						[98.371745, 39.957454],
						[98.392539, 39.965779],
						[98.420701, 39.955373],
						[98.444115, 39.955769],
						[98.474897, 39.969247],
						[98.497001, 39.950219],
						[98.497328, 39.916114],
						[98.520087, 39.909469],
						[98.518777, 39.892905],
						[98.484557, 39.864428],
						[98.491106, 39.840705],
						[98.456395, 39.823429],
						[98.355535, 39.78002],
						[98.361102, 39.756169],
						[98.406947, 39.731016],
						[98.413824, 39.710331],
						[98.391229, 39.690733],
						[98.381732, 39.663765],
						[98.370762, 39.654309],
						[98.357009, 39.630315],
						[98.330156, 39.569544],
						[98.362412, 39.542629],
						[98.396632, 39.535549],
						[98.402035, 39.514406],
						[98.410058, 39.550904],
						[98.434127, 39.577517],
						[98.549723, 39.509718],
						[98.530566, 39.486771],
						[98.515503, 39.480384],
						[98.526473, 39.467509],
						[98.553325, 39.470204],
						[98.579686, 39.481981],
						[98.57019, 39.460622],
						[98.612269, 39.444548],
						[98.660407, 39.43646],
						[98.710509, 39.414788],
						[98.72852, 39.399203],
						[98.752589, 39.389811],
						[98.800235, 39.360426],
						[98.838713, 39.34423],
						[98.866547, 39.324229],
						[98.880956, 39.33003],
						[98.902078, 39.316527],
						[98.906498, 39.33253],
						[98.975758, 39.33073],
						[98.985418, 39.312926],
						[99.023568, 39.30032],
						[99.046491, 39.285511],
						[99.060244, 39.257885],
						[99.080711, 39.267795],
						[99.120498, 39.261088],
						[99.141292, 39.24607],
						[99.143585, 39.208211],
						[99.179115, 39.181556],
						[99.176331, 39.171634],
						[99.207113, 39.205706],
						[99.213663, 39.226642],
						[99.198927, 39.275903],
						[99.207277, 39.283809],
						[99.280793, 39.289113],
						[99.293073, 39.30012],
						[99.30519, 39.33313],
						[99.308137, 39.357527],
						[99.256233, 39.427472],
						[99.23593, 39.458426],
						[99.183372, 39.475394],
						[99.135234, 39.503633],
						[99.10609, 39.514107],
						[99.097575, 39.530763],
						[99.072852, 39.554891],
						[99.056478, 39.587681],
						[99.064665, 39.609997],
						[99.053695, 39.623144],
						[99.025205, 39.629617],
						[98.977886, 39.619559],
						[98.946613, 39.594955],
						[98.938099, 39.577916],
						[98.872114, 39.594058],
						[98.816118, 39.592065],
						[98.804492, 39.627028],
						[98.824632, 39.676405],
						[98.881447, 39.665457],
						[98.94956, 39.66496],
						[98.94956, 39.701478],
						[98.960039, 39.788565],
						[98.987055, 39.832762],
						[99.026843, 39.854007],
						[99.06925, 39.850136],
						[99.083331, 39.837329],
						[99.113785, 39.835046],
						[99.140965, 39.80148],
						[99.193196, 39.809128],
						[99.206295, 39.829982],
						[99.229872, 39.851624],
						[99.247719, 39.838024],
						[99.320581, 39.847753],
						[99.35873, 39.86681],
						[99.455988, 39.877427]
					]
				],
				[
					[
						[97.862533, 39.715005],
						[97.85975, 39.716895],
						[97.855493, 39.713016],
						[97.857458, 39.711823],
						[97.862533, 39.715005]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 621000,
			"name": "庆阳市",
			"center": [107.638372, 35.734218],
			"centroid": [107.593489, 36.166303],
			"childrenNum": 8,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 9,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[106.754738, 35.691225],
						[106.823833, 35.661607],
						[106.876719, 35.632188],
						[106.90308, 35.611168],
						[106.926003, 35.579101],
						[106.989368, 35.539131],
						[106.990187, 35.532187],
						[107.052242, 35.491036],
						[107.056499, 35.465451],
						[107.064522, 35.478929],
						[107.096613, 35.466609],
						[107.126413, 35.493141],
						[107.171112, 35.474401],
						[107.189287, 35.517981],
						[107.198783, 35.509562],
						[107.233986, 35.513561],
						[107.256745, 35.499878],
						[107.255108, 35.522085],
						[107.290638, 35.518192],
						[107.332553, 35.488825],
						[107.352365, 35.490931],
						[107.383802, 35.48114],
						[107.405251, 35.50051],
						[107.423589, 35.502089],
						[107.451752, 35.485351],
						[107.482861, 35.485983],
						[107.479586, 35.461659],
						[107.500708, 35.459974],
						[107.504474, 35.480087],
						[107.53018, 35.497984],
						[107.542951, 35.495247],
						[107.570622, 35.46345],
						[107.592726, 35.467135],
						[107.585031, 35.482508],
						[107.598129, 35.487141],
						[107.594527, 35.462397],
						[107.617614, 35.462186],
						[107.636279, 35.444281],
						[107.634969, 35.431851],
						[107.665096, 35.427637],
						[107.678522, 35.43459],
						[107.700626, 35.424581],
						[107.690639, 35.407195],
						[107.707667, 35.371251],
						[107.721912, 35.353432],
						[107.736812, 35.353643],
						[107.744343, 35.338034],
						[107.737139, 35.326748],
						[107.745817, 35.311662],
						[107.808036, 35.287286],
						[107.831122, 35.27272],
						[107.845039, 35.275676],
						[107.868617, 35.256357],
						[107.90251, 35.261741],
						[107.936075, 35.253928],
						[107.936894, 35.266809],
						[107.960635, 35.26153],
						[107.949829, 35.24527],
						[107.970132, 35.241574],
						[108.048724, 35.253823],
						[108.094897, 35.280109],
						[108.123878, 35.281798],
						[108.174635, 35.30512],
						[108.193792, 35.306597],
						[108.233252, 35.286441],
						[108.22703, 35.276942],
						[108.23931, 35.256251],
						[108.268618, 35.268814],
						[108.29809, 35.268392],
						[108.345409, 35.300688],
						[108.352777, 35.285808],
						[108.400096, 35.282747],
						[108.403043, 35.27747],
						[108.449052, 35.27367],
						[108.488021, 35.274831],
						[108.525025, 35.288974],
						[108.543527, 35.303959],
						[108.56825, 35.290874],
						[108.600342, 35.308813],
						[108.615406, 35.331706],
						[108.610821, 35.35649],
						[108.631124, 35.418575],
						[108.619499, 35.443017],
						[108.616552, 35.477244],
						[108.605909, 35.502826],
						[108.625721, 35.537132],
						[108.618517, 35.55691],
						[108.567596, 35.585515],
						[108.56383, 35.597922],
						[108.539761, 35.605596],
						[108.523224, 35.661187],
						[108.530428, 35.680514],
						[108.517002, 35.716004],
						[108.533866, 35.746232],
						[108.520113, 35.766797],
						[108.524861, 35.774875],
						[108.527808, 35.824162],
						[108.524534, 35.839676],
						[108.499482, 35.872267],
						[108.500956, 35.885048],
						[108.518639, 35.905472],
						[108.563011, 35.921285],
						[108.569233, 35.939606],
						[108.593793, 35.950806],
						[108.633744, 35.944735],
						[108.656503, 35.953004],
						[108.661742, 35.993917],
						[108.688595, 36.021111],
						[108.682536, 36.055091],
						[108.690887, 36.088742],
						[108.707424, 36.10974],
						[108.697764, 36.117052],
						[108.712336, 36.138774],
						[108.702839, 36.160803],
						[108.665017, 36.214753],
						[108.646024, 36.254175],
						[108.655029, 36.273982],
						[108.642094, 36.311186],
						[108.641603, 36.359098],
						[108.651263, 36.384708],
						[108.619008, 36.433927],
						[108.593629, 36.431534],
						[108.562684, 36.438607],
						[108.533048, 36.454624],
						[108.510616, 36.474485],
						[108.51471, 36.445576],
						[108.496863, 36.422691],
						[108.485565, 36.429453],
						[108.459368, 36.42394],
						[108.418762, 36.448696],
						[108.402552, 36.4462],
						[108.408119, 36.459616],
						[108.391582, 36.505462],
						[108.365385, 36.519698],
						[108.359654, 36.547229],
						[108.340661, 36.558862],
						[108.311189, 36.561043],
						[108.287447, 36.553357],
						[108.270255, 36.567482],
						[108.262396, 36.549307],
						[108.245532, 36.571012],
						[108.216551, 36.571324],
						[108.204762, 36.596656],
						[108.222936, 36.630904],
						[108.197885, 36.62997],
						[108.182331, 36.590116],
						[108.163665, 36.563743],
						[108.141397, 36.562601],
						[108.139105, 36.576723],
						[108.115691, 36.586587],
						[108.092932, 36.587313],
						[108.094897, 36.604545],
						[108.081143, 36.615235],
						[108.06215, 36.592608],
						[108.032023, 36.606413],
						[108.002715, 36.636403],
						[108.022363, 36.647193],
						[108.023345, 36.6697],
						[108.004843, 36.683181],
						[107.986178, 36.6753],
						[107.985687, 36.652172],
						[107.975044, 36.666278],
						[107.937385, 36.658188],
						[107.940987, 36.694897],
						[107.932473, 36.711172],
						[107.914299, 36.721018],
						[107.907422, 36.750238],
						[107.881879, 36.74713],
						[107.866652, 36.766708],
						[107.826701, 36.785453],
						[107.820316, 36.776755],
						[107.768248, 36.792909],
						[107.745326, 36.810716],
						[107.709632, 36.80554],
						[107.673283, 36.832554],
						[107.640373, 36.818789],
						[107.603532, 36.825827],
						[107.58896, 36.836487],
						[107.540168, 36.828622],
						[107.528543, 36.853766],
						[107.533618, 36.867215],
						[107.477949, 36.908476],
						[107.447167, 36.899378],
						[107.365464, 36.905374],
						[107.332881, 36.925636],
						[107.311759, 36.913025],
						[107.295386, 36.929046],
						[107.304391, 36.951988],
						[107.287363, 36.992377],
						[107.290965, 37.004046],
						[107.279995, 37.041931],
						[107.286217, 37.055552],
						[107.268697, 37.099496],
						[107.249704, 37.106302],
						[107.23546, 37.096196],
						[107.2276, 37.106818],
						[107.180445, 37.143518],
						[107.134108, 37.134757],
						[107.095795, 37.115582],
						[107.078275, 37.12919],
						[107.061738, 37.124139],
						[107.030629, 37.140838],
						[107.031448, 37.115479],
						[106.984783, 37.107539],
						[106.960878, 37.113932],
						[106.952528, 37.128778],
						[106.9057, 37.15135],
						[106.891292, 37.14125],
						[106.913396, 37.132386],
						[106.911922, 37.11022],
						[106.891292, 37.098465],
						[106.870989, 37.115891],
						[106.858872, 37.113726],
						[106.780771, 37.158667],
						[106.767182, 37.132283],
						[106.77324, 37.123005],
						[106.756539, 37.102177],
						[106.726903, 37.108983],
						[106.72854, 37.121459],
						[106.699723, 37.11785],
						[106.687771, 37.129912],
						[106.66976, 37.111148],
						[106.660755, 37.126098],
						[106.640124, 37.118984],
						[106.616874, 37.135169],
						[106.605249, 37.127644],
						[106.620804, 37.095784],
						[106.645528, 37.065045],
						[106.651913, 37.033881],
						[106.666813, 37.016745],
						[106.641598, 37.011996],
						[106.646674, 37.000432],
						[106.643235, 36.96294],
						[106.622932, 36.959324],
						[106.595425, 36.969035],
						[106.595753, 36.940415],
						[106.57987, 36.934834],
						[106.580525, 36.947442],
						[106.540411, 36.984425],
						[106.554983, 36.953125],
						[106.549089, 36.942585],
						[106.601974, 36.91809],
						[106.609997, 36.90403],
						[106.600665, 36.891416],
						[106.609506, 36.878178],
						[106.627026, 36.89245],
						[106.638651, 36.870525],
						[106.626698, 36.861939],
						[106.641925, 36.853559],
						[106.640616, 36.834003],
						[106.658463, 36.819617],
						[106.641762, 36.802744],
						[106.639469, 36.771473],
						[106.627517, 36.75231],
						[106.632265, 36.723298],
						[106.611471, 36.730241],
						[106.594934, 36.749617],
						[106.57545, 36.746923],
						[106.57283, 36.733972],
						[106.553837, 36.737805],
						[106.514377, 36.715629],
						[106.53075, 36.68992],
						[106.490963, 36.685773],
						[106.495056, 36.646363],
						[106.491291, 36.628725],
						[106.468532, 36.620424],
						[106.444627, 36.624886],
						[106.444299, 36.600808],
						[106.471315, 36.580461],
						[106.449702, 36.577658],
						[106.459199, 36.568728],
						[106.444954, 36.5572],
						[106.397471, 36.574335],
						[106.392232, 36.556473],
						[106.364233, 36.577658],
						[106.371765, 36.548891],
						[106.401565, 36.546294],
						[106.453796, 36.497875],
						[106.475408, 36.495692],
						[106.483759, 36.480931],
						[106.494729, 36.494445],
						[106.518143, 36.480931],
						[106.51978, 36.456288],
						[106.503407, 36.441728],
						[106.504717, 36.41468],
						[106.492273, 36.422587],
						[106.488507, 36.400424],
						[106.503898, 36.401569],
						[106.526985, 36.390224],
						[106.525183, 36.372737],
						[106.510284, 36.378879],
						[106.506354, 36.328271],
						[106.497349, 36.313791],
						[106.509792, 36.30358],
						[106.510447, 36.286073],
						[106.480157, 36.316083],
						[106.470824, 36.306289],
						[106.504717, 36.26606],
						[106.514541, 36.272002],
						[106.541229, 36.253862],
						[106.556293, 36.260639],
						[106.559895, 36.292117],
						[106.584291, 36.287949],
						[106.594279, 36.270334],
						[106.605904, 36.295661],
						[106.61098, 36.273148],
						[106.655352, 36.258658],
						[106.685315, 36.273357],
						[106.698741, 36.243017],
						[106.716588, 36.231963],
						[106.735745, 36.237282],
						[106.763579, 36.214961],
						[106.795344, 36.223098],
						[106.808442, 36.210997],
						[106.827763, 36.21517],
						[106.833821, 36.229251],
						[106.841353, 36.206511],
						[106.851504, 36.207555],
						[106.875082, 36.176877],
						[106.898168, 36.169362],
						[106.912413, 36.153913],
						[106.90701, 36.136372],
						[106.918471, 36.128853],
						[106.93026, 36.138565],
						[106.925676, 36.116112],
						[106.940084, 36.126451],
						[106.944014, 36.099607],
						[106.957604, 36.091563],
						[106.959405, 36.075367],
						[106.940575, 36.064916],
						[106.942376, 36.033136],
						[106.930588, 36.028954],
						[106.928623, 36.011176],
						[106.951218, 36.004482],
						[106.944178, 35.984293],
						[106.917653, 35.961168],
						[106.891783, 35.966191],
						[106.902589, 35.943584],
						[106.918963, 35.940443],
						[106.938447, 35.953109],
						[106.944832, 35.940234],
						[106.925184, 35.926206],
						[106.912904, 35.932173],
						[106.905373, 35.912698],
						[106.886052, 35.917515],
						[106.850195, 35.887562],
						[106.873117, 35.878239],
						[106.877865, 35.852777],
						[106.89997, 35.827307],
						[106.911267, 35.831186],
						[106.926331, 35.811686],
						[106.922237, 35.803402],
						[106.897677, 35.80854],
						[106.914378, 35.791342],
						[106.908975, 35.767741],
						[106.897677, 35.759768],
						[106.885233, 35.771832],
						[106.868533, 35.772042],
						[106.867059, 35.738676],
						[106.827763, 35.745287],
						[106.818103, 35.739515],
						[106.816465, 35.717579],
						[106.806314, 35.7096],
						[106.782409, 35.723667],
						[106.753101, 35.726396],
						[106.744586, 35.700466],
						[106.754738, 35.691225]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 621100,
			"name": "定西市",
			"center": [104.626294, 35.579578],
			"centroid": [104.456158, 35.122537],
			"childrenNum": 7,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 10,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[105.638403, 35.139396],
						[105.648227, 35.145845],
						[105.63873, 35.173117],
						[105.617117, 35.1821],
						[105.614661, 35.216438],
						[105.607457, 35.223304],
						[105.573564, 35.207459],
						[105.545893, 35.257941],
						[105.549495, 35.283697],
						[105.559483, 35.293301],
						[105.532631, 35.311873],
						[105.54049, 35.342148],
						[105.506925, 35.358915],
						[105.489569, 35.387591],
						[105.47778, 35.388435],
						[105.477289, 35.352166],
						[105.456331, 35.345101],
						[105.440285, 35.373782],
						[105.427841, 35.380107],
						[105.426859, 35.398342],
						[105.404427, 35.407406],
						[105.393457, 35.425003],
						[105.383797, 35.458921],
						[105.345483, 35.485351],
						[105.319777, 35.482824],
						[105.303404, 35.500299],
						[105.271476, 35.475138],
						[105.232998, 35.482719],
						[105.1752, 35.441858],
						[105.135413, 35.449126],
						[105.117894, 35.440278],
						[105.123461, 35.420156],
						[105.083673, 35.418575],
						[105.070738, 35.454814],
						[105.044541, 35.448916],
						[105.000333, 35.456183],
						[104.996731, 35.471347],
						[104.975446, 35.476402],
						[104.966768, 35.489983],
						[104.946465, 35.491562],
						[104.933202, 35.51293],
						[104.937132, 35.544602],
						[104.95285, 35.548179],
						[104.954979, 35.57216],
						[104.967095, 35.608435],
						[104.986743, 35.635025],
						[104.985597, 35.700361],
						[104.980358, 35.716634],
						[104.937296, 35.738256],
						[104.891941, 35.767112],
						[104.884246, 35.79344],
						[104.864762, 35.804031],
						[104.865744, 35.832444],
						[104.853628, 35.854873],
						[104.807291, 35.865875],
						[104.811385, 35.877924],
						[104.768978, 35.887457],
						[104.769305, 35.91741],
						[104.738032, 35.931754],
						[104.72788, 35.951958],
						[104.709379, 35.94955],
						[104.676959, 35.986804],
						[104.646505, 35.996533],
						[104.648797, 36.010758],
						[104.676141, 36.022994],
						[104.680725, 36.033764],
						[104.663369, 36.041501],
						[104.633242, 36.035541],
						[104.61867, 36.044846],
						[104.584941, 36.029477],
						[104.561855, 36.028013],
						[104.532383, 36.014627],
						[104.500618, 36.02017],
						[104.484572, 36.020693],
						[104.483754, 35.993708],
						[104.441019, 35.974771],
						[104.42612, 35.916154],
						[104.44282, 35.89657],
						[104.448879, 35.875619],
						[104.439055, 35.864618],
						[104.421371, 35.865456],
						[104.398612, 35.808855],
						[104.401068, 35.793964],
						[104.384695, 35.767426],
						[104.369959, 35.766692],
						[104.357351, 35.74109],
						[104.331154, 35.732379],
						[104.316746, 35.705296],
						[104.317564, 35.66791],
						[104.331809, 35.658561],
						[104.305939, 35.643327],
						[104.310196, 35.601812],
						[104.290057, 35.589616],
						[104.282198, 35.571109],
						[104.225382, 35.578575],
						[104.198039, 35.598973],
						[104.202787, 35.614111],
						[104.173151, 35.649421],
						[104.148591, 35.635025],
						[104.138931, 35.618525],
						[104.110769, 35.638178],
						[104.101436, 35.636076],
						[104.092431, 35.657615],
						[104.067543, 35.664759],
						[104.053135, 35.68608],
						[104.040036, 35.68902],
						[104.019569, 35.713589],
						[103.997956, 35.716109],
						[103.980928, 35.735737],
						[103.963736, 35.735318],
						[103.952111, 35.746756],
						[103.919855, 35.757354],
						[103.901354, 35.774979],
						[103.865005, 35.794803],
						[103.848959, 35.774979],
						[103.849614, 35.803927],
						[103.837498, 35.815985],
						[103.837334, 35.841773],
						[103.799184, 35.841039],
						[103.795909, 35.852463],
						[103.779863, 35.848166],
						[103.776425, 35.896256],
						[103.76742, 35.89039],
						[103.714697, 35.909975],
						[103.702581, 35.927253],
						[103.660993, 35.914269],
						[103.643801, 35.931336],
						[103.623989, 35.934895],
						[103.595991, 35.909452],
						[103.558659, 35.911127],
						[103.542122, 35.943898],
						[103.509212, 35.940967],
						[103.498897, 35.927253],
						[103.476629, 35.917306],
						[103.471062, 35.8818],
						[103.515925, 35.851729],
						[103.547853, 35.803193],
						[103.56439, 35.807177],
						[103.59157, 35.781063],
						[103.595663, 35.75704],
						[103.621533, 35.753577],
						[103.640526, 35.719993],
						[103.694558, 35.672952],
						[103.719937, 35.659191],
						[103.785267, 35.598973],
						[103.793126, 35.564378],
						[103.8113, 35.534186],
						[103.830948, 35.520928],
						[103.832913, 35.506825],
						[103.854362, 35.498089],
						[103.854198, 35.477349],
						[103.828001, 35.458605],
						[103.822925, 35.445018],
						[103.800494, 35.435117],
						[103.811791, 35.422685],
						[103.814084, 35.39634],
						[103.780682, 35.387486],
						[103.77708, 35.356912],
						[103.74024, 35.312717],
						[103.731726, 35.277787],
						[103.699634, 35.238512],
						[103.689974, 35.219818],
						[103.691611, 35.195626],
						[103.721083, 35.190237],
						[103.716498, 35.133263],
						[103.748426, 35.115074],
						[103.735328, 35.100477],
						[103.748918, 35.088417],
						[103.738275, 35.064927],
						[103.743514, 35.044817],
						[103.758087, 35.028302],
						[103.786249, 35.01549],
						[103.784612, 35.002676],
						[103.816703, 34.993038],
						[103.834878, 34.977996],
						[103.860584, 34.987106],
						[103.911178, 34.969096],
						[103.942942, 34.936138],
						[103.952766, 34.94981],
						[103.981092, 34.946737],
						[103.984366, 34.938046],
						[104.017768, 34.936774],
						[104.024809, 34.917057],
						[104.011055, 34.910165],
						[104.027265, 34.893411],
						[104.021207, 34.872411],
						[103.964555, 34.840581],
						[103.997629, 34.807678],
						[103.999103, 34.787717],
						[104.02399, 34.774868],
						[104.004669, 34.735244],
						[103.989115, 34.738219],
						[103.963572, 34.728656],
						[103.909049, 34.744701],
						[103.881214, 34.747357],
						[103.853052, 34.738644],
						[103.833404, 34.71686],
						[103.862876, 34.682526],
						[103.850432, 34.641369],
						[103.841591, 34.634667],
						[103.834714, 34.604768],
						[103.839462, 34.575497],
						[103.828328, 34.545364],
						[103.779045, 34.536524],
						[103.768566, 34.523316],
						[103.794763, 34.492524],
						[103.810318, 34.483572],
						[103.804751, 34.471102],
						[103.8113, 34.424508],
						[103.802786, 34.408722],
						[103.753993, 34.371592],
						[103.733363, 34.331883],
						[103.698488, 34.315011],
						[103.69243, 34.300166],
						[103.70209, 34.280617],
						[103.745152, 34.287561],
						[103.77315, 34.273245],
						[103.792798, 34.270574],
						[103.821779, 34.281258],
						[103.83717, 34.273673],
						[103.879577, 34.267369],
						[103.924276, 34.213605],
						[103.936884, 34.193609],
						[103.990916, 34.161733],
						[104.028738, 34.127276],
						[104.060339, 34.151782],
						[104.067052, 34.177993],
						[104.105693, 34.194143],
						[104.153503, 34.193074],
						[104.165783, 34.210397],
						[104.162509, 34.247492],
						[104.136966, 34.269399],
						[104.116008, 34.323127],
						[104.148755, 34.339036],
						[104.14941, 34.350779],
						[104.202787, 34.375113],
						[104.269754, 34.348644],
						[104.28711, 34.376287],
						[104.328862, 34.376607],
						[104.353913, 34.369564],
						[104.366684, 34.336687],
						[104.406308, 34.338929],
						[104.417769, 34.331028],
						[104.437417, 34.298137],
						[104.445113, 34.271108],
						[104.435125, 34.258713],
						[104.452153, 34.229214],
						[104.472456, 34.218202],
						[104.511097, 34.208045],
						[104.527634, 34.19147],
						[104.536967, 34.219592],
						[104.552358, 34.204196],
						[104.571024, 34.201629],
						[104.623746, 34.234986],
						[104.665498, 34.226114],
						[104.689894, 34.248026],
						[104.720021, 34.252942],
						[104.741143, 34.233383],
						[104.779293, 34.239583],
						[104.789117, 34.252515],
						[104.814332, 34.255187],
						[104.821536, 34.27613],
						[104.844131, 34.281472],
						[104.863288, 34.301768],
						[104.852973, 34.320457],
						[104.855429, 34.343199],
						[104.844459, 34.367856],
						[104.856902, 34.379382],
						[104.895871, 34.377995],
						[104.938278, 34.386318],
						[104.96644, 34.382583],
						[104.991983, 34.396134],
						[104.983632, 34.405735],
						[104.989035, 34.425574],
						[104.966768, 34.437198],
						[104.918139, 34.438691],
						[104.88572, 34.422908],
						[104.837909, 34.445622],
						[104.791573, 34.431866],
						[104.793046, 34.482293],
						[104.783222, 34.487089],
						[104.748347, 34.472914],
						[104.753914, 34.52747],
						[104.738523, 34.555587],
						[104.716255, 34.541423],
						[104.695952, 34.544725],
						[104.671556, 34.575816],
						[104.690877, 34.618176],
						[104.685965, 34.628497],
						[104.699555, 34.6737],
						[104.646177, 34.655941],
						[104.595584, 34.654027],
						[104.601642, 34.679017],
						[104.589362, 34.699535],
						[104.601642, 34.710058],
						[104.577246, 34.721218],
						[104.591818, 34.726106],
						[104.60639, 34.745763],
						[104.584777, 34.767221],
						[104.584286, 34.787292],
						[104.597385, 34.804387],
						[104.598858, 34.838883],
						[104.620144, 34.86456],
						[104.657803, 34.872304],
						[104.697262, 34.859574],
						[104.728863, 34.86212],
						[104.740979, 34.85289],
						[104.757844, 34.86212],
						[104.794356, 34.869334],
						[104.850189, 34.865833],
						[104.878679, 34.856073],
						[104.895871, 34.862439],
						[104.909788, 34.903909],
						[104.898818, 34.924584],
						[104.920922, 34.950022],
						[104.933694, 34.93635],
						[104.971352, 34.953202],
						[104.970042, 34.940484],
						[105.006391, 34.939636],
						[105.007865, 34.928718],
						[105.035372, 34.925432],
						[105.070738, 34.943452],
						[105.073686, 34.955639],
						[105.058131, 34.981915],
						[105.092515, 34.969096],
						[105.130501, 34.963904],
						[105.16816, 34.969308],
						[105.193539, 34.954897],
						[105.192884, 34.937516],
						[105.217771, 34.93211],
						[105.254611, 34.964646],
						[105.259851, 34.979797],
						[105.249699, 35.00956],
						[105.261816, 35.028196],
						[105.27606, 35.033596],
						[105.290141, 35.006806],
						[105.299147, 35.01962],
						[105.297346, 35.046722],
						[105.321415, 35.03836],
						[105.336478, 35.049369],
						[105.354489, 35.04831],
						[105.379867, 35.072017],
						[105.391656, 35.064927],
						[105.396568, 35.089475],
						[105.41114, 35.079424],
						[105.42031, 35.114334],
						[105.456495, 35.130831],
						[105.484984, 35.093178],
						[105.505615, 35.085561],
						[105.52428, 35.063339],
						[105.541636, 35.07244],
						[105.559974, 35.127659],
						[105.535578, 35.138762],
						[105.539508, 35.152717],
						[105.558501, 35.161385],
						[105.558173, 35.1821],
						[105.572418, 35.181361],
						[105.609094, 35.152929],
						[105.638403, 35.139396]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 621200,
			"name": "陇南市",
			"center": [104.929379, 33.388598],
			"centroid": [105.225469, 33.598913],
			"childrenNum": 9,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 11,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[106.494238, 34.241827],
						[106.494238, 34.201415],
						[106.475081, 34.180025],
						[106.472298, 34.154885],
						[106.453959, 34.135517],
						[106.402874, 34.109829],
						[106.363087, 34.100622],
						[106.336562, 34.109829],
						[106.327393, 34.140868],
						[106.344585, 34.179277],
						[106.330177, 34.203447],
						[106.323627, 34.230497],
						[106.282039, 34.225472],
						[106.270742, 34.206869],
						[106.276963, 34.191256],
						[106.266648, 34.161412],
						[106.244708, 34.152638],
						[106.246836, 34.132199],
						[106.229972, 34.118071],
						[106.189693, 34.110471],
						[106.14876, 34.124279],
						[106.139755, 34.113575],
						[106.117323, 34.111434],
						[106.100622, 34.125457],
						[106.082121, 34.124814],
						[106.071805, 34.146646],
						[106.041351, 34.158737],
						[106.017773, 34.159058],
						[105.9716, 34.146111],
						[105.945076, 34.144185],
						[105.90316, 34.119034],
						[105.86501, 34.125136],
						[105.86108, 34.15328],
						[105.815235, 34.147502],
						[105.781997, 34.11957],
						[105.772664, 34.136694],
						[105.771027, 34.164407],
						[105.740409, 34.176602],
						[105.72338, 34.174035],
						[105.718141, 34.158844],
						[105.704715, 34.162054],
						[105.667711, 34.144613],
						[105.651665, 34.119034],
						[105.640859, 34.081241],
						[105.61548, 34.081348],
						[105.623994, 34.096232],
						[105.596978, 34.105868],
						[105.591739, 34.084453],
						[105.563576, 34.086381],
						[105.552606, 34.113682],
						[105.563085, 34.137229],
						[105.547858, 34.152745],
						[105.555226, 34.197245],
						[105.540163, 34.248668],
						[105.554899, 34.258072],
						[105.530338, 34.273245],
						[105.527391, 34.28457],
						[105.547039, 34.291621],
						[105.558009, 34.306788],
						[105.546384, 34.319496],
						[105.522807, 34.304972],
						[105.501521, 34.328786],
						[105.491861, 34.352166],
						[105.460261, 34.391653],
						[105.408193, 34.420988],
						[105.384943, 34.408615],
						[105.350887, 34.43144],
						[105.31159, 34.442423],
						[105.312082, 34.43048],
						[105.291615, 34.428667],
						[105.290633, 34.439331],
						[105.260342, 34.452979],
						[105.254284, 34.49977],
						[105.24053, 34.512343],
						[105.243969, 34.528429],
						[105.227759, 34.533009],
						[105.20631, 34.518948],
						[105.160792, 34.527364],
						[105.128373, 34.508401],
						[105.108725, 34.460975],
						[105.084001, 34.460548],
						[105.06861, 34.44189],
						[105.038974, 34.423441],
						[105.013104, 34.420455],
						[104.989035, 34.425574],
						[104.983632, 34.405735],
						[104.991983, 34.396134],
						[104.96644, 34.382583],
						[104.938278, 34.386318],
						[104.895871, 34.377995],
						[104.856902, 34.379382],
						[104.844459, 34.367856],
						[104.855429, 34.343199],
						[104.852973, 34.320457],
						[104.863288, 34.301768],
						[104.844131, 34.281472],
						[104.821536, 34.27613],
						[104.814332, 34.255187],
						[104.789117, 34.252515],
						[104.779293, 34.239583],
						[104.741143, 34.233383],
						[104.720021, 34.252942],
						[104.689894, 34.248026],
						[104.665498, 34.226114],
						[104.623746, 34.234986],
						[104.571024, 34.201629],
						[104.552358, 34.204196],
						[104.536967, 34.219592],
						[104.527634, 34.19147],
						[104.511097, 34.208045],
						[104.472456, 34.218202],
						[104.452153, 34.229214],
						[104.435125, 34.258713],
						[104.445113, 34.271108],
						[104.437417, 34.298137],
						[104.417769, 34.331028],
						[104.406308, 34.338929],
						[104.366684, 34.336687],
						[104.353913, 34.369564],
						[104.328862, 34.376607],
						[104.28711, 34.376287],
						[104.269754, 34.348644],
						[104.202787, 34.375113],
						[104.14941, 34.350779],
						[104.148755, 34.339036],
						[104.116008, 34.323127],
						[104.136966, 34.269399],
						[104.162509, 34.247492],
						[104.165783, 34.210397],
						[104.153503, 34.193074],
						[104.105693, 34.194143],
						[104.067052, 34.177993],
						[104.060339, 34.151782],
						[104.028738, 34.127276],
						[104.02661, 34.084989],
						[104.03627, 34.056714],
						[104.064432, 34.043966],
						[104.077858, 34.022643],
						[104.194764, 33.949099],
						[104.248305, 33.922817],
						[104.330827, 33.867653],
						[104.341961, 33.853803],
						[104.385186, 33.847897],
						[104.410892, 33.838984],
						[104.446259, 33.80719],
						[104.450188, 33.785593],
						[104.469181, 33.771084],
						[104.531073, 33.763238],
						[104.528944, 33.7412],
						[104.490139, 33.705497],
						[104.486373, 33.69076],
						[104.509296, 33.675806],
						[104.514536, 33.658803],
						[104.501437, 33.660202],
						[104.50553, 33.642013],
						[104.548592, 33.64309],
						[104.521412, 33.611869],
						[104.542698, 33.590761],
						[104.555797, 33.598623],
						[104.570041, 33.576543],
						[104.581011, 33.575789],
						[104.584122, 33.534845],
						[104.57217, 33.536461],
						[104.583631, 33.516413],
						[104.60508, 33.50283],
						[104.657148, 33.482774],
						[104.699391, 33.457428],
						[104.698081, 33.439843],
						[104.714454, 33.415672],
						[104.730828, 33.408333],
						[104.713636, 33.401101],
						[104.715764, 33.346142],
						[104.729682, 33.328859],
						[104.759481, 33.308007],
						[104.727226, 33.299686],
						[104.675322, 33.302388],
						[104.661405, 33.29612],
						[104.646341, 33.269314],
						[104.639628, 33.238824],
						[104.627676, 33.226927],
						[104.567585, 33.221411],
						[104.539096, 33.226927],
						[104.532219, 33.251259],
						[104.540078, 33.274071],
						[104.501273, 33.340742],
						[104.487683, 33.329507],
						[104.467217, 33.333721],
						[104.437253, 33.323242],
						[104.393537, 33.310924],
						[104.41253, 33.281745],
						[104.385841, 33.298606],
						[104.349165, 33.300659],
						[104.33623, 33.314274],
						[104.302828, 33.302604],
						[104.329026, 33.252989],
						[104.328371, 33.224115],
						[104.350966, 33.159087],
						[104.377818, 33.109174],
						[104.36079, 33.099318],
						[104.367175, 33.086753],
						[104.33754, 33.038208],
						[104.360135, 33.028452],
						[104.391408, 33.03539],
						[104.421044, 33.024225],
						[104.42612, 33.010781],
						[104.383549, 32.994299],
						[104.378473, 32.95319],
						[104.349329, 32.940495],
						[104.305939, 32.951562],
						[104.286127, 32.939085],
						[104.276958, 32.888504],
						[104.288911, 32.870371],
						[104.294314, 32.835722],
						[104.330172, 32.82464],
						[104.359807, 32.823988],
						[104.422026, 32.768776],
						[104.447569, 32.761709],
						[104.45903, 32.748552],
						[104.510279, 32.754424],
						[104.526652, 32.728432],
						[104.555142, 32.73387],
						[104.582813, 32.722232],
						[104.591327, 32.697101],
						[104.619653, 32.68339],
						[104.64192, 32.662711],
						[104.667954, 32.662494],
						[104.696771, 32.673487],
						[104.738032, 32.636148],
						[104.76603, 32.645512],
						[104.79583, 32.643552],
						[104.820717, 32.662929],
						[104.845769, 32.653894],
						[104.873603, 32.622973],
						[104.88179, 32.601191],
						[104.927799, 32.608924],
						[104.972007, 32.632882],
						[105.014905, 32.640177],
						[105.030296, 32.650411],
						[105.079416, 32.637237],
						[105.096608, 32.606092],
						[105.110853, 32.59411],
						[105.184697, 32.617419],
						[105.214988, 32.636802],
						[105.219736, 32.666412],
						[105.241185, 32.668916],
						[105.263289, 32.65237],
						[105.297673, 32.657051],
						[105.308807, 32.671092],
						[105.340899, 32.679581],
						[105.365623, 32.710375],
						[105.394276, 32.714291],
						[105.425385, 32.733979],
						[105.446507, 32.732239],
						[105.459442, 32.752358],
						[105.45322, 32.767689],
						[105.425713, 32.774212],
						[105.413105, 32.812362],
						[105.392966, 32.833115],
						[105.395095, 32.864723],
						[105.380686, 32.877103],
						[105.407866, 32.88579],
						[105.413105, 32.918899],
						[105.425549, 32.931163],
						[105.456331, 32.932682],
						[105.499065, 32.911844],
						[105.527882, 32.918899],
						[105.534104, 32.909456],
						[105.565541, 32.906851],
						[105.590592, 32.876777],
						[105.638239, 32.879275],
						[105.656577, 32.895344],
						[105.699475, 32.903486],
						[105.735497, 32.905331],
						[105.785599, 32.926822],
						[105.827024, 32.950803],
						[105.861735, 32.938976],
						[105.917405, 32.993866],
						[105.928047, 33.04146],
						[105.913311, 33.053164],
						[105.915112, 33.066276],
						[105.933287, 33.077003],
						[105.918714, 33.105384],
						[105.936889, 33.113614],
						[105.920188, 33.132131],
						[105.923463, 33.147721],
						[105.896447, 33.142741],
						[105.924609, 33.167529],
						[105.916913, 33.177811],
						[105.92772, 33.198478],
						[105.945567, 33.188091],
						[105.946877, 33.153567],
						[105.968326, 33.154108],
						[105.962595, 33.207565],
						[105.906598, 33.240121],
						[105.862554, 33.234282],
						[105.835538, 33.251151],
						[105.792803, 33.26272],
						[105.791493, 33.278611],
						[105.767425, 33.282502],
						[105.747777, 33.298822],
						[105.755145, 33.328859],
						[105.728947, 33.353163],
						[105.708972, 33.380698],
						[105.732877, 33.391062],
						[105.743192, 33.385341],
						[105.802627, 33.378755],
						[105.829643, 33.382858],
						[105.837994, 33.410816],
						[105.830953, 33.456457],
						[105.841923, 33.490107],
						[105.877945, 33.517707],
						[105.884167, 33.535707],
						[105.902669, 33.556181],
						[105.919533, 33.55478],
						[105.954081, 33.587099],
						[105.962104, 33.606485],
						[105.979787, 33.612407],
						[105.998944, 33.604115],
						[106.019083, 33.609715],
						[106.029562, 33.595931],
						[106.045772, 33.609715],
						[106.063946, 33.604115],
						[106.086705, 33.617145],
						[106.119452, 33.602392],
						[106.108482, 33.569756],
						[106.141392, 33.574927],
						[106.143684, 33.564908],
						[106.187237, 33.546483],
						[106.237504, 33.564046],
						[106.277455, 33.5969],
						[106.303325, 33.604331],
						[106.335089, 33.586991],
						[106.351462, 33.587207],
						[106.384864, 33.612084],
						[106.431364, 33.619083],
						[106.446919, 33.613268],
						[106.452813, 33.591838],
						[106.456088, 33.53797],
						[106.477537, 33.519431],
						[106.494238, 33.530426],
						[106.541066, 33.513071],
						[106.563006, 33.543035],
						[106.559731, 33.570834],
						[106.580525, 33.575897],
						[106.581672, 33.609823],
						[106.575613, 33.631679],
						[106.534844, 33.695171],
						[106.482613, 33.707326],
						[106.48818, 33.758186],
						[106.479829, 33.780757],
						[106.461819, 33.789676],
						[106.468695, 33.820081],
						[106.491291, 33.834473],
						[106.493419, 33.846179],
						[106.474262, 33.876671],
						[106.428253, 33.866472],
						[106.410897, 33.90919],
						[106.444627, 33.935905],
						[106.476063, 33.973764],
						[106.478683, 33.997885],
						[106.471643, 34.024037],
						[106.505535, 34.0565],
						[106.501933, 34.104904],
						[106.561205, 34.110899],
						[106.584782, 34.149428],
						[106.574958, 34.163765],
						[106.557766, 34.229748],
						[106.53206, 34.254011],
						[106.512903, 34.239369],
						[106.494238, 34.241827]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 622900,
			"name": "临夏回族自治州",
			"center": [103.212006, 35.599446],
			"centroid": [103.289177, 35.625236],
			"childrenNum": 8,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 12,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[102.742448, 35.495247],
						[102.747687, 35.487351],
						[102.820385, 35.460922],
						[102.853132, 35.420577],
						[102.871142, 35.408565],
						[102.889317, 35.411199],
						[102.907655, 35.425846],
						[102.926975, 35.428163],
						[102.949079, 35.4073],
						[102.959395, 35.356912],
						[102.951699, 35.30417],
						[102.955137, 35.259946],
						[102.97102, 35.252978],
						[102.983463, 35.260685],
						[102.989849, 35.283064],
						[103.019485, 35.288552],
						[103.060091, 35.273459],
						[103.08023, 35.275676],
						[103.099059, 35.246115],
						[103.114778, 35.236717],
						[103.165371, 35.226895],
						[103.211217, 35.2364],
						[103.262138, 35.236928],
						[103.269833, 35.232704],
						[103.297996, 35.18284],
						[103.36398, 35.142674],
						[103.408024, 35.143414],
						[103.457145, 35.128399],
						[103.488745, 35.133475],
						[103.490874, 35.152294],
						[103.5359, 35.141088],
						[103.573068, 35.115391],
						[103.624971, 35.094025],
						[103.651824, 35.067043],
						[103.676875, 35.052332],
						[103.680477, 35.036772],
						[103.708312, 35.039736],
						[103.729597, 35.010831],
						[103.70078, 35.006383],
						[103.677857, 34.992826],
						[103.691938, 34.987212],
						[103.729761, 35.004159],
						[103.733036, 34.978419],
						[103.712733, 34.960196],
						[103.686699, 34.954473],
						[103.668524, 34.932958],
						[103.685717, 34.907939],
						[103.703563, 34.915997],
						[103.757104, 34.927128],
						[103.803932, 34.929142],
						[103.833732, 34.91483],
						[103.848468, 34.953732],
						[103.834878, 34.977996],
						[103.816703, 34.993038],
						[103.784612, 35.002676],
						[103.786249, 35.01549],
						[103.758087, 35.028302],
						[103.743514, 35.044817],
						[103.738275, 35.064927],
						[103.748918, 35.088417],
						[103.735328, 35.100477],
						[103.748426, 35.115074],
						[103.716498, 35.133263],
						[103.721083, 35.190237],
						[103.691611, 35.195626],
						[103.689974, 35.219818],
						[103.699634, 35.238512],
						[103.731726, 35.277787],
						[103.74024, 35.312717],
						[103.77708, 35.356912],
						[103.780682, 35.387486],
						[103.814084, 35.39634],
						[103.811791, 35.422685],
						[103.800494, 35.435117],
						[103.822925, 35.445018],
						[103.828001, 35.458605],
						[103.854198, 35.477349],
						[103.854362, 35.498089],
						[103.832913, 35.506825],
						[103.830948, 35.520928],
						[103.8113, 35.534186],
						[103.793126, 35.564378],
						[103.785267, 35.598973],
						[103.719937, 35.659191],
						[103.694558, 35.672952],
						[103.640526, 35.719993],
						[103.621533, 35.753577],
						[103.595663, 35.75704],
						[103.59157, 35.781063],
						[103.56439, 35.807177],
						[103.547853, 35.803193],
						[103.515925, 35.851729],
						[103.471062, 35.8818],
						[103.476629, 35.917306],
						[103.498897, 35.927253],
						[103.509212, 35.940967],
						[103.542122, 35.943898],
						[103.558659, 35.911127],
						[103.595991, 35.909452],
						[103.623989, 35.934895],
						[103.616785, 35.959284],
						[103.632831, 35.982409],
						[103.622352, 35.99444],
						[103.633322, 36.017451],
						[103.621697, 36.025922],
						[103.596318, 36.069514],
						[103.575033, 36.06293],
						[103.571267, 36.091876],
						[103.538848, 36.105039],
						[103.521819, 36.101697],
						[103.496604, 36.108382],
						[103.483342, 36.098354],
						[103.475646, 36.110785],
						[103.438315, 36.069201],
						[103.41048, 36.07777],
						[103.412282, 36.123005],
						[103.396727, 36.128958],
						[103.365617, 36.119872],
						[103.343022, 36.125198],
						[103.312895, 36.152556],
						[103.298323, 36.145038],
						[103.278184, 36.151929],
						[103.259846, 36.146605],
						[103.257881, 36.15955],
						[103.230374, 36.168318],
						[103.200902, 36.170301],
						[103.19075, 36.180321],
						[103.165863, 36.176146],
						[103.155711, 36.19013],
						[103.123128, 36.195661],
						[103.10741, 36.221637],
						[103.102661, 36.211623],
						[103.070897, 36.206929],
						[103.049121, 36.199208],
						[103.01883, 36.204842],
						[102.987393, 36.193782],
						[102.966435, 36.152242],
						[102.948588, 36.150572],
						[102.94122, 36.104935],
						[102.910111, 36.088219],
						[102.883913, 36.088951],
						[102.89603, 36.065647],
						[102.909947, 36.070455],
						[102.932379, 36.048609],
						[102.969219, 36.044114],
						[102.9535, 36.015778],
						[102.971838, 35.995277],
						[102.950062, 35.963156],
						[102.942203, 35.928195],
						[102.948424, 35.920447],
						[102.951208, 35.871219],
						[102.95612, 35.861579],
						[102.942366, 35.829928],
						[102.91404, 35.845126],
						[102.886369, 35.849319],
						[102.853295, 35.846908],
						[102.848383, 35.854768],
						[102.820057, 35.850367],
						[102.784036, 35.862313],
						[102.737208, 35.820598],
						[102.715104, 35.81546],
						[102.694801, 35.796481],
						[102.68596, 35.772147],
						[102.708064, 35.704981],
						[102.727057, 35.69133],
						[102.743921, 35.657825],
						[102.764552, 35.653308],
						[102.763242, 35.611903],
						[102.78027, 35.587829],
						[102.801719, 35.574684],
						[102.80876, 35.560486],
						[102.781744, 35.549441],
						[102.746214, 35.545233],
						[102.729513, 35.523664],
						[102.773557, 35.534186],
						[102.78289, 35.528083],
						[102.742448, 35.495247]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 623000,
			"name": "甘南藏族自治州",
			"center": [102.911008, 34.986354],
			"centroid": [102.766903, 34.325574],
			"childrenNum": 8,
			"level": "city",
			"parent": {
				"adcode": 620000
			},
			"subFeatureIndex": 13,
			"acroutes": [100000, 620000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[104.028738, 34.127276],
						[103.990916, 34.161733],
						[103.936884, 34.193609],
						[103.924276, 34.213605],
						[103.879577, 34.267369],
						[103.83717, 34.273673],
						[103.821779, 34.281258],
						[103.792798, 34.270574],
						[103.77315, 34.273245],
						[103.745152, 34.287561],
						[103.70209, 34.280617],
						[103.69243, 34.300166],
						[103.698488, 34.315011],
						[103.733363, 34.331883],
						[103.753993, 34.371592],
						[103.802786, 34.408722],
						[103.8113, 34.424508],
						[103.804751, 34.471102],
						[103.810318, 34.483572],
						[103.794763, 34.492524],
						[103.768566, 34.523316],
						[103.779045, 34.536524],
						[103.828328, 34.545364],
						[103.839462, 34.575497],
						[103.834714, 34.604768],
						[103.841591, 34.634667],
						[103.850432, 34.641369],
						[103.862876, 34.682526],
						[103.833404, 34.71686],
						[103.853052, 34.738644],
						[103.881214, 34.747357],
						[103.909049, 34.744701],
						[103.963572, 34.728656],
						[103.989115, 34.738219],
						[104.004669, 34.735244],
						[104.02399, 34.774868],
						[103.999103, 34.787717],
						[103.997629, 34.807678],
						[103.964555, 34.840581],
						[104.021207, 34.872411],
						[104.027265, 34.893411],
						[104.011055, 34.910165],
						[104.024809, 34.917057],
						[104.017768, 34.936774],
						[103.984366, 34.938046],
						[103.981092, 34.946737],
						[103.952766, 34.94981],
						[103.942942, 34.936138],
						[103.911178, 34.969096],
						[103.860584, 34.987106],
						[103.834878, 34.977996],
						[103.848468, 34.953732],
						[103.833732, 34.91483],
						[103.803932, 34.929142],
						[103.757104, 34.927128],
						[103.703563, 34.915997],
						[103.685717, 34.907939],
						[103.668524, 34.932958],
						[103.686699, 34.954473],
						[103.712733, 34.960196],
						[103.733036, 34.978419],
						[103.729761, 35.004159],
						[103.691938, 34.987212],
						[103.677857, 34.992826],
						[103.70078, 35.006383],
						[103.729597, 35.010831],
						[103.708312, 35.039736],
						[103.680477, 35.036772],
						[103.676875, 35.052332],
						[103.651824, 35.067043],
						[103.624971, 35.094025],
						[103.573068, 35.115391],
						[103.5359, 35.141088],
						[103.490874, 35.152294],
						[103.488745, 35.133475],
						[103.457145, 35.128399],
						[103.408024, 35.143414],
						[103.36398, 35.142674],
						[103.297996, 35.18284],
						[103.269833, 35.232704],
						[103.262138, 35.236928],
						[103.211217, 35.2364],
						[103.165371, 35.226895],
						[103.114778, 35.236717],
						[103.099059, 35.246115],
						[103.08023, 35.275676],
						[103.060091, 35.273459],
						[103.019485, 35.288552],
						[102.989849, 35.283064],
						[102.983463, 35.260685],
						[102.97102, 35.252978],
						[102.955137, 35.259946],
						[102.951699, 35.30417],
						[102.959395, 35.356912],
						[102.949079, 35.4073],
						[102.926975, 35.428163],
						[102.907655, 35.425846],
						[102.889317, 35.411199],
						[102.871142, 35.408565],
						[102.853132, 35.420577],
						[102.820385, 35.460922],
						[102.747687, 35.487351],
						[102.742448, 35.495247],
						[102.695292, 35.528504],
						[102.63553, 35.534397],
						[102.571182, 35.548074],
						[102.531395, 35.580468],
						[102.503233, 35.584254],
						[102.514203, 35.569426],
						[102.49783, 35.571845],
						[102.498648, 35.545233],
						[102.482603, 35.51293],
						[102.463446, 35.507773],
						[102.460826, 35.478823],
						[102.451002, 35.478718],
						[102.438067, 35.45534],
						[102.447564, 35.437329],
						[102.408595, 35.41004],
						[102.314776, 35.434379],
						[102.292672, 35.422579],
						[102.282193, 35.385062],
						[102.286613, 35.366507],
						[102.306589, 35.359864],
						[102.317723, 35.342886],
						[102.311665, 35.314405],
						[102.284485, 35.313244],
						[102.280883, 35.303115],
						[102.312156, 35.282431],
						[102.335242, 35.283486],
						[102.369954, 35.263958],
						[102.365697, 35.235555],
						[102.400081, 35.19552],
						[102.403519, 35.17819],
						[102.37372, 35.16128],
						[102.343429, 35.161702],
						[102.339499, 35.141088],
						[102.313138, 35.130937],
						[102.301841, 35.105872],
						[102.295128, 35.070641],
						[102.2799, 35.056672],
						[102.252393, 35.048734],
						[102.224067, 35.059],
						[102.213916, 35.03656],
						[102.17462, 35.032537],
						[102.157428, 35.010831],
						[102.133686, 35.014643],
						[102.107489, 34.989331],
						[102.095045, 34.986788],
						[102.061807, 34.94271],
						[102.04789, 34.910802],
						[102.068357, 34.887684],
						[102.028242, 34.896274],
						[101.985999, 34.89988],
						[101.959801, 34.887154],
						[101.939662, 34.888639],
						[101.916903, 34.87379],
						[101.93344, 34.845887],
						[101.923289, 34.835912],
						[101.927546, 34.803007],
						[101.920178, 34.799822],
						[101.917394, 34.706232],
						[101.930002, 34.681888],
						[101.918213, 34.667108],
						[101.91985, 34.625198],
						[101.934586, 34.587526],
						[101.956035, 34.582949],
						[101.974374, 34.548878],
						[101.999589, 34.539186],
						[102.040849, 34.534713],
						[102.09308, 34.536417],
						[102.106998, 34.521824],
						[102.121406, 34.522996],
						[102.139581, 34.503713],
						[102.15579, 34.507548],
						[102.172327, 34.476218],
						[102.16938, 34.458203],
						[102.191157, 34.438691],
						[102.222594, 34.384717],
						[102.234055, 34.382796],
						[102.25927, 34.355582],
						[102.220956, 34.339356],
						[102.186572, 34.352807],
						[102.16938, 34.324942],
						[102.169871, 34.310633],
						[102.150878, 34.292048],
						[102.148259, 34.271322],
						[102.133359, 34.272925],
						[102.085058, 34.291727],
						[102.067865, 34.293543],
						[102.060334, 34.278801],
						[102.059843, 34.227183],
						[102.038721, 34.229962],
						[102.014161, 34.218523],
						[102.030862, 34.190507],
						[102.018254, 34.190293],
						[102.003191, 34.161947],
						[101.965368, 34.167403],
						[101.967497, 34.155634],
						[101.955053, 34.109614],
						[101.895618, 34.134019],
						[101.872531, 34.13327],
						[101.865982, 34.15007],
						[101.838147, 34.124707],
						[101.788372, 34.131664],
						[101.763812, 34.122674],
						[101.757427, 34.099658],
						[101.736141, 34.080063],
						[101.728282, 34.099658],
						[101.710926, 34.086809],
						[101.713219, 34.109079],
						[101.703067, 34.119249],
						[101.67032, 34.11197],
						[101.643304, 34.138728],
						[101.65231, 34.148786],
						[101.627586, 34.165477],
						[101.624966, 34.176923],
						[101.600243, 34.179277],
						[101.576665, 34.197031],
						[101.561274, 34.191042],
						[101.540644, 34.21168],
						[101.492506, 34.195534],
						[101.482354, 34.218737],
						[101.418171, 34.228038],
						[101.371671, 34.247706],
						[101.323205, 34.246744],
						[101.327626, 34.264911],
						[101.295698, 34.268544],
						[101.262951, 34.285745],
						[101.265735, 34.292903],
						[101.229059, 34.298457],
						[101.23528, 34.325156],
						[101.193856, 34.336687],
						[101.169132, 34.319176],
						[101.156033, 34.329961],
						[101.140479, 34.324729],
						[101.070728, 34.328893],
						[101.054519, 34.32302],
						[101.051408, 34.337221],
						[101.024064, 34.342986],
						[100.986897, 34.37458],
						[100.975435, 34.369884],
						[100.950875, 34.383757],
						[100.916164, 34.373833],
						[100.897171, 34.375754],
						[100.868517, 34.332737],
						[100.822672, 34.318642],
						[100.808427, 34.274314],
						[100.799422, 34.26224],
						[100.809737, 34.247064],
						[100.782394, 34.197779],
						[100.764383, 34.178956],
						[100.806299, 34.15542],
						[100.839209, 34.114432],
						[100.849033, 34.089593],
						[100.870155, 34.083918],
						[100.879979, 34.058],
						[100.879324, 34.039038],
						[100.89668, 34.035931],
						[100.909451, 34.007425],
						[100.934829, 33.989846],
						[100.927625, 33.975157],
						[100.966594, 33.945881],
						[100.975763, 33.919384],
						[100.999013, 33.889659],
						[101.023246, 33.896098],
						[101.048461, 33.878818],
						[101.052226, 33.864325],
						[101.153577, 33.844461],
						[101.149812, 33.828566],
						[101.171261, 33.804504],
						[101.189763, 33.793115],
						[101.184196, 33.765173],
						[101.188944, 33.744641],
						[101.16291, 33.719587],
						[101.164711, 33.692912],
						[101.178301, 33.683767],
						[101.166676, 33.659987],
						[101.217761, 33.66978],
						[101.237082, 33.685596],
						[101.259677, 33.669565],
						[101.302902, 33.65805],
						[101.351368, 33.657512],
						[101.391155, 33.645242],
						[101.423083, 33.654283],
						[101.427504, 33.678388],
						[101.469911, 33.686242],
						[101.491687, 33.699904],
						[101.542117, 33.695171],
						[101.557999, 33.669672],
						[101.582559, 33.675052],
						[101.588617, 33.638138],
						[101.605973, 33.628988],
						[101.616943, 33.598839],
						[101.611868, 33.590115],
						[101.614651, 33.538617],
						[101.622674, 33.502291],
						[101.635281, 33.491616],
						[101.650018, 33.502183],
						[101.677197, 33.496468],
						[101.702249, 33.501428],
						[101.735814, 33.496361],
						[101.749404, 33.506064],
						[101.759064, 33.535599],
						[101.782314, 33.556289],
						[101.806056, 33.5481],
						[101.830288, 33.554457],
						[101.830779, 33.578805],
						[101.844369, 33.6025],
						[101.882028, 33.579344],
						[101.907079, 33.542065],
						[101.89791, 33.517707],
						[101.907407, 33.480186],
						[101.929019, 33.469617],
						[101.924435, 33.449985],
						[101.946375, 33.442757],
						[101.915921, 33.425708],
						[101.91412, 33.405851],
						[101.887267, 33.383829],
						[101.876297, 33.351111],
						[101.87597, 33.314166],
						[101.857959, 33.312005],
						[101.832253, 33.291689],
						[101.823903, 33.27126],
						[101.809658, 33.288231],
						[101.76987, 33.268774],
						[101.770362, 33.249637],
						[101.788045, 33.225846],
						[101.797541, 33.232984],
						[101.829797, 33.213948],
						[101.841258, 33.189064],
						[101.840603, 33.160386],
						[101.82554, 33.119462],
						[101.865982, 33.103001],
						[101.88563, 33.134405],
						[101.921815, 33.154],
						[101.935569, 33.1869],
						[101.957345, 33.186684],
						[101.993858, 33.199992],
						[102.010559, 33.191661],
						[102.055094, 33.190038],
						[102.089642, 33.204969],
						[102.089478, 33.227576],
						[102.10929, 33.264017],
						[102.112728, 33.286825],
						[102.144165, 33.274395],
						[102.152679, 33.253097],
						[102.174947, 33.233633],
						[102.203437, 33.22325],
						[102.217518, 33.248123],
						[102.202291, 33.300983],
						[102.205565, 33.320108],
						[102.1869, 33.332532],
						[102.21981, 33.351435],
						[102.238148, 33.388579],
						[102.261071, 33.396352],
						[102.263363, 33.417075],
						[102.275152, 33.408657],
						[102.292017, 33.413945],
						[102.310682, 33.397971],
						[102.347522, 33.409736],
						[102.370118, 33.394193],
						[102.36717, 33.408981],
						[102.396151, 33.405311],
						[102.403519, 33.424521],
						[102.434301, 33.439412],
						[102.442324, 33.453113],
						[102.462463, 33.449661],
						[102.453785, 33.483637],
						[102.460498, 33.509406],
						[102.445762, 33.529456],
						[102.475889, 33.531072],
						[102.473433, 33.547669],
						[102.454604, 33.555104],
						[102.440359, 33.574819],
						[102.406466, 33.581498],
						[102.386655, 33.598731],
						[102.344575, 33.606808],
						[102.333605, 33.642013],
						[102.315267, 33.665153],
						[102.328366, 33.706358],
						[102.341628, 33.720877],
						[102.325418, 33.735287],
						[102.30135, 33.709907],
						[102.287105, 33.716575],
						[102.288087, 33.733029],
						[102.322799, 33.746038],
						[102.323126, 33.757541],
						[102.300203, 33.782369],
						[102.243552, 33.78699],
						[102.234546, 33.794619],
						[102.261235, 33.82137],
						[102.253376, 33.861534],
						[102.233891, 33.87023],
						[102.204583, 33.905649],
						[102.136306, 33.965185],
						[102.166924, 33.982877],
						[102.198525, 33.978374],
						[102.202618, 33.967115],
						[102.237985, 33.963577],
						[102.241587, 33.981483],
						[102.258124, 33.975694],
						[102.277772, 33.99006],
						[102.287268, 33.977516],
						[102.316249, 33.994026],
						[102.313138, 33.974407],
						[102.350633, 33.977409],
						[102.39304, 33.973227],
						[102.39959, 34.017714],
						[102.417764, 34.042252],
						[102.437576, 34.087238],
						[102.467212, 34.073851],
						[102.516823, 34.087452],
						[102.557429, 34.091521],
						[102.585263, 34.10105],
						[102.616045, 34.099765],
						[102.649447, 34.080063],
						[102.660417, 34.085096],
						[102.655833, 34.113468],
						[102.64126, 34.127062],
						[102.598362, 34.147823],
						[102.625378, 34.16751],
						[102.650429, 34.165584],
						[102.647482, 34.178314],
						[102.665002, 34.192753],
						[102.701187, 34.196924],
						[102.731805, 34.237445],
						[102.777978, 34.235628],
						[102.783872, 34.258072],
						[102.798281, 34.273032],
						[102.856734, 34.270681],
						[102.861154, 34.302409],
						[102.879165, 34.312128],
						[102.911748, 34.312982],
						[102.93991, 34.299952],
						[102.956447, 34.269399],
						[102.980189, 34.241293],
						[102.977078, 34.198314],
						[103.007532, 34.184839],
						[103.039788, 34.185801],
						[103.05043, 34.194678],
						[103.071552, 34.184839],
						[103.100369, 34.181951],
						[103.124111, 34.16184],
						[103.132625, 34.128989],
						[103.121818, 34.112719],
						[103.135408, 34.1003],
						[103.149817, 34.10287],
						[103.178306, 34.080384],
						[103.170283, 34.065712],
						[103.130824, 34.06689],
						[103.119198, 34.039573],
						[103.147197, 34.036466],
						[103.157185, 33.998743],
						[103.136718, 33.973656],
						[103.123947, 33.968188],
						[103.120508, 33.9506],
						[103.134426, 33.930327],
						[103.164716, 33.929361],
						[103.181254, 33.900713],
						[103.153419, 33.819114],
						[103.161278, 33.80719],
						[103.20303, 33.795371],
						[103.228081, 33.794834],
						[103.250022, 33.814065],
						[103.284733, 33.802033],
						[103.278347, 33.775383],
						[103.3201, 33.752059],
						[103.349572, 33.743458],
						[103.431766, 33.750769],
						[103.464513, 33.802462],
						[103.506428, 33.81009],
						[103.518381, 33.807082],
						[103.539994, 33.766785],
						[103.531316, 33.749049],
						[103.54949, 33.74034],
						[103.545069, 33.718941],
						[103.520509, 33.678603],
						[103.55211, 33.671501],
						[103.565045, 33.700657],
						[103.598774, 33.717866],
						[103.643473, 33.708939],
						[103.65166, 33.721415],
						[103.669016, 33.712381],
						[103.650023, 33.700119],
						[103.666887, 33.699366],
						[103.667706, 33.685812],
						[103.689155, 33.69345],
						[103.778226, 33.658803],
						[103.800494, 33.67021],
						[103.86173, 33.682154],
						[103.926732, 33.679679],
						[103.96652, 33.670425],
						[104.013184, 33.683337],
						[104.052316, 33.685274],
						[104.103564, 33.663538],
						[104.169385, 33.610792],
						[104.179701, 33.575681],
						[104.168076, 33.571049],
						[104.155632, 33.541311],
						[104.169058, 33.51361],
						[104.180683, 33.473068],
						[104.213102, 33.446856],
						[104.221944, 33.42873],
						[104.220798, 33.404663],
						[104.249779, 33.407038],
						[104.270573, 33.393329],
						[104.295788, 33.332856],
						[104.328043, 33.333072],
						[104.367667, 33.345062],
						[104.437253, 33.323242],
						[104.467217, 33.333721],
						[104.487683, 33.329507],
						[104.501273, 33.340742],
						[104.540078, 33.274071],
						[104.532219, 33.251259],
						[104.539096, 33.226927],
						[104.567585, 33.221411],
						[104.627676, 33.226927],
						[104.639628, 33.238824],
						[104.646341, 33.269314],
						[104.661405, 33.29612],
						[104.675322, 33.302388],
						[104.727226, 33.299686],
						[104.759481, 33.308007],
						[104.729682, 33.328859],
						[104.715764, 33.346142],
						[104.713636, 33.401101],
						[104.730828, 33.408333],
						[104.714454, 33.415672],
						[104.698081, 33.439843],
						[104.699391, 33.457428],
						[104.657148, 33.482774],
						[104.60508, 33.50283],
						[104.583631, 33.516413],
						[104.57217, 33.536461],
						[104.584122, 33.534845],
						[104.581011, 33.575789],
						[104.570041, 33.576543],
						[104.555797, 33.598623],
						[104.542698, 33.590761],
						[104.521412, 33.611869],
						[104.548592, 33.64309],
						[104.50553, 33.642013],
						[104.501437, 33.660202],
						[104.514536, 33.658803],
						[104.509296, 33.675806],
						[104.486373, 33.69076],
						[104.490139, 33.705497],
						[104.528944, 33.7412],
						[104.531073, 33.763238],
						[104.469181, 33.771084],
						[104.450188, 33.785593],
						[104.446259, 33.80719],
						[104.410892, 33.838984],
						[104.385186, 33.847897],
						[104.341961, 33.853803],
						[104.330827, 33.867653],
						[104.248305, 33.922817],
						[104.194764, 33.949099],
						[104.077858, 34.022643],
						[104.064432, 34.043966],
						[104.03627, 34.056714],
						[104.02661, 34.084989],
						[104.028738, 34.127276]
					]
				]
			]
		}
	}]
};

//湖南省永州市道县
var daoxianJson = {
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 431124,
			"name": "道县",
			"center": [111.591614, 25.518444],
			"centroid": [111.596062, 25.493276],
			"childrenNum": 0,
			"level": "district",
			"acroutes": [100000, 430000, 431100],
			"parent": {
				"adcode": 431100
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[111.736428, 25.64684],
						[111.734952, 25.644945],
						[111.732395, 25.642284],
						[111.729001, 25.639246],
						[111.725973, 25.637156],
						[111.720097, 25.637289],
						[111.713724, 25.63816],
						[111.706973, 25.639713],
						[111.702834, 25.638536],
						[111.699062, 25.634816],
						[111.69452, 25.629395],
						[111.691039, 25.626364],
						[111.688935, 25.625863],
						[111.686968, 25.624093],
						[111.686006, 25.62187],
						[111.686441, 25.620323],
						[111.689456, 25.61677],
						[111.690952, 25.614191],
						[111.695252, 25.609599],
						[111.69545, 25.606359],
						[111.694389, 25.60408],
						[111.690983, 25.601418],
						[111.688451, 25.6007],
						[111.683102, 25.602596],
						[111.677301, 25.605843],
						[111.67619, 25.608728],
						[111.676022, 25.612637],
						[111.67305, 25.618414],
						[111.670996, 25.620463],
						[111.666504, 25.62302],
						[111.665139, 25.624023],
						[111.664146, 25.627124],
						[111.665368, 25.628949],
						[111.668614, 25.632224],
						[111.668831, 25.634593],
						[111.667627, 25.636237],
						[111.663997, 25.636251],
						[111.657953, 25.638452],
						[111.657147, 25.639873],
						[111.657544, 25.646638],
						[111.656272, 25.647773],
						[111.653951, 25.647969],
						[111.649508, 25.648742],
						[111.645711, 25.650086],
						[111.643824, 25.65141],
						[111.641082, 25.652733],
						[111.637681, 25.657303],
						[111.634089, 25.664429],
						[111.632153, 25.667591],
						[111.629584, 25.669917],
						[111.627915, 25.670906],
						[111.623075, 25.671637],
						[111.619625, 25.673434],
						[111.617174, 25.676213],
						[111.613221, 25.676227],
						[111.610361, 25.677314],
						[111.607612, 25.679828],
						[111.606383, 25.681374],
						[111.605155, 25.687537],
						[111.608127, 25.692857],
						[111.608003, 25.69402],
						[111.606861, 25.695761],
						[111.604044, 25.695657],
						[111.603002, 25.692182],
						[111.600668, 25.685935],
						[111.599974, 25.685378],
						[111.597318, 25.684626],
						[111.595065, 25.684612],
						[111.591584, 25.686096],
						[111.589841, 25.687593],
						[111.589003, 25.689877],
						[111.589015, 25.692927],
						[111.586918, 25.696179],
						[111.586713, 25.697704],
						[111.588209, 25.702077],
						[111.586955, 25.706283],
						[111.585696, 25.709715],
						[111.585261, 25.711595],
						[111.586478, 25.714387],
						[111.588283, 25.717625],
						[111.587272, 25.719831],
						[111.583952, 25.720542],
						[111.581166, 25.720493],
						[111.578138, 25.721182],
						[111.576667, 25.722338],
						[111.575619, 25.725387],
						[111.573943, 25.727872],
						[111.570996, 25.730741],
						[111.570797, 25.73436],
						[111.568948, 25.748094],
						[111.570853, 25.751518],
						[111.573193, 25.754748],
						[111.574465, 25.758743],
						[111.575321, 25.760643],
						[111.576804, 25.762926],
						[111.578076, 25.764067],
						[111.578926, 25.766155],
						[111.577666, 25.768257],
						[111.574725, 25.772279],
						[111.571989, 25.773817],
						[111.570307, 25.775536],
						[111.568961, 25.777435],
						[111.570593, 25.78017],
						[111.574347, 25.783907],
						[111.574961, 25.785458],
						[111.573863, 25.787476],
						[111.572547, 25.788033],
						[111.570022, 25.788047],
						[111.56597, 25.786238],
						[111.560398, 25.785472],
						[111.558096, 25.786078],
						[111.555353, 25.78628],
						[111.550513, 25.787261],
						[111.547138, 25.789181],
						[111.545884, 25.79186],
						[111.545686, 25.795666],
						[111.546114, 25.79815],
						[111.544221, 25.801586],
						[111.540647, 25.803319],
						[111.537917, 25.805239],
						[111.535603, 25.807924],
						[111.534765, 25.81022],
						[111.534976, 25.810978],
						[111.538364, 25.8163],
						[111.538798, 25.818964],
						[111.536906, 25.8203],
						[111.534374, 25.821086],
						[111.531842, 25.819959],
						[111.52905, 25.815813],
						[111.525606, 25.813434],
						[111.520301, 25.811674],
						[111.514617, 25.81125],
						[111.500674, 25.816912],
						[111.495518, 25.823952],
						[111.47802, 25.836465],
						[111.468762, 25.838913],
						[111.458611, 25.843907],
						[111.456879, 25.848087],
						[111.44916, 25.847544],
						[111.433263, 25.846278],
						[111.43119, 25.844282],
						[111.429571, 25.84118],
						[111.427573, 25.835783],
						[111.42506, 25.826247],
						[111.425724, 25.823729],
						[111.42712, 25.821956],
						[111.433263, 25.818547],
						[111.435044, 25.816175],
						[111.436074, 25.813587],
						[111.437104, 25.807083],
						[111.438885, 25.793919],
						[111.440064, 25.788736],
						[111.440945, 25.783559],
						[111.442279, 25.778083],
						[111.442235, 25.772133],
						[111.440219, 25.769607],
						[111.436651, 25.767999],
						[111.432853, 25.766614],
						[111.42802, 25.766844],
						[111.42421, 25.769133],
						[111.416081, 25.768201],
						[111.410745, 25.761763],
						[111.404621, 25.752674],
						[111.399594, 25.744614],
						[111.397733, 25.743354],
						[111.39136, 25.740841],
						[111.376177, 25.737869],
						[111.372615, 25.734604],
						[111.37017, 25.733567],
						[111.367502, 25.733713],
						[111.365349, 25.734451],
						[111.36283, 25.734813],
						[111.346808, 25.729648],
						[111.342576, 25.72875],
						[111.337972, 25.729265],
						[111.333232, 25.730949],
						[111.330334, 25.732502],
						[111.327293, 25.732718],
						[111.323062, 25.731527],
						[111.318687, 25.729522],
						[111.315045, 25.723229],
						[111.311272, 25.721593],
						[111.308747, 25.720033],
						[111.307847, 25.718481],
						[111.307555, 25.716336],
						[111.308449, 25.707578],
						[111.308747, 25.692342],
						[111.311483, 25.688798],
						[111.313922, 25.682648],
						[111.31394, 25.677829],
						[111.313444, 25.672543],
						[111.309777, 25.658069],
						[111.309404, 25.652887],
						[111.31, 25.644938],
						[111.311706, 25.640577],
						[111.317645, 25.631269],
						[111.322385, 25.626845],
						[111.328175, 25.622121],
						[111.334702, 25.618358],
						[111.339604, 25.612672],
						[111.342421, 25.607801],
						[111.343309, 25.604547],
						[111.34316, 25.60277],
						[111.340113, 25.599585],
						[111.336849, 25.595808],
						[111.333666, 25.587298],
						[111.329205, 25.575972],
						[111.324904, 25.564128],
						[111.323645, 25.556509],
						[111.323868, 25.548854],
						[111.324756, 25.545821],
						[111.32676, 25.540947],
						[111.327722, 25.537398],
						[111.328305, 25.531659],
						[111.328323, 25.527761],
						[111.328038, 25.523417],
						[111.328125, 25.521443],
						[111.323862, 25.506428],
						[111.323142, 25.50428],
						[111.321548, 25.502892],
						[111.321405, 25.502013],
						[111.322516, 25.500353],
						[111.320803, 25.497598],
						[111.321473, 25.49635],
						[111.320617, 25.495562],
						[111.318972, 25.495952],
						[111.317303, 25.494376],
						[111.317607, 25.491286],
						[111.3161, 25.489758],
						[111.315417, 25.487917],
						[111.313922, 25.488949],
						[111.31162, 25.485147],
						[111.307171, 25.480111],
						[111.305024, 25.477146],
						[111.311694, 25.473832],
						[111.322454, 25.463786],
						[111.339071, 25.450871],
						[111.344711, 25.443153],
						[111.352567, 25.435993],
						[111.355464, 25.430452],
						[111.358579, 25.420025],
						[111.361322, 25.410268],
						[111.363984, 25.408013],
						[111.368886, 25.405654],
						[111.369922, 25.40439],
						[111.370145, 25.401807],
						[111.369103, 25.396328],
						[111.369103, 25.393884],
						[111.371331, 25.392928],
						[111.374818, 25.393005],
						[111.385112, 25.394645],
						[111.387414, 25.396572],
						[111.38778, 25.398722],
						[111.388971, 25.400418],
						[111.390746, 25.401675],
						[111.396523, 25.403015],
						[111.403566, 25.403643],
						[111.406594, 25.403197],
						[111.411043, 25.399727],
						[111.41659, 25.394177],
						[111.420363, 25.392097],
						[111.423838, 25.391657],
						[111.428349, 25.39195],
						[111.435745, 25.394673],
						[111.436564, 25.394596],
						[111.437371, 25.393116],
						[111.438332, 25.388795],
						[111.439735, 25.385535],
						[111.442986, 25.382197],
						[111.44787, 25.374866],
						[111.450153, 25.373016],
						[111.454075, 25.371082],
						[111.456209, 25.369448],
						[111.456575, 25.368045],
						[111.455837, 25.365231],
						[111.456284, 25.364567],
						[111.460931, 25.362151],
						[111.461893, 25.359121],
						[111.462042, 25.35697],
						[111.462786, 25.354896],
						[111.464487, 25.353122],
						[111.468681, 25.351334],
						[111.472379, 25.349994],
						[111.473267, 25.349323],
						[111.47511, 25.346809],
						[111.47305, 25.345915],
						[111.475749, 25.338212],
						[111.472504, 25.335572],
						[111.47089, 25.336941],
						[111.470623, 25.341306],
						[111.464859, 25.341704],
						[111.465101, 25.335753],
						[111.463519, 25.332876],
						[111.46458, 25.331507],
						[111.463401, 25.323167],
						[111.464803, 25.31862],
						[111.464065, 25.314582],
						[111.467242, 25.308951],
						[111.468532, 25.306017],
						[111.471027, 25.304341],
						[111.473788, 25.302133],
						[111.476369, 25.299087],
						[111.476729, 25.296558],
						[111.476717, 25.293686],
						[111.476158, 25.292002],
						[111.474303, 25.290668],
						[111.472814, 25.288991],
						[111.472435, 25.286629],
						[111.473707, 25.28106],
						[111.473701, 25.279376],
						[111.47277, 25.278035],
						[111.468508, 25.275862],
						[111.46811, 25.268615],
						[111.469215, 25.266421],
						[111.470685, 25.264387],
						[111.472894, 25.262521],
						[111.475488, 25.262332],
						[111.478448, 25.263332],
						[111.482525, 25.265163],
						[111.48438, 25.266665],
						[111.487911, 25.271536],
						[111.488872, 25.279621],
						[111.493365, 25.293924],
						[111.497826, 25.299457],
						[111.499874, 25.301469],
						[111.505688, 25.30302],
						[111.508673, 25.305312],
						[111.510677, 25.305822],
						[111.512371, 25.305822],
						[111.51399, 25.304927],
						[111.518048, 25.29966],
						[111.519451, 25.299136],
						[111.521883, 25.298835],
						[111.523509, 25.299276],
						[111.527865, 25.302741],
						[111.533542, 25.3055],
						[111.53487, 25.306604],
						[111.535758, 25.308972],
						[111.538711, 25.312961],
						[111.542993, 25.31665],
						[111.546679, 25.31871],
						[111.551115, 25.320331],
						[111.552815, 25.320617],
						[111.554509, 25.319877],
						[111.558121, 25.316321],
						[111.563817, 25.310977],
						[111.564927, 25.309126],
						[111.56507, 25.304396],
						[111.565809, 25.304173],
						[111.57068, 25.306234],
						[111.571648, 25.306234],
						[111.572901, 25.304753],
						[111.573199, 25.30105],
						[111.574235, 25.299345],
						[111.577933, 25.298235],
						[111.587613, 25.297634],
						[111.593018, 25.298297],
						[111.594277, 25.297487],
						[111.594885, 25.29618],
						[111.597622, 25.297235],
						[111.598819, 25.298996],
						[111.595382, 25.302776],
						[111.593756, 25.306842],
						[111.593235, 25.310691],
						[111.594277, 25.31424],
						[111.596344, 25.318459],
						[111.600122, 25.322378],
						[111.609964, 25.325193],
						[111.61463, 25.325416],
						[111.621145, 25.323048],
						[111.626556, 25.319283],
						[111.628188, 25.316475],
						[111.628256, 25.313737],
						[111.623739, 25.305815],
						[111.624111, 25.30404],
						[111.625737, 25.301819],
						[111.634331, 25.298577],
						[111.640114, 25.298395],
						[111.647225, 25.298779],
						[111.654863, 25.296942],
						[111.658648, 25.295244],
						[111.660578, 25.29296],
						[111.662942, 25.287412],
						[111.66517, 25.284456],
						[111.668806, 25.281319],
						[111.676072, 25.277043],
						[111.679776, 25.273493],
						[111.683015, 25.267462],
						[111.689673, 25.26466],
						[111.694346, 25.261047],
						[111.696573, 25.258538],
						[111.698131, 25.255798],
						[111.703132, 25.23362],
						[111.707817, 25.227846],
						[111.713408, 25.224099],
						[111.717987, 25.220631],
						[111.722206, 25.219254],
						[111.727568, 25.219653],
						[111.731315, 25.218758],
						[111.7352, 25.216248],
						[111.737576, 25.214046],
						[111.738588, 25.210081],
						[111.740592, 25.198706],
						[111.744123, 25.194832],
						[111.765356, 25.186524],
						[111.770817, 25.184832],
						[111.775415, 25.181818],
						[111.78116, 25.177119],
						[111.785411, 25.17251],
						[111.79532, 25.158382],
						[111.798019, 25.153625],
						[111.799713, 25.15238],
						[111.806421, 25.15061],
						[111.810299, 25.151995],
						[111.812589, 25.155773],
						[111.82928, 25.166761],
						[111.83479, 25.169656],
						[111.839376, 25.173755],
						[111.844334, 25.176],
						[111.854969, 25.17607],
						[111.857693, 25.175447],
						[111.862229, 25.174958],
						[111.866318, 25.175636],
						[111.869837, 25.178881],
						[111.87292, 25.183301],
						[111.877096, 25.188811],
						[111.889333, 25.193342],
						[111.896177, 25.193692],
						[111.90062, 25.195734],
						[111.90389, 25.198999],
						[111.906961, 25.202964],
						[111.91231, 25.207026],
						[111.918763, 25.212179],
						[111.921481, 25.215458],
						[111.923597, 25.216206],
						[111.925291, 25.218108],
						[111.92552, 25.220974],
						[111.924701, 25.225923],
						[111.921568, 25.22879],
						[111.919477, 25.23204],
						[111.918447, 25.23471],
						[111.918881, 25.237192],
						[111.92078, 25.238324],
						[111.923522, 25.239457],
						[111.924801, 25.241547],
						[111.923963, 25.243266],
						[111.921555, 25.247131],
						[111.916802, 25.249256],
						[111.914972, 25.252772],
						[111.911832, 25.255022],
						[111.909505, 25.257909],
						[111.907551, 25.262619],
						[111.908668, 25.267846],
						[111.91105, 25.272773],
						[111.914972, 25.27807],
						[111.915748, 25.281934],
						[111.913979, 25.285707],
						[111.913402, 25.288271],
						[111.910802, 25.290947],
						[111.904932, 25.297718],
						[111.90518, 25.301378],
						[111.904405, 25.304641],
						[111.902475, 25.306136],
						[111.898045, 25.30432],
						[111.895314, 25.301714],
						[111.891138, 25.299883],
						[111.887527, 25.299171],
						[111.884803, 25.300023],
						[111.882414, 25.301993],
						[111.865239, 25.342765],
						[111.863687, 25.346069],
						[111.859753, 25.351355],
						[111.857023, 25.355888],
						[111.854789, 25.360154],
						[111.851972, 25.370663],
						[111.851283, 25.375299],
						[111.84949, 25.382302],
						[111.848156, 25.388586],
						[111.846326, 25.395134],
						[111.84501, 25.40164],
						[111.843415, 25.407943],
						[111.836999, 25.432225],
						[111.830217, 25.451471],
						[111.825371, 25.454743],
						[111.821096, 25.455218],
						[111.817292, 25.455211],
						[111.813396, 25.453829],
						[111.807352, 25.447054],
						[111.80057, 25.440774],
						[111.791107, 25.435805],
						[111.785659, 25.434046],
						[111.77364, 25.432888],
						[111.765803, 25.433327],
						[111.761193, 25.436342],
						[111.760628, 25.439134],
						[111.760454, 25.443976],
						[111.761664, 25.450571],
						[111.766405, 25.460423],
						[111.769904, 25.470567],
						[111.779609, 25.482427],
						[111.790729, 25.489151],
						[111.796741, 25.49522],
						[111.796319, 25.498456],
						[111.79689, 25.500465],
						[111.799012, 25.503666],
						[111.799018, 25.504873],
						[111.79725, 25.505389],
						[111.795364, 25.504196],
						[111.792702, 25.503311],
						[111.789941, 25.503625],
						[111.78798, 25.509065],
						[111.788116, 25.513089],
						[111.788575, 25.515397],
						[111.789357, 25.516897],
						[111.791026, 25.517692],
						[111.792683, 25.51758],
						[111.797325, 25.516241],
						[111.801271, 25.51479],
						[111.806855, 25.515997],
						[111.810008, 25.515404],
						[111.811689, 25.51539],
						[111.813377, 25.51615],
						[111.815071, 25.517468],
						[111.817652, 25.521966],
						[111.824447, 25.523291],
						[111.827078, 25.523138],
						[111.828914, 25.523954],
						[111.83005, 25.525725],
						[111.830639, 25.53419],
						[111.831887, 25.537565],
						[111.835758, 25.542167],
						[111.841455, 25.547585],
						[111.845891, 25.556516],
						[111.848957, 25.564156],
						[111.850396, 25.570277],
						[111.849552, 25.576299],
						[111.84076, 25.584859],
						[111.839395, 25.587235],
						[111.838358, 25.590511],
						[111.838836, 25.593703],
						[111.838619, 25.59785],
						[111.837992, 25.599954],
						[111.836069, 25.601446],
						[111.832532, 25.601655],
						[111.828387, 25.604192],
						[111.826786, 25.606582],
						[111.827524, 25.609983],
						[111.828393, 25.612707],
						[111.830974, 25.617195],
						[111.830987, 25.61948],
						[111.828672, 25.620644],
						[111.824893, 25.621996],
						[111.8188, 25.624894],
						[111.816697, 25.626622],
						[111.815859, 25.627772],
						[111.814823, 25.63044],
						[111.815288, 25.637874],
						[111.81383, 25.640737],
						[111.810454, 25.640946],
						[111.806868, 25.640584],
						[111.803709, 25.640612],
						[111.80119, 25.642152],
						[111.798032, 25.643308],
						[111.795084, 25.643705],
						[111.793819, 25.64296],
						[111.793391, 25.642005],
						[111.793595, 25.63972],
						[111.794421, 25.637616],
						[111.794818, 25.633046],
						[111.794179, 25.630949],
						[111.787688, 25.622476],
						[111.781868, 25.619285],
						[111.779603, 25.615954],
						[111.773237, 25.609892],
						[111.771636, 25.606554],
						[111.770854, 25.604164],
						[111.767038, 25.600993],
						[111.764692, 25.599599],
						[111.764196, 25.598582],
						[111.765753, 25.594867],
						[111.765604, 25.591522],
						[111.764407, 25.590574],
						[111.7619, 25.589626],
						[111.758599, 25.589166],
						[111.754311, 25.587138],
						[111.753151, 25.587061],
						[111.7516, 25.588127],
						[111.749912, 25.59256],
						[111.750328, 25.595425],
						[111.752623, 25.603787],
						[111.752369, 25.605941],
						[111.751327, 25.607376],
						[111.750805, 25.609174],
						[111.751885, 25.612401],
						[111.754293, 25.617529],
						[111.753387, 25.620163],
						[111.751153, 25.621849],
						[111.744439, 25.62511],
						[111.737707, 25.625138],
						[111.73533, 25.625626],
						[111.733251, 25.626531],
						[111.732978, 25.630273],
						[111.734269, 25.635032],
						[111.736397, 25.639797],
						[111.736838, 25.642075],
						[111.735783, 25.643413],
						[111.735789, 25.644938],
						[111.736428, 25.64684]
					]
				]
			]
		}
	}]
};

//注册到echarts中
echarts.registerMap('china', chinaJson);
echarts.registerMap('yunnan', yunnanJson);
echarts.registerMap('pingxiang', pingxiangJson);
echarts.registerMap('zhangye', zhangyeJson);
echarts.registerMap('xihe', xiheJson);
echarts.registerMap('gansu', gansuJson);
echarts.registerMap('daoxian', daoxianJson);

//地图json和地区id对应关系
const mapMap = new Map();
mapMap.set("china", "china");
mapMap.set("30", "yunnan");
mapMap.set("239", "pingxiang");
mapMap.set("75", "zhangye");
mapMap.set("657", "xihe");
mapMap.set("5", "gansu");
mapMap.set("1747", "daoxian");

export default {
	mapMap
}